webpackJsonp([10],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// document.write("<script src='//stock.9fzt.com/server/static/jquery.min.js'></script>");
	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(8);
	__webpack_require__(4);
	
	// 全局 css
	__webpack_require__(9);
	
	var React = __webpack_require__(27);
	var ReactDOM = __webpack_require__(179);
	// const ReactDomServer = require('react-dom/server');
	var HeaderBox = __webpack_require__(189);
	var FooterBox = __webpack_require__(213);
	var MainCharts = __webpack_require__(233);
	var Cash = __webpack_require__(505);
	var HotSearch = __webpack_require__(351); // 九方智投热搜股票
	var NeswWrap = __webpack_require__(355); // 公司资讯
	var StockInfo = __webpack_require__(383); // 个股信息
	var StockBar = __webpack_require__(368);
	var request = __webpack_require__(180);
	
	var _require = __webpack_require__(206),
	    getIsToday = _require.getIsToday;
	
	var _ref = typeof window.WebSocket === 'function' ? __webpack_require__(208) : {},
	    ws = _ref.ws;
	
	var transformStaticData = __webpack_require__(225);
	
	var _require2 = __webpack_require__(207),
	    getIsAIndexStock = _require2.getIsAIndexStock;
	
	var Ad = __webpack_require__(226);
	var CenterAd = __webpack_require__(227);
	
	var commonHtml = __webpack_require__(369);
	
	new transformStaticData();
	
	var token = '';
	
	var _hmt = _hmt || [];
	(function () {
	  var hm = document.createElement("script");
	  hm.src = "https://hm.baidu.com/hm.js?6e2ca337a699e09c7012d6d8e8c27630";
	  hm.defer = 'defer';
	  var s = document.getElementsByTagName("script")[0];
	  s.parentNode.insertBefore(hm, s);
	})();
	
	var App = React.createClass({
	  displayName: 'App',
	
	  getInitialState: function getInitialState() {
	    var params = {};
	    if (location.href.indexOf('server') === -1 && (location.hostname === "stock.richbays.com" || location.hostname === "gmg.9fzt.com")) {
	      location.pathname.replace(/\/zsindex\/(.+?).html/gi, function (match, p1) {
	        if (p1) {
	          var query = p1.split('_');
	          params.symbol = query[1];
	          params.market = query[0].toLowerCase();
	          var market = params.market,
	              symbol = params.symbol;
	
	          if (market.indexOf('hk') > -1) {
	            params.dataSourceType = 'HK';
	            params.code = symbol.replace(/^0/, '');
	          } else {
	            params.dataSourceType = market === 'sh' || market === 'sz' ? 'A' : 'US';
	            params.code = symbol;
	          }
	        }
	      });
	    } else {
	      var search = location.href.split('?')[1];
	      if (search) {
	        search.split('&').forEach(function (val) {
	          var key = val.split('=')[0];
	          var kv = val.split('=')[1];
	          params[key] = kv.toLowerCase();
	        });
	        var market = params.market,
	            symbol = params.symbol;
	
	        if (market.indexOf('hk') > -1) {
	          params.dataSourceType = 'HK';
	          params.code = symbol.replace(/^0/, '');
	        } else {
	          params.dataSourceType = market === 'sh' || market === 'sz' ? 'A' : 'US';
	          params.code = symbol;
	        }
	      }
	    }
	    console.log(params, '====');
	    var dyna = {};
	    var statistics = {};
	    var StatusType = -1;
	
	    var staticqqzs = { // HK
	      '.HSI': {},
	      '.HSCC': {},
	      '.HSCE': {}
	    };
	    if (params.dataSourceType === 'US') {
	      staticqqzs = {
	        'DIA': {},
	        'SPY': {},
	        'QQQ': {}
	      };
	    }
	    var qqzs = { // HK
	      '.HSI': {},
	      '.HSCC': {},
	      '.HSCE': {}
	    };
	    if (params.dataSourceType === 'US') {
	      qqzs = {
	        'DIA': {},
	        'SPY': {},
	        'QQQ': {}
	      };
	    }
	
	    var name = '';
	    if (window.jfztglobal.stockname) name = window.jfztglobal.stockname;
	
	    return {
	      StatusType: StatusType,
	      quoteStocks: {},
	      symbol: params.symbol,
	      code: params.code,
	      market: params.market,
	      dataSourceType: params.dataSourceType,
	      name: name,
	      token: '',
	      statistics: statistics,
	      reqId: 1,
	      dyna: dyna,
	      tick: [],
	      statics: {},
	      staticqqzs: staticqqzs,
	      qqzs: qqzs,
	      leftSideAd: {},
	      rightSideAd: {},
	      centerAd1: {},
	      centerAd2: {},
	      screenChange: 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    $('.global-header-wrap1').html(commonHtml.headerHtml);
	    $('.global-footer-wrap1').html(commonHtml.footerHtml);
	    $('link[rel="shortcut icon"]').attr('href', '//stock.9fzt.com/server/jfzt_favicon.ico');
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    //  美股延时修改websocket订阅参数，ie的兼容暂时抛弃
	    // if(!ws) {
	    //   this.ieInitData()
	    // } else {
	    this.initData();
	    this.initGangguData();
	    // setTimeout(() => {
	    //   this.getStatiscisData()
	    // }, 200)
	    // }
	    this.registerResize();
	
	    // 获取个股名称
	    if (!window.jfztglobal.stockname) this.getStockName();
	
	    // tradingdays
	    request.get(request.apis.quote.tradingdays, { market: 'sh', limit: '1' }).then(function (res) {
	      var today = res.data[0] * 1000;
	      var now = new Date();
	      var day = now.getDay();
	      var hours = now.getHours();
	      if (getIsToday(today) && !(hours < 9 || hours > 15)) {
	        _this.setState({
	          isPay: true
	        });
	      } else {
	        _this.setState({
	          isPay: false
	        });
	      }
	    });
	
	    //获取广告
	    request.get(request.apis.activity.activity, {
	      activityStatus: 'NOW',
	      hiddenStatus: 'SHOWN',
	      orderBy: 'sort',
	      direction: 'asc',
	      position: 'flgmgzs_stockbardetail'
	    }).then(function (res) {
	      try {
	        _this.setState({
	          leftSideAd: res.data.list[0],
	          rightSideAd: res.data.list[1],
	          centerAd1: res.data.list[2],
	          centerAd2: res.data.list[3]
	        });
	      } catch (e) {}
	    });
	  },
	
	  registerResize: function registerResize() {
	    var _this2 = this;
	
	    window.onresize = function () {
	      _this2.setState({
	        screenChange: new Date().getTime()
	      });
	    };
	  },
	
	  /**
	   * 获取港股的init 数据信息
	   */
	  initGangguData: function initGangguData() {
	    var _state = this.state,
	        code = _state.code,
	        market = _state.market;
	
	    request.get(request.apis.quote.getFdStockDetail, {
	      symbol: code.toUpperCase(),
	      market: market.toUpperCase()
	    }).then(function (res) {
	      console.log('asdasdres', res);
	    });
	  },
	
	  /**
	   * 获取个股名称
	   */
	  getStockName: function getStockName() {
	    var _this3 = this;
	
	    function marketTransform(val) {
	      var keytmar = {
	        NASDAQ: 'NASDAQ',
	        nasdaq: 'NASDAQ',
	        NA: 'NASDAQ',
	        sh: 'sh',
	        SH: 'sh',
	        sz: 'sz',
	        SZ: 'sz',
	        HK: 'HKSE',
	        hk: 'HKSE',
	        hkse: 'HKSE',
	        AMEX: 'AMEX',
	        amex: 'AMEX',
	        AM: 'AMEX',
	        am: 'AMEX',
	        HKIDX: 'HKIDX',
	        hkidx: 'HKIDX'
	      };
	      return keytmar[val] || val.toUpperCase();
	    }
	    var market = marketTransform(this.state.market);
	    request.get(request.apis.quote.getStockName, {
	      symbol: /\d+/.test(this.state.symbol) ? this.state.symbol : this.state.symbol.toUpperCase(),
	      market: market
	    }).then(function (res) {
	      if (res && res.data && res.data.length > 0) {
	        _this3.setState({
	          name: res.data[0].Name
	        });
	        document.title = decodeURIComponent(res.data[0].Name) + ' ' + (_this3.state.dyna.Updown ? (_this3.state.dyna.Updown * 100).toFixed(2) + '%' : '--');
	      }
	    });
	  },
	
	  getStatiscisData: function getStatiscisData() {
	    var _this4 = this;
	
	    // let vm = this
	    if (Object.keys(this.state.statistics).length === 0) {
	      request.get(request.apis.quote.getToken, {
	        AppName: 'jfztWeb',
	        Tag: 1111
	      }, true).then(function (lr) {
	        token = lr.QuoteData.AuthData[0].Token;
	        var _state2 = _this4.state,
	            code = _state2.code,
	            market = _state2.market;
	
	        _this4.connectHttp(market, code, 'STATISTICS').then(function (msg) {
	          _this4.setState({
	            statistics: msg.QuoteData.StatisticsData[0]
	          });
	        });
	      });
	    }
	  },
	
	  ieInitData: function ieInitData() {
	    var _this5 = this;
	
	    request.get(request.apis.quote.getToken, {
	      AppName: 'jfztWeb',
	      Tag: 1111
	    }, true).then(function (lr) {
	      token = lr.QuoteData.AuthData[0].Token;
	      _this5.startIeSub();
	    });
	  },
	
	  startIeSub: function startIeSub() {
	    var _this6 = this;
	
	    var _state3 = this.state,
	        code = _state3.code,
	        market = _state3.market;
	
	    this.connectHttp(market, code, 'DYNA').then(function (msg) {
	      stockname;
	      _this6.setState({
	        dyna: msg.QuoteData.DynaData[0]
	      });
	    });
	    this.connectHttp(market, code, 'STATISTICS').then(function (msg) {
	      _this6.setState({
	        statistics: msg.QuoteData.StatisticsData[0]
	      });
	    });
	    this.connectHttp(market, code, 'STATUS').then(function (msg) {
	      _this6.setState({
	        StatusType: msg.QuoteData.InstStatusData[0].StatusType
	      });
	    });
	    this.connectHttp(market, code, 'TICK').then(function (msg) {
	      _this6.setState({
	        tick: msg.QuoteData.TickData
	      });
	    });
	
	    var qqzss = [{ code: '.HSI', market: 'HKIDX' }, { code: '.HSCC', market: 'HKIDX' }, { code: '.HSCE', market: 'HKIDX' }];
	
	    if (this.state.dataSourceType === 'US') {
	      qqzss = [{
	        code: 'DIA',
	        market: 'AMEX'
	      }, {
	        code: 'SPY',
	        market: 'AMEX'
	      }, {
	        code: 'QQQ',
	        market: 'NASDAQ'
	      }];
	    }
	    qqzss.forEach(function (item) {
	      _this6.connectHttp(item.market, item.code, 'DYNA').then(function (msg) {
	        var qqzs = _this6.state.qqzs;
	        qqzs[item.code] = msg.QuoteData.DynaData[0];
	        document.title = decodeURIComponent(_this6.state.name) + ' ' + (msg.QuoteData.DynaData[0].Updown ? (msg.QuoteData.DynaData[0].Updown * 100).toFixed(2) + '%' : '--');
	        _this6.setState({
	          qqzs: qqzs
	        });
	      });
	    });
	    qqzss.forEach(function (item) {
	      _this6.connectHttp(item.market, item.code, 'STATISTICS').then(function (msg) {
	        var qqzs = _this6.state.staticqqzs;
	        qqzs[item.code] = msg.QuoteData.StatisticsData[0];
	        _this6.setState({
	          staticqqzs: qqzs
	        });
	      });
	    });
	  },
	
	  connectHttp: function connectHttp(market, code, type) {
	    return request.postHttp(request.apis.zbHttp.busi, {
	      Market: market,
	      Inst: code,
	      ServiceType: type
	    }, token);
	  },
	
	  initData: function initData() {
	    var _this7 = this;
	
	    var _state4 = this.state,
	        code = _state4.code,
	        market = _state4.market;
	
	    ws.init();
	    this.unsocket();
	    var tmpMarket = 'DELAY_' + market; // 港美股都要订阅延迟数据
	    ws.websocket.safeSubscribeSTATISTICS(code, tmpMarket);
	    ws.websocket.safeSubscribeDYNA(code, tmpMarket);
	    ws.websocket.safeSubscribeTICK(code, tmpMarket);
	    ws.websocket.safeSubscribeCAPITALFLOW(code, tmpMarket);
	    ws.websocket.safeSubscribeSTATUS(code, tmpMarket);
	    // inststatus
	
	    if (this.state.dataSourceType === 'HK') {
	      ws.websocket.safeSubscribeDYNA('.HSI', 'DELAY_HKIDX');
	      ws.websocket.safeSubscribeDYNA('.HSCC', 'DELAY_HKIDX');
	      ws.websocket.safeSubscribeDYNA('.HSCE', 'DELAY_HKIDX');
	      ws.websocket.safeSubscribeSTATISTICS('.HSI', 'DELAY_HKIDX');
	      ws.websocket.safeSubscribeSTATISTICS('.HSCC', 'DELAY_HKIDX');
	      ws.websocket.safeSubscribeSTATISTICS('.HSCE', 'DELAY_HKIDX');
	    }
	
	    if (this.state.dataSourceType === 'US') {
	      ws.websocket.safeSubscribeDYNA('DIA', 'DELAY_AMEX');
	      ws.websocket.safeSubscribeDYNA('SPY', 'DELAY_AMEX');
	      ws.websocket.safeSubscribeDYNA('QQQ', 'DELAY_NASDAQ');
	      ws.websocket.safeSubscribeSTATISTICS('DIA', 'DELAY_AMEX');
	      ws.websocket.safeSubscribeSTATISTICS('SPY', 'DELAY_AMEX');
	      ws.websocket.safeSubscribeSTATISTICS('QQQ', 'DELAY_NASDAQ');
	    }
	
	    ws.websocket.on('onSTATUS', function (msg) {
	      var StatusType = msg.QuoteData.InstStatusData[0].StatusType;
	      if (StatusType !== _this7.state.StatusType && _this7.state.StatusType !== -1) {
	        setTimeout(function () {
	          window.location.reload();
	        }, 30000);
	      }
	      _this7.setState({
	        StatusType: StatusType
	      });
	    });
	
	    ws.websocket.on('onSTATISTICS', function (msg) {
	      var tmpMarket = msg.Market.replace('DELAY_', '');
	      if (msg.Inst === code && market.toUpperCase() === tmpMarket) {
	        _this7.state.staticqqzs[msg.Inst.toUpperCase()] = msg.QuoteData.StatisticsData[0];
	        _this7.setState({
	          statistics: msg.QuoteData.StatisticsData[0],
	          staticqqzs: _this7.state.staticqqzs
	        });
	      } else {
	        var staticqqzs = _this7.state.staticqqzs;
	        staticqqzs[msg.Inst.toUpperCase()] = msg.QuoteData.StatisticsData[0];
	        _this7.setState({
	          staticqqzs: staticqqzs
	        });
	      }
	    });
	
	    ws.websocket.on('onDYNA', function (msg) {
	      var tmpMarket = msg.Market.replace('DELAY_', '');
	      if (msg.Inst === code && tmpMarket.toLowerCase() == market) {
	        // 当前股票
	        document.title = decodeURIComponent(_this7.state.name) + ' ' + (msg.QuoteData.DynaData[0].Updown ? (msg.QuoteData.DynaData[0].Updown * 100).toFixed(2) + '%' : '--');
	        _this7.state.qqzs[msg.Inst.toUpperCase()] = msg.QuoteData.DynaData[0];
	        _this7.setState({
	          dyna: msg.QuoteData.DynaData[0],
	          qqzs: _this7.state.qqzs
	        });
	      } else {
	        // 订阅股票列表
	        var qqzs = _this7.state.qqzs;
	        qqzs[msg.Inst] = msg.QuoteData.DynaData[0];
	        _this7.setState({
	          qqzs: qqzs
	        });
	        _this7.state.quoteStocks[msg.Inst] = msg.QuoteData.DynaData[0];
	        _this7.setState({
	          quoteStocks: _this7.state.quoteStocks
	        });
	      }
	    });
	
	    ws.websocket.on('onCAPITALFLOW', function (msg) {
	      if (msg.Inst === code) {
	        _this7.setState({
	          statistics: msg.QuoteData.StatisticsData[0]
	        });
	      }
	    });
	
	    ws.websocket.on('onTICK', function (msg) {
	      if (msg.Inst === code) {
	        if (_this7.state.tick.length === 1) {
	          _this7.setState({
	            tick: msg.QuoteData.TickData.concat(_this7.state.tick)
	          });
	        } else {
	          _this7.setState({
	            tick: msg.QuoteData.TickData.reverse().concat(_this7.state.tick)
	          });
	        }
	      }
	    });
	
	    if (this.state.dataSourceType !== 'A') {
	      ws.websocket.on('onSTATIC', function (msg) {
	        if (msg.Inst === code) {
	          _this7.setState({
	            statics: msg.QuoteData.StaticData[0]
	          });
	        }
	      });
	    }
	  },
	
	  unsocket: function unsocket() {
	    var _state5 = this.state,
	        code = _state5.code,
	        market = _state5.market;
	
	    var tmpMarket = 'DELAY_' + market;
	    ws.websocket.safeUnsubscribeDYNA(code, tmpMarket);
	    ws.websocket.safeUnsubscribeSTATISTICS(code, tmpMarket);
	    ws.websocket.safeUnsubscribeTICK(code, tmpMarket);
	    ws.websocket.safeUnsubscribeCAPITALFLOW(code, tmpMarket);
	
	    if (this.state.dataSourceType === 'HK') {
	      ws.websocket.safeUnsubscribeDYNA('.HSI', 'DELAY_HKIDX');
	      ws.websocket.safeUnsubscribeDYNA('.HSCC', 'DELAY_HKIDX');
	      ws.websocket.safeUnsubscribeDYNA('.HSCE', 'DELAY_HKIDX');
	      ws.websocket.safeUnsubscribeSTATISTICS('.HSI', 'DELAY_HKIDX');
	      ws.websocket.safeUnsubscribeSTATISTICS('.HSCC', 'DELAY_HKIDX');
	      ws.websocket.safeUnsubscribeSTATISTICS('.HSCE', 'DELAY_HKIDX');
	    }
	
	    if (this.state.dataSourceType === 'US') {
	      ws.websocket.safeUnsubscribeDYNA('DIA', 'DELAY_AMEX');
	      ws.websocket.safeUnsubscribeDYNA('SPY', 'DELAY_AMEX');
	      ws.websocket.safeUnsubscribeDYNA('QQQ', 'DELAY_NASDAQ');
	      ws.websocket.safeUnsubscribeSTATISTICS('DIA', 'DELAY_AMEX');
	      ws.websocket.safeUnsubscribeSTATISTICS('SPY', 'DELAY_AMEX');
	      ws.websocket.safeUnsubscribeSTATISTICS('QQQ', 'DELAY_NASDAQ');
	    }
	  },
	
	  render: function render() {
	    var _React$createElement;
	
	    var staticqqzs = this.state.staticqqzs;
	    var qqzs = this.state.qqzs;
	    var stockInfo = {
	      stockCode: this.state.code,
	      market: this.state.market,
	      stockName: this.state.name,
	      dataSourceType: this.state.dataSourceType
	    };
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { 'data-key': 'dyna', style: { display: 'none' } },
	        JSON.stringify(this.state.dyna)
	      ),
	      React.createElement(
	        'div',
	        { 'data-key': 'statistics', style: { display: 'none' } },
	        JSON.stringify(this.state.statistics)
	      ),
	      React.createElement(
	        'div',
	        { 'data-key': 'StatusType', style: { display: 'none' } },
	        JSON.stringify(this.state.StatusType)
	      ),
	      React.createElement(
	        'div',
	        { 'data-key': 'staticqqzs', style: { display: 'none' } },
	        JSON.stringify(this.state.staticqqzs)
	      ),
	      React.createElement(
	        'div',
	        { 'data-key': 'qqzs', style: { display: 'none' } },
	        JSON.stringify(this.state.qqzs)
	      ),
	      React.createElement(
	        'div',
	        { 'data-key': 'stockname', style: { display: 'none' } },
	        JSON.stringify(this.state.name)
	      ),
	      React.createElement('link', { rel: 'stylesheet', href: 'https://www.9fzt.com/css/common.css?v=1661237959363' }),
	      React.createElement('div', { className: 'global-header-wrap1' }),
	      React.createElement(
	        'div',
	        { className: 'block---page-content-wrap' },
	        React.createElement('div', { style: { height: '45px' } }),
	        React.createElement(StockInfo, (_React$createElement = { symbol: this.state.symbol, market: this.state.market, dataSourceType: this.state.dataSourceType, StatusType: this.state.StatusType, name: this.state.name }, _defineProperty(_React$createElement, 'symbol', this.state.symbol), _defineProperty(_React$createElement, 'statistics', this.state.statistics), _defineProperty(_React$createElement, 'dyna', this.state.dyna), _React$createElement)),
	        React.createElement(
	          'div',
	          { className: 'clearfix', style: { marginBottom: '12px' } },
	          React.createElement(
	            'div',
	            { className: 'float-left', style: { width: '210px' } },
	            React.createElement(
	              'div',
	              { className: 'block--hot-search' },
	              React.createElement(HotSearch, { market: this.state.market, symbol: this.state.symbol, token: token, quoteStocks: this.state.quoteStocks, dataSourceType: this.state.dataSourceType })
	            ),
	            React.createElement('div', { style: { width: '100%', height: '320px' } })
	          ),
	          React.createElement(
	            'div',
	            { className: 'float-right', style: { width: '782px' } },
	            React.createElement(MainCharts, {
	              code: this.state.code,
	              market: this.state.market,
	              symbol: this.state.symbol,
	              dataSourceType: this.state.dataSourceType,
	              statics: this.state.statics,
	              statistics: this.state.statistics }),
	            getIsAIndexStock(this.state.symbol, this.state.market) ? React.createElement(
	              'div',
	              { className: 'block--cash-wrap' },
	              React.createElement(Cash, { code: this.state.code, market: this.state.market, symbol: this.state.symbol })
	            ) : ''
	          )
	        )
	      ),
	      React.createElement('div', { className: 'global-footer-wrap1' })
	    );
	  }
	});
	
	ReactDOM.render(React.createElement(App, null), document.getElementById('app'));
	
	// console.log(ReactDomServer.renderToStaticMarkup(<App></App>))

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Object.assign != 'function') {
	  // Must be writable: true, enumerable: false, configurable: true
	  Object.defineProperty(Object, "assign", {
	    value: function assign(target, varArgs) {
	      // .length of function is 2
	      'use strict';
	
	      if (target == null) {
	        // TypeError if undefined or null
	        throw new TypeError('Cannot convert undefined or null to object');
	      }
	
	      var to = Object(target);
	
	      for (var index = 1; index < arguments.length; index++) {
	        var nextSource = arguments[index];
	
	        if (nextSource != null) {
	          // Skip over if undefined or null
	          for (var nextKey in nextSource) {
	            // Avoid bugs when hasOwnProperty is shadowed
	            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	              to[nextKey] = nextSource[nextKey];
	            }
	          }
	        }
	      }
	      return to;
	    },
	    writable: true,
	    configurable: true
	  });
	}
	
	if (!String.prototype.padStart) {
	  String.prototype.padStart = function padStart(targetLength, padString) {
	    targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
	    padString = String(padString !== undefined ? padString : ' ');
	    if (this.length >= targetLength) {
	      return String(this);
	    } else {
	      targetLength = targetLength - this.length;
	      if (targetLength > padString.length) {
	        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	      }
	      return padString.slice(0, targetLength) + String(this);
	    }
	  };
	}
	
	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	if (!Array.from) {
	  Array.from = function () {
	    var toStr = Object.prototype.toString;
	    var isCallable = function isCallable(fn) {
	      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
	    };
	    var toInteger = function toInteger(value) {
	      var number = Number(value);
	      if (isNaN(number)) {
	        return 0;
	      }
	      if (number === 0 || !isFinite(number)) {
	        return number;
	      }
	      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
	    };
	    var maxSafeInteger = Math.pow(2, 53) - 1;
	    var toLength = function toLength(value) {
	      var len = toInteger(value);
	      return Math.min(Math.max(len, 0), maxSafeInteger);
	    };
	
	    // The length property of the from method is 1.
	    return function from(arrayLike /*, mapFn, thisArg */) {
	      // 1. Let C be the this value.
	      var C = this;
	
	      // 2. Let items be ToObject(arrayLike).
	      var items = Object(arrayLike);
	
	      // 3. ReturnIfAbrupt(items).
	      if (arrayLike == null) {
	        throw new TypeError('Array.from requires an array-like object - not null or undefined');
	      }
	
	      // 4. If mapfn is undefined, then let mapping be false.
	      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
	      var T;
	      if (typeof mapFn !== 'undefined') {
	        // 5. else
	        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
	        if (!isCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	
	        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	      }
	
	      // 10. Let lenValue be Get(items, "length").
	      // 11. Let len be ToLength(lenValue).
	      var len = toLength(items.length);
	
	      // 13. If IsConstructor(C) is true, then
	      // 13. a. Let A be the result of calling the [[Construct]] internal method 
	      // of C with an argument list containing the single item len.
	      // 14. a. Else, Let A be ArrayCreate(len).
	      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
	
	      // 16. Let k be 0.
	      var k = 0;
	      // 17. Repeat, while k < len… (also steps a - h)
	      var kValue;
	      while (k < len) {
	        kValue = items[k];
	        if (mapFn) {
	          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
	        } else {
	          A[k] = kValue;
	        }
	        k += 1;
	      }
	      // 18. Let putStatus be Put(A, "length", len, true).
	      A.length = len;
	      // 20. Return A.
	      return A;
	    };
	  }();
	}
	
	// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	if (!Array.prototype.includes) {
	  Object.defineProperty(Array.prototype, 'includes', {
	    value: function value(valueToFind, fromIndex) {
	
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      // 1. Let O be ? ToObject(this value).
	      var o = Object(this);
	
	      // 2. Let len be ? ToLength(? Get(O, "length")).
	      var len = o.length >>> 0;
	
	      // 3. If len is 0, return false.
	      if (len === 0) {
	        return false;
	      }
	
	      // 4. Let n be ? ToInteger(fromIndex).
	      //    (If fromIndex is undefined, this step produces the value 0.)
	      var n = fromIndex | 0;
	
	      // 5. If n ≥ 0, then
	      //  a. Let k be n.
	      // 6. Else n < 0,
	      //  a. Let k be len + n.
	      //  b. If k < 0, let k be 0.
	      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	      function sameValueZero(x, y) {
	        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	      }
	
	      // 7. Repeat, while k < len
	      while (k < len) {
	        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
	        // b. If SameValueZero(valueToFind, elementK) is true, return true.
	        if (sameValueZero(o[k], valueToFind)) {
	          return true;
	        }
	        // c. Increase k by 1. 
	        k++;
	      }
	
	      // 8. Return false
	      return false;
	    }
	  });
	}
	
	// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	if (!Array.prototype.findIndex) {
	  Object.defineProperty(Array.prototype, 'findIndex', {
	    value: function value(predicate) {
	      // 1. Let O be ? ToObject(this value).
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      var o = Object(this);
	
	      // 2. Let len be ? ToLength(? Get(O, "length")).
	      var len = o.length >>> 0;
	
	      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	
	      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
	      var thisArg = arguments[1];
	
	      // 5. Let k be 0.
	      var k = 0;
	
	      // 6. Repeat, while k < len
	      while (k < len) {
	        // a. Let Pk be ! ToString(k).
	        // b. Let kValue be ? Get(O, Pk).
	        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
	        // d. If testResult is true, return k.
	        var kValue = o[k];
	        if (predicate.call(thisArg, kValue, k, o)) {
	          return k;
	        }
	        // e. Increase k by 1.
	        k++;
	      }
	
	      // 7. Return -1.
	      return -1;
	    }
	  });
	}
	
	// if (!String.prototype.includes) {
	//   String.prototype.includes = function(search, start) {
	//     'use strict';
	//     if (typeof start !== 'number') {
	//       start = 0;
	//     }
	
	//     if (start + search.length > this.length) {
	//       return false;
	//     } else {
	//       return this.indexOf(search, start) !== -1;
	//     }
	//   };
	// }
	
	Number.isNaN = Number.isNaN || function isNaN(input) {
	  return typeof input === 'number' && input !== input;
	};
	
	if (Number.isFinite === undefined) Number.isFinite = function (value) {
	  return typeof value === 'number' && isFinite(value);
	};

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(181);
	var md5 = __webpack_require__(182);
	var apis = __webpack_require__(186);
	
	function checkStatus(response) {
	  if (response.status >= 200 && response.status < 300) {
	    return response;
	  } else {
	    var error = new Error(response.statusText);
	    error.response = response;
	    throw error;
	  }
	}
	
	function parseJSON(response) {
	  return response.json();
	}
	
	var Request = function () {
	  function Request() {
	    _classCallCheck(this, Request);
	
	    this.apis = apis;
	    this.ReqID = 1000;
	  }
	
	  Request.prototype.createSign = function createSign(params) {
	    var valueArr = [];
	    var signStr = 'sjdxfnqogbzoun13d971ckh8p';
	    if (params) {
	      var sortedObjKeys = Object.keys(params).sort();
	      for (var index in sortedObjKeys) {
	        valueArr.push(params[sortedObjKeys[index]]);
	      }
	    }
	    var timestamp = new Date().getTime();
	    var md5str = signStr + valueArr.join('') + timestamp;
	    var sign = md5(decodeURIComponent(md5str));
	    //console.log('---------md5----------------',sign)
	    var headers = {
	      signature: sign,
	      timestamp: timestamp
	    };
	    return headers;
	  };
	
	  Request.prototype.get = function get(url, params) {
	    var sign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var header = {};
	    if (sign) {
	      header = this.createSign(params);
	    }
	
	    header.appcode = 'com.rjhy.uranus';
	    Object.keys(params).forEach(function (key, idx) {
	      if (idx === 0) url += '?' + key + '=' + params[key];else url += '&' + key + '=' + params[key];
	    });
	    return this.request({
	      url: url,
	      method: 'GET',
	      header: header
	    });
	  };
	
	  Request.prototype.post = function post(url, params) {
	    return this.request({
	      url: url,
	      params: params,
	      method: 'POST',
	      header: {
	        appcode: 'com.rjhy.uranus'
	      }
	    });
	  };
	
	  Request.prototype.postHttp = function postHttp(url, params, token) {
	    this.ReqID++;
	    params.ReqID = this.ReqID;
	    return fetch(url, {
	      method: 'post',
	      body: JSON.stringify(params),
	      headers: {
	        token: token,
	        // 'Accept': 'application/json',
	        'Content-Type': 'application/json',
	        appcode: 'com.rjhy.uranus'
	      }
	    }).then(checkStatus).then(parseJSON);
	  };
	
	  Request.prototype.postForm = function postForm(url, params) {
	    var header = this.createSign(params);
	    header.appcode = 'com.rjhy.uranus';
	    return $.ajax({
	      type: 'POST',
	      headers: Object.assign({
	        'Content-Type': 'application/x-www-form-urlencoded'
	      }, header),
	      url: url,
	      data: params,
	      success: function success(res) {
	        return res;
	      },
	      error: function error(err) {
	        return err;
	      }
	    });
	  };
	
	  Request.prototype.request = function request(opt) {
	    var url = opt.url,
	        params = opt.params,
	        method = opt.method,
	        header = opt.header;
	
	    var headers = {};
	    if (method === 'POST') {
	      headers = this.createSign(params);
	      headers = Object.assign({ 'Content-Type': 'application/json', headers: headers });
	    }
	    headers.appcode = 'com.rjhy.uranus';
	    return fetch(url, {
	      method: method,
	      body: JSON.stringify(params),
	      headers: Object.assign({
	        'Accept': 'application/json'
	      }, header, headers)
	    }).then(checkStatus).then(parseJSON);
	  };
	
	  return Request;
	}();
	
	module.exports = new Request();

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Host = __webpack_require__(187);
	
	var _Host = Host(("production")),
	    activity = _Host.activity,
	    stockDiagnosisHost = _Host.stockDiagnosisHost,
	    gmgQuoteHost = _Host.gmgQuoteHost,
	    quotes = _Host.quotes,
	    money = _Host.money,
	    rankHost = _Host.rankHost,
	    bsSignalHost = _Host.bsSignalHost,
	    circle = _Host.circle,
	    sms = _Host.sms,
	    user = _Host.user,
	    rjhyNewsHost = _Host.rjhyNewsHost,
	    rjhyDynamic = _Host.rjhyDynamic;
	
	var channel = 'channelH5';
	
	module.exports = {
	  quote: {
	    hotSerchAdd: gmgQuoteHost + '/stock/hotSearch/add',
	    queryStockSearch: gmgQuoteHost + '/searchshszv1', // 个股模糊搜索
	    getUsStockData: gmgQuoteHost + '/stock/quotes/getData', // 港股个股简况接口
	    getStockName: gmgQuoteHost + '/getstockname', // 获取个股名称
	    getHkStockData: gmgQuoteHost + '/stock/quotes/getHKStockData', // 港股个股简况接口
	    getFdStockDetail: gmgQuoteHost + '/stock/quotes/getFdStockDetail', // 获取方得股票信息
	    // queryStockSearch: `${gmgQuoteHost}/search`, // 个股模糊搜索
	    getAShareProfile: gmgQuoteHost + '/stock/quotes/getAShareProfile', // A股公司简况
	    getDividendDistribution: gmgQuoteHost + '/stock/quotes/getDividendDistribution', // 分红配送
	    hotSearchV2: gmgQuoteHost + '/stock/hotSearchV2', // 热搜A股股票
	    hotSearchV3: gmgQuoteHost + '/stock/hotSearchV3', // 热搜港美股票
	    getQuoteRankPage: gmgQuoteHost + '/stock/quotes/getQuoteRankPage', // 中概股排行
	    getStockAlarm: gmgQuoteHost + '/stock/alarm/getStockAlarm', // 沪深A股个股异动
	    getStockThemes: gmgQuoteHost + '/stock/quotes/getStockThemes', // 概念机会分析
	    articles: gmgQuoteHost + '/stock/articles', // 查询资讯列表
	    newsOne: gmgQuoteHost + '/report/news/one', // 研报列表
	    ratingInfo: gmgQuoteHost + '/report/rating/info', // 研报评级统计
	    profitInfo: gmgQuoteHost + '/report/profit/info', // 研报盈利评测
	    newsDetail: gmgQuoteHost + '/stock/newsDetail', // 资讯详情
	    detailByNewsId: gmgQuoteHost + '/report/news/detailByNewsId', // 研报详情
	    announcementDetail: gmgQuoteHost + '/stock/announcementDetail', // 公告详情
	    gene: gmgQuoteHost + '/stock/quote/gene', // 涨停基因
	    httpV30: quotes + '/api/v30', // test
	    getBillList: money + '/api/openapi.php/CN_Bill.GetBillList', // 大单 ?num=100000&symbol=sz300344
	    getKline: gmgQuoteHost + '/stock/quote/v1/historyv1',
	    getIeQqzs: gmgQuoteHost + '/stock/quote/v30',
	    getIEKline: gmgQuoteHost + '/stock/quote/v30v2',
	    getStatistics: gmgQuoteHost + '/stock/quote/lastprice',
	    getDayBsSignal: bsSignalHost + '/day/bs/finance',
	    getsigntoken: gmgQuoteHost + '/symbol/getsigntoken', // 获取签名
	    hsFinance: gmgQuoteHost + '/stock/quote/finance/report/detail', // A股财务
	    financeStockQuota: gmgQuoteHost + '/stock/quotes/getStockQuota', // 港美股财务
	    financeStockFinance: gmgQuoteHost + '/stock/quotes/getStockFinance', // 港美股财务
	    getToken: gmgQuoteHost + '/symbol/gettoken', // 一步获取token
	    tradingdays: gmgQuoteHost + '/stock/tradingdays', // 最近交易日 ?market=sh&limit=3
	    stockDetail: gmgQuoteHost + '/stock/detailv1', // 港美个股信息
	    getLv2AdayInfo: gmgQuoteHost + '/stock/quotes/getLv2AdayInfo', // 主力净资金今日
	    getLv2AdayMin: gmgQuoteHost + '/stock/quotes/getLv2AdayMin', // 资金流入今日
	    getLv2Day5Info: gmgQuoteHost + '/stock/quotes/getLv2Day5Info', // 五日流入今日
	    getDynamicConfig: rjhyDynamic + '/config/analysis'
	  },
	  lhb: {
	    rankList: rankHost + '/stock/rank/list', // 每日龙虎榜
	    rankSales: rankHost + '/stock/rank/sales', // 个股龙虎榜营业部数据
	    optionHistory: rankHost + '/sales/option/history', // 营业部历史操作明细
	    salesStop: rankHost + '/stock/rank/sales/top', // 最关注该股营业部
	    rankHistory: rankHost + '/stock/rank/history', // 个股龙虎榜历史明细
	    salesList: rankHost + '/sales/rank/list', // 营业部龙虎榜
	    stockStatis: rankHost + '/stock/statis', // 龙虎榜大数据
	    natureList: rankHost + '/department/nature/list', // 营业部性质列表
	    styleList: rankHost + '/department/style/list', // 营业部操作风格列表
	    search: rankHost + '/search' // 股票营业部检索
	  },
	  zbHttp: {
	    'login': '/v30/login', //  换取token
	    'busi': '/v30/busi' // http 获取 订阅数据的
	  },
	  aiDiagnosis: {
	    summary: stockDiagnosisHost + '/jfztPc/BEEF00C14F8274BE5FACDDA11568F187/summary/stock/diagnosis',
	    coefficientChart: stockDiagnosisHost + '/jfztPc/stock/diagnosis/coefficientChart',
	    fundPerspective: stockDiagnosisHost + '/jfztPc/stock/diagnosis/fundPerspective',
	    cashInflow: stockDiagnosisHost + '/jfztPc/token/period/cash/inflow',
	    bigPerspective: stockDiagnosisHost + '/jfztPc/stock/diagnosis/bigPerspective',
	    newsList: stockDiagnosisHost + '/jfztPc/token/stock/news',
	    valuePerspective: stockDiagnosisHost + '/jfztPc/stock/diagnosis/valuePerspective'
	  },
	  stockBar: {
	    list: circle + '/news/customer/stockbar/list/' + channel, // 股吧列表
	    publish: circle + '/news/customer/publish/stockbar/unaudited/' + channel,
	    detail: circle + '/news/customer/stockbar/detail/' + channel,
	    support: circle + '/review/customer/support/news/' + channel, // 点赞观点
	    unSupport: circle + '/review/customer/unSupport/news/' + channel, // 取消点赞观点
	    supportReview: circle + '/review/customer/support/review/' + channel, // 点赞评论
	    unSupportReview: circle + '/review/customer/unSupport/review/' + channel, // 取消点赞评论
	    publishDetail: circle + '/review/customer/reviews/' + channel,
	    reviewList: circle + '/news/customer/stockbar/review/list/' + channel
	  },
	  sms: {
	    captcha: sms + '/' + channel + '/captcha/sms/freesend'
	  },
	  user: {
	    login: user + '/user/' + channel + '/sms/login'
	  },
	  activity: {
	    activity: activity + '/activities/pages'
	  },
	  news: {
	    getUkIndexNewsList: rjhyNewsHost + '/1/ios/xl/stock/news/list', // 港美指数资讯列表
	    getUkIndexNewsDetail: rjhyNewsHost + '/1/ios/xl/stock/news/detail' // 港美指数资讯详情
	  }
	};

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	'use strict';
	
	var _dev, _production;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function make(hosts) {
	  // Object.keys(hosts).map(key => (hosts[key] += `/${process.env.version}`));
	  return hosts;
	}
	
	var testdomain = 'api';
	var dytestdomain = 'dyapi';
	var moneydomain = '/money';
	
	var pdomain = '/gmg';
	var domain = '//test-gateway.jinyi999.cn';
	// const prodDomain = `//gateway.jinyi999.cn`;
	
	var general = {
	  mock: 'http://' + domain
	};
	
	var dev = (_dev = {
	  stockQuoteHost: domain + '/rjhy-stock-quote/api/1',
	  rankHost: domain + '/rjhy-stock-rank/api/1/jfzt',
	  gmgQuoteHost: pdomain + '/rjhy-gmg-quote/api/1',
	  rjhyNewsHost: domain + '/rjhy-news/api'
	}, _defineProperty(_dev, 'stockQuoteHost', domain + '/rjhy-stock-quote/api/1'), _defineProperty(_dev, 'stockDiagnosisHost', pdomain + '/rjhy-stock-diagnosis/api/1'), _defineProperty(_dev, 'bsSignalHost', pdomain + '/node-stock-finance-service'), _defineProperty(_dev, 'quotes', '' + dytestdomain), _defineProperty(_dev, 'money', '' + moneydomain), _defineProperty(_dev, 'circle', pdomain + '/rjhy-circle/api/1'), _defineProperty(_dev, 'sms', pdomain + '/rjhy-sms/api/1'), _defineProperty(_dev, 'user', pdomain + '/rjhy-user/api/1'), _defineProperty(_dev, 'activity', domain + '/rjhy-activity-manage/api/v1'), _defineProperty(_dev, 'rjhyDynamic', domain + '/rjhy-dynamic/api/1'), _dev);
	
	var test = {};
	
	var preview = {};
	
	var production = (_production = {
	  // https://stockhq-aliyun.caixun99.com/curhq/QueryStockPriceVolume
	  stockQuoteHost: pdomain + '/rjhy-stock-quote/api/1',
	  rankHost: pdomain + '/rjhy-stock-rank/api/1/jfzt',
	  gmgQuoteHost: pdomain + '/rjhy-gmg-quote/api/1',
	  rjhyNewsHost: pdomain + '/rjhy-news/api'
	}, _defineProperty(_production, 'stockQuoteHost', pdomain + '/rjhy-stock-quote/api/1'), _defineProperty(_production, 'stockDiagnosisHost', pdomain + '/rjhy-stock-diagnosis/api/1'), _defineProperty(_production, 'bsSignalHost', pdomain + '/node-stock-finance-service'), _defineProperty(_production, 'quotes', '' + dytestdomain), _defineProperty(_production, 'money', '' + moneydomain), _defineProperty(_production, 'circle', pdomain + '/rjhy-circle/api/1'), _defineProperty(_production, 'sms', pdomain + '/rjhy-sms/api/1'), _defineProperty(_production, 'user', pdomain + '/rjhy-user/api/1'), _defineProperty(_production, 'activity', pdomain + '/rjhy-activity-manage/api/v1'), _defineProperty(_production, 'rjhyDynamic', pdomain + '/rjhy-dynamic/api/1'), _production);
	
	module.exports = function (env) {
	  return make({
	    dev: dev,
	    test: test,
	    preview: preview,
	    production: production
	  }[env]);
	};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * CANNOT use `import` to import `react` or `react-dom`,
	 * because `import` will run `react` before `require('es5-shim')`.
	 */
	var React = __webpack_require__(27);
	
	var request = __webpack_require__(180);
	var debounce = __webpack_require__(190);
	var Qqzs = __webpack_require__(204);
	
	var _require = __webpack_require__(206),
	    getColor = _require.getColor,
	    goSymbolHtml = _require.goSymbolHtml;
	// let jquery = require('jquery')
	
	
	var $ = __webpack_require__(205);
	
	var searchVal = '';
	var searchIndex = 0;
	var marketTypes = {
	  A: ['sh', 'sz'],
	  HK: ['NASDAQ', 'HKSE', 'NYSE', 'AMEX', 'HKIDX'],
	  US: ['NASDAQ', 'HKSE', 'NYSE', 'AMEX', 'HKIDX']
	};
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {
	      data: [1, 2, 3, 4],
	      searchList: [],
	      noData: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    // if ($) {
	    this.registerScroll();
	    // }
	    // // let scrollInterval = setInterval(() => {
	    // //   if ($) {
	    // //     clearInterval(scrollInterval)
	    // //     this.registerScroll()
	    // //   }
	    // // }, 100)
	
	    // hk
	    var data = [{
	      name: '恒生指数',
	      market: 'HKIDX',
	      code: '.HSI'
	    }, {
	      name: '国企指数',
	      market: 'HKIDX',
	      code: '.HSCE'
	    }, {
	      name: '红筹指数',
	      market: 'HKIDX',
	      code: '.HSCC'
	    }];
	    if (this.props.dataSourceType === 'US') {
	      data = [{
	        name: '道琼斯ETF',
	        market: 'AMEX',
	        code: 'DIA'
	      }, {
	        name: '纳斯达克ETF',
	        market: 'NASDAQ',
	        code: 'QQQ'
	      }, {
	        name: '标普500ETF',
	        market: 'AMEX',
	        code: 'SPY'
	      }];
	    }
	
	    this.setState({
	      data: data,
	      searchlistStyle: 'none'
	    });
	
	    var _this = this;
	    window.onclick = function (e) {
	      if (e.target.className != 'span--stock-name' && e.target.className != 'input--search') {
	        _this.setState({
	          searchlistStyle: 'none'
	        });
	        $('.input--search').val('');
	      }
	    };
	  },
	
	  registerScroll: function registerScroll() {
	    $(window).on('scroll', function (val) {
	      console.log(val);
	      if (window.scrollY > 0) {
	        $('.block--header-logo-wrap').css({ opacity: .8 });
	      } else {
	        $('.block--header-logo-wrap').css({ opacity: 1 });
	      }
	    });
	  },
	
	  handleInputChange: function handleInputChange(e) {
	    searchVal = e.target.value;
	    if (searchVal.length > 0) {
	      this.getSearchData(searchVal);
	    } else {
	      this.setState({ searchList: [], searchlistStyle: 'none' });
	    }
	  },
	
	  getSearchData: debounce(function (val) {
	    var _this2 = this;
	
	    if (searchVal.length > 0) {
	      var dcidx = searchIndex++;
	      request.get(request.apis.quote.queryStockSearch, {
	        keyword: encodeURIComponent(val),
	        pageNo: 0,
	        pageSize: 100,
	        types: 'stock',
	        markets: marketTypes.HK
	      }).then(function (res) {
	        if (dcidx === searchIndex - 1) {
	          if (res && res.data && res.data.stock && res.data.stock.length) {
	            _this2.setState({
	              searchlistStyle: 'block',
	              noData: false
	            });
	            _this2.forceUpdate(_this2.setState({
	              searchList: res.data.stock
	            }));
	          } else {
	            _this2.setState({ noData: true });
	          }
	        }
	      });
	    }
	  }, 300),
	
	  onSelectStock: function onSelectStock(item, e) {
	    var _this3 = this;
	
	    var Market = item.Market,
	        _Symbol = item.Symbol;
	    // window.open(`index.html?symbol=${Symbol}&market=${Market}`)
	    // Object.assign(document.createElement('a'), { target: '_blank', href: `index.html?symbol=${Symbol}&market=${Market}&name=${Name}`}).click();
	
	    request.post(request.apis.quote.hotSerchAdd, {
	      market: Market,
	      symbol: _Symbol
	    }).then(function () {
	      _this3.setState({
	        searchlistStyle: 'none'
	      });
	      $('.input--search').val('');
	    });
	    // hotSerchAdd
	    goSymbolHtml(Market.toUpperCase(), _Symbol.toString().toUpperCase());
	  },
	
	  onSearchBlur: function onSearchBlur() {},
	
	  onSearchFocus: function onSearchFocus() {
	    if (this.state.searchList.length) {
	      this.setState({
	        searchlistStyle: 'block'
	      });
	    }
	  },
	
	  gettoFixNum: function gettoFixNum() {
	    return this.props.dataSourceType === 'US' ? 3 : 2;
	  },
	
	  goStockIndex: function goStockIndex(i) {
	    var stock = this.state.data[i];
	    if (true) {
	      window.open('/zsindex/' + stock.market + '_' + stock.code + '.html');
	    } else {
	      window.open('zsIndex.html?market=' + stock.market + '&symbol=' + stock.code);
	    }
	  },
	
	
	  render: function render() {
	    var _this4 = this;
	
	    var qqzs = this.props.qqzs;
	    var staticqqzs = this.props.staticqqzs;
	    var isLoad = Object.keys(staticqqzs).every(function (key) {
	      return Object.keys(staticqqzs[key]).length > 0;
	    });
	
	    var lis = [];
	    this.state.data.forEach(function (d, index) {
	      lis.push(React.createElement(
	        'li',
	        { key: index, className: 'float-left' },
	        d.name
	      ));
	    });
	    var searchList = [];
	
	    this.state.searchList.forEach(function (i, index) {
	      searchList.push(React.createElement(
	        'li',
	        { key: index, className: 'block--stock-item', onClick: function onClick(e) {
	            return _this4.onSelectStock(i, e);
	          } },
	        React.createElement(
	          'span',
	          { style: { marginRight: '10px' } },
	          i.Exchange.slice(0, 2)
	        ),
	        React.createElement(
	          'span',
	          null,
	          i.Symbol
	        ),
	        React.createElement(
	          'span',
	          { className: 'span--stock-name' },
	          i.Name
	        )
	      ));
	    });
	
	    return React.createElement(
	      'div',
	      { className: 'block--header-wrap' },
	      React.createElement(
	        'div',
	        { className: 'block--header-logo-wrap', style: { background: '#03112b' } },
	        React.createElement(
	          'div',
	          { className: 'block--header' },
	          React.createElement(
	            'div',
	            { className: 'logo clearfix', style: { "float": 'left' } },
	            React.createElement(
	              'a',
	              { href: 'http://www.richbays.com.cn/' },
	              React.createElement('img', { style: { "float": 'left', height: '30px', paddingRight: '13px' }, src: 'https://rjhy-gmg-oss.oss-cn-shanghai.aliyuncs.com/web/richbays/img/logo.png', alt: '', className: 'brand' }),
	              React.createElement(
	                'span',
	                { style: { borderLeft: '1px solid #fff', paddingLeft: '13px', "float": 'left', height: '30px', lineHeight: '30px', color: '#fff', fontSize: '17px' } },
	                '\u4E13\u4E1A\u7684\u6E2F\u7F8E\u80A1\u6295\u8D44\u670D\u52A1'
	              )
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'clearfix', style: { "float": 'right', paddingRight: '130px' } },
	            React.createElement(
	              'a',
	              { className: 'header-tag', target: 'window_view', style: { marginRight: '40px' }, href: 'http://www.richbays.com.cn/home.html' },
	              ' \u9996\u9875 '
	            ),
	            React.createElement(
	              'a',
	              { className: 'header-tag', target: 'window_view', style: { marginRight: '40px' }, href: 'http://www.richbays.com.cn/download.html' },
	              ' \u4E0B\u8F7D '
	            ),
	            React.createElement(
	              'a',
	              { className: 'header-tag', target: 'window_view', style: { marginRight: '40px' }, href: 'http://www.richbays.com.cn/help.html' },
	              ' \u5E2E\u52A9\u4E2D\u5FC3 '
	            ),
	            React.createElement(
	              'a',
	              { className: 'header-tag', target: 'window_view', style: { marginRight: '40px' }, href: 'http://www.richbays.com.cn/about.html' },
	              ' \u5173\u4E8E\u6211\u4EEC '
	            ),
	            React.createElement(
	              'a',
	              { className: 'header-tag', target: 'window_view', href: '//s.richbays.com/4ZwkZp' },
	              ' \u624B\u673A\u5F00\u6237 '
	            )
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { style: { height: '33px', width: '1000px', margin: '0 auto' } },
	        React.createElement(Qqzs, null)
	      ),
	      this.props.hideSearch ? '' : React.createElement(
	        'div',
	        { className: 'input--search-wrap clearfix', style: { width: '1000px', margin: '0 auto', background: '#fff' } },
	        React.createElement('input', { onChange: this.handleInputChange, onPropertychange: this.handleInputChange, onBlur: function onBlur(e) {
	            return _this4.onSearchBlur(e);
	          }, onFocus: this.onSearchFocus, className: 'input--search', placeholder: '\u80A1\u7968\u4EE3\u7801/\u540D\u79F0/\u7B80\u62FC', type: 'text', style: { "float": 'right', marginRight: '10px' } }),
	        React.createElement('img', { className: 'block--icon-search', src: __webpack_require__(212), alt: '' }),
	        this.state.noData ? React.createElement(
	          'div',
	          { className: 'searchnodata-block' },
	          '\u6682\u65E0\u5339\u914D\u4FE1\u606F'
	        ) : React.createElement(
	          'ul',
	          { className: 'ul--search-lists', style: { display: this.state.searchlistStyle } },
	          searchList
	        )
	      )
	    );
	  }
	});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(27);
	var $ = __webpack_require__(205);
	
	var _require = __webpack_require__(206),
	    getColor = _require.getColor,
	    goSymbolHtml = _require.goSymbolHtml;
	
	var _ref = typeof window.WebSocket === 'function' ? __webpack_require__(208) : {},
	    ws = _ref.ws;
	
	var request = __webpack_require__(180);
	var isIe = document.documentMode < 10 ? true : false;
	var ReqId = 1;
	var delayIndexSymbol = ['QQQ', 'DIA', 'SPY', '.HSI', '.HSCE', '.HSCC'];
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {
	      zsIndexs: [{ label: '上证指数', symbol: '000001', market: 'sh' }, { label: '深证成指', symbol: '399001', market: 'sz' }, { label: '创业板指', symbol: '399006', market: 'sz' }, { label: '恒生指数', symbol: '.HSI', market: 'HKIDX' }, { label: '国企指数', symbol: '.HSCE', market: 'HKIDX' }, { label: '红筹指数', symbol: '.HSCC', market: 'HKIDX' }, { label: '纳斯达克ETF', symbol: 'QQQ', market: 'NASDAQ' }, { label: '标普500ETF', symbol: 'SPY', market: 'AMEX' }, { label: '道琼斯ETF', symbol: 'DIA', market: 'AMEX' }, { label: '日经225', symbol: 'N225', market: 'ASIDX' }, { label: '德国DAX', symbol: 'GDAXI', market: 'EUIDX' }, { label: '英国富时100', symbol: 'FTSE', market: 'EUIDX' }]
	    };
	  },
	
	  toFixed: function toFixed(num, nullStr) {
	    if (typeof num === 'number' && num !== NaN) {
	      return num.toFixed(2);
	    } else if (nullStr) {
	      return nullStr;
	    } else return '--';
	  },
	
	  getColor: function getColor(num) {
	    if (num > 0) {
	      return '#D4332F';
	    } else if (num === 0) {
	      return '#666';
	    } else return '#258d01';
	  },
	  wsInit: function wsInit() {
	    ws.init();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.initView(); // 挂载dom
	    // if (!isIe) {
	    this.wsInit();
	    this.unSocket(); // 清理 可能存在的链接
	    this.subscribeIndex(); // 创建指数的链接  
	    this.socketOnEvent(); // 连接后消息处理
	    // } else {
	    //   this.ieInit()
	    //   ieInterval = setInterval(this.ieInit, 5000)
	    // }
	  },
	
	  subscribeIndex: function subscribeIndex() {
	    this.state.zsIndexs.forEach(function (item) {
	      var symbol = item.symbol,
	          market = item.market;
	
	      var tmpMarket = delayIndexSymbol.includes(symbol) ? 'DELAY_' + market : market;
	      ws.websocket.safeSubscribeDYNA(symbol, tmpMarket);
	      ws.websocket.safeSubscribeSTATISTICS(symbol, tmpMarket);
	    });
	  },
	
	  unSocket: function unSocket() {
	    this.state.zsIndexs.forEach(function (item) {
	      var symbol = item.symbol,
	          market = item.market;
	
	      var tmpMarket = delayIndexSymbol.includes(symbol) ? 'DELAY_' + market : market;
	      ws.websocket.safeUnsubscribeDYNA(symbol, tmpMarket);
	      ws.websocket.safeUnsubscribeSTATISTICS(symbol, tmpMarket);
	    });
	  },
	
	  loop: function loop(obj, cb) {
	    ReqId++;
	    var dyna = new Promise(function (resolve, reject) {
	      $.ajax({
	        type: "POST",
	        url: url,
	        data: JSON.stringify({
	          ReqId: ReqId,
	          Market: obj.market,
	          Inst: obj.symbol,
	          ServiceType: "DYNA"
	        }),
	        dataType: 'json',
	        contentType: "application/json",
	        success: function success(res) {
	          return resolve(res);
	        }
	      });
	    });
	    ReqId++;
	    var statistics = new Promise(function (resolve, reject) {
	      $.ajax({
	        type: "POST",
	        url: url,
	        data: JSON.stringify({
	          ReqId: ReqId,
	          Market: obj.market,
	          Inst: obj.symbol,
	          ServiceType: "STATISTICS"
	        }),
	        dataType: 'json',
	        contentType: "application/json",
	        success: function success(res) {
	          return resolve(res);
	        }
	      });
	    });
	    return Promise.all([dyna, statistics]);
	  },
	
	  headerIsChange: function headerIsChange() {
	    var _this = this;
	
	    this.state.zsIndexs.forEach(function (item) {
	      if (item.dyna && item.statistics) {
	        // alert('?')
	        var market = item.market,
	            symbol = item.symbol;
	        var _item$dyna = item.dyna,
	            _item$dyna$Updown = _item$dyna.Updown,
	            Updown = _item$dyna$Updown === undefined ? null : _item$dyna$Updown,
	            _item$dyna$LastPrice = _item$dyna.LastPrice,
	            LastPrice = _item$dyna$LastPrice === undefined ? null : _item$dyna$LastPrice;
	        var _item$statistics$PreC = item.statistics.PreClosePrice,
	            PreClosePrice = _item$statistics$PreC === undefined ? null : _item$statistics$PreC;
	
	        var domSelector = market + symbol.replace('.', '');
	        $('.' + domSelector + '_index .price').text(_this.toFixed(LastPrice, '----')).css({ color: _this.getColor(Updown) });
	        $('.' + domSelector + '_index .changePrice').html(LastPrice ? (Updown > 0 ? '&uarr;' : '&darr;') + _this.toFixed(LastPrice - PreClosePrice, '----') : '----').css({ color: _this.getColor(Updown) });
	        $('.' + domSelector + '_index .upDown').text(_this.toFixed(Updown * 100, '--') + '%').css({ color: _this.getColor(Updown) });
	      }
	    });
	  },
	  socketOnEvent: function socketOnEvent() {
	    var _this2 = this;
	
	    ws.websocket.on('onDYNA', function (msg) {
	      var tmpMarket = msg.Market.replace('DELAY_', '');
	      _this2.state.zsIndexs.filter(function (_) {
	        return _.market.toLowerCase() + _.symbol.toLowerCase() === tmpMarket.toLowerCase() + msg.Inst.toLowerCase();
	      }).map(function (item) {
	        item.dyna = msg.QuoteData.DynaData[0] || {};
	        return item;
	      });
	      _this2.headerIsChange();
	    });
	
	    ws.websocket.on('onSTATISTICS', function (msg) {
	      var tmpMarket = msg.Market.replace('DELAY_', '');
	      _this2.state.zsIndexs.filter(function (_) {
	        return _.market.toLowerCase() + _.symbol.toLowerCase() === tmpMarket.toLowerCase() + msg.Inst.toLowerCase();
	      }).map(function (item) {
	        item.statistics = msg.QuoteData.StatisticsData[0] || {};
	        return item;
	      });
	      _this2.headerIsChange();
	    });
	  },
	
	  initView: function initView() {
	    var _this3 = this;
	
	    var swhtml = '\n    <div class="swiper-container" id="global-stockindex-swiper" style="height:33px;">\n      <div class="stock-all-swiper-content" style="width: 18000px;position:relative;left:0px;">';
	    // <div class="swiper-wrapper" style="width:3348px;position:relative;left:0px">`
	    var contentHtml1 = '<div class="swiper-wrapper" style="width:auto;float:left">';
	    var contentHtml2 = '<div class="swiper-wrapper" style="width:auto;float:left">';
	    this.state.zsIndexs.forEach(function (item, index) {
	      var market = item.market,
	          symbol = item.symbol,
	          label = item.label;
	
	      contentHtml1 += '\n      <div class="' + (market + symbol.replace('.', '')) + '_index_all swiper-slide" style="float:left;cursor:' + (['ASIDX', 'EUIDX'].indexOf(market) === -1 ? 'pointer' : 'unset') + ';">\n        <p class="' + (market + symbol.replace('.', '')) + '_index" style="width: 285px;">\n          ' + (['ASIDX', 'EUIDX'].indexOf(market) === -1 ? '<a class="stock-index-label">' + label + '\uFF1A</a>' : '<span class="stock-index-label-nor">' + label + '\uFF1A</span>') + '\n          <span class="price"></span>\n          <span class="changePrice"></span>\n          <span class="upDown"></span>\n        </p>\n      </div>\n    ';
	      contentHtml2 += '\n      <div class="' + (market + symbol.replace('.', '')) + '_index_all swiper-slide" style="float:left;cursor:' + (['ASIDX', 'EUIDX'].indexOf(market) === -1 ? 'pointer' : 'unset') + ';">\n        <p class="' + (market + symbol.replace('.', '')) + '_index" style="width: 285px;">\n          ' + (['ASIDX', 'EUIDX'].indexOf(market) === -1 ? '<a class="stock-index-label">' + label + '\uFF1A</a>' : '<span class="stock-index-label-nor">' + label + '\uFF1A</span>') + '\n          <span class="price"></span>\n          <span class="changePrice"></span>\n          <span class="upDown"></span>\n        </p>\n      </div>\n    ';
	
	      setTimeout(function () {
	        if (['ASIDX', 'EUIDX'].indexOf(market) === -1) {
	          $('.' + (market + symbol.replace('.', '')) + '_index_all').off('click').on('click', function () {
	            _this3.getIndexHtml(market, symbol);
	          });
	        }
	      }, 100);
	    });
	    contentHtml1 += '</div>';
	    contentHtml2 += '</div>';
	    swhtml += '\n        ' + contentHtml1 + '\n        ' + contentHtml2 + '\n      </div>\n    </div>\n  ';
	    $('.stock-swiper-content').append(swhtml);
	    this.startAnimate();
	  },
	
	  getIndexHtml: function getIndexHtml(market, symbol) {
	    if (market === 'sh' || market === 'sz') {
	      return window.open('https://stock.9fzt.com/zsindex/' + market + '_' + symbol + '.html');
	    } else if (market === 'HKIDX' || market == 'NASDAQ' || market === 'AMEX') {
	      return goSymbolHtml(market, symbol);
	    }
	  },
	
	  startAnimate: function startAnimate() {
	    var _this4 = this;
	
	    var leftval = $('#global-stockindex-swiper .stock-all-swiper-content').attr('style').match(/(left|LEFT):.*/)[0];
	    var left = leftval.match(/\d{1,6}/)[0];
	    var animates = 3348 - left;
	    var stockIndexAnimate = $('#global-stockindex-swiper .stock-all-swiper-content').animate({
	      left: '-3348px'
	    }, animates * 20, 'linear', function () {
	      $('#global-stockindex-swiper .stock-all-swiper-content').css({ left: 0 });
	      _this4.startAnimate();
	    });
	
	    $('.stock-swiper-content').off('mouseover').on('mouseover', function () {
	      stockIndexAnimate.stop();
	    });
	    $('.stock-swiper-content').off('mouseout').on('mouseout', function () {
	      _this4.startAnimate();
	    });
	  },
	
	  ieInit: function ieInit() {
	    var _this5 = this;
	
	    this.state.zsIndexs.forEach(function (index) {
	      _this5.loop(index).then(function (res) {
	        index.dyna = res[0].QuoteData.DynaData[0];
	        index.statistics = res[1].QuoteData.StatisticsData[0];
	        _this5.headerIsChange();
	      });
	    });
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'stock-swiper-content', style: { width: '100%', lineHeight: '33px' } },
	      React.createElement('i', { style: { marginRight: "8px" }, className: 'global_earth-icon' }),
	      React.createElement(
	        'span',
	        { style: { color: '#001F64', marginRight: '16px' } },
	        '\u5168\u7403\u6307\u6570'
	      ),
	      React.createElement(
	        'span',
	        null,
	        '>>'
	      )
	    );
	  }
	
	});

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(207),
	    getIsIndexStock = _require.getIsIndexStock,
	    getIsUkIndexStock = _require.getIsUkIndexStock,
	    getIsAIndexStock = _require.getIsAIndexStock;
	
	var units = {
	  '万亿': 1000000000000,
	  '十亿': 1000000000,
	  '亿': 100000000,
	  '千万': 10000000,
	  '万': 10000,
	  '千': 1000
	
	  /**
	   *数据以个位数为单位时适用
	   * @param {
	   * val
	   * base: 换算基数单位
	   * unitText: 是否拼接单位名
	   * hasPrecision: 不到万位的是否要小数点
	   * }
	   */
	};module.exports.formatVolume = function (val) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	  var fixedUnit = arguments[2];
	
	  var number = +val;
	  if (!number && number !== 0) return '--';
	  var value = Math.ceil(val / base);
	  if (value > 100000) {
	    return (value / 10000).toFixed(fixedUnit || 0) + '\u4E07';
	  } else if (value > 10000) {
	    return (value / 10000).toFixed(fixedUnit || 1) + '\u4E07';
	  } else {
	    return value.toFixed(fixedUnit || 0);
	  }
	};
	
	/**
	 *数据以个位数为单位时适用
	 * @param {
	 * val
	 * base: 换算基数单位
	 * unitText: 是否拼接单位名
	 * hasPrecision: 不到万位的是否要小数点
	 * }
	 */
	module.exports.formatUnit = function (val, base) {
	  var unitText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
	  var hasPrecision = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  var number = +val;
	  if (!number && number !== 0) return '--';
	  var absValue = Math.abs(val);
	  if (base) {
	    if (/^\d+$/.test(base)) {
	      return '' + (val - 0).toFixed(base);
	    }
	    return '' + (val / units[base]).toFixed(2) + (unitText ? base : '');
	  }
	  if (absValue > 1000000000000) {
	    return '' + (number / 1000000000000).toFixed(2) + (unitText ? '万亿' : '');
	  } else if (absValue > 100000000) {
	    return '' + (number / 100000000).toFixed(2) + (unitText ? '亿' : '');
	  } else if (absValue > 10000000) {
	    return '' + (number / 10000000).toFixed(2) + (unitText ? '千万' : '');
	  } else if (absValue > 10000) {
	    return '' + (number / 10000).toFixed(2) + (unitText ? '万' : '');
	  } else {
	    return hasPrecision ? number.toFixed(precision) : number;
	  }
	};
	
	/**
	 *数据以个位数为单位时适用
	 * @param {
	 * val
	 * base: 换算基数单位
	 * unitText: 是否拼接单位名
	 * hasPrecision: 不到万位的是否要小数点
	 * }
	 */
	module.exports.lhbFormatUnit = function (val, base) {
	  var unitText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
	  var hasPrecision = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  var number = +val;
	  if (!number) return '--';
	  var absValue = Math.abs(val);
	  if (base) {
	    if (/^\d+$/.test(base)) {
	      return '' + (val - 0).toFixed(base);
	    }
	    return '' + (val / units[base]).toFixed(2) + (unitText ? base : '');
	  }
	  if (absValue > 1000000000000) {
	    return '' + ((number / 1000000000000).toFixed(2) % 1 === 0 ? (number / 1000000000000).toFixed(0) : (number / 1000000000000).toFixed(2)) + (unitText ? '万亿' : '');
	  } else if (absValue > 100000000) {
	    return '' + ((number / 100000000).toFixed(2) % 1 === 0 ? (number / 100000000).toFixed(0) : (number / 100000000).toFixed(2)) + (unitText ? '亿' : '');
	    // } else if (absValue > 10000000) {
	    //   return `${(number / 10000000).toFixed(2)}${unitText ? '千万' : ''}`
	  } else if (absValue > 10000) {
	    return '' + ((number / 10000).toFixed(2) % 1 === 0 ? (number / 10000).toFixed(0) : (number / 10000).toFixed(2)) + (unitText ? '万' : '');
	  } else {
	    return hasPrecision ? number % 1 === 0 ? number : number.toFixed(precision) : number;
	  }
	};
	
	module.exports.toFixed = function (val) {
	  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  return val ? val.toFixed(num) : 0;
	};
	
	// long 转换成时分秒
	module.exports.dateLongToDate = function (datelong) {
	  var date = new Date(datelong);
	  return date.getHours().toString().padStart(2, 0) + ':' + date.getMinutes().toString().padStart(2, 0) + ':' + date.getSeconds().toString().padStart(2, 0);
	};
	
	var dateLongToMinute = function dateLongToMinute(datelong) {
	  var date = new Date(datelong);
	  return date.getHours().toString().padStart(2, 0) + ':' + date.getMinutes().toString().padStart(2, 0);
	};
	
	// long 转换成时分
	module.exports.dateLongToMinute = function (value) {
	  return dateLongToMinute(value);
	};
	
	var getTimesForDate = function getTimesForDate(dateStr) {
	  if (typeof dateStr === 'number') return;
	  var nowday = new Date();
	  var day = dateStr.split(' ')[0].split('-');
	  var times = dateStr.split(' ')[1].split(':');
	  // 非科学判断，仅从 月 日 和 周几 完全一致来进行判断，很少出现
	  // nowday.getMonth() === day.getMonth() && 
	  if (nowday.getMonth() + 1 === +day[1] && nowday.getDate() === +day[2]) {
	    return times[0].toString().padStart(2, 0) + ':' + times[1].toString().padStart(2, 0);
	  } else {
	    return day[1].toString().padStart(2, 0) + '-' + day[2].toString().padStart(2, 0) + ' ' + times[0].toString().padStart(2, 0) + ':' + times[1].toString().padStart(2, 0);
	  }
	};
	
	// long 转换为时间，如果为当天则获取 时：分， 否则 月-日 时：分
	module.exports.getTimesForDate = function (value) {
	  getTimesForDate(value);
	};
	
	var getTimesYYYYForDate = function getTimesYYYYForDate(dateStr) {
	  var nowday = new Date();
	  var day = dateStr.split(' ')[0].split('-');
	  var times = dateStr.split(' ')[1].split(':');
	  // 非科学判断，仅从 月 日 和 周几 完全一致来进行判断，很少出现
	  // nowday.getMonth() === day.getMonth() && 
	
	  if (nowday.getMonth() + 1 === +day[1] && nowday.getDate() === +day[2]) {
	    return times[0].toString().padStart(2, 0) + ':' + times[1].toString().padStart(2, 0);
	  } else {
	    return day[0].toString() + '-' + day[1].toString().padStart(2, 0) + '-' + day[2].toString().padStart(2, 0) + ' ' + times[0].toString().padStart(2, 0) + ':' + times[1].toString().padStart(2, 0);
	  }
	};
	
	// long 转换为时间，如果为当天则获取 时：分， 否则 月-日 时：分
	module.exports.getTimesYYYYForDate = function (value) {
	  getTimesYYYYForDate(value);
	};
	
	// long 转换为时间，如果为当天则获取 时：分， 否则 月-日 时：分
	module.exports.getTimesForDatelong = function (datelong) {
	  var day = new Date(datelong);
	  return day.getFullYear() + '-' + (day.getMonth() + 1).toString().padStart(2, 0) + '-' + day.getDate().toString().padStart(2, 0);
	};
	
	var getDateStringForLong = function getDateStringForLong(datelong) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var day = new Date(datelong);
	  return '' + day.getFullYear() + val + (day.getMonth() + 1).toString().padStart(2, 0) + val + day.getDate().toString().padStart(2, 0);
	};
	
	var getMonthDateStringForLong = function getMonthDateStringForLong(datelong) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var day = new Date(datelong);
	  return '' + (day.getMonth() + 1).toString().padStart(2, 0) + val + day.getDate().toString().padStart(2, 0) + ' ' + day.getHours().toString().padStart(2, 0) + ':' + day.getMinutes().toString().padStart(2, 0);
	};
	
	var getMmDdStringForLong = function getMmDdStringForLong(datelong) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var day = new Date(datelong);
	  return '' + (day.getMonth() + 1).toString().padStart(2, 0) + val + day.getDate().toString().padStart(2, 0);
	};
	
	module.exports.getMonthDateStringForLong = function (datelong) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  return getMmDdStringForLong(datelong, val);
	};
	
	// 字符串时间转换为 month-day
	module.exports.getDateStringForMonth = function (datelong) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var day = new Date(datelong);
	  return '' + (day.getMonth() + 1).toString().padStart(2, 0) + val + day.getDate().toString().padStart(2, 0);
	};
	
	module.exports.getTodayYesterday = function (value) {
	  if (!value) return '';
	  var date = value instanceof Date ? value : new Date(value);
	  var today = new Date();
	  var yesterday = new Date();
	  yesterday.setDate(yesterday.getDate() - 1);
	
	  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
	    return dateLongToMinute(value);
	  } else if (date.getFullYear() === yesterday.getFullYear()) {
	    if (typeof value === 'number') {
	      return getMonthDateStringForLong(value);
	    } else {
	      return getTimesForDate(value);
	    }
	  } else {
	    return getDateStringForLong(value);
	  }
	};
	
	module.exports.getTodayYesterdayPlus = function (value) {
	  if (!value) return '';
	  var date = value instanceof Date ? value : new Date(value);
	  var today = new Date();
	  var yesterday = new Date();
	  yesterday.setDate(yesterday.getDate() - 1);
	
	  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
	    return dateLongToMinute(value);
	  } else if (date.getFullYear() === yesterday.getFullYear()) {
	    if (typeof value === 'number') {
	      return getMonthDateStringForLong(value);
	    } else {
	      return getTimesForDate(value);
	    }
	  } else {
	    return getDateStringForLong(value);
	  }
	};
	
	// 字符串时间转换为 year-month-day
	module.exports.getDateStringForLong = function (value) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  return getDateStringForLong(value, val);
	};
	
	// 字符串时间非今年转换为 year-month-day，今年转换为month-day
	module.exports.getMMDD = function (value) {
	  var part = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  if (!value) return '';
	  var date = value instanceof Date ? value : new Date(value);
	  var today = new Date();
	  var y = date.getFullYear();
	  if (date.getFullYear() === today.getFullYear()) {
	    // return `${now.getFullYear().toString()}${part}${(now.getMonth()+1).toString().padStart(2, 0)}${part}${now.getDate().toString().padStart(2, 0)}`
	
	    return '' + (date.getMonth() + 1).toString().padStart(2, 0) + part + date.getDate().toString().padStart(2, 0);
	  } else {
	    return '' + date.getFullYear().toString() + part + (date.getMonth() + 1).toString().padStart(2, 0) + part + date.getDate().toString().padStart(2, 0);
	  }
	};
	
	module.exports.getYmdHsForLong = function (value) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var n = new Date(value);
	  return n.getFullYear() + '-' + (n.getMonth() + 1).toString().padStart(2, 0) + '-' + n.getDate().toString().padStart(2, 0) + ' ' + n.getHours().toString().padStart(2, 0) + ':' + n.getMinutes().toString().padStart(2, 0);
	};
	
	module.exports.getIsToday = function (value) {
	  if (!value) return false;
	  var date = value instanceof Date ? value : new Date(value);
	  var today = new Date();
	
	  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
	    return true;
	  } else return false;
	};
	
	// long to 
	module.exports.getYYYYMMDDHHMMSS = function (time) {
	  var now = new Date();
	  if (time) now = new Date(time);
	  // let now = new Date()
	  return now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, 0) + '-' + now.getDate().toString().padStart(2, 0) + ' ' + now.getHours().toString().padStart(2, 0) + ':' + now.getMinutes().toString().padStart(2, 0);
	};
	
	module.exports.getYYYYMMDD = function (time) {
	  var now = new Date();
	  if (time) now = new Date(time);
	  // let now = new Date()
	  return now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, 0) + '-' + now.getDate().toString().padStart(2, 0);
	};
	
	module.exports.longToYYMMDD = function (long, partter) {
	  var now = new Date(long);
	  var part = partter || '/';
	  return '' + now.getFullYear().toString().slice(2, 4) + part + (now.getMonth() + 1).toString().padStart(2, 0) + part + now.getDate().toString().padStart(2, 0);
	};
	
	module.exports.longToYYYYMMDD = function (long, partter) {
	  var now = new Date(long);
	  var part = partter || '/';
	  return '' + now.getFullYear().toString() + part + (now.getMonth() + 1).toString().padStart(2, 0) + part + now.getDate().toString().padStart(2, 0);
	};
	
	// long to 
	module.exports.getHHMM = function (long) {
	  var now = new Date(long);
	  return now.getHours().toString().padStart(2, 0) + ':' + now.getMinutes().toString().padStart(2, 0);
	};
	
	module.exports.getColor = function (up) {
	  if (up > 0) {
	    return '#eb0000';
	  } else if (up < 0) {
	    return '#249000';
	  } else {
	    return '';
	  }
	};
	
	var trade = {
	  1: '开市中',
	  2: '开市中',
	  3: '盘中',
	  4: '已收盘',
	  5: '午间休市',
	  6: '停牌中',
	  7: '集合竞价',
	  8: '熔断中',
	  9: '日间竞价',
	  10: '集合竞价',
	  11: '',
	  12: '已收盘',
	  13: '已收盘',
	  14: '已收盘',
	  15: '报价',
	  16: '停牌',
	  17: '停牌',
	  18: '停牌',
	  19: '停牌',
	  20: '停牌',
	  21: '停牌'
	};
	
	module.exports.getGszt = function (type) {
	  return trade[type] || '';
	};
	
	module.exports.formatRate = function (value) {
	  var sign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  if (value === null || value === undefined || Number.isNaN(value) || !Number.isFinite(value)) return '--';
	  var rate = Math.abs(value) * 100;
	  rate = rate.toFixed(2);
	  var s = sign ? value < 0 ? '-' : '+' : '';
	  return '' + s + rate + '%';
	};
	
	module.exports.createMeta = function (name, content) {
	  var head = document.getElementsByTagName('head')[0];
	  console.log(head, '=====');
	  var metaTag = null;
	  if (!name) {
	    return false;
	  }
	  metaTag = document.createElement('meta');
	  metaTag.setAttribute('name', name);
	  metaTag.setAttribute('content', content);
	  head.appendChild(metaTag);
	};
	
	module.exports.goSymbolHtml = function (market, symbol) {
	  if (true) {
	    if (getIsIndexStock(symbol, market)) {
	      window.open('/zsindex/' + market.toUpperCase() + '_' + symbol.toUpperCase() + '.html');
	    } else {
	      window.open('/index/' + market.toUpperCase() + '_' + symbol + '.html');
	    }
	  } else {
	    if (getIsIndexStock(symbol, market)) {
	      window.open('/rjhy/stock-richbays-pc/zsIndex.html?market=' + market + '&symbol=' + symbol);
	    } else {
	      window.open('/rjhy/stock-richbays-pc/index.html?market=' + market + '&symbol=' + symbol);
	    }
	  }
	};
	
	module.exports.goListHtml = function (market, symbol, type) {
	  if (true) {
	    //window.open(`/list/${market.toUpperCase()}_${symbol}_${type}.html`)
	    window.open('/server/list.html?market=' + market.toUpperCase() + '&symbol=' + symbol + '&type=' + type);
	  } else {
	    window.open('/rjhy/stock-richbays-pc/list.html?market=' + market + '&symbol=' + symbol + '&type=' + type);
	  }
	};
	
	module.exports.goDetailHtml = function (market, symbol, type, reportId, url) {
	  var code = market == 'hkse' && symbol.length < 5 ? '0' + symbol : symbol;
	  // if (process.env.NODE_ENV === 'production' && !url) {
	  //   window.open(`/detail/${market.toLowerCase()}_${code}_${type}_${reportId}${`url? _${url} : ''`}.html`) //TODO 兼容url
	  // } else {
	  if (false) {
	    window.open('/rjhy/stock-richbays-pc/detail.html?market=' + market + '&symbol=' + code + '&type=' + type + '&' + (type === '1' ? 'news_id' : type === '2' ? 'eventId' : 'reportId') + '=' + reportId + (type === '1' && url ? '&url=' + encodeURIComponent(url) : ''));
	    return;
	  }
	  window.open('/server/detail.html?market=' + market + '&symbol=' + code + '&type=' + type + '&' + (type === '1' ? 'news_id' : type === '2' ? 'eventId' : 'reportId') + '=' + reportId + (type === '1' && url ? '&url=' + encodeURIComponent(url) : ''));
	  // }
	};
	
	module.exports.goGglhbHtml = function (code, name, url) {
	  // let code = market.includes('hk') && symbol.length < 5 ? `0${symbol}` : symbol
	  if (true) {
	    // window.open(`/gglhb/${code}_${decodeURI(name)}${`url? _${url} : ''`}.html`) //TODO 兼容url
	    window.open('/server/gglhb.html?symbol=' + code + '&name=' + decodeURI(name));
	  } else {
	    window.open('gglhb.html?symbol=' + code + '&name=' + decodeURI(name));
	  }
	};
	
	module.exports.goLhbHtml = function (market, symbol, url) {
	  // let code = market.includes('hk') && symbol.length < 5 ? `0${symbol}` : symbol
	  if (true) {
	    // window.open(`/lhb.html`) //TODO 兼容url
	    window.open('/server/lhb.html'); //TODO 兼容url
	  } else {
	    window.open('lhb.html');
	  }
	};
	
	module.exports.goLhbDetailHtml = function (tab, url) {
	  if (true) {
	    // window.open(`/lhbdetail_${tab}.html`) //TODO 兼容url
	    window.open('/server/lhbdetail_' + tab + '.html'); //TODO 兼容url
	  } else {
	    window.open('lhbdetail.html?tab=' + tab);
	  }
	};
	
	module.exports.goStockDetailHtml = function (market, symbol, newsId) {
	  if (true) {
	    // window.location.href = `/stockBarDetail/${market.toLowerCase()}_${symbol}_${newsId}.html`
	    window.open('/server/stockBarDetail.html?market=' + market + '&symbol=' + symbol + '&newsId=' + newsId);
	  } else {
	    window.open('stockBarDetail.html?market=' + market + '&symbol=' + symbol + '&newsId=' + newsId);
	  }
	};
	
	module.exports.goStockListHtml = function (market, symbol) {
	  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  if (true) {
	    // window.location.href = `/stockBarList/${market.toLowerCase()}_${symbol}_${position}.html`
	    window.open('/server/stockBarList.html?market=' + market + '&symbol=' + symbol + '&position=' + position);
	  } else {
	    window.open('stockBarList.html?market=' + market + '&symbol=' + symbol + '&position=' + position);
	  }
	};
	
	module.exports.goProtocolHtml = function () {
	  if (true) {
	    // window.open(`/protocol.html`)
	    window.open('/serer/protocol.html');
	  } else {
	    window.open('protocol.html');
	  }
	};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var request = __webpack_require__(180);
	var UKIndexs = ['.hsi', 'hscei', 'hscci', 'dia', 'ndaq', 'spy', 'qqq', '.hscc', '.hsce'];
	
	module.exports.getStockName = function (state) {
	  var symbol = state.symbol,
	      market = state.market,
	      dataSourceType = state.dataSourceType;
	
	  return request.get(request.apis.quote.getStockName, {
	    symbol: symbol.toUpperCase(),
	    market: dataSourceType === 'A' ? market : market.toUpperCase()
	  }).then(function (res) {
	    if (res && res.data && res.data.length > 0) {
	      return res.data[0].Name;
	    }
	    return '--';
	  });
	};
	
	// 判断是否股指
	module.exports.getIsIndexStock = function (symbol, market) {
	  if (!symbol || !market) return false;
	  if (market.toLocaleUpperCase() === 'HKIDX') return true;
	  if (UKIndexs.includes(symbol.toLowerCase())) return true;
	  if (market !== 'sz' && market !== 'sh') return false;
	  var symbolS3 = symbol.slice(0, 3);
	  if (market === 'sz') return symbolS3 === '399';
	  if (market === 'sh') return symbolS3 === '000';
	  return false;
	};
	
	// 判断是否A股股指
	module.exports.getIsAIndexStock = function (symbol, market) {
	  if (!symbol || !market) return false;
	  var symbolS3 = symbol.slice(0, 3);
	  if (market === 'sz') return symbolS3 === '399';
	  if (market === 'sh') return symbolS3 === '000';
	  return false;
	};
	
	// 判断是否港美股股指
	module.exports.getIsUkIndexStock = function (symbol, market) {
	  if (!symbol || !market) return false;
	  if (UKIndexs.includes(symbol.toLowerCase())) return true;
	  return false;
	};
	
	// 判断市场
	module.exports.getExchange = function (symbol, market) {
	  if (market.indexOf('hk') > -1 || market.indexOf('HK') > -1) {
	    return 'HK';
	  } else if (market == 'sz') {
	    return 'SZ';
	  } else if (market == 'sh') {
	    return 'SH';
	  } else {
	    return 'US';
	  }
	};
	
	// 市盈率
	module.exports.getPERatio = function (NetProfTTM, TotalShare, symbol, LastPrice) {
	  var text = '--';
	  if (NetProfTTM && Number(NetProfTTM) !== 0) {
	    var ttm1 = LastPrice * Number(TotalShare) / Number(NetProfTTM);
	    if (ttm1 < 0) {
	      text = symbol === 'yin' ? '--' : '亏损';
	    } else {
	      text = ttm1.toFixed(2);
	    }
	  }
	  return text;
	};

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * this function only used in utils, if you want to use it outside, please export it from `index.js`.
	 */
	var QuotationWebSocket = __webpack_require__(209);
	var config = __webpack_require__(211);
	
	var Socket = function () {
	    function Socket() {
	        _classCallCheck(this, Socket);
	    }
	
	    Socket.prototype.init = function init() {
	        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	        if (!this.websocket) {
	            this.websocket = new QuotationWebSocket(config.baseWebSocket, 'sinaQuotation'); // 'ws://test-quotes.fdzq.com:18886/quote'  config.baseWebSocket
	            // this.websocket = {}
	            // 打开log
	            // this.websocket.openLog()
	            // 打开自动重新连接，但它并不会在一开始没连接时主动连接
	            this.websocket.autoReconnect();
	
	            this.websocket.on(QuotationWebSocket.EVENT.onOpen, function () {
	                console.log('WebSocket连接已打开！');
	                cb();
	            });
	            this.websocket.on(QuotationWebSocket.EVENT.onClose, function () {
	                console.log('WebSocket 已关闭！');
	            });
	            this.websocket.on(QuotationWebSocket.EVENT.onError, function () {
	                console.log('WebSocket连接打开失败，请检查！');
	            });
	            // 开始链接
	            this.websocket.connect();
	        }
	    };
	    // 关闭链接
	
	
	    Socket.prototype.closeSocket = function closeSocket() {
	        try {
	            console.log('------- ', this.websocket);
	            this.websocket.close();
	        } catch (error) {
	            console.log(error);
	        }
	    };
	
	    return Socket;
	}();
	
	var ws = new Socket();
	ws.init();
	module.exports = {
	    Socket: Socket,
	    ws: ws
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventEmitter = __webpack_require__(210);
	var config = __webpack_require__(211);
	var COUNT_ID = 0;
	
	var cacheSub = {};
	
	var SERVICE_TYPE = {
	    DYNA: 'DYNA',
	    DYNAPOST: 'DYNAPOST',
	    DYNAPRE: 'DYNAPRE',
	    KLINE: 'KLINE',
	    MIN: 'MIN',
	    MMP: 'MMP',
	    STATISTICS: 'STATISTICS',
	    CAPITALFLOW: 'CAPITALFLOW',
	    TICK: 'TICK',
	    STATIC: 'STATIC',
	    INSTRUMENTS: 'INSTRUMENTS',
	    STATUS: 'STATUS',
	    SECTOR: 'NEWSECTORLIST' // 板块
	};
	
	var STATE = {
	    unknow: 0,
	    error: 1,
	    beforeConnect: 2,
	    connected: 3,
	    disconnected: 4
	};
	
	var EVENT = {
	    stateChanged: 'stateChanged',
	    onMessage: 'onMessage',
	    onError: 'onError',
	    onClose: 'onClose',
	    onOpen: 'onOpen',
	    onDYNA: 'onDYNA',
	    onDYNAPOST: 'onDYNAPOST',
	    onDYNAPRE: 'onDYNAPRE',
	    onKLINE: 'onKLINE',
	    onMIN: 'onMIN',
	    onMMP: 'onMMP',
	    onSTATISTICS: 'onSTATISTICS',
	    onTICK: 'onTICK',
	    onSTATIC: 'onSTATIC',
	    onINSTRUMENTS: 'onINSTRUMENTS',
	    onSTATUS: 'onSTATUS',
	    onSECTOR: 'onNEWSECTORLIST' // 板块
	};
	
	var WXQuotationWebSocket = function (_EventEmitter$EventEm) {
	    _inherits(WXQuotationWebSocket, _EventEmitter$EventEm);
	
	    _createClass(WXQuotationWebSocket, [{
	        key: 'state',
	        set: function set(newValue) {
	            var oldValue = this._state;
	            this._state = newValue;
	            this._log('stateChanged oldValue:' + oldValue + ' newValue:' + newValue);
	            this.emit(EVENT.stateChanged, oldValue, newValue);
	        },
	        get: function get() {
	            return this._state;
	        }
	    }]);
	
	    function WXQuotationWebSocket(url) {
	        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var protocol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        _classCallCheck(this, WXQuotationWebSocket);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter$EventEm.call(this));
	
	        _this._state = STATE.unknow;
	        _this.retryTimesCount = 0;
	        _this.retryTimes = null;
	        _this.isLog = false;
	        _this.sendData = [];
	        _this.userCloseSocket = false;
	        _this.subscribeSTATISTICSData = [];
	        _this.subscribeDYNAData = [];
	        _this.subscribeKLINEData = [];
	        _this.subscribeMINData = [];
	        _this.subscribeMMPData = [];
	        _this.subscribeTICKData = [];
	        _this.subscribeSTATICData = [];
	        _this.subscribeINSTRUMENTData = [];
	        _this.subscribeSTATUSData = [];
	        _this.subscribeSTATUSData = [];
	        _this.subscribeDYNAPOSTData = [];
	        _this.subscribeDYNAPREData = [];
	        _this.subscribeSECTORData = [];
	        _this.reqID = 0;
	
	        COUNT_ID++;
	        _this._name = name || COUNT_ID + '';
	        _this.url = url;
	        _this.protocol = protocol;
	        _this.state = STATE.unknow;
	        _this.heartTimer = null;
	        return _this;
	    }
	
	    WXQuotationWebSocket.prototype.setHeartBeat = function setHeartBeat() {
	        var _this2 = this;
	
	        this.heartTimer = window.setInterval(function () {
	            _this2.socketTask && _this2.socketTask.send(JSON.stringify({
	                ServiceType: 'ping'
	            }));
	        }, 30000);
	    };
	
	    WXQuotationWebSocket.prototype.clearHeartBeat = function clearHeartBeat() {
	        window.clearInterval(this.heartTimer);
	    };
	
	    WXQuotationWebSocket.prototype.connect = function connect() {
	        var _this3 = this;
	
	        this.state = STATE.beforeConnect;
	
	        var socketTask = void 0;
	        if (window && window.WebSocket) {
	            console.log('this.url', this.url);
	            socketTask = new window.WebSocket(this.url);
	            this.socketTask = socketTask;
	            // web端使用
	            this.socketTask.onopen = function () {
	                if (_this3.socketTask !== socketTask) {
	                    return;
	                }
	                _this3._log('onOpen');
	
	                var authStr = JSON.stringify(config.authConf);
	                //   console.log('authStr', authStr)
	                _this3.socketTask.send(authStr);
	                _this3.state = STATE.connected;
	                _this3.retryTimesCount = 0;
	                _this3.sendData.length > 0 && _this3.doSendCacheData();
	                _this3.safeSubscribeAll();
	                _this3.emit(EVENT.onOpen);
	                _this3.setHeartBeat();
	            };
	
	            this.socketTask.onclose = function (data) {
	                _this3.clearHeartBeat();
	                if (_this3.socketTask !== socketTask) {
	                    return;
	                }
	                _this3._log('onClose');
	                _this3.state = STATE.disconnected;
	                if (!_this3.userCloseSocket) {
	                    // 不是用户主动close都有重新连接
	                    _this3.doReconnect();
	                } else {
	                    _this3.userCloseSocket = false;
	                }
	                _this3.emit(EVENT.onClose, data);
	            };
	
	            this.socketTask.onerror = function (e) {
	                _this3.clearHeartBeat();
	                if (_this3.socketTask !== socketTask) {
	                    return;
	                }
	                // 需要错误信息应该监听stateChanged 这个时候可以拿到errorMsg
	                _this3._error('onError errorMsg:', e);
	                _this3.state = STATE.error;
	                _this3.doReconnect();
	                _this3.emit(EVENT.onError, e);
	            };
	
	            this.socketTask.onmessage = function (response) {
	                if (_this3.socketTask !== socketTask) {
	                    return;
	                }
	
	                try {
	                    var data = JSON.parse(response.data);
	                    _this3._log('onMessage data:', data);
	                    _this3.emit(EVENT.onMessage, data);
	
	                    _this3.handleData(data);
	                } catch (e) {
	                    _this3._error('JSON.parse errorMsg:', e);
	                }
	            };
	        }
	        // return new Promise((resolve, reject) => {
	
	        // })
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeSTATISTICS = function safeSubscribeSTATISTICS(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATISTICS });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSTATISTICS = function safeUnsubscribeSTATISTICS(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATISTICS });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeCAPITALFLOW = function safeSubscribeCAPITALFLOW(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.CAPITALFLOW });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeCAPITALFLOW = function safeUnsubscribeCAPITALFLOW(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.CAPITALFLOW });
	    };
	
	    // capitalflow
	
	
	    WXQuotationWebSocket.prototype.safeSubscribeDYNA = function safeSubscribeDYNA(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNA });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeDYNA = function safeUnsubscribeDYNA(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNA });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeKLINE = function safeSubscribeKLINE(Inst, Market, Period, Limit) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, Period: Period, Limit: Limit, ServiceType: SERVICE_TYPE.KLINE });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeKLINE = function safeUnsubscribeKLINE(Inst, Market, Period, Limit) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, Period: Period, Limit: Limit, ServiceType: SERVICE_TYPE.KLINE });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeMIN = function safeSubscribeMIN(Inst, Market, Period, Limit) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, Period: Period, Limit: Limit, ServiceType: SERVICE_TYPE.MIN });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeMIN = function safeUnsubscribeMIN(Inst, Market, Period, Limit) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, Period: Period, Limit: Limit, ServiceType: SERVICE_TYPE.MIN });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeMMP = function safeSubscribeMMP(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.MMP });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeMMP = function safeUnsubscribeMMP(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.MMP });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeTICK = function safeSubscribeTICK(Inst, Market, Limit) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, Limit: Limit, ServiceType: SERVICE_TYPE.TICK });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeTICK = function safeUnsubscribeTICK(Inst, Market, Limit) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, Limit: Limit, ServiceType: SERVICE_TYPE.TICK });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeSTATIC = function safeSubscribeSTATIC(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATIC });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSTATIC = function safeUnsubscribeSTATIC(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATIC });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeINSTRUMENTS = function safeSubscribeINSTRUMENTS(Industry, Market, StartID, EndID, SortField, OrderBy) {
	        return this.safeSubscribe({ ServiceType: SERVICE_TYPE.INSTRUMENTS, Industry: Industry, Market: Market, StartID: StartID, EndID: EndID, SortField: SortField });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeINSTRUMENTS = function safeUnsubscribeINSTRUMENTS(Industry, Market, StartID, EndID, SortField, OrderBy) {
	        return this.safeUnsubscribe({ ServiceType: SERVICE_TYPE.INSTRUMENTS, Industry: Industry, Market: Market, StartID: StartID, EndID: EndID, SortField: SortField });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeSTATUS = function safeSubscribeSTATUS(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATUS });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSTATUS = function safeUnsubscribeSTATUS(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.STATUS });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeDYNAPOST = function safeSubscribeDYNAPOST(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNAPOST });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeDYNAPOST = function safeUnsubscribeDYNAPOST(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNAPOST });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeDYNAPRE = function safeSubscribeDYNAPRE(Inst, Market) {
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNAPRE });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeDYNAPRE = function safeUnsubscribeDYNAPRE(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.DYNAPRE });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeSECTOR = function safeSubscribeSECTOR(Inst, Market) {
	        // Inst 字段取值如下: SECTORFDHK(方德港股板块) SECTORFDUS(方德美股板块) SECTORRHHK(融汇港股板块) SECTORRHUS(融汇美股板块)
	        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.SECTOR });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSECTOR = function safeUnsubscribeSECTOR(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.SECTOR });
	    };
	
	    // 板块的成分股列表
	
	
	    WXQuotationWebSocket.prototype.safeSubscribeSECTORRCONSTITUENT = function safeSubscribeSECTORRCONSTITUENT(Inst, Market) {
	        // Inst 填板块合约ID，例如BK4002
	        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
	        return this.safeSubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSECTORRCONSTITUENT = function safeUnsubscribeSECTORRCONSTITUENT(Inst, Market) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' });
	    };
	
	    // 板块成份股排行榜
	
	
	    WXQuotationWebSocket.prototype.safeSubscribeSECTORCONSTITUENTRANKINGS = function safeSubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {
	        // Inst 填板块合约ID，例如BK4002
	        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
	        // Period 填updown，这个是表示涨跌幅
	        // SortType  1是涨幅由大到小排序 0 是涨幅由小到大排序
	        return this.safeSubscribe({ Inst: Inst, Market: Market, Period: Period, SortType: SortType, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' });
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribeSECTORCONSTITUENTRANKINGS = function safeUnsubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {
	        return this.safeUnsubscribe({ Inst: Inst, Market: Market, Period: Period, SortType: SortType, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' });
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribe = function safeSubscribe(data) {
	        var param = Object.assign({
	            SubType: 'SUBON'
	        }, data);
	        return this.safeSend(param);
	    };
	
	    WXQuotationWebSocket.prototype.safeUnsubscribe = function safeUnsubscribe(data) {
	        var Inst = data.Inst,
	            Market = data.Market,
	            ServiceType = data.ServiceType,
	            Limit = data.Limit;
	        // 根据Inst，Market，ServiceType获取订阅的ReqID
	
	        var key = Limit ? '' + Market + Inst + '_' + ServiceType + '_' + Limit : '' + Market + Inst + '_' + ServiceType;
	        var ReqID = cacheSub[key];
	        var param = Object.assign({
	            SubType: 'SUBOFF',
	            ReqID: ReqID
	        }, data);
	        return this.safeSend(param);
	    };
	
	    WXQuotationWebSocket.prototype.safeSend = function safeSend(data) {
	        if (this.state === STATE.connected) {
	            return this.send(data);
	        }
	        this._log('state no connected sendData cache', data);
	        // 存Data
	        this.sendData.push(data);
	
	        if (this.state === STATE.beforeConnect) {
	            // return new Promise((resolve, reject) => {
	            //   setTimeout(resolve, 0)
	            // })
	            return;
	        }
	        return this.connect();
	    };
	
	    WXQuotationWebSocket.prototype.safeSubscribeAll = function safeSubscribeAll() {
	        var _this4 = this;
	
	        this._log('safeSubscribeAll');
	        this.subscribeDYNAData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeDYNAPOSTData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeDYNAPREData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeSTATISTICSData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeKLINEData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeMINData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeMMPData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeTICKData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeSTATICData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeINSTRUMENTData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeSTATUSData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	
	        this.subscribeSECTORData.forEach(function (item) {
	            _this4.safeSend(item);
	        });
	    };
	
	    WXQuotationWebSocket.prototype.unsubscribeFromSaveData = function unsubscribeFromSaveData(data) {
	        switch (data.ServiceType) {
	            case SERVICE_TYPE.DYNA:
	                var paramDYNA = data;
	                var stockDYNA = this.subscribeDYNAData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexDYNA = this.subscribeDYNAData.indexOf(stockDYNA);
	                this.subscribeDYNAData.splice(indexDYNA, 1);
	                if (stockDYNA) {
	                    paramDYNA = stockDYNA;
	                }
	                paramDYNA.SubType = 'SUBOFF';
	                return paramDYNA;
	            case SERVICE_TYPE.DYNAPRE:
	                var paramDYNAPRE = data;
	                var stockDYNAPRE = this.subscribeDYNAPREData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexDYNAPRE = this.subscribeDYNAPREData.indexOf(stockDYNAPRE);
	                this.subscribeDYNAPREData.splice(indexDYNAPRE, 1);
	                if (stockDYNAPRE) {
	                    paramDYNAPRE = stockDYNAPRE;
	                }
	                paramDYNAPRE.SubType = 'SUBOFF';
	                return paramDYNAPRE;
	            case SERVICE_TYPE.DYNAPOST:
	                var paramDYNAPOST = data;
	                var stockDYNAPOST = this.subscribeDYNAPOSTData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexDYNAPOST = this.subscribeDYNAPOSTData.indexOf(stockDYNAPOST);
	                this.subscribeDYNAPOSTData.splice(indexDYNAPOST, 1);
	                if (stockDYNAPOST) {
	                    paramDYNAPOST = stockDYNAPOST;
	                }
	                paramDYNAPOST.SubType = 'SUBOFF';
	                return paramDYNAPOST;
	            case SERVICE_TYPE.KLINE:
	                var paramKLINE = data;
	                var stockKLINE = this.subscribeKLINEData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market && item.Period === data.Period && item.Limit === data.Limit;
	                });
	                var indexKLINE = this.subscribeKLINEData.indexOf(stockKLINE);
	                this.subscribeKLINEData.splice(indexKLINE, 1);
	                if (stockKLINE) {
	                    paramKLINE = stockKLINE;
	                }
	                paramKLINE.SubType = 'SUBOFF';
	                return paramKLINE;
	            case SERVICE_TYPE.MIN:
	                var paramMIN = data;
	                var stockMIN = this.subscribeMINData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market && item.Period === data.Period && item.Limit === data.Limit;
	                });
	                var indexMIN = this.subscribeMINData.indexOf(stockMIN);
	                this.subscribeMINData.splice(indexMIN, 1);
	                if (stockMIN) {
	                    paramMIN = stockMIN;
	                }
	                paramMIN.SubType = 'SUBOFF';
	                return paramMIN;
	            case SERVICE_TYPE.MMP:
	                var paramMMP = data;
	                var stockMMP = this.subscribeMMPData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexMMP = this.subscribeMMPData.indexOf(stockMMP);
	                this.subscribeMMPData.splice(indexMMP, 1);
	                if (stockMMP) {
	                    paramMMP = stockMMP;
	                }
	                paramMMP.SubType = 'SUBOFF';
	                return paramMMP;
	            case SERVICE_TYPE.STATISTICS:
	                var paramSTATISTICS = data;
	                var stockSTATISTICS = this.subscribeSTATISTICSData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexSTATISTICS = this.subscribeSTATISTICSData.indexOf(stockSTATISTICS);
	                this.subscribeSTATISTICSData.splice(indexSTATISTICS, 1);
	                if (stockSTATISTICS) {
	                    paramSTATISTICS = stockSTATISTICS;
	                }
	                paramSTATISTICS.SubType = 'SUBOFF';
	                return paramSTATISTICS;
	            case SERVICE_TYPE.TICK:
	                var paramTICK = data;
	                var stockTICK = this.subscribeTICKData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market && item.Limit === data.Limit;
	                });
	                var indexTICK = this.subscribeTICKData.indexOf(stockTICK);
	                this.subscribeTICKData.splice(indexTICK, 1);
	                if (stockTICK) {
	                    paramTICK = stockTICK;
	                }
	                paramTICK.SubType = 'SUBOFF';
	                return paramTICK;
	            case SERVICE_TYPE.STATIC:
	                var paramSTATIC = data;
	                var stockSTATIC = this.subscribeSTATICData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexSTATIC = this.subscribeSTATICData.indexOf(stockSTATIC);
	                this.subscribeSTATICData.splice(indexSTATIC, 1);
	                if (stockSTATIC) {
	                    paramSTATIC = stockSTATIC;
	                }
	                paramSTATIC.SubType = 'SUBOFF';
	                return paramSTATIC;
	            case SERVICE_TYPE.INSTRUMENTS:
	                var paramINSTRUMENTS = data;
	                if (this.subscribeINSTRUMENTData.length) {
	                    paramINSTRUMENTS = this.subscribeINSTRUMENTData[0];
	                    paramINSTRUMENTS.SubType = 'SUBOFF';
	                    this.subscribeINSTRUMENTData.pop();
	                }
	                return paramINSTRUMENTS;
	            case SERVICE_TYPE.STATUS:
	                var paramSTATUS = data;
	                var stockSTATUS = this.subscribeSTATUSData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexSTATUS = this.subscribeSTATUSData.indexOf(stockSTATUS);
	                this.subscribeSTATUSData.splice(indexSTATUS, 1);
	                if (stockSTATUS) {
	                    paramSTATUS = stockSTATUS;
	                }
	                paramSTATUS.SubType = 'SUBOFF';
	                return paramSTATUS;
	            case SERVICE_TYPE.SECTOR:
	                var paramSECTOR = data;
	                var stockSECTOR = this.subscribeSECTORData.find(function (item) {
	                    return item.Inst === data.Inst && item.Market === data.Market;
	                });
	                var indexSECTOR = this.subscribeSECTORData.indexOf(stockSECTOR);
	                this.subscribeSECTORData.splice(indexSECTOR, 1);
	                if (stockSECTOR) {
	                    paramSECTOR = stockSECTOR;
	                }
	                paramSECTOR.SubType = 'SUBOFF';
	                return paramSECTOR;
	        }
	    };
	
	    WXQuotationWebSocket.prototype.saveSendData = function saveSendData(data) {
	        switch (data.ServiceType) {
	            case SERVICE_TYPE.DYNA:
	                var newDYNAData = this.subscribeDYNAData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeDYNAData = newDYNAData;
	                this.subscribeDYNAData.push(data);
	                break;
	            case SERVICE_TYPE.DYNAPOST:
	                var newDYNAPOSTData = this.subscribeDYNAPOSTData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeDYNAPOSTData = newDYNAPOSTData;
	                this.subscribeDYNAPOSTData.push(data);
	                break;
	            case SERVICE_TYPE.DYNAPRE:
	                var newDYNAPREData = this.subscribeDYNAPREData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeDYNAPREData = newDYNAPREData;
	                this.subscribeDYNAPREData.push(data);
	                break;
	            case SERVICE_TYPE.KLINE:
	                var newKLINEData = this.subscribeKLINEData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market && item.Period !== data.Period && item.Limit !== data.Limit;
	                });
	                this.subscribeKLINEData = newKLINEData;
	                this.subscribeKLINEData.push(data);
	                break;
	            case SERVICE_TYPE.MIN:
	                var newMINData = this.subscribeMINData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market && item.Period !== data.Period && item.Limit !== data.Limit;
	                });
	                this.subscribeMINData = newMINData;
	                this.subscribeMINData.push(data);
	                break;
	            case SERVICE_TYPE.MMP:
	                var newMMPData = this.subscribeMMPData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeMMPData = newMMPData;
	                this.subscribeMMPData.push(data);
	                break;
	            case SERVICE_TYPE.STATISTICS:
	                var newSTATISTICSData = this.subscribeSTATISTICSData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeSTATISTICSData = newSTATISTICSData;
	                this.subscribeSTATISTICSData.push(data);
	                break;
	            case SERVICE_TYPE.TICK:
	                var newTICKData = this.subscribeTICKData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market && item.Limit !== data.Limit;
	                });
	                this.subscribeTICKData = newTICKData;
	                this.subscribeTICKData.push(data);
	                break;
	            case SERVICE_TYPE.STATIC:
	                var newSTATICData = this.subscribeSTATICData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeSTATICData = newSTATICData;
	                this.subscribeSTATICData.push(data);
	                break;
	            case SERVICE_TYPE.INSTRUMENTS:
	                if (this.subscribeINSTRUMENTData.length) {
	                    this.subscribeINSTRUMENTData.pop(); // 删除
	                }
	                this.subscribeINSTRUMENTData.push(data);
	                break;
	            case SERVICE_TYPE.STATUS:
	                var newSTATUSData = this.subscribeSTATUSData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeSTATUSData = newSTATUSData;
	                this.subscribeSTATUSData.push(data);
	                break;
	            case SERVICE_TYPE.SECTOR:
	                var newSECTORData = this.subscribeSECTORData.filter(function (item) {
	                    return item.Inst !== data.Inst && item.Market !== data.Market;
	                });
	                this.subscribeSECTORData = newSECTORData;
	                this.subscribeSECTORData.push(data);
	                break;
	        }
	    };
	
	    WXQuotationWebSocket.prototype.send = function send(data) {
	        // return new Promise((resolve, reject) => {
	        // 不存在或者没有连接上
	        if (!this.socketTask || this.state !== STATE.connected) {
	            // return setTimeout(reject, 0)
	            return;
	        }
	        if (!data.ReqID && data.ReqID !== 0) {
	            data.ReqID = this.reqID++;
	        }
	        var ReqID = data.ReqID,
	            Inst = data.Inst,
	            Market = data.Market,
	            ServiceType = data.ServiceType,
	            Limit = data.Limit;
	
	        var key = Limit ? '' + Market + Inst + '_' + ServiceType + '_' + Limit : '' + Market + Inst + '_' + ServiceType;
	        // 根据Inst，Market，ServiceType存储订阅的ReqID
	        cacheSub[key] = ReqID;
	        // this.saveSendData(data)
	        this._log('send data:', data);
	
	        if (window && window.WebSocket) {
	            this.socketTask.send(JSON.stringify(data));
	        }
	
	        // })
	    };
	
	    // 当onOpen时把存的data发出去
	
	
	    WXQuotationWebSocket.prototype.doSendCacheData = function doSendCacheData() {
	        var _this5 = this;
	
	        var promiseArr = this.sendData.map(function (data) {
	            _this5._log(' doSendCacheData');
	            return _this5.safeSend(data);
	        });
	        // return Promise.all(promiseArr)
	        return promiseArr;
	    };
	
	    WXQuotationWebSocket.prototype.close = function close() {
	        this.sendData = [];
	        this.userCloseSocket = true;
	        if (this.socketTask) {
	            this.socketTask.close();
	        }
	    };
	
	    WXQuotationWebSocket.prototype.handleData = function handleData(data) {
	        switch (data.ServiceType) {
	            case SERVICE_TYPE.DYNA:
	                this.emit(EVENT.onDYNA, data);
	                break;
	            case SERVICE_TYPE.DYNAPOST:
	                this.emit(EVENT.onDYNAPOST, data);
	                break;
	            case SERVICE_TYPE.DYNAPRE:
	                this.emit(EVENT.onDYNAPRE, data);
	                break;
	            case SERVICE_TYPE.KLINE:
	                this.emit(EVENT.onKLINE, data);
	                break;
	            case SERVICE_TYPE.MIN:
	                this.emit(EVENT.onMIN, data);
	                break;
	            case SERVICE_TYPE.MMP:
	                this.emit(EVENT.onMMP, data);
	                break;
	            case SERVICE_TYPE.STATISTICS:
	                this.emit(EVENT.onSTATISTICS, data);
	                break;
	            case SERVICE_TYPE.TICK:
	                this.emit(EVENT.onTICK, data);
	                break;
	            case SERVICE_TYPE.STATIC:
	                this.emit(EVENT.onSTATIC, data);
	                break;
	            case SERVICE_TYPE.INSTRUMENTS:
	                this.emit(EVENT.onINSTRUMENTS, data);
	                break;
	            case SERVICE_TYPE.STATUS:
	                this.emit(EVENT.onSTATUS, data);
	                break;
	            case SERVICE_TYPE.SECTOR:
	                this.emit(EVENT.onSECTOR, data);
	                break;
	        }
	    };
	
	    WXQuotationWebSocket.prototype.openLog = function openLog() {
	        this.isLog = true;
	        return this;
	    };
	
	    WXQuotationWebSocket.prototype.closeLog = function closeLog() {
	        this.isLog = true;
	        return this;
	    };
	
	    WXQuotationWebSocket.prototype._log = function _log(msg) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        this.isLog && console.log('WXQuotationWebSocket.' + this._name + ' ' + msg, data);
	    };
	
	    WXQuotationWebSocket.prototype._error = function _error(err) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        this.isLog && console.error('WXQuotationWebSocket.' + this._name + ' ' + err, data);
	    };
	
	    WXQuotationWebSocket.prototype.doReconnect = function doReconnect() {
	        var _this6 = this;
	
	        this._log('doReconnect');
	        if (this.retryTimes === null) {
	            return;
	        }
	
	        if (this.retryTimesCount++ >= this.retryTimes) {
	            return;
	        }
	        setTimeout(function () {
	            _this6.connect();
	        }, 3000);
	    };
	
	    WXQuotationWebSocket.prototype.autoReconnect = function autoReconnect() {
	        var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	
	        this.retryTimes = times;
	    };
	
	    return WXQuotationWebSocket;
	}(EventEmitter.EventEmitter);
	
	WXQuotationWebSocket.STATE = STATE;
	WXQuotationWebSocket.EVENT = EVENT;
	WXQuotationWebSocket.SERVICE_TYPE = SERVICE_TYPE;
	
	
	module.exports = WXQuotationWebSocket;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var config = {
	    dev: {
	        originId: 'gh_6e545a97baf3',
	        BID: '110789',
	        stockService: 'http://test-gateway.jinyi999.cn/rjhy-stock-diagnosis/api/',
	        rjhyEdu: 'http://test-gateway.jinyi999.cn/rjhy-edu/api/',
	        rjhyUser: 'http://test-gateway.jinyi999.cn/rjhy-user/api/',
	        rjhyQr: 'https://gateway.jinyi999.cn/rjhy-wechat-platform',
	        rjhySms: 'http://test-gateway.jinyi999.cn/rjhy-sms/api/',
	        rjhyFile: 'http://test-gateway.jinyi999.cn/rjhy-file/api/1/',
	        rjhyNews: 'http://test-gateway.jinyi999.cn/rjhy-news/api/1/',
	        rjhyGmgQuote: 'http://test-gateway.jinyi999.cn/rjhy-gmg-quote/api/1/',
	        rjhyOptional: 'http://test-gateway.jinyi999.cn/rjhy-optional/api/1/',
	        rjhyMiniLive: 'http://test-gateway.jinyi999.cn/rjhy-minilive/api/v1/',
	        rjhyActivityManage: 'http://test-gateway.jinyi999.cn/rjhy-activity-manage/api/v1/',
	        rjhyMarketSort: 'http://test-hq.caixun99.com/curhq/',
	        rjhyDynamic: 'http://test-gateway.jinyi999.cn/rjhy-dynamic/api/1/',
	        baseWebSocket: 'wss://qas.sylapp.cn/quote',
	        authConf: {
	            OrgCode: 'rh',
	            Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
	            AppName: 'htzpc',
	            AppVer: 'v1.0.0',
	            AppType: 'pc',
	            Tag: 'af91c60a-1acc-4150-9014-d11086cb9489'
	        }
	    },
	    production: {
	        BID: '111361',
	        originId: 'gh_a4dfed35c02a',
	        stockService: 'https://gateway.jinyi999.cn/rjhy-stock-diagnosis/api/',
	        rjhyEdu: 'https://gateway.jinyi999.cn/rjhy-edu/api/',
	        rjhyUser: 'https://gateway.jinyi999.cn/rjhy-user/api/',
	        rjhyQr: 'https://gateway.jinyi999.cn/rjhy-wechat-platform',
	        rjhySms: 'https://gateway.jinyi999.cn/rjhy-sms/api/',
	        rjhyFile: 'https://gateway.jinyi999.cn/rjhy-file/api/1/',
	        rjhyNews: 'https://gateway.jinyi999.cn/rjhy-news/api/1/',
	        rjhyGmgQuote: 'https://gateway.jinyi999.cn/rjhy-gmg-quote/api/1/',
	        rjhyOptional: 'https://gateway.jinyi999.cn/rjhy-optional/api/1/',
	        rjhyMarketSort: 'https://stockhq-aliyun.caixun99.com/curhq/',
	        rjhyMiniLive: 'https://gateway.jinyi999.cn/rjhy-minilive/api/v1/',
	        rjhyActivityManage: 'https://gateway.jinyi999.cn/rjhy-activity-manage/api/v1/',
	        rjhyDynamic: 'https://gateway.jinyi999.cn/rjhy-dynamic/api/1/',
	        baseWebSocket: 'wss://qas.sylapp.cn/quote',
	        authConf: {
	            'OrgCode': 'rh',
	            'Token': 'e9252a64-6ac8-4bf8-9725-6f106f682908',
	            'AppName': 'htzpc',
	            'AppVer': 'v1.0.0',
	            'AppType': 'pc',
	            'Tag': 'af91c60a-1acc-4150-9014-d11086cb9489'
	        }
	    }
	};
	
	module.exports = config[("production")];

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAmCAYAAACsyDmTAAAFAklEQVRYR8WXf2gcRRTHv2/ubEquaFWsFGxQrLYIigjWarUaEdPszN6dAa2oIPUPhYJSFH/Un1Shf1WhUCiCgsUff1Rj7O3setFqFOrPSFVQi1L9o6JSW1FTE2J2b57MsReu5ja7G6WZ/+7m+9777JuZN28IGUa9Xj8tiqIqgGuJ6EJm7gGwCMDfAH4FcICI9hHRHsdxvsngMlFCsxnX6/XlURQ9CuBmAF0ZA31ERFullDqj/jhZRyBmJt/3LcgjCSBMRBN2jpmLnQIT0ZtRFG2oVCqH84DNABoZGVk0Pj7+EoBKm6MGEb0LYI8QYu/ChQu/7+3tjex8vV5fGobhaiKy+jKAU9vsDtn/pZRfZIU6DiiGeR/AJS0HROQ1Go3N5XL56zSnQRCcbIx5gIg2MXMp1o8LIfocx/kgzd7OTwPFyzTUlhm7Ye9SSu3K4qhd43neSiKqATgv/v+wMWZVuVw+lOZrGkhr/RiAJ+fyVZ2CaK3t0tUBrIrn95dKpctaS50E1gSKT9NX8Qa2G/ZGKeVg2tekzQ8ODi7t6ur6FMBZzeUguk9K+cxsdk0grfULAG6PhTuUUnenBcs6HwTB1caY92L9EWY+23Vde0I7DoqL3s9xdsaEEMsdxzmSNWAWndZ6T3wCbZY2SCltAjoDaa3vAPB8PLtNKXV/liB5NJ7nrSKiT2KbulKqfzYgW3NujQVrlFIf5gmWUWsL7SFmtntpvFQqLU7a3Fb4JTNfBOC30dHRJVu2bDEZg+SSaa2fBXCnNSoUCiv7+/u/7eSAtNZ/ADgFwD6l1FW5ouQQ+75/DzNvj0/b9VLKt5OAQgBFInpDSnlDjhi5pL7v38LML1sjZh5wXdcW4RnDZugvALbM15RS7fdXroBpYq31bQBejIGk67pBEtAPAM5h5o9d1708zfFc533fv5eZn46X7FIp5WdJQD4AB8BYqVQ6Pa20zxWoVXyZ2RhjFlcqlWMdgXzf38zMW+NUXue67jtzDZpkt3v37kJ3d/cvAM4gos+llNPdxL9tKAiCC4wxrdZip1Jq4/8NpLXuBWD7KTueUEq1LvGZm9r+o7W2xdDun0ljzIosbUIeaK217bHWEtFkGIbnV6vVH5Psm5er7/uKmb14w70ipWxV7jxxO2qDIKgaY5pHnIi2Syk3zeZ0uh/yfT9g5uYdI4TY6DjOzv9K43neefEdZnuj36emplYODAzYV0rimAYaHh5eEobhKIAeIgqNMeuTilcW0Fqt1lMoFN5i5hX2ZAFwk2pPu7/jemrf9y9m5n1xobROHpdSbiUizgLR0tRqtSuFEK8BODPO+DbHcTJ1ETNeHUEQrDHG2G6x6YyZ9xPRg0qpvWlQw8PDy8IwfAqArcqFNv1PxWLxmnXr1h1M89HxXWbTLYSwG7G9XhxgZtto7RVCHGTmMSLqajQay4QQq+3jgIjWMvNJcdCjAL4DcEX8OxNU4st1ZGSkODExYW/oh2xBS/uytvkpALuY+eFCoXCMmQeZWWaFmvUpbZ14ntcthLiJmdcDsO1J673Vzmg7Bns3+Y1G47n212oQBPZ1mxkqFag9qs3a5OTkucaYHmPMomKxOBZF0dEFCxYc7OvrG0/KooUyxrwe35lWlrh8uYByLNsMadZMnTAgS5gF6oQCZYE64UBpUPMCNBvUvAF1grLlYV6B2qBeZWYXwI55B2rVh6GhocXVavXPfwBHdV8DFVWdyAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * CANNOT use `import` to import `react` or `react-dom`,
	 * because `import` will run `react` before `require('es5-shim')`.
	 */
	// import React from 'react';
	// import ReactDOM from 'react-dom';
	var React = __webpack_require__(27);
	
	module.exports = React.createClass({
	  displayName: "exports",
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(
	      "div",
	      { className: "block--footer-wrap" },
	      React.createElement(
	        "div",
	        { className: "block-footer-con clearfix" },
	        React.createElement(
	          "div",
	          { className: "footer-left" },
	          React.createElement("img", { className: "fl-footer-logo", src: __webpack_require__(214) }),
	          React.createElement(
	            "div",
	            { className: "txt" },
	            "\u5BCC\u5229\u8BC1\u5238\u4E3A\u9999\u6E2F\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u6301\u724C\u6CD5\u56E2\uFF08\u7F16\u53F7\uFF1AALT947\uFF09\uFF0C\u63D0\u4F9B\u8BC1\u5238\u4EA4\u6613\u670D\u52A1\u5E76\u53D7\u5176\u76D1\u7BA1\u3002"
	          ),
	          React.createElement(
	            "div",
	            { className: "txt" },
	            "fuli@richbays.com"
	          ),
	          React.createElement(
	            "div",
	            { className: "txt" },
	            "\u98CE\u9669\u63D0\u793A\uFF1A\u6295\u8D44\u6709\u98CE\u9669\uFF0C\u5165\u5E02\u9700\u8C28\u614E"
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "footer-right clearfix" },
	          React.createElement("img", { className: "footer-line-img", src: __webpack_require__(215) }),
	          React.createElement(
	            "div",
	            { className: "info" },
	            React.createElement(
	              "div",
	              null,
	              React.createElement(
	                "span",
	                { style: { marginRight: '10px' } },
	                "\u5BA2\u670D\u7535\u8BDD"
	              ),
	              React.createElement(
	                "span",
	                { className: "phone" },
	                "30908080"
	              )
	            ),
	            React.createElement(
	              "div",
	              { style: { marginTop: '22px' } },
	              React.createElement(
	                "span",
	                { style: { marginRight: '10px' } },
	                "\u4EA4\u6613\u65E5"
	              ),
	              React.createElement(
	                "span",
	                null,
	                "09:30-18:00"
	              )
	            )
	          ),
	          React.createElement(
	            "div",
	            { style: { marginTop: '90px', marginLeft: '25px' } },
	            React.createElement("img", { className: "footer-qrcode", src: "https://upload.techgp.cn/production/jfzt/flkh-download-qrcode.png" }),
	            React.createElement(
	              "span",
	              { className: "footer-mobile-kh" },
	              "\u624B\u673A\u626B\u7801\u5F00\u6237"
	            )
	          )
	        )
	      )
	    );
	  }
	});

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAACCCAMAAABrVPjvAAAA4VBMVEUAAAAAAAD///9VVaqqqqp/f39mZpmZmZl/f3+KipWFhY+EhI2FhZCIiJKKio+Hh5KHh5GJiZOHh5WGhpCJiZKGhpSGhpOFhZGHh5KJiZCFiJCHh5GGhpGIiJKIiJKFh5KGhpGHh5GGhpGGhpGGiJGHh5GHiJGGiJGGhpGGhpGHh5GHh5GHh5GHh5KGhpGHh5KGh5KGiJGGiJKHiJGGiJCHiJGHh5GHh5GGh5GHh5GGh5GFhpGGiJGGh5GFhpGGiJGGh5KFhpGGh5GFhpGGh5GGh5GGh5GGh5KGh5GGh5CGh5HAPv8DAAAASnRSTlMAAQEDAwQFBQYYGR0uLzAxMzQ1Nzg5O0NERUdISktNYnJ/iYuNjpCSlJaXmZukpaaoqausra6wxerr7O3t7u/v8PHx9fX29/f4+STMXFEAAAEWSURBVEjH7ZLXdsIwEETXBgOh9957Cy2hd7DBzP9/UI7j+FgG5Z0H7YtGM2rnrojskmXiljwcchNpAAwkjt/HVUX/JZF6UDMZFb3npAstS5TV0HX6HWg5Y8xp6LB+G7e8qfI3tG2/hXvB0oU7WpZuQi/aq4o6mqZqQC+x55Z0NIyxjkfZ+ZLyA3Ui/wpLnzPwLbH6IAqusfCyvneBddAQoQ3mHtv3zLEJmTK8xZdi+co3tmFrEtlh9pcoM+wi9vboHtPfRJliH2UvjB0wcRO5JzjEnE+MHzF2ucY4xp8bkjjhc4RT4rWFyTNwTvKanrpcUvxvkk7TG1al8k9Qq71jEAgIVoKVYCVYCVaClWAlWAlWVK0ykx/L8TB7kT70NwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(218);
	var React = __webpack_require__(27);
	var Button = __webpack_require__(220);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  render: function render() {
	    var morehtml = void 0;
	    var selfhtml = void 0;
	    if (this.props.showmore) {
	      morehtml = React.createElement(
	        'span',
	        { onClick: this.props.more, className: 'more' },
	        '\u66F4\u591A\xA0>'
	      );
	    }
	    if (this.props.showself) {
	      selfhtml = React.createElement(
	        'div',
	        {
	          className: 'bar-btn',
	          type: 'primary',
	          style: { background: '#FFFFFF', width: 'auto', border: 'none', margin: '0 0 0 20px', padding: '0 10px', color: '#003560', height: '21px', lineHeight: '21px' },
	          onClick: this.props.self },
	        this.props.selfText,
	        React.createElement('i', { className: 'icon-bar-btn', style: { top: '2px', marginLeft: '0' } })
	      );
	    }
	    return React.createElement(
	      'div',
	      { className: 'box-header' },
	      React.createElement(
	        'span',
	        { style: { maxWidth: '75%', verticalAlign: 'middle', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
	        this.props.title
	      ),
	      selfhtml,
	      morehtml
	    );
	  }
	});

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import store 
	window.jfztglobal = {};
	/**
	 * 静态化页面table 特殊处理方案
	 */
	module.exports = function () {
	  function _class() {
	    _classCallCheck(this, _class);
	
	    this.transformData();
	  }
	
	  _class.prototype.transformData = function transformData() {
	    var dataRowKeys = document.querySelectorAll('div[data-key]');
	    Array.from(dataRowKeys).forEach(function (node) {
	      var key = node.getAttribute('data-key');
	      var val = node.innerText;
	      try {
	        window.jfztglobal[key] = JSON.parse(val);
	      } catch (error) {
	        window.jfztglobal[key] = val;
	      }
	    });
	  };
	
	  return _class;
	}();

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(218);
	var React = __webpack_require__(27);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {
	      show: true,
	      downlink: 'https://upload.techgp.cn/production/jfzt/setup_ow.exe',
	      canShow: false,
	      width: (window.innerWidth - 1000) / 2,
	      scrollBarWidth: 0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.setState({
	      scrollBarWidth: $('.block--header-logo-wrap').width() - ($('#app').width() || $('.block--header-logo-wrap').width()),
	      canShow: window.innerWidth > 1300 + +(this.props.offsetX || 0),
	      width: (window.innerWidth - 1000) / 2 - +(this.props.offsetX || 0)
	    });
	  },
	
	  openwin: function openwin(url) {
	    var a = document.createElement("a");
	    a.setAttribute("href", url);
	    a.setAttribute("target", "_blank");
	    a.setAttribute("id", "openwin");
	    document.body.appendChild(a);
	    a.click();
	  },
	
	
	  handleSize: function handleSize() {
	    console.log('333', $('.block--header-logo-wrap').width(), $('#app').width());
	    this.setState({
	      canShow: window.innerWidth > 1300 + +(this.props.offsetX || 0),
	      width: (window.innerWidth - 1000) / 2 - +(this.props.offsetX || 0),
	      scrollBarWidth: $('.block--header-logo-wrap').width() - ($('#app').width() || $('.block--header-logo-wrap').width())
	    });
	    this.forceUpdate();
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    if (this.props.screenChange !== nextProps.screenChange) {
	      this.handleSize();
	    }
	    return true;
	  },
	
	  clickAd: function clickAd() {
	    if (!this.props.content.link) return;
	    this.openwin(this.props.content.link);
	  },
	  close: function close() {
	    this.setState({ show: false });
	  },
	
	  render: function render() {
	    var _state = this.state,
	        canShow = _state.canShow,
	        width = _state.width,
	        scrollBarWidth = _state.scrollBarWidth;
	    var _props = this.props,
	        content = _props.content,
	        right = _props.right;
	
	    var style = {
	      left: width - 159 - scrollBarWidth / 2 + 'px'
	    };
	    if (right) {
	      style = {
	        // left: 'auto',
	        right: width - 159 - scrollBarWidth / 2 + 'px',
	        //top: '436px',
	        marginLeft: 'auto'
	        // marginRight: '-684px',
	      };
	    }
	    if (this.props.style) {
	      style = Object.assign(style, this.props.style, { "cursor": "pointer" });
	    }
	    return React.createElement(
	      'div',
	      { style: { display: canShow ? '' : 'none' } },
	      content.image && this.state.show ? React.createElement(
	        'div',
	        { className: 'jfzt-position-block', style: style },
	        React.createElement('i', { className: 'icon-close', onClick: this.close }),
	        React.createElement('img', { src: content.image, onClick: this.clickAd })
	      ) : React.createElement('div', null)
	    );
	  }
	});

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(218);
	var React = __webpack_require__(27);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  openwin: function openwin(url) {
	    var a = document.createElement("a");
	    a.setAttribute("href", url);
	    a.setAttribute("target", "_blank");
	    a.setAttribute("id", "openwin");
	    document.body.appendChild(a);
	    a.click();
	  },
	
	
	  clickAd: function clickAd() {
	    if (!this.props.content.link) return;
	    this.openwin(this.props.content.link);
	  },
	
	  render: function render() {
	    var content = this.props.content;
	
	    return React.createElement(
	      'div',
	      { style: { width: '100%', height: '100%', cursor: 'pointer' } },
	      React.createElement('img', { src: content.image, onClick: this.clickAd })
	    );
	  }
	});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var React = __webpack_require__(27);
	
	var MainChartsTab = __webpack_require__(234);
	var MainChartsTech = __webpack_require__(235);
	var charts = __webpack_require__(236);
	var BS = __webpack_require__(239);
	var config = __webpack_require__(241);
	
	var _require = __webpack_require__(206),
	    formatUnit = _require.formatUnit;
	
	var _require2 = __webpack_require__(207),
	    getIsIndexStock = _require2.getIsIndexStock,
	    getIsAIndexStock = _require2.getIsAIndexStock;
	
	var last = __webpack_require__(240);
	var cloneDeep = __webpack_require__(242);
	
	var apis = __webpack_require__(186);
	var request = __webpack_require__(180);
	
	var _ref = typeof window.WebSocket === 'function' ? __webpack_require__(208) : {},
	    ws = _ref.ws;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	  getInitialState: function getInitialState() {
	    return {
	      symbolCode: '',
	      symbolMarket: '',
	      MIN1Time: [],
	      titleData: [
	        // {title: '', value: '', className: ''}
	      ],
	      subTitleData: [
	        // {title: 'MA5', value: 1.23, color: ''},
	      ],
	      bottomRawData: [],
	      bottomTitleData: [],
	      tradingKlines: config.tradingKlines,
	      klineType: 'MIN1',
	      techType: 'v',
	      init: false,
	      topOptions: {
	        grid: {
	          top: 10,
	          left: 60,
	          bottom: 10,
	          right: 60
	        }
	      }
	    };
	  },
	
	  // data
	  dataSet: {},
	  pendingType: {},
	  klineDataInit: false,
	  // if realKlineType is not null, klineType convert to realKlineType after handle data
	  realKlineType: null,
	  initDataSet: function initDataSet(key) {
	    this.dataSet[key] = {
	      t: [],
	      h: [],
	      o: [],
	      l: [],
	      c: [],
	      v: [],
	      a: [],
	      avg: [],
	      totalAmount: 0,
	      totalVol: 0
	    };
	  },
	  getMyData: function getMyData() {
	    return this.dataSet[this.state.klineType];
	  },
	  componentDidMount: function componentDidMount() {
	    ws && this.handleWSListeners('on');
	    this.initRegion();
	    this.resetSymbol({
	      code: this.props.code,
	      market: String.prototype.toUpperCase.call(this.props.market)
	    });
	    this.topChart = echarts.init(document.getElementById('main-chart-top'));
	    this.bottomChart = echarts.init(document.getElementById('main-chart-bottom'));
	    document.querySelector('#main-chart-top').addEventListener('mouseout', this.resetTitle);
	    document.querySelector('#main-chart-bottom').addEventListener('mouseout', this.resetTitle);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(next) {
	    var sta = next.statistics;
	    this.singleHand = this.state.regionConfig.singleHand;
	    if (sta === this.state._statistics) return;
	    this.cbStatistics(sta);
	    this.setState({
	      _statistics: sta
	    });
	  },
	  initRegion: function initRegion() {
	    var vm = this.state;
	    vm.region = config.typeToRegion[this.props.dataSourceType];
	    vm.klines = config.klines(vm.region);
	    vm.MIN1Time = charts.tradingTime.create(vm.region);
	    vm.regionConfig = config.region[vm.region];
	    vm.topOptions.grid.left = vm.isIndex ? 70 : 60;
	  },
	  resetSymbol: function resetSymbol(next) {
	    if (!(this.props.code && this.props.market)) return;
	    if (this.klineDataInit) return;
	    this.initDataSet('MIN1');
	    this.setState({
	      symbolCode: next.code.toUpperCase(),
	      symbolMarket: next.market.toUpperCase()
	    }, this.initData);
	  },
	  initData: function initData(st) {
	    if (this.state.klineType === 'MIN1') {
	      this.getKlineByWS();
	    } else {
	      this.getKlineByHttp(st);
	    }
	  },
	  handleWSListeners: function handleWSListeners(key) {
	    // ws.websocket[key]('onSTATISTICS', this.cbStatistics)
	    ws.websocket[key]('onKLINE', this.cbKline);
	  },
	  getKlineByWS: function getKlineByWS() {
	    var vm = this.state;
	    // if(!ws) return this.advanceIE()
	    var tmpMarket = 'DELAY_' + vm.symbolMarket;
	    ws.websocket.safeSubscribeSTATISTICS(vm.symbolCode, tmpMarket);
	    ws.websocket.safeUnsubscribeSTATISTICS(vm.symbolCode, tmpMarket);
	    ws.websocket.safeSubscribeKLINE(vm.symbolCode, tmpMarket, vm.klineType);
	    ws.websocket.safeUnsubscribeKLINE(vm.symbolCode, tmpMarket, vm.klineType);
	  },
	  advanceIE: function advanceIE() {
	    this.getStatistics();
	  },
	
	  // get trading day's kline
	  ieGetKline: function ieGetKline() {
	    var _this = this;
	
	    var vm = this.state;
	    var klineType = vm.klineType;
	    var params = {
	      "ReqID": 1890,
	      "Market": vm.symbolMarket,
	      "Inst": vm.symbolCode,
	      "ServiceType": "KLINE",
	      "Period": klineType
	    };
	    request.get(apis.quote.getIEKline, params).then(function (res) {
	      if (!res.QuoteData || !res.QuoteData.KlineData || vm.klineType !== res.Period) {
	        return;
	      }
	      _this.preHandleData(res.QuoteData.KlineData);
	      _this.ieHttpTimer(klineType);
	    })['catch'](function (e) {
	      _this.ieHttpTimer(klineType);
	    });
	  },
	  ieHttpTimer: function ieHttpTimer(klineType) {
	    var _this2 = this;
	
	    setTimeout(function () {
	      if (klineType !== _this2.state.klineType || _this2.dataSet.MIN1.c.length > 240) return;
	      _this2.ieGetKline();
	    }, 10000);
	  },
	  getStatistics: function getStatistics() {
	    var _this3 = this;
	
	    var vm = this.state;
	    var params = {
	      ReqId: 1890,
	      Market: vm.symbolMarket,
	      Inst: vm.symbolCode,
	      ServiceType: 'STATISTICS'
	    };
	    request.get(apis.quote.getStatistics, params).then(function (res) {
	      if (res.QuoteData && res.QuoteData.StatisticsData) {
	        var data = res.QuoteData.StatisticsData[0];
	        _this3.setState({
	          statistics: {
	            open: data.OpenPrice !== 0 ? data.OpenPrice : data.PreClosePrice,
	            preClose: data.PreClosePrice,
	            tradingDay: data.TradingDay
	          }
	        }, _this3.ieGetKline);
	      }
	    });
	  },
	  getKlineByHttp: function getKlineByHttp(st) {
	    var _this4 = this;
	
	    var vm = this.state;
	    var oldKlineType = this.oldKlineType = vm.klineType;
	    if (this.pendingType[oldKlineType]) return;
	    this.pendingType[oldKlineType] = true;
	    var myKline = vm.klines[oldKlineType];
	    var params = {
	      endtime: parseInt(new Date().getTime() / 1000),
	      inst: vm.symbolCode,
	      limit: -myKline.limit,
	      market: vm.symbolMarket,
	      servicetype: 'KLINEB',
	      starttime: st ? st + 1 : 0,
	      resptype: 'JSON',
	      period: myKline.period || vm.klineType
	    };
	    params.inst = params.inst.replace(/^BRK(A|B)$/, function (word, v) {
	      return 'BRK' + v.toLocaleLowerCase();
	    });
	    request.get(apis.quote.getKline, params, true).then(function (res) {
	      delete _this4.pendingType[oldKlineType];
	      var myKline = vm.klines[vm.klineType];
	      var period = myKline.period || vm.klineType;
	      if (!res || !res.KlineData || period !== res.Period) {
	        return;
	      }
	      if (config.minKlines.includes(vm.klineType) && oldKlineType === _this4.state.klineType) {
	        _this4.getKlineByWS(res.Period);
	      }
	      _this4.preHandleData(res.KlineData, oldKlineType);
	    })['catch'](function (e) {
	      delete _this4.pendingType[oldKlineType];
	    });
	  },
	  getBS: function getBS(klineType) {
	    var _this5 = this;
	
	    this.realKlineType = klineType;
	    this.setState({
	      klineType: 'DAY'
	    }, function () {
	      _this5.initDataSet('DAY');
	      _this5.getKlineByHttp();
	    });
	  },
	  getBsSignal: function getBsSignal() {
	    var _this6 = this;
	
	    var vm = this.state;
	    var klineDay = this.dataSet['DAY'];
	    var params = {
	      finance: 'DAY_BS_FINANCE',
	      date: new Date(),
	      limit: klineDay.c.length,
	      stock: '' + vm.symbolMarket.toLowerCase() + vm.symbolCode
	    };
	    request.get(apis.quote.getDayBsSignal, params).then(function (res) {
	      var data = res.data;
	      if (data && data.length) {
	        _this6.dataSet.BS = cloneDeep(klineDay);
	        _this6.dataSet.BS = BS.encodeData(_this6.dataSet.BS, data);
	        if (vm.klineType === 'BS') {
	          _this6.renderCandleChart();
	        }
	      }
	    });
	  },
	  cbStatistics: function cbStatistics(data) {
	    var statistics = {
	      open: data.OpenPrice !== 0 ? data.OpenPrice : data.PreClosePrice,
	      preClose: data.PreClosePrice,
	      tradingDay: data.TradingDay
	      // charts.setTradingFirstBar.call(this, statistics)
	    };this.setState({
	      statistics: statistics
	    }, this.renderMIN1Chart);
	  },
	  cbKline: function cbKline(data) {
	    var vm = this.state;
	    var tmpMarket = data.Market.replace('DELAY_', '');
	    if (data.Inst !== vm.symbolCode || tmpMarket !== vm.symbolMarket) return;
	    var period = data.Period;
	    data = data.QuoteData.KlineData;
	    if (data.length > 1 && this.klineDataInit) return;
	    this.preHandleData(data, period);
	  },
	  preHandleData: function preHandleData(data, klineType) {
	    if (!data) return;
	    if (klineType === 'MIN1') {
	      this.handleLackData(data, klineType);
	    }
	    this.handleData(data, klineType);
	  },
	
	  // 给部分美股补分时数据
	  handleLackData: function handleLackData(data, klineType) {
	    var restTime = {};
	    var startTime = (new Date(new Date(last(data).Time * 1000).toLocaleDateString()).getTime() + 9.5 * 3600000) / 1000;
	    var endTime = (new Date(new Date(last(data).Time * 1000).toLocaleDateString()).getTime() + 16 * 3600000) / 1000;
	    if (this.state.region === "HK") {
	      // 港股12-1点不交易
	      restTime.from = (new Date(new Date(last(data).Time * 1000).toLocaleDateString()).getTime() + 12 * 3600000) / 1000;
	      restTime.to = (new Date(new Date(last(data).Time * 1000).toLocaleDateString()).getTime() + 13 * 3600000) / 1000;
	    } else if (this.state.region === "USA") {
	      startTime = startTime + 60;
	    }
	    if (data.length === 1) {
	      var lastData = last(this.dataSet[klineType].t);
	      while (data[0].Time - lastData > 60) {
	        if (restTime.from && restTime.to && data[0].Time - 60 < restTime.to && data[0].Time - 60 > restTime.from) {
	          return;
	        }
	        data.unshift(Object.assign({}, data[0], {
	          Time: data[0].Time - 60
	        }));
	      }
	      return;
	    }
	    var prevT = Infinity,
	        i = 0;
	
	    while (i < data.length) {
	      if (data[i].Time - prevT > 60) {
	        if (restTime.from && restTime.to && prevT + 60 < restTime.to + 1 && prevT + 60 > restTime.from + 1) return;
	        data.splice(i, 0, Object.assign({}, data[i], {
	          Time: prevT + 60,
	          Volume: 0,
	          Amount: 0,
	          TickCount: 0
	        }));
	      }
	      prevT = data[i].Time;
	      i++;
	    }
	    // 补充头部数据
	    if (data[0].Time > startTime) {
	      var length = Math.floor((data[0].Time - startTime) / 60);
	      if (restTime.from && data[0].Time > restTime.from) {
	        if (data[0].Time < restTime.to) {
	          length -= Math.floor((data[0].Time - restTime.from) / 60);
	        } else {
	          length -= 60;
	        }
	      }
	      data.unshift.apply(data, _toConsumableArray(Array(length).fill(Object.assign({}, data[0], { Volume: 0, Amount: 0 }))));
	    }
	    //补充尾部数据
	    if (last(data).Time < endTime && Date.now() / 1000 > endTime) {
	      data.push.apply(data, _toConsumableArray(Array(Math.floor((endTime - last(data).Time) / 60)).fill(last(data))));
	    }
	  },
	  handleData: function handleData(data, klineType) {
	    var _this7 = this;
	
	    var vm = this.state;
	    klineType = klineType || vm.klineType;
	    var limit = vm.klines['MIN1'].limit;
	    var is5day = klineType === '5-MIN1' && data.length > limit;
	    var isMin1 = klineType === 'MIN1';
	    var min1Len = this.dataSet['MIN1'].c.length;
	    // IE: polling should clear up cache
	    if (!ws && isMin1) {
	      this.initDataSet('MIN1');
	    }
	    var _dataSet$klineType = this.dataSet[klineType],
	        h = _dataSet$klineType.h,
	        o = _dataSet$klineType.o,
	        l = _dataSet$klineType.l,
	        c = _dataSet$klineType.c,
	        t = _dataSet$klineType.t,
	        v = _dataSet$klineType.v,
	        a = _dataSet$klineType.a,
	        avg = _dataSet$klineType.avg,
	        totalAmount = _dataSet$klineType.totalAmount,
	        totalVol = _dataSet$klineType.totalVol;
	
	    if (last(t) === last(data).Time) {
	      // 防止分钟k线重复
	      if (!isMin1) return this.renderCandleChart();
	      h.pop();
	      o.pop();
	      l.pop();
	      c.pop();
	      t.pop();
	      avg.pop();
	      totalVol = totalVol - v.pop();
	      totalAmount = totalAmount - a.pop();
	    }
	    if (klineType === 'DAY' && data.length) {
	      var today = charts.getTodayData(this.dataSet.MIN1, last(data));
	      today && data.push(today);
	    }
	    data.forEach(function (el, index) {
	      if (is5day && index % limit === 0) {
	        totalAmount = 0;
	        totalVol = 0;
	        t.push(el.Time + 1);
	        h.push('-');
	        o.push('-');
	        l.push('-');
	        c.push('-');
	        v.push('-');
	        a.push('-');
	        avg.push('-');
	      }
	      totalAmount += el.Amount;
	      totalVol += el.Volume;
	      t.push(el.Time);
	      h.push(el.High);
	      o.push(el.Open);
	      l.push(el.Low);
	      c.push(el.Close);
	      v.push(el.Volume);
	      a.push(el.Amount);
	      avg.push(totalVol ? charts.formatUnit(totalAmount / totalVol, 0) : vm.statistics.preClose);
	    });
	    this.dataSet[klineType].totalAmount = totalAmount;
	    this.dataSet[klineType].totalVol = totalVol;
	    !ws && isMin1 && charts.setTradingFirstBar.call(this, vm.statistics);
	    this.klineDataInit = true;
	    if (klineType === 'DAY' && this.realKlineType) {
	      this.setState({
	        klineType: this.realKlineType
	      }, function () {
	        _this7.realKlineType = null;
	        _this7.getBsSignal();
	      });
	    }
	    if (vm.klineType === 'MIN1') return this.renderMIN1Chart();
	    // 特殊的k线，可能需要借用MIN1作为今日数据
	    if (vm.klineType === '1-MIN1' || vm.klineType === '5-MIN1') return this.borrowMIN1(klineType === 'MIN1', min1Len);
	    if (klineType !== 'MIN1' && this.oldKlineType === vm.klineType) return this.renderCandleChart();
	  },
	  borrowMIN1: function borrowMIN1(isTick, len) {
	    var vm = this.state;
	    var limit = vm.klines['MIN1'].limit;
	    var dataSet = this.dataSet;
	    var debtor = dataSet[vm.klineType];
	    var debtee = dataSet['MIN1'];
	    // 5日数据真空期
	    if (!debtor.t.length && isTick) return;
	    var next = vm.klineType === '5-MIN1' ? this.renderMIN1Chart : this.renderCandleChart;
	    if (last(debtor.t) === last(debtee.t) || !debtee.c.length) return next();
	    // 5日需要切除第一天数据
	    if (!isTick && vm.klineType === '5-MIN1' && debtor.t.length > 4 * limit) {
	      debtor.t.splice(0, limit);
	      debtor.h.splice(0, limit);
	      debtor.o.splice(0, limit);
	      debtor.l.splice(0, limit);
	      debtor.c.splice(0, limit);
	      debtor.v.splice(0, limit);
	      debtor.a.splice(0, limit);
	      debtor.avg.splice(0, limit);
	    }
	    if (isTick) {
	      debtor.t.splice(-len);
	      debtor.h.splice(-len);
	      debtor.o.splice(-len);
	      debtor.l.splice(-len);
	      debtor.c.splice(-len);
	      debtor.v.splice(-len);
	      debtor.a.splice(-len);
	      debtor.avg.splice(-len);
	    }
	    dataSet[vm.klineType] = {
	      t: debtor.t.concat(debtee.t),
	      h: debtor.h.concat(debtee.h),
	      o: debtor.o.concat(debtee.o),
	      l: debtor.l.concat(debtee.l),
	      c: debtor.c.concat(debtee.c),
	      v: debtor.v.concat(debtee.v),
	      a: debtor.a.concat(debtee.a),
	      avg: debtor.avg.concat(debtee.avg),
	      totalAmount: debtee.totalAmount,
	      totalVol: debtee.totalVol
	    };
	    next();
	  },
	  renderMIN1Chart: function renderMIN1Chart() {
	    var vm = this.state;
	    var precision = vm.regionConfig.precision;
	
	    if (!config.tradingKlines.includes(vm.klineType)) return;
	    var myData = this.getMyData();
	    var y0 = charts.createMIN1YAxis(vm, myData);
	    var y1 = charts.createMIN1YAxis(vm, myData);
	    // 处理哈撒韦y轴刻度太长
	    y0.axisLabel.formatter = function (val) {
	      if (val.toString().split('.')[0].length > 5) {
	        return val.toFixed(0);
	      } else {
	        return val.toFixed(precision);
	      }
	    };
	    y0.axisPointer.label.formatter = function (val) {
	      return val.value.toFixed(precision);
	    };
	    y1.axisLabel.formatter = function (val) {
	      return charts.formatUnit((val - vm.statistics.preClose) / vm.statistics.preClose, -2) + '%';
	    };
	    y1.axisPointer.label.formatter = function (val) {
	      return charts.formatUnit((val.value - vm.statistics.preClose) / vm.statistics.preClose, -2) + '%';
	    };
	    var option = {
	      animation: false,
	      grid: vm.topOptions.grid,
	      tooltip: {
	        trigger: 'axis',
	        axisPointer: {
	          type: 'cross',
	          snap: false,
	          lineStyle: {
	            color: '#868C9F'
	          },
	          crossStyle: {
	            color: '#868C9F',
	            type: 'solid'
	          }
	        },
	        transitionDuration: 0,
	        formatter: function (val) {
	          this.createTitleData(val[0].dataIndex);
	          return '';
	        }.bind(this)
	      },
	      xAxis: {
	        type: 'category',
	        show: false,
	        axisPointer: {
	          label: {
	            show: false
	          }
	        },
	        data: vm.klineType === 'MIN1' ? vm.MIN1Time : myData.t
	      },
	      yAxis: [y0, y1],
	      series: charts.createMIN1Series(vm, myData)
	    };
	    this.topChart.setOption(option, true);
	    this.renderBottomChart();
	  },
	  renderCandleChart: function renderCandleChart() {
	    var vm = this.state;
	    if (config.tradingKlines.includes(vm.klineType)) return;
	    var myData = this.getMyData();
	    this.topOption = {
	      animation: false,
	      grid: vm.topOptions.grid,
	      tooltip: {
	        trigger: 'axis',
	        transitionDuration: 0,
	        axisPointer: {
	          type: 'cross',
	          snap: false,
	          lineStyle: {
	            color: '#868C9F'
	          },
	          crossStyle: {
	            color: '#868C9F',
	            type: 'solid'
	          }
	        },
	        formatter: function (val) {
	          this.createTitleData(val[0].dataIndex, val);
	          return '';
	        }.bind(this)
	      },
	      dataZoom: [{
	        type: 'inside',
	        start: charts.getZoomStart(myData.c.length),
	        end: 100,
	        zoomLock: true,
	        zoomOnMouseWhee: false,
	        moveOnMouseMove: false,
	        moveOnMouseWheel: false
	      }],
	      xAxis: {
	        type: 'category',
	        show: false,
	        axisPointer: {
	          label: {
	            show: false
	          }
	        },
	        data: myData.t
	      },
	      yAxis: charts.candle.yAxis(vm),
	      series: charts.candle.series(vm, myData)
	    };
	    this.topChart.setOption(this.topOption, true);
	    this.renderBottomChart();
	  },
	  renderBottomChart: function renderBottomChart() {
	    var vm = this.state;
	    var myData = this.getMyData();
	    var isMin1 = vm.klineType === 'MIN1';
	    var isLikeMin1 = config.tradingKlines.includes(vm.klineType);
	    var techData = charts.bottom.series({
	      type: vm.techType === 'BOLL' ? 'v' : vm.techType,
	      myData: myData
	    });
	    this.setState({
	      bottomRawData: techData.rawData
	    });
	    this.bottomOption = {
	      animation: false,
	      grid: {
	        top: 10,
	        left: vm.isIndex ? 70 : 60,
	        bottom: isLikeMin1 ? 40 : 60,
	        right: 60
	      },
	      dataZoom: isLikeMin1 ? null : function () {
	        var s = charts.getZoomStart(myData.c.length);
	        this.topOption.dataZoom[0].start = s;
	        this.topOption.dataZoom[0].end = 100;
	        this.topOption.dataZoom[0].type = 'inside';
	        this.topChart.setOption(this.topOption, true);
	        return [{
	          type: 'slider',
	          showDetail: false,
	          start: s,
	          end: 100
	        }];
	      }.call(this),
	      tooltip: {
	        trigger: 'axis',
	        transitionDuration: 0,
	        axisPointer: {
	          type: 'cross',
	          snap: false,
	          lineStyle: {
	            color: '#868C9F'
	          },
	          crossStyle: {
	            color: '#868C9F',
	            type: 'solid'
	          }
	        },
	        formatter: function formatter(val) {
	          return '';
	        }
	      },
	      xAxis: {
	        type: 'category',
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          interval: isLikeMin1 ? function (index) {
	            var _vm$klines$vm$klineTy = vm.klines[vm.klineType],
	                limit = _vm$klines$vm$klineTy.limit,
	                remainder = _vm$klines$vm$klineTy.remainder,
	                xMultiple = _vm$klines$vm$klineTy.xMultiple;
	
	            if (isMin1) {
	              if (index % parseInt(limit / 4) === 0) {
	                return true;
	              }
	            } else {
	              return index % xMultiple === remainder;
	            }
	          } : 20,
	          formatter: function formatter(value) {
	            if (!isMin1) return charts.dateFormat(value * 1000, vm.klines[vm.klineType].dateType);
	            var val = value.split(':')[0];
	            if (vm.region === 'CN') {
	              switch (val) {
	                case '13':
	                  return '11:30/13:00';
	                default:
	                  return value;
	              }
	            } else if (vm.region === 'HK') {
	              switch (val) {
	                case '09':
	                  return '09:30';
	                case '10':
	                  return '11:30';
	                case '13':
	                  return '12:00/13:00';
	                case '14':
	                  return '14:30';
	                case '15':
	                  return '16:00';
	              }
	            } else if (vm.region === 'USA') {
	              switch (val) {
	                case '21':
	                  return '21:30';
	                case '23':
	                  return '23:00';
	                case '00':
	                  return '01:00';
	                case '02':
	                  return '02:30';
	                case '03':
	                  return '04:00';
	              }
	            }
	          }
	        },
	        axisPointer: {
	          label: {
	            backgroundColor: 'rgba(0, 0, 0, 0.3)',
	            formatter: function (val) {
	              return isMin1 ? val.value : charts.dateFormat(this.getTimeZone(val.value), vm.klines[vm.klineType].dateType);
	            }.bind(this)
	          }
	        },
	        data: isMin1 ? vm.MIN1Time : myData.t
	      },
	      yAxis: charts.bottom.yAxis(vm, this.singleHand),
	      series: techData.series
	    };
	    this.bottomChart.setOption(this.bottomOption, true);
	    this.resetTitle();
	    !vm.init && this.decorateCharts();
	  },
	  decorateCharts: function decorateCharts() {
	    var _this8 = this;
	
	    this.setState({
	      init: true
	    });
	    this.bottomChart.on('datazoom', function (obj) {
	      if (_this8.state.klineType === 'MIN1') return;
	      _this8.topOption.dataZoom[0].start = obj.start;
	      _this8.topOption.dataZoom[0].end = obj.end;
	      _this8.topOption.dataZoom[0].type = 'inside';
	      _this8.topChart.setOption(_this8.topOption, true);
	      var distance = obj.end - obj.start;
	      if (_this8.oldXaxisLabelDistance !== distance) {
	        _this8.oldXaxisLabelDistance = distance;
	        _this8.bottomChart.setOption({
	          xAxis: {
	            axisLabel: {
	              interval: parseInt((obj.end - obj.start) / 250 * _this8.state.klines[_this8.state.klineType].limit)
	            }
	          }
	        });
	      }
	    });
	    charts.connectCharts([this.topChart, this.bottomChart]);
	  },
	  cacheUsable: function cacheUsable(type) {
	    return !!(this.dataSet.hasOwnProperty(type) && this.dataSet[type].t.length > 0 && ws);
	  },
	  tabMutate: function tabMutate(val) {
	    var _this9 = this;
	
	    var vm = this.state;
	    if (vm.klineType === val) return;
	    if (val === 'BS') return this.getBS(val);
	    var useCache = this.cacheUsable(val);
	    this.klinedatainit = useCache;
	    this.setState({
	      klineType: val
	    }, function () {
	      if (useCache) {
	        config.tradingKlines.includes(_this9.state.klineType) ? _this9.renderMIN1Chart() : _this9.renderCandleChart();
	      } else {
	        _this9.initDataSet(val);
	        _this9.initData();
	      }
	    });
	  },
	  techMutate: function techMutate(val) {
	    var _this10 = this;
	
	    // BOLL is belongs to top chart
	    var renderCandle = this.state.techType === 'BOLL' || val === 'BOLL';
	    this.setState({
	      techType: val
	    }, function () {
	      renderCandle && _this10.renderCandleChart();
	      _this10.renderBottomChart();
	    });
	  },
	  resetTitle: function resetTitle() {
	    var myData = this.getMyData();
	    this.createTitleData(myData.c.length - 1);
	    this.createBottomTitle();
	    this.createSubtitle();
	  },
	  getTimeZone: function getTimeZone(t) {
	    t = +t;
	    if (this.state.region === 'USA') {
	      t = t + 12 * 3600;
	    }
	    return t * 1000;
	  },
	
	  // tips below
	  createTitleData: function createTitleData(index, val) {
	    var vm = this.state;
	    var precision = vm.regionConfig.precision;
	
	    try {
	      var myData = this.getMyData();
	      if (!charts.isDef(myData.c[index])) return this.setState({ titleData: [] });
	      var titleData = [];
	      var prev = myData.c[index - 1] || myData.c[index];
	      if (config.tradingKlines.includes(vm.klineType)) {
	        prev = vm.statistics.preClose;
	        var className = charts.getColorClass(myData.c[index], prev);
	        titleData = [{
	          title: '', value: vm.klineType === 'MIN1' ? vm.MIN1Time[index] : charts.dateFormat(this.getTimeZone(myData.t[index]), 'hh:mm'), className: 'draw-color'
	        }, { title: '价', value: myData.c[index].toFixed(precision), className: className }, { title: '幅', value: (((myData.c[index] - prev) / prev * 100).toFixed(2) || 0) + '%', className: className }, { title: '量', value: formatUnit(myData.v[index] / this.singleHand, false, true, 0), className: 'draw-color' }];
	        !this.state.isIndex && titleData.splice(2, 0, { title: '均', value: myData.avg[index] ? myData.avg[index].toFixed(precision) : 0, className: charts.getColorClass(myData.avg[index], prev) });
	      } else {
	        var _prev = myData.c[index - 1] || myData.c[index];
	        titleData = [{ title: '', value: charts.dateFormat(this.getTimeZone(myData.t[index]), vm.klines[vm.klineType].dateType), className: 'draw-color' }, { title: '开', value: myData.o[index].toFixed(precision), className: charts.getColorClass(myData.o[index], _prev) }, { title: '收', value: myData.c[index].toFixed(precision), className: charts.getColorClass(myData.c[index], _prev) }, { title: '高', value: myData.h[index].toFixed(precision), className: charts.getColorClass(myData.h[index], _prev) }, { title: '低', value: myData.l[index].toFixed(precision), className: charts.getColorClass(myData.l[index], _prev) }, { title: '幅', value: (((myData.c[index] - _prev) / _prev * 100).toFixed(2) || 0) + '%', className: charts.getColorClass(myData.c[index], _prev) }, { title: '量', value: formatUnit(myData.v[index] / this.singleHand, false, true, 0), className: 'draw-color' }];
	      }
	      (vm.techType !== 'v' || vm.techType !== 'BOLL') && this.createBottomTitle(index);
	      !config.tradingKlines.includes(vm.klineType) && this.createSubtitle(val);
	      this.setState({
	        titleData: titleData
	      });
	    } catch (e) {}
	  },
	  createSubtitle: function createSubtitle(val) {
	    var _this11 = this;
	
	    var subTitleData = val instanceof Array ? val.slice(1).map(function (item) {
	      return {
	        title: item.seriesName,
	        color: item.color,
	        value: item.value ? item.value.toFixed(_this11.state.regionConfig.precision) : '-'
	      };
	    }) : [];
	    this.setState({
	      subTitleData: subTitleData
	    });
	  },
	  createBottomTitle: function createBottomTitle(index) {
	    var vm = this.state;
	    this.setState({
	      bottomTitleData: charts.isDef(vm.bottomRawData) && charts.isDef(index) ? vm.bottomRawData.map(function (item) {
	        return {
	          title: item.name,
	          value: formatUnit(item.data[index]),
	          color: item.color
	        };
	      }) : []
	    });
	  },
	  getTitle: function getTitle() {
	    var vm = this.state;
	    return vm.titleData.map(function (item, index) {
	      return React.createElement(
	        'span',
	        { key: index },
	        item.title,
	        React.createElement(
	          'span',
	          {
	            style: { paddingLeft: '4px' },
	            key: index,
	            className: item.className
	          },
	          item.value
	        )
	      );
	    });
	  },
	  getSubtitle: function getSubtitle() {
	    var vm = this.state;
	    return vm.subTitleData.map(function (item, index) {
	      return React.createElement(
	        'span',
	        { key: index, style: { color: item.color } },
	        item.title,
	        React.createElement(
	          'span',
	          {
	            style: { paddingLeft: '4px' },
	            key: index
	          },
	          item.value
	        )
	      );
	    });
	  },
	  getBottomTitle: function getBottomTitle() {
	    var vm = this.state;
	    return vm.bottomTitleData.map(function (item, index) {
	      return React.createElement(
	        'span',
	        { key: index, style: { color: item.color } },
	        item.title,
	        React.createElement(
	          'span',
	          {
	            style: { paddingLeft: '4px' },
	            key: index
	          },
	          item.value
	        )
	      );
	    });
	  },
	
	
	  render: function render() {
	    this.state.isIndex = getIsIndexStock(this.props.symbol, this.props.market);
	    return React.createElement(
	      'div',
	      { className: 'block--chart-wrap', style: { width: this.state.isIndex ? getIsAIndexStock(this.props.symbol, this.props.market) ? '893px' : '100%' : '', height: this.state.isIndex ? '513px' : '' } },
	      React.createElement('img', { className: 'chart-icon', src: 'https://upload.9fzt.com/production/9fzt-stock-pc-ssr/assets/mainchart/icon-chart-logo.png' }),
	      React.createElement(MainChartsTab, { currentTab: this.tabMutate }),
	      React.createElement(
	        'p',
	        { className: 'main-chart-title' },
	        this.getTitle.call(this)
	      ),
	      React.createElement(
	        'div',
	        { className: 'main-chart-subtitle' },
	        this.getSubtitle.call(this)
	      ),
	      React.createElement(
	        'div',
	        { className: 'main-chart-bottomtitle' },
	        this.getBottomTitle.call(this)
	      ),
	      React.createElement('div', { id: 'main-chart-top', style: { height: this.state.isIndex ? '304px' : '164px', width: '100%' } }),
	      React.createElement(MainChartsTech, {
	        tradingKlines: this.state.tradingKlines,
	        klineType: this.state.klineType,
	        currentTech: this.techMutate }),
	      React.createElement('div', { id: 'main-chart-bottom', style: { height: '128px', width: '100%' } })
	    );
	  }
	});

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(27);
	var $ = __webpack_require__(205);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	  getInitialState: function getInitialState() {
	    return {
	      tabs: [{ value: 'MIN1', label: '分时' }, { value: '5-MIN1', label: '5日' }, { value: 'DAY', label: '日K' }, { value: 'WEEK', label: '周K' }, { value: 'MONTH', label: '月K' },
	      // {value: 'BS', label: '多空'}, 
	      { value: 'mins', label: '分钟' }],
	      minTabs: [],
	      minIndex: -1,
	      mins: [{ value: '1-MIN1', label: '1分' }, { value: 'MIN5', label: '5分' }, { value: 'MIN15', label: '15分' }, { value: 'MIN30', label: '30分' }, { value: 'MIN60', label: '60分' }],
	      currentItem: 'MIN1'
	    };
	  },
	  handleClick: function handleClick(val) {
	    var _this = this;
	
	    var minTabs = [];
	    var minIndex = void 0;
	    if (val !== 'mins') {
	      this.props.currentTab(val);
	      minIndex = this.state.mins.findIndex(function (item) {
	        return item.value === val;
	      });
	    } else {
	      this.oldItem = this.state.currentItem;
	      if (this.state.minTabs.length) {
	        minTabs = [];
	      } else {
	        minTabs = this.state.mins;
	        $('body').one('click', function () {
	          _this.handleClick(_this.oldItem);
	        });
	      }
	      minIndex = this.state.minIndex;
	    }
	    setTimeout(function () {
	      _this.setState({
	        minTabs: minTabs,
	        minIndex: minIndex,
	        currentItem: minIndex > -1 ? 'mins' : val
	      });
	    }, 20);
	  },
	  getItemClass: function getItemClass(val) {
	    return val === this.state.currentItem ? 'active text-wrapper' : 'text-wrapper';
	  },
	  createDom: function createDom() {
	    var _this2 = this;
	
	    return this.state.tabs.map(function (item, index) {
	      var _React$createElement;
	
	      return React.createElement(
	        'span',
	        (_React$createElement = { key: index,
	          className: _this2.getItemClass.call(_this2, item.value)
	        }, _defineProperty(_React$createElement, 'key', item.value), _defineProperty(_React$createElement, 'onClick', _this2.handleClick.bind(_this2, item.value)), _React$createElement),
	        item.value === 'mins' && _this2.state.minIndex > -1 ? _this2.state.mins[_this2.state.minIndex].label : item.label,
	        item.value === 'mins' && React.createElement('div', { className: 'tab-arrow' })
	      );
	    });
	  },
	  createMins: function createMins() {
	    var _this3 = this;
	
	    return this.state.minTabs.map(function (item, index) {
	      var _React$createElement2;
	
	      return React.createElement(
	        'span',
	        (_React$createElement2 = { key: index,
	          className: _this3.getItemClass.call(_this3, item.value)
	        }, _defineProperty(_React$createElement2, 'key', item.value), _defineProperty(_React$createElement2, 'onClick', _this3.handleClick.bind(_this3, item.value)), _React$createElement2),
	        item.label
	      );
	    });
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'main-charts-tab' },
	      this.createDom.call(this),
	      React.createElement(
	        'div',
	        { className: 'main-charts-subtab' },
	        this.createMins.call(this)
	      )
	    );
	  }
	});

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(27);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	  getInitialState: function getInitialState() {
	    return {
	      tabs: [{ value: 'v', label: '成交量' }, { value: 'MACD', label: 'MACD' }, { value: 'KDJ', label: 'KDJ' }, { value: 'RSI', label: 'RSI' }, { value: 'BIAS', label: 'BIAS' }, { value: 'CCI', label: 'CCI' }, { value: 'BOLL', label: 'BOLL' },
	      // {value: 'WR', label: 'WR'},
	      { value: 'OBV', label: 'OBV' }],
	      currentItem: 'v',
	      klineType: 'MIN1'
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (nextProps.klineType !== this.state.klineType || nextState.currentItem !== this.state.currentItem) {
	      if (this.props.tradingKlines.includes(nextProps.klineType)) {
	        this.handleClick('v');
	      }
	      this.setState({
	        klineType: this.props.klineType
	      });
	      return true;
	    }
	    return false;
	  },
	  handleClick: function handleClick(val) {
	    if (this.state.currentItem === val) return;
	    this.setState({
	      currentItem: val
	    });
	    this.props.currentTech(val);
	  },
	  getItemClass: function getItemClass(val) {
	    if (val === 'v' && this.state.currentItem === 'BOLL') return 'active';
	    return val === this.state.currentItem ? 'active' : '';
	  },
	  createTechTabs: function createTechTabs() {
	    var _this = this;
	
	    var isTrading = this.props.tradingKlines.includes(this.props.klineType);
	    return this.state.tabs.map(function (item) {
	      if (isTrading && item.value !== 'v') return;
	      return React.createElement(
	        'span',
	        {
	          key: item.value,
	          className: _this.getItemClass.call(_this, item.value),
	          onClick: _this.handleClick.bind(_this, item.value)
	        },
	        item.label
	      );
	    });
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'main-chart-techs' },
	      this.createTechTabs.call(this)
	    );
	  }
	});

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var unitUtils = __webpack_require__(206);
	var indicatorGenerator = __webpack_require__(237);
	var BS = __webpack_require__(239);
	var last = __webpack_require__(240);
	
	var RISE = '#D4332F';
	var FALL = '#258D01';
	
	var hasWS = typeof window.WebSocket === 'function';
	
	var getRoundedTime = function getRoundedTime(resolution, time) {
	  var coeff = 60 * 1000;
	  var rounded = void 0;
	  coeff *= resolution;
	  rounded = Math.ceil(time / coeff) * coeff;
	  return rounded;
	};
	
	var tradingTime = {
	  timeList: function timeList(h, m, len, removeStartIndex, removeLen) {
	    var res = [];
	    while (len--) {
	      res.push((h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m));
	      m++;
	      if (m === 60) {
	        h++;
	        if (h === 24) {
	          h = 0;
	        }
	        m = 0;
	      }
	    }
	    res.splice(removeStartIndex, removeLen);
	    return res;
	  },
	  CN: function CN() {
	    return this.timeList(9, 30, 331, 120, 90);
	  },
	  HK: function HK() {
	    return this.timeList(9, 30, 391, 150, 60);
	  },
	  USA: function USA() {
	    return this.timeList(21, 31, 390, 0, 0);
	  },
	  create: function create(region) {
	    return tradingTime[region]();
	  }
	};
	
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	
	function formatUnit(data) {
	  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	  var str = arguments[2];
	  var precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
	
	  if (!isDef(data)) return data;
	  data = data / Math.pow(10, n);
	  data = +data.toFixed(precision) === 0 ? 0 : data; // 去掉-0
	  return str ? data.toFixed(precision) : Number(data.toFixed(precision));
	}
	
	function createBaseLine(val) {
	  if (!isDef(val)) {
	    val = 0;
	  }
	  return Array.apply(null, { length: 1200 }).map(function () {
	    return val;
	  });
	}
	
	function dateFormat(val, format) {
	  val = typeof val === 'number' ? new Date(val) : val;
	  var o = {
	    'M+': val.getMonth() + 1, //month
	    'd+': val.getDate(), //day
	    'h+': val.getHours(), //hour
	    'm+': val.getMinutes(), //minute
	    's+': val.getSeconds() //second
	  };
	  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (val.getFullYear() + '').substr(4 - RegExp.$1.length));
	  for (var k in o) {
	    if (new RegExp('(' + k + ')').test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	  }return format;
	}
	
	function genUid(a, b) {
	  return a + ':' + b;
	}
	
	/**
	 *
	 * @param {prise} a
	 * @param {base} b
	 */
	function getColorClass(a, b) {
	  a = a - b;
	  if (a < 0) return 'fall-color';
	  if (a > 0) return 'rise-color';
	  if (a === 0) return 'draw-color';
	}
	
	function getColorStyle(a, b) {
	  a = a - b;
	  if (a < 0) return FALL;
	  if (a > 0) return RISE;
	  if (a === 0) return '#666';
	}
	
	function getTodayData(min1, lastDay) {
	  if (!min1.c.length || min1.t[0] - lastDay.TradingDay < 24 * 3600) return;
	  var a = 0,
	      v = 0,
	      h = -Infinity,
	      l = Infinity;
	  min1.a.forEach(function (item) {
	    return a += item;
	  });
	  min1.v.forEach(function (item) {
	    return v += item;
	  });
	  min1.h.forEach(function (item) {
	    h = item > h ? item : h;
	  });
	  min1.l.forEach(function (item) {
	    l = item < l ? item : l;
	  });
	  return {
	    Time: min1.t[0],
	    Open: min1.o[0],
	    Close: last(min1.c),
	    High: h,
	    Low: l,
	    Amount: a,
	    Volume: v
	  };
	}
	
	/**
	 * ============================= shared utils end
	 */
	
	function setTradingFirstBar(_ref) {
	  var tradingDay = _ref.tradingDay,
	      open = _ref.open;
	
	  var min1 = this.dataSet['MIN1'];
	  min1.t.unshift(tradingDay + 9.5 * 3600);
	  min1.h.unshift(open);
	  min1.l.unshift(open);
	  min1.o.unshift(open);
	  min1.c.unshift(open);
	  min1.a.unshift(0);
	  min1.v.unshift(1);
	  min1.avg.unshift(open);
	}
	
	function createArea(base) {
	  return hasWS ? {
	    type: 'line',
	    smooth: true,
	    lineStyle: {
	      width: 1,
	      color: base + ')'
	    },
	    areaStyle: {
	      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
	        offset: 0,
	        color: base + ',0.2)'
	      }, {
	        offset: 1,
	        color: base + ',0.03)'
	      }])
	    }
	  } : {
	    type: 'line',
	    smooth: true,
	    lineStyle: {
	      width: 1,
	      color: base + ')'
	    }
	  };
	}
	
	var connectCharts = function connectCharts(chartList) {
	  echarts.util.each(chartList, function (fromChart) {
	    echarts.util.each(chartList, function (toChart) {
	      if (fromChart === toChart) return;
	      fromChart.on('updateAxisPointer', function (params) {
	        var payload = toChart.makeActionFromEvent(params);
	        var axesInfo = payload.axesInfo || [];
	        for (var i = axesInfo.length - 1; i >= 0; i--) {
	          if (axesInfo[i].axisDim === 'y') {
	            axesInfo.splice(i, 1);
	          }
	        }
	        toChart.dispatchAction(payload, true);
	      });
	    });
	  });
	};
	
	function getZoomStart(val) {
	  return 100 - 48 / val * 100;
	}
	
	function calculateMA(data, dayCount) {
	  var result = [];
	  var sum = 0;
	  data[-1] = 0;
	  for (var i = 0, len = data.length; i < len; i++) {
	    sum += data[i];
	    if (i < dayCount - 1) {
	      result.push('');
	    } else {
	      sum -= data[i - dayCount];
	      result.push(sum / dayCount);
	    }
	  }
	  delete data[-1];
	  return result;
	}
	
	function createMA(data, d, color) {
	  return {
	    type: 'line',
	    name: 'MA' + d,
	    data: calculateMA(data, d),
	    symbol: 'none',
	    smooth: true,
	    color: color,
	    lineStyle: {
	      width: 1
	    }
	  };
	}
	
	// ========================= MIN1
	function createMIN1YAxis(vm, myData) {
	  var preClose = vm.statistics.preClose;
	  var maxGap = -Infinity,
	      minGap = Infinity;
	  var len = myData.c.length;
	  var i = 0;
	  while (i < len) {
	    if (myData.h[i] > maxGap) maxGap = myData.h[i];
	    if (myData.l[i] < minGap) minGap = myData.l[i];
	    i++;
	  }
	  maxGap = Math.abs(maxGap - preClose);
	  minGap = Math.abs(minGap - preClose);
	  maxGap = Math.max(maxGap, minGap);
	  maxGap = maxGap || preClose * 0.05;
	  return {
	    type: 'value',
	    axisTick: {
	      show: false
	    },
	    axisLabel: {
	      margin: 3,
	      color: function color(val) {
	        return getColorStyle(formatUnit(val, 0), formatUnit(preClose, 0));
	      }
	    },
	    axisPointer: {
	      label: {
	        backgroundColor: 'rgba(0, 0, 0, 0.5)'
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        color: '#DCDCDC'
	      }
	    },
	    axisLine: {
	      lineStyle: {
	        color: '#ccc'
	      }
	    },
	    max: function max() {
	      return formatUnit(preClose + maxGap, 0, true, 3);
	    },
	    min: function min() {
	      return formatUnit(preClose - maxGap, 0, true, 3);
	    },
	
	    interval: maxGap / 2
	  };
	}
	// ================================== Candle
	/**
	 * input: 多个一维数组
	 * output: 二维数组
	 */
	function genCandleData() {
	  var args = Array.prototype.slice.call(arguments);
	  var len = args.length;
	  var res = [];
	  args[0].forEach(function (el, index) {
	    var temp = [];
	    var i = 0;
	    while (i < len) {
	      temp.push(args[i][index]);
	      i++;
	    }
	    res.push(temp);
	  });
	  return res;
	}
	
	var candle = {
	  series: function series(vm, myData) {
	    var series = [{
	      type: 'candlestick',
	      itemStyle: {
	        color: '#D4332F',
	        color0: '#258D01',
	        borderColor: '#D4332F',
	        borderColor0: '#258D01'
	      },
	      data: genCandleData(myData.o, myData.c, myData.l, myData.h)
	    }];
	    if (vm.techType === 'BOLL') {
	      series = series.concat(indicatorGenerator.createBOLL(myData.c).series);
	    } else {
	      series.push(createMA(myData.c, 5, '#076FFD'), createMA(myData.c, 10, '#994300'), createMA(myData.c, 20, '#D330FF'));
	    }
	    myData.bs && vm.klineType === 'BS' && series.push(BS.series(myData.bs));
	    return series;
	  },
	  yAxis: function yAxis(vm) {
	    var _ref2;
	
	    return _ref2 = {
	      type: 'value',
	      splitNumber: 3,
	      axisTick: {
	        show: false
	      },
	      axisLine: {
	        lineStyle: {
	          color: '#DCDCDC'
	        }
	      },
	      splitLine: {
	        lineStyle: {
	          color: '#DCDCDC'
	        }
	      },
	      axisPointer: {
	        label: {
	          backgroundColor: 'rgba(0, 0, 0, 0.5)',
	          formatter: function formatter(val) {
	            return val.value.toFixed(vm.regionConfig.precision);
	          }
	        }
	      },
	      axisLabel: {
	        color: '#666',
	        margin: 3,
	        formatter: function formatter(val) {
	          // 处理哈撒韦y轴刻度太长
	          if (val.toString().split('.')[0].length > 5) {
	            return val.toFixed(0);
	          } else {
	            return val.toFixed(vm.regionConfig.precision);
	          }
	        }
	      }
	    }, _defineProperty(_ref2, 'splitNumber', 4), _defineProperty(_ref2, 'scale', true), _ref2;
	  }
	};
	
	// =========================== Bottom
	
	var bottom = {
	  yFormatter: function yFormatter(type, val, singleHand) {
	    if (type === 'v' || type === 'BOLL') return unitUtils.formatUnit(val / singleHand, false, true, 0);
	    if (type === 'OBV') return unitUtils.formatUnit(val, false, true, 0);
	    return formatUnit(val, 0);
	  },
	  yAxis: function yAxis(vm, singleHand) {
	    return {
	      type: 'value',
	      splitNumber: 3,
	      axisTick: {
	        show: false
	      },
	      axisPointer: {
	        label: {
	          backgroundColor: 'rgba(0, 0, 0, 0.5)',
	          formatter: function formatter(val) {
	            return bottom.yFormatter(vm.techType, val.value, singleHand);
	          }
	        }
	      },
	      axisLine: {
	        lineStyle: {
	          color: '#DCDCDC'
	        }
	      },
	      splitLine: {
	        lineStyle: {
	          color: '#DCDCDC'
	        }
	      },
	      axisLabel: {
	        color: '#666666',
	        margin: 3,
	        formatter: function formatter(val) {
	          return bottom.yFormatter(vm.techType, val, singleHand);
	        }
	      }
	    };
	  },
	  series: function series(_ref3) {
	    var type = _ref3.type,
	        myData = _ref3.myData;
	
	    if (type === 'v') {
	      return {
	        rawData: null,
	        series: [{
	          type: 'bar',
	          itemStyle: {
	            color: function color(params) {
	              var index = params.dataIndex;
	              return myData.c[index] < (myData.c[index - 1] || myData.c[index]) ? FALL : RISE;
	            }
	          },
	          data: myData.v
	        }]
	      };
	    }
	    var data = void 0;
	    if (type === 'MACD' || type === 'KDJ' || type === 'CCI' || type === 'WR') {
	      data = genCandleData(myData.o, myData.c, myData.l, myData.h);
	    }
	    if (type === 'RSI' || type === 'BOLL' || type === 'BIAS') {
	      data = myData.c;
	    }
	    if (type === 'OBV') {
	      data = genCandleData(myData.c, myData.v);
	    }
	    if (!data) return { series: [], rawData: [] };
	    return indicatorGenerator['create' + type](data);
	  }
	};
	
	// ======================== Series
	function createMIN1Series(vm, myData) {
	  var series = [Object.assign({}, createArea('rgba(122, 165, 210'), {
	    symbol: 'none',
	    data: myData.c
	  }), {
	    yAxisIndex: 1,
	    symbol: 'none',
	    type: 'line',
	    lineStyle: {
	      width: 0
	    },
	    data: myData.c
	  }];
	  !vm.isIndex && series.push({
	    type: 'line',
	    smooth: true,
	    symbol: 'none',
	    lineStyle: {
	      width: 1,
	      color: '#E7C25D'
	    },
	    data: myData.avg
	  });
	  return series;
	}
	
	module.exports = {
	  getRoundedTime: getRoundedTime,
	  tradingTime: tradingTime,
	  createArea: createArea,
	  connectCharts: connectCharts,
	  isDef: isDef,
	  formatUnit: formatUnit,
	  createBaseLine: createBaseLine,
	  getColorClass: getColorClass,
	  getColorStyle: getColorStyle,
	  getTodayData: getTodayData,
	  setTradingFirstBar: setTradingFirstBar,
	  dateFormat: dateFormat,
	  genUid: genUid,
	  getZoomStart: getZoomStart,
	  calculateMA: calculateMA,
	  createMA: createMA,
	  createMIN1YAxis: createMIN1YAxis,
	  genCandleData: genCandleData,
	  candle: candle,
	  bottom: bottom,
	  BS: BS,
	  createMIN1Series: createMIN1Series
	};

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Indicator = __webpack_require__(238);
	var RISE = '#D4332F';
	var FALL = '#258D01';
	
	var lineColor = ['#D330FF', '#994300', '#39afe6'];
	
	function createLines(arr) {
	  return arr.map(function (_ref) {
	    var name = _ref.name,
	        color = _ref.color,
	        data = _ref.data;
	
	    return {
	      name: name,
	      type: 'line',
	      symbol: "none",
	      data: data,
	      lineStyle: {
	        normal: {
	          color: color,
	          width: 1
	        }
	      }
	    };
	  });
	}
	
	function createMACD(data) {
	  var res = Indicator.MACD(12, 26, 9, data, 1);
	  var rawData = [{ name: 'MACD', color: '#666', data: res.macd }, { name: 'DIF', color: '#da6ee8', data: res.dif }, { name: 'DEA', color: '#39afe6', data: res.dea }];
	  var series = [{
	    name: 'MACD',
	    type: 'bar',
	    data: res.macd,
	    barWidth: '40%',
	    itemStyle: {
	      normal: {
	        color: function color(params) {
	          return params.data >= 0 ? RISE : FALL;
	        }
	      }
	    }
	  }].concat(createLines(rawData.slice(1)));
	  return {
	    series: series,
	    rawData: rawData
	  };
	}
	
	var createKDJ = function createKDJ(data) {
	  var res = Indicator.KDJ(data);
	  var rawData = [{ name: 'K', color: lineColor[0], data: res.k }, { name: 'D', color: lineColor[1], data: res.d }, { name: 'J', color: lineColor[2], data: res.j }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createRSI = function createRSI(data) {
	  var res = Indicator.RSI(data);
	  var rawData = [{ name: 'RSI6', color: lineColor[0], data: res.rsi6 }, { name: 'RSI12', color: lineColor[1], data: res.rsi12 }, { name: 'RSI24', color: lineColor[2], data: res.rsi24 }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createBOLL = function createBOLL(data) {
	  var res = Indicator.BOLL(data);
	  var rawData = [{ name: 'UPPER', color: lineColor[0], data: res.upper }, { name: 'MID', color: lineColor[1], data: res.mid }, { name: 'LOWER', color: lineColor[2], data: res.lower }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createOBV = function createOBV(data) {
	  var res = Indicator.OBV(data);
	  var rawData = [{ name: 'OBV', color: lineColor[0], data: res }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createBIAS = function createBIAS(data) {
	  var res = Indicator.BIAS(data);
	  var rawData = [{ name: 'BIAS6', color: lineColor[0], data: res[0] }, { name: 'BIAS12', color: lineColor[1], data: res[1] }, { name: 'BIAS24', color: lineColor[2], data: res[2] }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createCCI = function createCCI(data) {
	  var res = Indicator.CCI(data);
	  var rawData = [{ name: 'CCI', color: lineColor[0], data: res }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	var createWR = function createWR(data) {
	  var res = Indicator.WR(data);
	  var rawData = [{ name: 'WR6', color: lineColor[0], data: res[0] }, { name: 'WR10', color: lineColor[1], data: res[1] }];
	  return {
	    series: createLines(rawData),
	    rawData: rawData
	  };
	};
	
	module.exports = {
	  createMACD: createMACD,
	  createKDJ: createKDJ,
	  createRSI: createRSI,
	  createBOLL: createBOLL,
	  createOBV: createOBV,
	  createBIAS: createBIAS,
	  createCCI: createCCI,
	  createWR: createWR
	};

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	"use strict";
	
	var Indicator = function () {
	  /**
	   * 计算obv指标
	   *
	   * @method OBV
	   * @param {Array} ticks
	   * ticks为二维数组类型，其中内层数组第一个值为收盘价，第二个值为成交量
	   * @return {Array} obvs
	   */
	  var obv = function obv(ticks) {
	    var lastTick,
	        obvs = [],
	        length = ticks.length;
	    for (var i = 0; i < length; i++) {
	      var value = 0,
	          curTick = ticks[i];
	      if (i != 0) {
	        var lastObvValue = obvs[i - 1];
	        if (curTick[0] >= lastTick[0]) {
	          value = lastObvValue + curTick[1];
	        } else {
	          value = lastObvValue - curTick[1];
	        }
	      }
	      obvs.push(value);
	      lastTick = curTick;
	    }
	    return obvs;
	  };
	
	  var calcEMA = function calcEMA(n, data, field) {
	    var i, l, ema, a;
	    a = 2 / (n + 1);
	    if (field) {
	      ema = [data[0][field]];
	      for (i = 1, l = data.length; i < l; i++) {
	        ema.push((a * data[i][field] + (1 - a) * ema[i - 1]).toFixed(2));
	      }
	    } else {
	      ema = [data[0]];
	      for (i = 1, l = data.length; i < l; i++) {
	        ema.push((a * data[i] + (1 - a) * ema[i - 1]).toFixed(3));
	      }
	    }
	    return ema;
	  };
	
	  var calcDIF = function calcDIF(short, long, data, field) {
	    var i, l, dif, emaShort, emaLong;
	    dif = [];
	    emaShort = calcEMA(short, data, field);
	    emaLong = calcEMA(long, data, field);
	    for (i = 0, l = data.length; i < l; i++) {
	      dif.push(emaShort[i] - emaLong[i]);
	    }
	    return dif;
	  };
	
	  var calcDEA = function calcDEA(mid, dif) {
	    return calcEMA(mid, dif);
	  };
	
	  /*
	   * 计算MACD
	   * @param {number} short 快速EMA时间窗口
	   * @param {number} long 慢速EMA时间窗口
	   * @param {number} mid dea时间窗口
	   * @param {array} data 输入数据
	   * @param {string} field 计算字段配置
	   */
	  var calcMACD = function calcMACD(short, long, mid, data, field) {
	    var i, l, dif, dea, macd, result;
	    result = {};
	    macd = [];
	    dif = calcDIF(short, long, data, field);
	    dea = calcDEA(mid, dif);
	    for (i = 0, l = data.length; i < l; i++) {
	      macd.push((dif[i] - dea[i]) * 2);
	    }
	    result.dif = dif.map(function (item) {
	      return Number(item);
	    });
	    result.dea = dea.map(function (item) {
	      return Number(item);
	    });
	    result.macd = macd.map(function (item) {
	      return Number(item);
	    });
	    return result;
	  };
	
	  var getMaxHighAndMinLow = function getMaxHighAndMinLow(ticks) {
	    var maxHigh = ticks[0][3],
	        minLow = ticks[0][2];
	    for (var i = 0; i < ticks.length; i++) {
	      var t = ticks[i],
	          high = t[3],
	          low = t[2];
	      if (high > maxHigh) {
	        maxHigh = high;
	      }
	      if (low < minLow) {
	        minLow = low;
	      }
	    }
	    return [maxHigh, minLow];
	  };
	
	  /**
	   *
	   * 计算kdj指标,rsv的周期为9日
	   *
	   * @method KDJ
	   * @param {Array} ticks
	   * 二维数组类型，其中内层数组包含三个元素值，第一个值表示当前Tick的最高价格，第二个表示当前Tick的最低价格，第三个表示当前Tick的收盘价格
	   * @return {Object} 返回一个包含k d j属性的对象,每个属性对应的类型为{Array[Number]}
	   */
	  var kdj = function kdj(ticks) {
	    var nineDaysTicks = [],
	        days = 9,
	        rsvs = [];
	    var ks = [],
	        ds = [],
	        js = [];
	    var lastK, lastD, curK, curD;
	    var maxAndMin, max, min;
	    for (var i = 0; i < ticks.length; i++) {
	      var t = ticks[i],
	          close = t[1];
	      nineDaysTicks.push(t);
	      maxAndMin = getMaxHighAndMinLow(nineDaysTicks);
	      max = maxAndMin[0];
	      min = maxAndMin[1];
	      if (max == min) {
	        rsvs.push(0);
	      } else {
	        rsvs.push((close - min) / (max - min) * 100);
	      }
	      if (nineDaysTicks.length == days) {
	        nineDaysTicks.shift();
	      }
	      if (i == 0) {
	        lastK = lastD = rsvs[i];
	      }
	      curK = 2 / 3 * lastK + 1 / 3 * rsvs[i];
	      ks.push(curK);
	      lastK = curK;
	
	      curD = 2 / 3 * lastD + 1 / 3 * curK;
	      ds.push(curD);
	      lastD = curD;
	
	      js.push(3 * curK - 2 * curD);
	    }
	    return { "k": ks, "d": ds, "j": js };
	  };
	
	  /**
	   *
	   * 计算boll指标,ma的周期为20日
	   *
	   * @method BOLL
	   * @param {Array} ticks
	   * 一维数组类型，每个元素为当前Tick的收盘价格
	   * @return {Object} 返回一个包含upper mid lower属性的对象,每个属性对应的类型为{Array[Number]}
	   */
	  var boll = function boll(ticks) {
	    //移动平均线周期为20
	    var maDays = 20,
	        tickBegin = maDays - 1,
	        maSum = 0,
	        p = 0;
	    var ups = [],
	        mas = [],
	        lows = [];
	    for (var i = 0; i < ticks.length; i++) {
	      var c = ticks[i],
	          ma,
	          md,
	          bstart,
	          mdSum;
	      maSum += c;
	      if (i >= tickBegin) {
	        maSum = maSum - p;
	        ma = maSum / maDays;
	        mas.push(ma);
	        bstart = i - tickBegin;
	        p = ticks[bstart];
	        mdSum = ticks.slice(bstart, bstart + maDays).reduce(function (a, b) {
	          return a + Math.pow(b - ma, 2);
	        }, 0);
	        md = Math.sqrt(mdSum / maDays);
	        ups.push(ma + 2 * md);
	        lows.push(ma - 2 * md);
	      } else {
	        //ugly constant, just keep the same type for client
	        ups.push('');
	        mas.push('');
	        lows.push('');
	      }
	    }
	    return { "upper": ups, "mid": mas, "lower": lows };
	  };
	
	  /**
	   *
	   * 计算rsi指标,分别返回以6日，12日，24日为参考基期的RSI值
	   *
	   * @method RSI
	   * @param {Array} ticks
	   * 一维数组类型，每个元素为当前Tick的收盘价格
	   * @return {Object} 返回一个包含rsi6 rsi12 rsi24属性的对象,每个属性对应的类型为{Array[Number]}
	   */
	  var rsi = function rsi(ticks) {
	    var lastClosePx = ticks[0];
	    var days = [6, 12, 24],
	        result = {};
	    for (var i = 0; i < ticks.length; i++) {
	      var c = ticks[i];
	      var m = Math.max(c - lastClosePx, 0),
	          a = Math.abs(c - lastClosePx);
	      for (var di = 0; di < days.length; di++) {
	        var d = days[di];
	        if (!result.hasOwnProperty("rsi" + d)) {
	          result["lastSm" + d] = result["lastSa" + d] = 0;
	          result["rsi" + d] = [0];
	        } else {
	          result["lastSm" + d] = (m + (d - 1) * result["lastSm" + d]) / d;
	          result["lastSa" + d] = (a + (d - 1) * result["lastSa" + d]) / d;
	          if (result["lastSa" + d] != 0) {
	            result["rsi" + d].push(result["lastSm" + d] / result["lastSa" + d] * 100);
	          } else {
	            result["rsi" + d].push(0);
	          }
	        }
	      }
	      lastClosePx = c;
	    }
	    days.forEach(function (key) {
	      result["rsi" + key] = result["rsi" + key].map(function (item, index) {
	        if (index < key) item = '';
	        return item;
	      });
	    });
	    return { "rsi6": result["rsi6"], "rsi12": result["rsi12"], "rsi24": result["rsi24"] };
	  };
	
	  var getMa = function getMa(data, dayCount) {
	    var result = [];
	    var sum = 0;
	    data[-1] = 0;
	    for (var i = 0, len = data.length; i < len; i++) {
	      sum += data[i];
	      if (i < dayCount - 1) {
	        result.push('-');
	      } else {
	        sum -= data[i - dayCount];
	        result.push(sum / dayCount);
	      }
	    }
	    delete data[-1];
	    return result;
	  };
	
	  var biasCalc = function biasCalc(ticks, days) {
	    var ma = getMa(ticks, days);
	    return ticks.map(function (c, index) {
	      if (index < days) return '-';
	      return 100 * (c - ma[index]) / ma[index];
	    });
	  };
	
	  var bias = function bias(ticks) {
	    return [biasCalc(ticks, 6), biasCalc(ticks, 12), biasCalc(ticks, 24)];
	  };
	
	  var getTyp = function getTyp(ticks) {
	    return ticks.map(function (tick) {
	      return (tick[1] + tick[2] + tick[3]) / 3;
	    });
	  };
	
	  var getAve = function getAve(typ, typMA, days) {
	    var res = [];
	    var sum = 0;
	    typ[-1] = 0;
	    typMA[-1] = 0;
	    for (var i = 0; i < typ.length; ++i) {
	      if (i < days - 1) {
	        res.push('-');
	        continue;
	      }
	      var _sum = 0;
	      for (var j = 0; j < days; ++j) {
	        _sum += Math.abs(typ[i - j] - typMA[i]);
	      }
	      res.push(_sum / days);
	    }
	    delete typ[-1];
	    delete typMA[-1];
	    return res;
	  };
	
	  var cci = function cci(ticks) {
	    var typ = getTyp(ticks);
	    var typMA = getMa(typ, 14);
	    var ave = getAve(typ, typMA, 14);
	    var res = [];
	    ticks.forEach(function (item, index) {
	      if (index < 13) return res.push('-');
	      var t = (typ[index] - typMA[index]) / ave[index] / 0.015;
	      res.push(t);
	    });
	    return res;
	  };
	
	  var getHighAndLow = function getHighAndLow(ticks, days) {
	
	    ticks.forEach(function (item) {});
	    return {
	      H: H,
	      L: L
	    };
	  };
	
	  var calcWr = function calcWr(ticks, days) {
	    var H = getMaxHighAndMinLow.H,
	        L = getMaxHighAndMinLow.L;
	
	    return ticks.map(function (item, index) {
	      return 100 * (H[index] - item[1]) / (H[index] - L[index]);
	    });
	  };
	
	  var wr = function wr(ticks) {
	    return [calcWr(ticks, 6), calcWr(ticks, 10)];
	  };
	
	  return {
	    "OBV": obv,
	    "MACD": calcMACD,
	    "KDJ": kdj,
	    "BOLL": boll,
	    "RSI": rsi,
	    'BIAS': bias,
	    'CCI': cci,
	    'WR': wr
	  };
	}();
	
	module.exports = Indicator;

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	'use strict';
	
	var RISE = 'rgba(212,51,47,0.5)';
	var FALL = 'rgba(0,153,255,0.5)';
	
	var BS = {
	  initSingle: function initSingle() {
	    return {
	      sIndex: -1,
	      eIndex: -1,
	      midIndex: -1,
	      sPrice: 0,
	      ePrice: 0,
	      midPrice: 0,
	      type: -1
	    };
	  },
	  getPrice: function getPrice(kline, index, type) {
	    if (type === '0') {
	      return kline.l[index];
	    }
	    return kline.h[index];
	  },
	  getMidPirce: function getMidPirce(temp, index, price) {
	    var isBuy = temp.type === '1';
	    if (price > temp.midPrice === isBuy) {
	      temp.midPrice = price;
	      temp.midIndex = index;
	    }
	  },
	  encodeData: function encodeData(kline, bs) {
	    var res = [];
	    var temp = BS.initSingle();
	    bs.forEach(function (item, index) {
	      var price = BS.getPrice(kline, index, item.bs);
	      index > 0 && BS.getMidPirce(temp, index, price);
	      if (temp.type !== item.bs) {
	        if (index > 0) {
	          temp.eIndex = index;
	          temp.ePrice = price;
	          res.push(temp);
	        }
	        temp = BS.initSingle();
	        temp.sIndex = index;
	        temp.sPrice = price;
	        temp.midIndex = index;
	        temp.midPrice = temp.sPrice;
	        temp.type = item.bs;
	      }
	    });
	    kline.bs = res;
	    console.log(kline);
	    return kline;
	  },
	  decodeData: function decodeData(data) {
	    var res = [];
	    var type = '';
	    data.forEach(function (item) {
	      res.push([item.sIndex, item.sPrice]);
	      res.push([item.midIndex, item.midPrice]);
	      res.push([item.eIndex, item.ePrice]);
	      type = item.type;
	    });
	    return {
	      res: res,
	      type: type
	    };
	  },
	  series: function series(data) {
	    return {
	      type: 'custom',
	      renderItem: function renderItem(params, api) {
	        if (params.context.rendered) {
	          return;
	        }
	        params.context.rendered = true;
	
	        var children = [];
	
	        data.forEach(function (item) {
	          var bsData = BS.decodeData([item]);
	          var color = bsData.type === '1' ? RISE : FALL;
	          var points = [];
	          for (var i = 0; i < 3; i++) {
	            points.push(api.coord(bsData.res[i]));
	          }
	          points = echarts.graphic.clipPointsByRect(points, {
	            x: params.coordSys.x,
	            y: params.coordSys.y,
	            width: params.coordSys.width,
	            height: params.coordSys.height
	          });
	          children.push({
	            type: 'polygon',
	            shape: {
	              points: points
	            },
	            style: api.style({
	              fill: color,
	              stroke: color
	            })
	          });
	        });
	        console.log(children);
	        return {
	          type: 'group',
	          children: children
	        };
	      },
	      data: BS.decodeData(data).res
	    };
	  }
	};
	
	module.exports = BS;

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  klines: function klines(region) {
	    var _region$region = this.region[region],
	        singleDayLimit = _region$region.singleDayLimit,
	        min1Remainder = _region$region.min1Remainder,
	        min1Remainder5 = _region$region.min1Remainder5;
	
	    return {
	      'MIN1': { dateType: 'hh:mm', resolution: 1, limit: singleDayLimit, remainder: min1Remainder },
	      '5-MIN1': { dateType: 'MM-dd', resolution: 1, limit: singleDayLimit * 5, period: 'MIN1', xMultiple: singleDayLimit, remainder: min1Remainder5 },
	      '1-MIN1': { dateType: 'MM-dd hh:mm', resolution: 1, limit: 960, period: 'MIN1' },
	      'MIN5': { dateType: 'MM-dd hh:mm', resolution: 5, limit: 960 },
	      'MIN15': { dateType: 'MM-dd hh:mm', resolution: 15, limit: 960 },
	      'MIN30': { dateType: 'MM-dd hh:mm', resolution: 30, limit: 960 },
	      'MIN60': { dateType: 'MM-dd hh:mm', resolution: 60, limit: 960 },
	      'DAY': { dateType: 'yyyy-MM-dd', resolution: 24 * 3600, limit: 1200 },
	      'BS': { dateType: 'yyyy-MM-dd', resolution: 24 * 3600, limit: 1200 },
	      'WEEK': { dateType: 'yyyy-MM-dd', resolution: 7 * 24 * 3600, limit: 960 },
	      'MONTH': { dateType: 'yyyy-MM-dd', resolution: 30 * 24 * 3600, limit: 240 }
	    };
	  },
	
	  tradingKlines: ['MIN1', '5-MIN1'],
	  // 1-MIN1
	  minKlines: ['MIN5', 'MIN15', 'MIN30', 'MIN60'],
	  noMA: ['SH:000001', 'SZ:339001', 'SZ:399005', 'SZ:399006', 'SZ:399300'],
	  typeToRegion: {
	    HK: 'HK',
	    A: 'CN',
	    US: 'USA'
	  },
	  region: {
	    HK: {
	      precision: 3,
	      singleHand: 1,
	      singleDayLimit: 328,
	      min1Remainder: 20,
	      min1Remainder5: 170
	    },
	    USA: {
	      precision: 3,
	      singleHand: 1,
	      singleDayLimit: 390,
	      min1Remainder: 25,
	      min1Remainder5: 195
	    },
	    CN: {
	      precision: 2,
	      singleHand: 100,
	      singleDayLimit: 240,
	      min1Remainder: 15,
	      min1Remainder5: 120
	    }
	  }
	};

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 九方智投热搜股票
	 * @author 一秒五喷
	 */
	var React = __webpack_require__(27);
	var BoxHeader = __webpack_require__(217);
	var request = __webpack_require__(180);
	
	var _ref = typeof window.WebSocket === 'function' ? __webpack_require__(208) : {},
	    ws = _ref.ws;
	
	var _require = __webpack_require__(206),
	    getColor = _require.getColor,
	    goSymbolHtml = _require.goSymbolHtml;
	
	var _require2 = __webpack_require__(207),
	    getIsIndexStock = _require2.getIsIndexStock,
	    getExchange = _require2.getExchange;
	
	var interval = null;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {
	      datalist: [],
	      stocks: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    // if (!window.jfztglobal.hotsearchlist) {
	    var url = this.props.dataSourceType === 'A' ? request.apis.quote.hotSearchV2 : request.apis.quote.hotSearchV3;
	    request.get(url, {}).then(function (res) {
	      _this.setState({
	        datalist: res.data
	      });
	      if (!ws) {
	        interval = setInterval(function () {
	          return _this.ieInitData();
	        }, 200);
	      } else {
	        _this.initData();
	      }
	    });
	    // } else {
	    //   this.setState({
	    //     datalist: window.jfztglobal.hotsearchlist
	    //   })
	    //   this.forceUpdate(() => {
	    //     if(!ws) {
	    //       interval = setInterval(() => this.ieInitData(), 200)
	    //     } else {
	    //       this.initData()
	    //     }
	    //   }) 
	    // }
	  },
	
	  ieInitData: function ieInitData() {
	    var _this2 = this;
	
	    if (this.props.token) {
	      clearInterval(interval);
	      this.state.datalist.forEach(function (item) {
	        _this2.connectHttp(item.Market, item.Symbol, 'DYNA').then(function (msg) {
	          var stocks = _this2.state.stocks;
	          stocks[item.Symbol] = msg.QuoteData.DynaData[0];
	          _this2.setState({ stocks: stocks });
	        });
	      });
	    }
	  },
	
	  connectHttp: function connectHttp(market, code, type) {
	    return request.postHttp(request.apis.zbHttp.busi, {
	      Market: market,
	      Inst: code,
	      ServiceType: type
	    }, this.props.token);
	  },
	
	  clickSymbol: function clickSymbol(item) {
	    goSymbolHtml(item.Market, item.Symbol);
	  },
	
	  initData: function initData() {
	    this.state.datalist.forEach(function (item) {
	      var tmpMarket = 'DELAY_' + item.Market;
	      if (item.Market === 'HKSE' && item.Symbol.length === 5) {
	        ws.websocket.safeSubscribeDYNA(item.Symbol.substr(1), tmpMarket);
	      } else {
	        ws.websocket.safeSubscribeDYNA(item.Symbol, tmpMarket);
	      }
	    });
	  },
	
	  isvalidData: function isvalidData(val) {
	    return val !== undefined && val !== null;
	  },
	
	
	  render: function render() {
	    var _this3 = this;
	
	    var stocks = this.props.quoteStocks;
	    if (!ws) stocks = this.state.stocks;
	    var isIndex = getIsIndexStock(this.props.symbol, this.props.market);
	    return React.createElement(
	      'div',
	      { className: 'box-content', style: { display: this.state.datalist.length ? 'block' : 'none', marginBottom: '8px' } },
	      React.createElement(
	        'div',
	        { 'data-key': 'hotsearchlist', style: { display: 'none' } },
	        JSON.stringify(this.state.datalist)
	      ),
	      React.createElement(BoxHeader, { title: '\u70ED\u641C\u80A1\u7968' }),
	      React.createElement(
	        'ul',
	        { className: 'ultable-box hotsearch' },
	        React.createElement(
	          'li',
	          { className: 'head clearfix' },
	          React.createElement(
	            'span',
	            { className: 'name' },
	            '\u540D\u79F0'
	          ),
	          React.createElement(
	            'span',
	            { className: 'price' },
	            '\u4EF7\u683C'
	          ),
	          React.createElement(
	            'span',
	            { className: 'percent' },
	            '\u6DA8\u8DCC\u5E45'
	          )
	        ),
	        this.state.datalist.map(function (symbol, index) {
	          // let item = this.state.datalist.filter(_ => {
	          //   const code = _.Market.includes('HK') ? _.Symbol.substr(1) : _.Symbol
	          //   return code === symbol
	          // })[0]
	          //if (item) {
	          var name = ~symbol.Market.indexOf('HK') ? symbol.Symbol.substr(1) : symbol.Symbol;
	          return React.createElement(
	            'li',
	            { style: { cursor: 'pointer' }, className: index % 2 ? "ultable-body clearfix" : "ultable-body clearfix oddbg", key: index, onClick: function onClick() {
	                return _this3.clickSymbol(symbol);
	              } },
	            React.createElement(
	              'span',
	              { className: 'name' },
	              symbol.Name.length > 16 ? symbol.Name.substring(0, 16) + '...' : symbol.Name
	            ),
	            React.createElement(
	              'span',
	              { className: 'price', style: { lineHeight: '18px', position: 'relative', color: stocks[name] ? getColor(stocks[name].Updown) : '' } },
	              stocks[name] && stocks[name].LastPrice ? stocks[name].LastPrice.toFixed(3) : '--'
	            ),
	            React.createElement(
	              'span',
	              { className: 'percent', style: { color: stocks[name] ? getColor(stocks[name].Updown) : '' } },
	              stocks[name] && stocks[name].Updown > 0 ? '+' : '',
	              stocks[name] && _this3.isvalidData(stocks[name].Updown) ? (stocks[name].Updown * 100).toFixed(2) + '%' : '--%'
	            )
	          );
	          //}
	        })
	      )
	    );
	  }
	});

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 公司咨询
	 * @author 一秒五喷
	 */
	var React = __webpack_require__(27);
	var BoxHeader = __webpack_require__(217);
	var request = __webpack_require__(180);
	
	var _require = __webpack_require__(206),
	    getTodayYesterday = _require.getTodayYesterday,
	    goListHtml = _require.goListHtml,
	    goDetailHtml = _require.goDetailHtml;
	
	var _require2 = __webpack_require__(207),
	    getIsIndexStock = _require2.getIsIndexStock,
	    getIsUkIndexStock = _require2.getIsUkIndexStock;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {
	      datalist: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (!window.jfztglobal.newsWraplist) {
	      this.getData();
	    } else {
	      this.setState({
	        datalist: window.jfztglobal.newsWraplist
	      });
	    }
	  },
	
	  getData: function getData() {
	    var _this = this;
	
	    if (getIsUkIndexStock(this.props.symbol, this.props.market) && this.props.dataSourceType === 'HK') {
	      request.get(request.apis.news.getUkIndexNewsList, {
	        appCode: 'com.sina.ggt',
	        showPermission: 2,
	        type: 'hkstock'
	      }, true).then(function (res) {
	        console.log('newslist', res.data);
	        _this.setState({
	          datalist: res.data.map(function (item) {
	            return {
	              title: item.title,
	              ctime: new Date(item.createdatetime).getTime() / 1000,
	              stock: {
	                market: _this.props.market,
	                symbol: _this.props.symbol
	              },
	              news_id: 0,
	              url: item.url
	            };
	          })
	        });
	      });
	    } else {
	      request.get(request.apis.quote.articles, {
	        market: this.props.market,
	        symbol: this.props.code,
	        pageNo: 0,
	        pageSize: 10,
	        types: 1
	      }).then(function (res) {
	        _this.setState({
	          datalist: res.data.list
	        });
	      });
	    }
	  },
	
	  clickZixun: function clickZixun(item) {
	    // window.open(`detail.html?type=1&market=${item.stock.market}&name=${this.props.name}&symbol=${item.stock.symbol}&news_id=${item.news_id}`)
	    goDetailHtml(item.stock.market, item.stock.symbol, '1', item.news_id, item.url);
	  },
	
	  goPage: function goPage() {
	    var _props = this.props,
	        symbol = _props.symbol,
	        market = _props.market;
	
	    goListHtml(market, symbol, '1');
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var isIndex = getIsIndexStock(this.props.symbol, this.props.market);
	    if (this.state.datalist && this.state.datalist.length > 0) {
	      return React.createElement(
	        'div',
	        { className: 'box-content', style: { width: isIndex ? '782px' : '' } },
	        React.createElement(
	          'div',
	          { 'data-key': 'newsWraplist', style: { display: 'none' } },
	          JSON.stringify(this.state.datalist)
	        ),
	        React.createElement(BoxHeader, { title: '\u5E02\u573A\u8D44\u8BAF', showmore: true, more: function more() {
	            return _this2.goPage();
	          } }),
	        React.createElement(
	          'ul',
	          { className: 'ultable-box', style: { height: '254px' } },
	          this.state.datalist.slice(0, 10).map(function (item, index) {
	            return React.createElement(
	              'li',
	              { className: 'ultable-body clearfix', style: { cursor: 'pointer', lineHeight: '24px' }, key: index, onClick: function onClick() {
	                  return _this2.clickZixun(item);
	                } },
	              React.createElement(
	                'span',
	                { style: { width: isIndex ? '679px' : '283px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' } },
	                item.title
	              ),
	              React.createElement(
	                'span',
	                { className: 'news-time' },
	                getTodayYesterday(item.ctime * 1000)
	              )
	            );
	          })
	        )
	      );
	    } else {
	      return React.createElement(
	        'div',
	        { className: 'box-content mrg-rt-6', style: { width: isIndex ? '782px' : '' } },
	        React.createElement(BoxHeader, { title: '\u516C\u53F8\u8D44\u8BAF' }),
	        React.createElement(
	          'div',
	          { className: 'noData' },
	          React.createElement('img', { src: __webpack_require__(356), style: { width: '180px', height: '160px', margin: 'auto' } })
	        )
	      );
	    }
	  }
	});

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcwAAAHMCAYAAABY25iGAAAgAElEQVR4Xuy9CZgcV3U2fE5VrzPdMyPNopGsxdJI3pBtbIwDNkkQZjFbAiZsH/lCABPWBJIQ9gRIWBySEBIgJPDnZwkYGZsAAbyAZYMBGxsDtuNNluSRNJY0i2bfeqs633Nq6a7u6Z6u7qrez30eaWa67/ree+utc+655yBIEgQEAUFAEBAEBIGyCGDZHJJBEBAEBAFBQBAQBEAIUxaBICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAICAICAKCgCDgAgEhTBcgSRZBQBAQBAQBQUAIU9aAINCCCBARnjw5s1VXlF2E+ggAjigAuwhwBIBGAOBPtw1vvLYFhyZdFgSaFgEhzKadGulYpyNw6BCFu7und+qojBDiLgCTGBFghAB2AUC4JEYIs0qGLjzjjP6xTsdRxi8I+IWAEKZfSEo9gkAVCBw7NrcBgzCioLYLEEcsCZHJcDcAnAEAShXV2kVu37ppw7MRUfdQhxQVBAQBCwEhTFkKgkANEXChOt1Yw+aBkN61fVP/P9WyDalbEOgUBIQwO2WmZZw1Q8CT6rRmvcpWnASES7dt2vhA7ZuSFgSB9kZACLO951dG5xMCpuo0PaKgsguQLNUpnytSCdVpU22tBzOr80/duXNnwic4pBpBoCMRaKpd3ZEzIINuCgSKq05pF5lniXym6EF12vhthoSf2rp5w182BdjSCUGgRRFo/E5uUeCk262HQL7qVN/FFqd8BQOBjW2I/y5tderLcBu63QhBec7W4b4DvgxFKhEEOhCBhu7gDsRbhlxjBCpXnda4QyWrb8jWO6EnlfN37OibbdSopV1BoJURaMiubWXApO+NRWCN6lTHEQVLqE5bZnXXr6MIcN3W4Y2vauwsSuuCQGsiUL+d2pr4SK8bgACrTgPd0zsRlREV9V2g4wgb2nhSnbbMSq99RxHxj7Zu2vBfDZhaaVIQaGkEar87Wxoe6XytELBVp2RZnaKOhjcbLGl1muuJ50XruYJaoeKst6adnFd1vHDLlg3H6jESaUMQaBcEaror2wUkGYe/CJyeXXhpKqW9N6Prl3qt2fMC9lyB1xG4KV+TTv5k66YNVyCi5qYHkkcQEAQAarITBVhBoBQCs7OzfRqpDwEAribTvQTQ5Rdanhazp8J+jcBNPT52lOC92zZv/Hs3rUoeQUAQEMKUNVBnBKZmFr4AAG/kx75G9PNkKnO5313wTCmeK/B7RMXq86WTKVTwt7YObbivHj2WNgSBVkfAl13X6iBI/+uDwNTs7DOB1NtYurQWnpZIZ47pOt+BrE3yvMA9V1CbceXX6qmTD0N6+ZJt27at1qOn0oYg0MoIeNpprTxw6Xt9ERgdpUisZ+EBQNxjt8yLjxAeW02k+bOar0VPDXgqXE+sq+ko/eu24f531LOX0pYg0IoIVLO7WnGc0ucGIzB5euEaRHqPSYvmsrMXX0bX70mlNc8GQG6H6HnRe67AbU+95Kuok0RIV27f1P9DLy1KWUGg3RGoaFe1OxgyvtogMDk7exHoyj0AELB1sQWkubyazqRIpw216UHpWj1vAM8V1GPErjp5CjOB87du7ZmuR4+kDUGgFRFwtZNacWDS5+ZAgIgCU7MLdwPBxVmpsoiUSQD3rybTFzay1542g6fC9Rz1Oh1FvGHbpg0vr2dvpC1BoJUQaJlt3kqgSl9zCEzMLPwVEn3SiUkJKRNSmczBjEZnNxo/z5vCcwX1QKB4J4nwdds3b/hyPXogbQgCrYZAS2ztVgNV+msiMDk5v5sUegARo3mEmS9qGl9ZQufkaiK9kQACzYKh5w3iuYJ6IJHXyUUNlAvPHO4brUfL0oYg0EoItMR2biVApa8mAuwkfWp6/gAB7ONLJIULLaeVzTcA0ojuS6YyT25GHD1tFk+F64kGAhL87IzhDc8UL0D1xF3aagUEWmYbtwKY0sccAuPTc1cjwRftTzCnh3VKlHm3SSwS1RIp7bSu65uaGU9PG8dT4fqgQkAf3D488LH6tCatCAKtgUALbN3WAFJ6mUNgamp5s45pdn/nsHrFrLeCLIk6dLHZX80vj64k02e2AqaeN5DnCmqGUlrX9afv2DL4q5q1IBULAi2GQPNu1xYDUrqbQ+DU6bkbEOBla9Sw7qVMSGf0R9IZ7dxWwtXzZvJcge9oParqyads2bJlxfeapUJBoAURaL4t2oIgSpdzCEycnr2KCL9lfIKF7nsqkDIRV1aTaSSiPIOhVsHa08byVNhfhBDp37ZuGnibv7VKbYJAayLQRFuzNQGUXucQGJ2d7YtmgFWxW2y2rFrKBAAd6GAimWn4NRMvc+x5g3muwEvvjbIEhC/ctnnjTZ5rkgoEgRZHoPHbscUBlO7nEBifmvkCARqRSLKypScpEyCV1k5kNP2MdsDZ82bzXEHVKI4HKHTB5s3xqaprkIKCQBsg0Lgt2AbgyRByCJyamn0mADgjkWR1suWkTINes5nyr5kAwvRqMr2RqPbO2es5n542nqfC1Y4Sv7NteONLqy0t5QSBdkCgIVuvHYCTMeQQGBsbi6rh2P0IsMemtfWlTCbI/KVnXSlZ45id69N0/bFkSjurHTH3vAE9V1ARqldvG+7/z4pKSGZBoI0QqO92ayPgZCgO6XJy5hoAfE+BJtbKYOpkXUmZWU3uGilTT6TSy7oO8XbG3fNm9FxBWXSXQNEu2jY0dLhsTskgCLQhArXfYm0Imgwph8CJydmLEOgeAAwUaFXzg3i5IM1CKdPJn0RwYjWZcpxltvfS9TQ6T4XLru67tm7a+NvN7AWIiEJLS6ndGYKzEeAsUOAsIuLfU33xyLPKjlAyCAIlEKjt1hLY2xoBjkRyanL2bkA7Eom1nPJ/lDzLrMRlHrNvOqONpTPatnxQ23sJex6d5wqKLGGED23b1P+3jV7c0ysrW1UNzwLAs5DgLAI4BxBYdc9OL9Q1/SN8X19P+JpG91vab10EarGdWhcN6XlFCJyYmPkrBPhkTt/q8BmbR5q5P8qpZteTMgEhsZpIB4lo7cPQqQ+uaBStk9nzZvVcQRarDBBdvm3zAMc4rWmamqJ4sCt9FhKdpZPOUuLZTJDAkiNArILGiQK0c0M0eqyCMpJVEMhDwL8tJMB2FAJjk/O7FdIeQADTsUCWEx1LKk8Na51LrllxlTgzMJy6H1tNpneUB7u9l7an0XkqbCFP8FgQ0xcPDw8vl5+L9XOwpmJhIXkmBOAsneAclhaZEJkcybjT60v6SV88wpbckgSBqhHwY+tU3bgUbE0EOBLJyanZA0CwL8uVjgPMmp1lWo2lUpmZjK5vdIde+y9xTyP0VBi+sG24/03u5gFgcXFxME3q2Qrg2aDgWWAS4zkAsAsAQm7rqSof0Zv6eqJfqKqsFBIELAS8bReBsSMRODE+fTUg5iKR2Ci4lDK9ucwzGptfTaZ6iSqFv72Xu+fRVVEBAr546/DG79szQUSR2eXUWQqTIVlSogJnA+l81uhwxl/p3HnKn0I9vLm3F2c81SKFOx6BKrZIx2PW0QAcnZraHNCVh9CIRJJbPrmzR1MMLC5lWiKiC4tZI2dBJc4/dU0fS6QzBQZAlUxNey99z6MrU4GCCIqi8L/FUDB4PSJuNQxuCLYDgFLJTNQ6LwL8T2888vu1bkfqb38EPO+r9odIRuhE4IlT0zcAWpFIHCxZSJClSTMrhpa9m5mr3jr/zJdkKZFMp3Uij6q89t8C1Y6QnUsoSpYYwUGSLbYp8JV98fA3W6zT0t0mRKDavdSEQ5Eu1RqBsYnTV6EdiSQrATZOyiSdJleT6SFj3L6sZF8qqfU0VF1/qdGZkqJFjJj7vdAbU9UNN7bgQm8svAkRE43thrTeDgi09xOiHWaoScYwOjrbF4jqrIrNs1o01aaVkmb1Uma2NauKdEY7nU5rA3kw+bKqfamkSWbPdEWoliDGpulkDTqCiF/ujYVfV4OqpcoORKC9ngodOIH1GvLY+PQXgOCNBS5gTap0fOj1LLNSZwYAkEok0iG9lAWQ5xXuuYJ6TZExDYohITokRv4d+epO64zDV8AQntsXi/zI1zqlso5FoEN3UcfOd1UDHzs19UwANCKRFCW0BkuZuk7jiWR6uOzgPK92zxWU7aKbDIb6tAQxuinfQXnGe2Phrc3sxq+D5qIthtocT4C2gLI9B8GRSECN3g8Ie8wRlnI0UKCWdWhqszazOU2sBVZxx+xVSJmQSmVWMpre5WoWfFn1vlRSsrt5BjfWuaKpUm0qA1RXcDcqExJ8qrcn8peNal/abT8Earvr2w+vjhvR2KnT1xDAe/IWCqv4CpBo9FkmACytJFIxqPRupi87wJdKsogyMXZ3mQ6UJHlAQFEu6esO/cpDDVJUEMhDwN+dLuC2FQJHT0xepKByDyDkIpF4lTItyXONPLrmbmZlLvO42oymTyVTmUF7Eipe3BUXKJxuzxUYFUbDYQgGA221lhowmIN98Qh7EZIkCPiGgD873LfuSEXNggD79xw7dfpuALw4Pyi01UPfpMwcg66VWvM/yR2VllT/UiKZIU3X8/SWFS/yigsUm7XqKmFVbLzbnWa5WdZKM/YDAT/UGw83PKJKM2Ijfaoegep2dfXtSckWQeDoqam/Ugg+6fCqXqCGrVwCzFPk5p1n5v4opMjiVrkWyTovtFgFiWh2JZEu6YKt4gVfcQFv5BkKBiES9uiLoUXWWA27SaDBnr6+yJEatiFVdyACvjwOOhC3th7y2Njkbl3FB1g7aC6QCggtJwbmSmZXWe1d5nGj6Yy+mEpn4uUmqeLFX3GBwh6UryDWFRXDnnITV/Z7vKsvHr6sbDbJIAhUiED5HVxhhZK9tRHgSCTHT54+AOiIRFIJYWb5tUBtWpY0S5GyeenemQpVs46q7WxpjptZ8m5mkSmqaCNUlLnUelhbSUBVoSsaae0F1AS9R4A/7Y1HPtsEXZEutBkCvmz9NsOko4dz9MTU1QhgRiKpVm3aBFIm6TCzkky5DAGWm/KKN0TFBYotL7OSaCQMwYAY+3jcgBkV0mfE4/FJj/VIcUFgDQK+bHfBtT0QOHp0ajMEwYpEUpowHVxqZioafWRNLocHvVKq2eqlzCKCLaRSWjqtacFqZ6fizVFxAQdRG8Y+3dV2VcrZCBDc3NcTeb4AIgjUAgEPW7wW3ZE6G4nA0ScmvwWIV+VRXbVSplFJgVrWwWqFatS8nEUIuBpnBgC4spJIdVHlgTO9vVlWsavCoRDwP0neEEDE1/TGwtd6q0VKCwLFEahiawuU7YjA0bGJq0DBb5ljM5dFgWY1F+Uyj0QtNHy7ZuKvlKlptJBIpXv8mrOKN4zLAixddqy/V/8mZzmxFN40PIzLflUp9QgCTgRcbmcBrZ0R4EgkEEybkUiqNs7x4DLPYueyUmZJt3wFJJ8nIgPfzURN132fwoo3T4kCfG4ZjYixj/cJomv74tHXeK9HahAERMKUNVACgaMnJr5AhG/MlyodUqaDgEr7hTVVsIWc0DCXeU7SJFhcTqTKXjPxskC8kGdXNApsISvJGwKow4t6eyM/8FaLlBYESiNQ8T4XMNsLgdGxqWcCkhmJZI0atlLjHJ+lzDWSp/lBpc4MuFQ6oydT6Uy41rNX6YZSVAViXeLZx4d5mbQik6R9qEuqEASKIlDp/hYY2wgBjkSiQegBQtztHFYhcxY30Clx1uiblJljy7VS69plmyPRkpJxZiWRClRyN9PrVLvZXJFwGEKhqg15vXaxbcoTwGc3xCN/2jYDkoE0JQJu9nRTdlw65R2BI2Pj1yDge0o7BrAkOrspTxazWfnVeUxq1VypJFuVMwPQNIJEqjECSKmNFo+JsY/3lQygkH5ZT0/XXX7UJXUIAqUQEMLs0LXBkUh0ne4BAOOmfKXedPLkODeRRgpMbvP/rI/LPG4lmcpAWtMaNuvODRcMBg1nBZI8I/B4byy8GxErDe7muWGpoLMQEMLsrPk2Rns7UWD72OTdiHBxVngs6X6uOimzWZ0ZcLzMlWQa/Lib6XXp8NmlqkpAaK84AtDH+uLRD3qvR2oQBNZHQAizA1fI4bGJdysAf1849JpLmaYom23Wq5RZjTMDbjOd0SGZzjR05pkoxdjHnylQCM7p6Ykc9Kc2qUUQKI2AEGaHrY7DY5O7kegBQDsSSQ6ASq+A5MmeeeebVp2+GQCVMDByoUo2++iMA2bY2cJqMg21uJvpdjmxKpZDeUnyiADRr/p6opd4rEWKCwKuEBDCdAVTe2TiSCSPH5+wIpGsvZ5hCoD5S8KdFFiK0DxcM1lDwMV91lYjZfI4SSdDNduIZASJZmOfRjTeZm0Swl9uiEU+1WbDkuE0KQKyZ5t0YmrRrUNj41crZEUiqcRpeoGYVkxiM/rbYlJmKqNBqgGq2XCIg0SLsY8Pa1xPK9q2we7ukz7UJVUIAmUREMIsC1F7ZOBIJBlFfwiBNuRGVCrSSJNImRYJF5x6FomOUp0zA1bNriRSUM+7mTykeHeXBIn2Z1vd2hePPMePqm6//fbAwNCOq0iB3gvO3WWGt5MkCBQgIITZIUvi8PFT3wIoiERSSso0iKoUaeZdKHFIlfniZV7pZjrLzJOEETRNh9U63s1kF3jdXdEOWXW1HSYRvW5DT/TLXlr5zW9G+5Sw9kYEfDsgzKaWo5ddcsmWFS91Stn2RUAIs33nNjuyI0cnriIkMxJJkTuTxa+A1F7KDAQDEFADkEqngWzn6FnedbSfx8WVnpfmGDJbY17VaFjMpjP1uZvZFY1IkGh/9lxCS4U39ffjQjXV/ebhI3tUoj8DxD8GgBgAzOsIlz753JHHqqlPynQGAkKYbT7Po6OjfRkl8hACbrEJ0yFklQ4AXZWUmSe+FRi15KtNFUSIRqNZI6OMpkE6lQLii5JWRwsJLk81WzRo9drl7MJlnnEnsx53M3nMbOwjyRcEbuiLR15eaU33P3T4WQrgOwnhhQBgX4Il0vEVF+7ddUOl9Un+zkJACLPN5/vQsfEvABCrnHIjbQIpk8lSVdZe2s9kWNqzHQvUx2Uet8Lef9gLUC0TB4iOhCVItB8YE+FLNvSEv+umrkOHDoVXM/hqAHwnEFxYpMynLzhv5M/d1CV5OhsBIcw2nv9Do6eeCQo4IpGUOme0ziWLrIZaODMIhULr3kFkKTNjqEkza/zO1krK5GXAZ5l8plmrxNIlS5mSvCJAM72xyGZETK1X0/33Hx5SQvgWIngLAGwqkfdORV/dt3fv3nXr8tpjKd8eCMjubY95XDMKjkSS0ALsoCAbiaRQyuRC5QloTS5HofISYGFpNaBCl8tgyawqZdLUMpbk5+oss7xf3GyfCs4ydeNuZm2emxwkms8vJfmCwBf64pE3larpgUeOnA8E7wQADia93v2dKdToKeefv3vMl15JJW2PgBBmm07xwdFT1ygI7zGGV0AMzs8KTXuKCUB+SZlcT3dX1xrnCOWmwCDONHvmMQ1zypF8tc4MmP5rdTeTLWMlSHS5mXb3PQE9c0M8+hNnbiJSHnz08ReQSZRXuKhJ01F54ZPP3XmLi7ySRRAofJQKIu2CwKGjJy4iUIxIJGsNZ0pZn1pUVNSYZn0ps5TEVkjM0UgEAgEjOEpVSdd143yTf1pKZLMeFwZARv7cf7muFXmZYCmTpU2/kqIoxt1LSb4gMNYbC5+JiIbu/P77x7shuPxaBHgHAJzltgUi+MiFTxr5sNv8kk8QyH8KCh5tgQBHIjnj2Km7AdCIRFLqKkV2sHUyAGK/qX55t2FJk884ifiZWcJlHnuMLdCfFJJmKWzYxyz7mvUr8bjZu48kHxBAuqYvFn3f//7v4W2k4tsB4E8AoK/Cmn/46Lm7XvAKxPrcJaqwc5K9eREQlWzzzk1VPXts9MS7AfHvCxSXWUnMJFHvUma+wJYn761xZqDUKDKHpmnAVrVGqC4vUqbjzcLGxq+7mYyMBImuaikXLTS3uPia+bnF30Ogl9mxXCuqHeGJTEC/+OI9e6YqKieZBYH80y3Bo9UROHx4bLemqg8gQNSpfmy0lBmrsSs4Jk0mT7auLXcm61bK9OtuJkvWEiS6up3Fc8DzyoZfPMeJZOr+1ZXVYtdC3DaQUhR61t5zdv/cbQHJJwg4ERAJs03WA0cieezoyQMAuK/keV0RScoYfv5tE1+dGfC5ZT3CWNkPV03Lv0tZaLBkDLfYWWYRbDKaDgmPbvMkSLS7DcYnxrbGIJNOZ0nSLs3zmzAnw4tu+y8uOG/kn931SHIJAmsREMJsk1Vx8PETVwNi1mm0W0kqO/wanGWaVynq6zfVJE5T4jRT9WeZXNrL3UwJEl16cxnkyP8scmQr6PVSMplK6DpVfS8HCb6197xdL0dE/6y52uTZIcNwj4AQpnusmjbnw0enNgco/RABZCORuJEyLTqxecUpbGbFzmqvmfAF/RjHfGzQRX0mzoxtUVukD25c5jEgHMlkNcEu+ypPEiTaxIytmk0PThlIp1m9antycodpOp1JZzJa1ZIlAhxKhuGpl4yMzLtrUXIJAsUREMJsg5VxcPQkO1a/qnAolVylcLJluXuOboJM833LQEBtOLr8sGaJ0zAMcqRKJPBq7mZ2apBofsFgRxMmOaYNCdJL+DT2vJRKpXnyqn1WrSi6cvnevTvva/hilA60PALVLsKWH3g7DeDRx0/cgYi/XZowTVky979bZwZWmSKrZD1nBuwv1a8rJH7NUzHiLEeaTsQqvZvZCUGiDSneslRmcuR/jLNfietnVSwReFHFvuH8J438/371qR3rOXVqcTAYpGfoAJciwLkIsIsAhsD8lwSAOQAYA4T7kOhnqRDeuKWn53Q7YlFuTEKY5RBqge8PHjnxbEL4UVEDlyxL5smNxb3/OBi1vJSZR79Zo1xVVSHe3bwROXRdMy1qybKoLWYAlHfrxvyj0ruZ7RgkmtWqhmrVOnfMnRPXZpMkk+llXderX0wIX7rg3JHX16Z3rV0re0aamll6GRK9DQAuB4By6iCnioYNBG5UUP/cxo29t3bSubAQZmuv+2zvH338xJ2A+PTCCc3ng2qkTJMY3Zxl2uGr2LNNsyd+2LOqtpyUaY3eGI7bu5ntECQ6e52jiMVqPeY2k9Ey6XSmerdQCPdLMOjiMzU1Nf9/AJG9HO2xcqx3RO/8jn/P/5vgHgD8wOBgPM9VYT3WSCPaEMJsBOo1aPOxI0+8UEf8fkVSZp5EmSdWGT2sVMpkf6n1uELiH3zmPT+WOtc4eigiZRp3MxMOg5USu6fVgkSbLgczWYvVrDMI/4CuqCZ2S5g0Y61VS5gSDLoI4jMzM72aHvgyALzEIr5SZ8NOYiwk08K/DXdbCPC1YJD+qre3d6aiyW6xzEKYLTZhpbrL9zAPjp78JSA+pdiklrMKdUpSNlvm11PcBZ1N0EyUTJitmJgImTTt87fsuIuQJp/ZJQy3eWtfMHjszR4k2nRkb1qq2g4B/Dx39GP+E4nUMhFVq4qVYNBFJoHPKQMh/YdAaDt+KCZV2p/ZhMmL3PmZ/XehpMkt8hnHKdLwdUND8Tv8WAfNWIcQZjPOSpV9Ojh68iVE9O26SplMEqoKPQ28QlIlXGuK2c4P2EdtIWk63Qkmkilgpwa5lNtGYcPgqTmCRJtXa9hTTto4e7Q9IvmFVy3qSaUyS5qmxTzULcGgC8AbHx/vVoPRnwHhk6yv7AXrfP7bC7qQJO3a+HuLPPkua9bs3JZS+SfnyRDQR4YGev/Vwxw2bVEhzKadmso7ZkmZ9wHgBUXPHE0x0p3FrJXNjZTZE4+1VegqJkzdMgwqFhrNvJuZzD0yHFMVj8caFiTavutokCNf6cg6b6h8LTWihKZpmVTKw7klgASDLjJxp08vfInM2KDFTJh5izslR67BimpgVMaOmgsJslAStcvYrRMCfq2/P/aXiJjveqsRC8vHNoUwfQSzGao6OHrilUSwv15SJru+a1dfqaTrhqqWfdSa7w+57cLqTPOYLZeCwfp5NnIa5RgEaRN8MyzCKvpgub7j6N3ViucSDLoI7lNTi68CpC85VKtFT2wsYnQQat7FZYd0aWwGIx8B6EhAzI5ofmYTqfE7AtzS3x9/EyLWJip7FevMaxEhTK8INll5Nhc/OHryIQA8p9ZSJru+40gc7Z74jM80DOJjmtyWWU5w3Myc+rZWzhqazSinFvOdSKbmSKdKw3TZXZFg0EXJcioOGP61dZ/SabrOBgloqVVtkrMXtk189jll3lmnQZL55JglUIcEa0mkRszSOwb6429ARP/i5dViAbqsUwjTJVCtlO3RIydfA0hfW1/KNGWm3P+VOTNQFIReVj+2wBUSv+bOkDYdF/M10mFl1Xx5Zhz4HNdrstzIrWYymWizGuV4HWNh+XQ6s5DJaD3V1lurYNDj43O7lKB6CQKcg0Q7iIj17d1AwKqFRUAYJ4KHFIBfDAz0PFpt/2tV7vTphY8RwIIoNs4AACAASURBVFsLVK5OFazz+V/UMpaZzyJIW03LPwskTiO+HhOpQa4EYDtytiRR+uFgf887sA3ijwph1mq1NrDe22+nwJYdJx8hwN1upMwsaRaxCnUyau5rhHisq8WukPg3IU7iTKbTkEprhlo6HKpMm8hqyFQqDalUCpKplPE7q1f5IngkEmIPK1V7uPFvtLWtSdP0TCqV5kvz1T6LfA0GTUTq9PTS7+oAL0WknUDZcz/77RJBB4UQjT4jEP9UEOBxXYEvDW3s+VltEXNX++nTC+cQwO3cNwNbAmTVqV2aVan8KXHfrd8tlarT6MdUq2T/scRokKNlCUE6gfHykKeKtf7m74zPFQAO9b5/aKDn4+5637y5ql2kzTsi6ZmBwKNHTrweEP6zFlImu71r1Sskvi0P4yqKDjpphpTpJkh0isk1aRIjE+R6ETpCwcCYGlC3+dbfJqzIOrdcBoDqRHOfg0FPTy8+SSP9rQi4hVWPiuF7nwgRFd0kHjtOOT83FUCTjJBQ1U3yDCDQXYiZT/b39y80EvKpqfn9gPgMqw82CdrSJX/M0h+TvYMQmdecSckZ+9gvDmhIj7YaNvvTkkKNwsQErJAOxLAZdXK7OgJ9dmCg96uNxMVr20KYXhFs0vL33ntvMLZx82MAcGZFBkBlpEz2YsOq2EZFIWk2uO2rKIFA/h17lhRtqZElSCbJQgfw5cYSjYanAGCwXL5W/T6ZTJ3WdRqosv++BYNmqXJqZvGPFIIXMEFa/TGJROGHPmsbraQbJMnfKYjIIhdLl4aUCQgqS5+AcFrBwPv7+7vGqhybp2KnTy89m0D/vEVUgdx5pVPfVBCNwDrTNA42WYY2mC+rerVVsOZPAg0U/mncv0KLGBkTwwrOIVmyQTmBYtVDQLoCH9i0sadlA3gLYXpams1d+NHRJ94MhJ/nvVA40Y7bJe7OMjmXgtAXjwH7i5WUQ4AlzWTSVqua5OiHMwBVVWZCoeDGdsQ6nc7MZTJatUY+DIkvwaDNO4rdfwG6/iSDHA2SMCUt+8Ff4A6OWceS1FAB1JkOVAd5MqEqgLisqdoHhvv6Rus5fydPnuwKBmPfAgTWTpiSsJmY0GyJ0v7bfizYP21pk9WpbAHL9G++QBBqBUZCGgJoBiHa9TMSORW2VRfpCArfWjZeNBSgRcTAnzfqZcLrXAhhekWwicsfOnQorCldRwDhjIqkTB6TtTKcVBvrjjZdFJJGw88CyYmT474QZLGxRCKhUUTc2ehx+tm+ruuZZDLNK6yqNy+/gkFPT0/3aBR8LwJuZ5K01bAGP5hkUTz0iill8nuoQUA6gIoGIWQJ1FTVIi7ruvK+oaHYuJ/4rVfX6dML7yGAPzD6YiRLOs5uZGT5kZXJhKw4tdWnhkaZh2KoYfMsZQ3DH5Yq84nRoZZl7BRWYZtGP6aUzpIl125jaP/kzx4fGIi/pxUtZ4Uw67WSG9TOo6Mn/wyI/qWYlGlteqtn61vMhkJBX6xAGwRDzZqdnJqGRCJRs/r5DlskGuJHT7V+VWvWt2oq5kdpMpmcJcoFO6+kHr+CQbMkFgp1v08H3KawpGSfzRmkYTz4jXO/nJTJqlmDgLISm0GSiIaEaRKk+QJgqWnNfARTwaD+d319fbOVjLOavJMzC89AHT4CaKwVwzjJ2uOsOraVSnmREXh8fFZrvSQ4pUWb7Cw8TKmbpUWDEO2XiZzaNmtliwCZbHtEaUQMEJF59mmouNkVAt0yMNDzlWrG2cgyQpiNRL8ObY+NjUWX08rjADBcrZSpKips6I3LuWXBfC0uLsHs3HzNZzEcChxWVHV3zRuqQwPJZPqUruubq2zKl2DQfFd5enrhrYR4gcFvpkiksXRlSUnm2Vs2ka2atImUS7Fmll0H24Y0qINunmeaG40phX9TiOiJRKLnmm3bcLXKcZctNjW1cBYifJwQoma7hqGS0TfLktfku6z0aEigzue/LVmy4GkbPJlStild2i8QhqRpk6wlUJpnmgbrKlbe7IuHU7VtlzPdN+vKZzZtit1fdnBNlEEIs4kmo1ZdeeTxE+9CgH8oGabL2kql7mX2xePAXmwk5RBgC9dT45N1gyQaDbOEsqFuDdagoUxGm02nM1WPAQl8CQY9Ob34ciR9H4GimZawltpQsaQgc+yWetG0CrWuRjDLGHpLLpclJEuytEnSItKsZS1LpYhwaGBjz2dr4SpuYmJuRFWV9xNR3DhtRMNql8nb8GlnGSU5LWXt8TmtZrMqV0uqdkiexguDqa41z3j5BcOQPG01rEmcWfWrqY7NWeCabduqWrNfDN8iUvJjg4ODizVYbjWpUgizJrA2V6UPPjgZC3Sl2fhgoFIpk0NVdfwVkoLpZIOek6cmanZuWWz1BALqiWAwcEZzrSz3vWGVXCKRYm8v1d0t9SkY9OTk8kWKor+OJUti9asC7PvQvjPIRimmpacpYeYu8ysKy0QIii1BWWPXDRWtqe5EDFjGLbZhEH/DlrP2c/bRgYH4V/xyFcc3XqamFp+BCr0aCEMszXI37Csw1nswn62yHGyeKJKuAirsgUO1jJzIMFwyyTCrkiUwXh5sidDxUmFhYqqucy8WBla5c0wbHcaRW8+T2M0XE0NKR6T7W+mqiRCm+z3f0jkfOXLyfYj0cbdSJg+WXd+xKlZSPgKTU6chkWC/AvVNkUjoOCIbqLReSiRS40Q0XFXPfQoGPTc3tyGTwb8gxDARGNKlYexjEoUOTIomWWalLSVnAOPsunGtxDL4MY19TN1nTmLTdftc0zafMyROBXBMUdJf37hxoydd/vT0ylYi7feIYI/DCN5o37wTarZvdJrPWZ3qV5PAbYmTR8KyoZnXvC5iSNWmEZRiSNKWCtY26smqaLNXRkzqNL/PefrJa0cB0vSsMZLp0MAEFb82MBB/pKq1UedCQph1BrxRzR06NN2jqYmjrNZz48yA82zs7QFVzbMRaFT3m6bdhYVFmJtvzJ10RVHmw+Egu5BrqX2bSqXHNE2v1gmDL8GgWRo7PbP4BiTYaZGkxhKWpUZkydIpMRnXa7OWnoZVaeGl/gIfWjkDG3vDmOeYlgrXIgbTMEinFSL1wOBg130sYrld3IcOUbinf/lsVdcvIqIRS6LMFrfIKGfcYxO42bes/1g+3yw4o7UlaZNETXUqn13aRk+6Ax+7PcYoXwo3CNd46bCxzDsjtaRN+x6reSZKoCPqy3MzPZ/fswfr/xbqFnwrX0ttvArHJtkLEHjkyIkPI8KHzJfOtVNv7zTeW+wXtVniOjbLRLIDgvEJ9iXQuBQOBw4qinp243pQWcuaps+mUulqzy19CwY9NTV3CSjq8w0JiFhystSC9tkbq2ZzZ3O2tGSQmSkJGURgk1ve5mFjH/uM09pa+Y7OdfuKRxY7m5jmdYCHAxAYSybnpjdv3szm1jg1NRXVtGgUIplupGBc1agfQD8DAFlCt6VZu40sKZt9MFz25aRdU9LNNYyg2meNtkRskpapNjV+omJHSM8/lwSyzyydODjJsSB/1trYxitnNJWPJSEq9w0MxG6tbHXVP7cQZp0wn5+f35jMKM9CoEtBpzMBcDMghBFwBgAe0xF+jnrixloegD9w7NiGkBZgKbNnPWcGTJQ9MS8xfOsEah2bacS5ZbHhsQPrSDS0CgRNP0HWueUKAFSr1/clGLR1mf8t1rUPJgYNrHM0h/oVFFDs80uLBGxjlzwnBoaoZhnTmHca81JWPetUg+ZJWvkaAocXIaMeJmb+zFQP55LzM7OMbXTkoGHr7NRB0JZ0aZGjs0+F5J89p7RVvISm555cyhr7GB8ZOOTU18ZHljGUooBx1msk+4UiN7Zs320/swbpa2ll/+bN8ca+kZZ5pghh1vih69isV9HaWH+5e09mP5YJ4KuD/fGv1+pS78HRJz5OhO8zVncRKTOgKrCxr1eukBSsi8nJ05BINofGKBgMHA4Emv+aSTKROqoTvxxWlXwLBj05M/98JDjHVgGa53Gm6tBUK5JOhoRpJSYBw+Wb7Tw8p661pTEH6TlCZeVvKDYRKqI+N6RLixH5p/EMtqxO+Q/Dc4CTKfPbMti0tMMHgyBzhOk43+Rhr/O8zxK05b/BuC9pn+naV05yCJm/8Qh1fmkgy/2d6cAh+4LBdRjWuo6CRp3IDuwV0PmndYbK5U4ODvZ8v6rVUqdCQpg1BJqNDNKa+jkg4jt0hWcVjkvRhieNrFoEEI+Rrn9oaKj3sN/dO3jw5AAFiS1m2SHsmsOwjX09hrGPpBwC8wuLMN+gc8tS8xAJh0+gAk1rNZtKZx7XMtquKteRb8Ggp6aWtyBmrrJVqqY60lLHKqZhi3E9wrouYZGoJWGal+z5gBNzpMAfGUTgILKstMb5zDFnHRzkSZfmvcys5WjhWZ/zGWH9bkuceUjaBjvOurO/29taBwyY6mTWbKNqvADkSLxQrcovCFnPRg5jJ8dZo0XuZj5+33ZavzrPQZ0qWEMNa5+3Os49TcItMJZKq/pPN2/YwFqwpkxCmDWaFiIKTk8vfgEAzrKbsO9v5ZtY5xwTO0iVD9yTAPjJwcH4j/3u4sHHT/wjAfyluVhzS4Bd33VHo34319L1sQP1iQafWxYDUFWV8VAoWJ3VaY1nhHR9NpFMs3FSNa7vfA0GPTG9+DJFp36WhArI0SDK3ANcYSmTP8v6kVUt6TPPotTErpBE7E1k/bQ3VS4UloaAVn2kmVarwH/z5+bvpPPn/NMOn1Xgu9WeNesc0KzDrtdZv0GOucT1Kw4iz3vmk+V5x5HfJtIsDrYKutyyKcxnj9fRFaPtXF8Nmdd5Fouo0+rAQPwHzRo7Uwiz3Cqo8vvJ6YXXI8BrreL5OOc7KM6el7CHDWM32u65DHUHfX5wsPcHVXajaLEHRyeHA5Rm7z9R+5pJKBiUKyQFaDXLuWWpuQ+HQwcVBZvKAIjPtBLJ5DQQDFWzZv0MBs0X+lFVftuSsqwzOj5b05HM+5ScjD1nSZhOErX3pRH/0bizaUlDBskGjDDS5r7m3/k7Phm1pEeLV/l7Wxq0bmpYtRgZcoRqeWAtbjFrt8U3Oi11p6HmtBVE3A+rD9k+mS/DTjIq6R2zUPuV51B9rWbMnlZrXLkxMEaFSisnVuZ32Tf0QumYDY5M14I6PTQ01HuomvVT6zIdQ5hTUwtnA+BFiLRDN65WGLr+ZSR9VNPo55s29R3xC+zTp1fOIMp8EZCKRBTmBWM4KzZUGAY5OsLf8AuYtZMMTxu8CImUzw4Nxe/wq39cz6OPn/gXAPgz/l1VFOjf0AsK2/pJshAgmJg4bYToataEiCuRSIj155VFrq7hgJLJ1EFdp2pJ3Ldg0GYg6MUXEWHUPl/LqV4N2rEjbZieaywStC1IA8b9zEARFakBnuViztjLjjw5MkDMFFOXZvPadSNm7GsW2VmxvsvGoiy8/J+zaDUcD9lSspMgs2Rs1c88qgSsvnKIcovnSXOcd6r5V2ssSmdfDLbqNINOTLhuIuP7wpS1hi3AAbi89ZnRB7svxvPYegFRFDXV39/941p4RfK69NueMKemljcjZl5GgNsslYxpSWYeVxsH5GQ4K6Zfzc/Gv+HHXaCp6cW/AbaGLX1fLs+xsRlKx3ZOzPef7AN3I4ICv3klkeBTAwM9j3qdcLv8wbGxM8j0MRva0BOHcLhpnrl+DdFTPXxmyWeXzZ6CocDDAVU9rxn6mcloh9LpzJ6q+uJzMOjJyfndioLn5wx7zHM3wwk4S2PWHUMmRoM+Sc0a/dh3My2DIIvkLHK0JTnraU8Bw5Im/zlqS55WjMkcHgUEa0iOlhQYyN3zdLiYqwpKfrplLXkztsozd/bicLCwRqI1JeniY80fR37XikqWeRK0ibItYRbktyVxSwpGzGQyo8PDffx8aqrU1oQ5MbF0oaJoL7UO6E1PHuzeykzWQbThpFg11QF0IrHS8x9enCRPT88/TQd4hx0jz27LUnsYbWddchnuqEyitGLL2Zel2SG0rX4xnEID0GIkBP/U09Mz7dcKevTIyc93dYXfzHcuJeUQSCaTMDF5ulUgoWg0zJ1taKBpXaeZZDLVVaXrO9+CQVv7S52eXt6n61qI3QSw5MSSjGqRohU5wyJQ0MEiK9s6NWAdmdhqWKfK0lQ7rrlXaUtU/LOYmoZfevOcBWSvbuQ5eTeWHIuMRhtW+8XuLhZbmw7Vr+l83dHXNc/5Ne7q1tbobNd6YGaNfCxDHhMHB05rainWjvPOp/0ozlgq5qzVMIE+tDH+y1rdFqh2c7ctYbLPSFT1F1mXlLOH+fZBf87vIjJZKmC5sgLAEwMD8S9VM1GTk5MxVCN/A7qt8s25ynK4l7LWmCHfakyMZogd40zF9G/p8LbheNvUkfD4wEDsi34diJ+YnntuVzB8S7HrJdUuqFYvp+k6nOL4loUB6Zt4YGpAfTwUDFRrkerHyGhlNXkcAXZUWZkvwaDttsfn5nYGMoxHVl1pXqi3iZFAZ5WS83ubqCytkCV1Bp151g4tCATpnHSZryo1t7ldqJRadU2ldp38s0zK3gXlPjjz239bfSs4OwREIxZpNhEFyf6Mf3d+x5/nPnOeudpUZ36fy0escs0PIWaobfOv3OTXy9+msx6SmO0NQyUMnmy2QNNtSZinZmfPDGTUlxtTanrwyF7KdYSlyV78Nd1VGaF6DP+LOuKRwY2xb1XitorvWwZC3W8wfH1mLwtnfTjab2uOi77W2aXp+Nn2PGJ7ysjGjXOqZ9g7CRH+YnAwfnu5zVTu+zGiaHwpeQ8A7C2Xt1O+Z/AnJqcgZfgIb60UjYQeA8SsRXY9e59Mpu/Tdf3J1bTpVzDoHDGROjOz8NQMosqSIksuqqnFMRnMPvow/gjkwngFTTdwIYtknZKR4+6lIU05Xcvl8jFRmC7nitzWWheaIm7qiuY367Ylx+wVj2x7TlJeS5Kmmz7bPZ3V72LXQwycnFc+CoyAjL6VkpjTgEow55/Xzmtp1vJfAmycUoDIuPNPTDsk9CDQ0Ibuh5vpLLPtCJOlPEWJ/l8d9KAltfEmMT14OC8nWxvIuGhrnWWaUqduxJFDwtGBgThLX2WfnqaRj/YiRNrIrqmyZwRmJANjfTkXoSlBciBW44qXaeST85hhxd6zopbbO9101mXeddLV671GcZ9bTHwOAN5azUOuXcuwj1j2FduKSVFwOhwO9VV5laPqIWcy2qPpdIadAlSc/AoG7WzYund5hhni0g6MvJYYg7lA0VZkEqOEfc7JpMjnndm7hRZR2p8ZOk9dz7cKNfazkqeuXe/5WkzVajwnONnt55NpGYgjQJCwJN4IECZZSsuzSnVKj0bfHN/bbxRZI5/C1grz5q7XmP11vLQ4/y7EoLAP9j1NK59Rk3GmyT9TKZgcHo7XL45eGYjbjjCnphZeDACbLXLU7QvJWWfKFlEWGOTYk2SEwrE9dCgEs0Tq3YOD3ScLcWRiBghzINw9iIoRQSJ3mG6SLhsWrTEIsMzCmfY4EoDDKIG/MdWxJrnbv9tzlD0nUQjn+vtj3+E9W/FTCgBmFxK/hwjfWccoqZpqW7pMIpGAySnfjocbgkU4HLhPUdSqJL1qOkxEs4lEil8Ke6so70swaGe7HBh6dnbpPJZy7PNIBzGydid35GEaAGX3G9fDBGjUFzFJy647bEqVtv1BHjkYe9WR10lCCQCMOK5lFP5d0Pc1pEMUKauWtepYc95o9iPB3Ua7Xf5ZjAQL+19uLosQZ64IEzYTt51sAndUWsxAyP7MqtvoNwswuk7a4GDPkWqfdeXGUun3bUWYlmXc5ZbJuG7dtTJUnuYlWmN5OzdJ1jqLv+GLwxbBOT3qA+rEa41FD944QQC9W0cM562BfA8ftmcLvi+cp8+3PW9YxLjG43/BReJSG4afCA9UExJnanl5S1APPADADp0lGfOuaUZ8y4LnXsuBw3EWI5Egr1V2GlDrRInV1KMEdG41DfkVDNrZ9smFhYFQCgZMEsvFsrQJwbyiBWQ/0O3PmdTMlCUoY19yYonRlCSzEqchlVlkW/T56cxr988igPy4kCXI1iHZ5kFbithKtedo2zbOyZJyKbWxS5WyK95IKUnjXiW/cNjYMokXI21zzoiS/Ay2pVWLbEMhfdprOLRq1mixMq4G7ldjtazH8qzzAiYyha8Um+99OUMavoRkWb9Z95GI7yY5+2SQpbbWyi3P0ssySc9eGuYKLDNyx6G/MxaeTcp5d7rWhsaxD9T5BhnozkvRfCHafgjYZxOkUGZ+puf2Sq7B8P6fX0r+CACeVcu5aKW6jXPLiSlIpctq3ltiWMFg4KFAQH1SrTubSqV/oWn606poZ4J0fPuFe3fdUEXZkkVYizk+N7dDTSuBrKTIuS1pkUmR3yRCeti0RLeSI6+p2bHemgqNdOz8zu/5MyZUw6y1i3RczqoT8/ppE1ohsTmlVi7g/NtJXHbd1L3WEi0GQEslrq9xf8x67XuU+X+Xw7+w3+tIllkLXUVB1Yl/MTLPPyM1X0TsFwqzv4kCo6EIbdwYfaISm5JyY6v2+7YhzOnpxfN0nXYb55UWORo/KKBZb4OW5ZtpHZe9a5RFLqc7tz4qVHNkLwjnX1bOLvXs26O1QNmIyOnZYo3VnHPjFkxgnnWdc9FbalRDhYwI4/398YfdTv7cQvK9gPQJt/k7Id/s3DwsLi611VC7ouGjBFCt0/OyWGQ0/eF0Ks3OCSpzfYfw9SCk3nHuuef6rvuempqKBwKBjfnnfzmVpqWOtfdVVuVqS5LOQTNB8d9MRs7PmZj4M2cb9velyKQYmZUiObu9QklyPZWp/V2p9i3d5prnfCmSLZx8Jl0mamXFNGji3wtfDJxtF14jcV6fcY6jUOIudfZr50sm52a2bNnCkW8amtqCMMfGKBqNLl9mvSFa54Kk86Vi806VMVV55xXFFqGtPy9CXtk3qGJ3s4qcBZoa+OJ3srIvqwWEWWwuCg0Dsipk+y7Yykr8Pjf3RufnU5eSov8MAIINXXFN1PjqagKmTvv+7G74CFVFOR4KB41zdb8TEc0lEikO27KpgrpPIMCbzj9vxFcXj872JyeXhlVVCdhGMpaONXvG7/zcfE6YD/9CYnSob9cch6xHTqXOMd1gVEjAznaKkaeu82mTgvzTrt/5N/9uk1ghka4jJRbtqk24dh85k/3i4PzpLFzshcCWdhlz/n55GRUb/2KScKFUnMnomWYI/dUWhDk5Ob+HVBw03VllD/Z1vh9kEJxlMu40AChGVutdsrUWhKW2yUYbKHrGaHvmL3VO4DSjtheabVbNfzt/L7Xh2Pya69f1zEI5jxhTUxQPRpK/AYARNxu4E/K0y7llqbkKh0P3KQr6bQBEiUTqXiJ6qss1Qgj0n8kwvuuSkZF5l2UqzsYvzJHISp9TFWgSZr6EWIwgdXYYbG/urDrWJNJClWlhx2wys4mLiarizhvGRjniW6+8pml6IVE68xe2X4ocnfmcYyxGspUSrN0fZ13rnb06+++Uep0kaqq9gYaGumfc3FqoZg7clqlqgt1WXo98o6MU6epaNnxXUhB0mxTtA37bEq7w7MHom8MMez3LrezGc1p/OQbnfPvK/p4wzaKdG68IHnlm5AXfZ6XaItESbL+RRhuzs/HR9c4yZxeS/4VIf1iP+WiFNvi5OD4xBek2ObcshjkiLkQiIdYm+BZ+Jp3O/DiT0Z7pco45hNyfXHDeyK0u81edbWFhoX9lha9bWhbmlhRTSITGM8Jh2WVJoVn1bLEOOMmQCcuZp5BMyqlHne2XIuP1yNP+TtM2k6qeKvnsLkfc9vduyNANCdvnlDx+xXJIXYyIC1WyNh75Kl37nBXRJlCbPEOhVLK/v3+h6oXiQ8GWJ0y+dwWgxazJMBa/HjIvKvNBv66HC1Sx+SbjpTZAobRZoDYpa+7NKlNnHS4uMxdeHzG6ZluVsZWZ08LMXmRsVQYJdbnUXaX5peRriOhrPqyVtqlidm4OFheX22Y8pQYSCgV+qaqqW2lwXTx0XX8omUxzXFendXhRjgHEz1Gq630XXjhcc5CJKDQ+vtRrS4/dtkvJApPnQqJ0dtx4ZlhSXilpqJT6cz3p0iYbtxKkM18hKfLf3OdMprwHIHtsgQCgk1iL9acYudoqXTcvAKUWjZOUS2FaKEyUIk7+3Fb/xuNxljLLPn9rtblbmjDZMnZ8bu4Mp9myQyVr2YqbP+yD/GJAFurc7Tea7BuqddbBn3d3k+48/LfzOK3B7IlnPb25KNbef7IXi1M6LdY326w9n9izkqt5WIGAGzdGxws9YszNre4CFVkVW49rBrVao77Wu7q6ClOnZ3yts4kr06LR8DiA50DT86urSfZXW06lf1DX4eon7x3hs/K6pJmZmV5VVbPGRzlNkkGCrMI0rFiLPbSdBOUkTbvjTvVnMWIsJML11KVOMGzycwtQIgE6k18xsty9O59ADx8G5Lzr1e38vpikao/DjaRqP/ecPwvbdqNGdj4/7Wej/Rx1Sq3T0/HlnTv5amljUksT5uzsbF8mE4pa28HeFsZhvm3N5txAhW+VhZCXU1EU23il3h5VVc2aRpeq1z5QzydDUyVReKBuj2cZUbEJ3rZW43oUZXVlcHAw66aGXybml1M/BaLfaszSar5WM5mMcd+yk5Kqqg+HQgFP0UySyfRtuq6vdxWJPWl9aike+vBl27atNhJfvqFQpv1S39tSS7nypaovPEIpB0NhO7WQmgrbKOzjmj4z4RbruJOwnYRbjpzLqY6Lnady+/bnTJbO5ye/BDXyTma1i6PcYqj596wuP7W4uNEmErtB57lEqUPyAvVq2b6WIkX+vPBt0V4gzoVQqJ5wvDmZ8mGJVOwcwM7qPFS3f3eqK+aWVj8OhO8rO7gOydAJ55alpjISDT2EgFXdzcxktB+m05nnrrNM/lfR4Q179478skOWVduvIgAAIABJREFUkgyzgxFoWcIcHx/vjkQiIUuVkncY7zyP4N8LCc8+HyimGmHCc6syYRVJMTUJv3UVvnkVvmmVUns4P3eSaeF5gpOETQlTUSYne5bZ+Gd2cXUfArKDgsruybXxRpiZnYWlpYZf42oIwoqCp8KR0CAQx311n4jowUQita2E67sUEXxCpdWP7927t3mjbLsfruQUBMoi0LKEyYf9tvqgQI+/xuFAWRTWZnCqKkoVL6dCsbFdg7Hdb5tYmXRtgrUJu5Qqo1ByZbK01b8sUYfD4ZCOoft9OLeqArbmLLKysgqnpzvm3LLoJIRDwV8oqlKBZx5aWE2kRoHgwiIV/goVfP355+x6oDlnXHolCNQGgZYlzNrA0dq18vnNwlLyOwTwe609Ev9634nnlsXQQ4TVSCTMIrYrH8LJZPp/dF0vXEdsbPHh6Ynj/7Rv3z4jApAkQaCTEBDCbKPZnl9MvJUAOGyXJCtm2vjEJKTT8mznBREIBO4JBtVLyy0OPaN9P5nOvKDAU9WdpODrLzxn18Fy5eV7QaBdERDCbJOZnVlM7lWAOCC0bxfVWx2a6ZlZWF7uzHPLEnNH0WiYCa9k/EoCeiixmuKIH7bru2UC+MAF5+76TLOEWGr1dSn9b10EhDBbd+6yPR8jisaXkkyWe9tgOL4MYXllFaY7/NyyGJCKohwMh4NnFY2FirCUWE3+mgh+xyiLcBuhevWF55zJXnskCQIdj4AQZhssgbnFBKth39oGQ/FlCOlMBk512H3LSoALh0N3KgoawQqcKZVOfV3L0GsAYB6Q3n3+OSNfbKRXlUrGJHkFgXogIIRZD5Rr2MbsQuL3EOE7RSWGGrbbrFWz9/3x8QnIZAzviJKKIICI05FIKAIA3fbXmqZ/J5VK87nlrZTW33ThhXueEPAEAUEgHwEhzBZeEVPLy1uCeuABAHJl+djCQ3Xd9enpWVhekXPLcoCFQoGfqqr625yPdHo4kUotI+Fnzj9v13+VKyvfCwKdioAQZovOPHs6ml9KsnOC9VyWtejoquv20vIKzMzMVle480qlo9HwSQAYTKYy76aUfsP55+/qLL+BnTfnMmKPCAhhegSwUcXnFpLvBaRPNKr9ZmuXQ3WdGp9stm41dX9UVfllOBT83O6dW7/S1B2VzgkCTYKAEGaTTEQl3ZifT11Kis4RITjeYccnjgE8Pj4JGU3OLV0uhl91d3f9si/eo6oBdWtfT4TPLiUJAoJAGQSEMFtsiUxNUTwYSXLIrnKhllpsZNV3l8N1cdguSSUR0BHwzp5Y94Px3nhMUZR9tutEJPxqb0/4tYKdICAIlEdACLM8Rk2VY3Yh+V+I9IdN1akGdmZxaRlmZ+ca2IOmbTqtKHhHb0/vkVisux8RrgCAvsLeEtHrNvREv9y0o5COCQJNhIAQZhNNhpuuLCwkXqQj/DMA7HaTv53zpNJpQxUrKYvASiCg/ri3r/dUNBrZqgD+LgDw9ZGSiTK0c8OG6FHBUBAQBMojIIRZHqOmy8GefXqWUu8iII532ZGu8Pjcko18NDm3nAuFgj/p7emdj0TDIwjAEUnchXVDONoXi+xsugUuHRIEmhQBIcwmnRg33ZpdXd2BGWRp86Vu8rdTno4+t0SY7IqEfxaP9ybC4eD5AMD/Kk5yflkxZFKgwxEQwmyDBTC/lHgeEfwrALCP0LZPHXpueZwtW3t7eiigqk8FhB1eJ1rOL70iKOU7DQEhzDaZcQ6oPb+Y+gtA+gAAxNpkWGuGkUylYGJiql2HlzcuBfGxWKz7gVhPLBxQApf57dFJzi87YhnJIH1EQAjTRzCboarplZVtqob/AICvbIb++NmHTji3VFXl/lg8frinO9qLisoO0rv8xDBbl5xf1gRWqbS9ERDCbNP5nV1c3QeAn0WA89pliJOnpyGxmmiX4djj0AOBwL29PbETXV1dmxCRAzwHaj1IOb+sNcJSfzsiIITZjrNqjYmIAnPLyXcgwYcAIN7KQ11YXIK5uflWHoKz7+lwOPTLeE/PVDQc3ImoXFDvgcn5Zb0Rl/baAQEhzHaYxTJjWF5e3pzSAp9ENGIdttyct8m55Uo0Grk33hNfioRD5wJBQ69zyPllB2x8GaLvCLTcw9N3BDqowpmF1d9WED8DABe2yrA1y09sK963RAXnuqLR3/T0xLRgIMiYDzYF7nJ+2RTTIJ1oPQSEMFtvzjz1mNW0C0vJtxDA3xZzleap8hoUnpw6DYlEsgY116ZKRVGmYrGu/413dwfVQODJzagKl/PL2sy9l1pfteW529SQegbosJA6Hjt4PVwvkQS8AFqjskKYNQK22atdXFwc1DB0DRC9rlnVtPMLizA/v9CUUKqBACAiZNJpUFT1RG8sdjAW64qjorAkGWrKTludkvPLxs/Oy7c+b2NAwZcDAEeKYUOvYUevJonwPzSKfeL6J66XqAKNn65sD4Qwm2gyGtGV+fmVp5GifA4ALm5E+6XaTCRTMDnZvPctu7q704gYjHV3j4ZDAXYioDQTfuv1Rc4vGzdTL9/17N5AOvjXgPR2AAiX6cnDOumvvG7shw82rsfSshMBIUxZD0BEyvxS8k8A4O8AYKDRkGiaDuMTzecnNhIOPxqPxyYjkfDWRDK1a2U1AYGACr3xFvITIeeXDVveL9/6ojMCSvpHAHhuBZ2Y1pGee92xW35dQRnJWiMEhDBrBGwrVruwsDCgY+ijAPDGRkpMk5OnIZFs/LklIurRaOTheCy2EA6HdjnVZkQEc/OLoBNBPNYFoWBrxPKW88vG7cxXb7/yNgDgWKSVJYQpSutP2X/yh2OVFZTcfiMghOk3om1Q39xy6img02cBiCNf1DXNzy/C/ELjzi0RMd3d3fVwPB5LBgOBswGgdz218fLKKqiqAn09rXHNVc4v67qcs429atsLLkHUf+mh9V9lYvHLrn/4+pSHOqSoRwSEMD0C2K7FWU07t5j4Y0S8pl7XIViqZOmy3klRldV4d/ej3d3drGJlz0jlzpayXZxfWIKMpkFXNALRiOti9R5itj05v2wM9K/e8byrgfCLXlpHgo9eO3bzX3upQ8p6Q0AI0xt+bV96dpb6IJD8OwR4cy1dtvE9y1MTk6Brel0wDQQCC7FY9+HurmhUVVWO8uIuhmRB79KZDCwsLhsWsyxlKkoTbyk5v6zL2irWyJvPv+pN8/Mr/+6xA0nUtfOvfeJHhzzWI8WrRKCJd3eVI5JiNUFgdin1ZIX0zxDAM/xugM8DJ6emIVnjc8tQMDQT7+k+Go1ENiiK4punncXlFUil0hAOBSHWXRtf6X5gjoRf6e0J/7EfdUkdlSFw7Vs++JLv/eDeb1dWqmjuH3zj+M0v8qEeqaIKBIQwqwCtU4sQES4sJ16jE34SATb7hcPc/AIsLCz6VV1ePZFIZDIe6z4RiYS3IOKmWjTCUVTmFpbY2hh6Yt0QDNbcd3pVw5Dzy6pg81SIvvnNEPT1DeiK9uJf3//4v3/t2jtgcsqbT2RFwad//ehNv/DUMSlcFQJCmFXB1tmFpqepJxBMfogQ/syrmnY1kYSpKf/OLVk1Go1GTsS7Y9PhSIjvR5Y02vFzFnkcfM1EUdgAKGaoaJstyfllbWeEXyjhjlv36ho9B4AuBaCLAHC3aXFOAESQSmXg+zfeC9+/6VfG79Ul+uo3jt/y2urKSikvCDTfrvYyGilbVwQWF5PnaUDs9OCZ1TTMxjLjpyaMqxleEpNUd1f0aFeseyUcDPL1j4iX+qotaxsARcIh7k+11dSmnJxf1gRX+uY31cxgz3MUwj8AgBcWeOxxtGkSpp0mJufha9f+BH5z/2g1/Zr8xvGba6ItqaYznVRGCLOTZrtGY51bTL4SgP4RALa6bYLVlxNT05Cq8twyoKp6d3fXaHd3F8eTZJKsymjHbX/d5OMXACZNTs2mmpXzSzcz6D4P3XLLkB7EtwHQ1QCwpXzJfMK08//owP3wla/9uHzxghwq0pavHbvlVMUFpYAnBIQwPcEnhW0EJicpFupKfBAI/9yNL9XZuQVYXKzs3DIYDGZisa6jXdGuoKoqrG5tutSsqlk5v/RnqRhEGcKPABEbT1WgyShOmNyr9//N1+H4WGXHEjrSU8T7jz9zWkktQpiVoCV5yyKwsJA4W0f4FwB4XqnMq6sJmDo9XbYuzhAOhxKxWNdYJNLVqyo45KpQgzPNLy5BJqM1ldWsnF96WxR8Pqn9+EdvQKJPAsAGl7UtIcAtOuLNqGvsXJ1dT65JH/7odXD4yLjLKs1shHjx/mM3/aaiQpLZMwJCmJ4hlAqKITC7kHwpIn0aALY7v2ciOTU+YViUFktsLBOJhJdj3d2nIpHQIKJSF6MdP2eRY3iyapbHyGeZfKbZ0CTnl57g53NKfaDvSwD0f11UxNFF/lsn/Gpgeu7H+IpXGJ55Mrfd+EesFi8sPzW1AO9671eA10wFiRDU/muP/2C2gjKS1QcEhDB9AFGqKI7AGFE0tpR4PwK+i9VXxrnl5JRxZ9GZ2GgnGo2wI4HT4VCIr6s0mcVM5TOcTKVgaXnVsJbtiXdDQG3cEaucX1Y+f84S2oFbPgoIHyhTy+OA+Eklg/vxOc9Zc28kfeDGZymAB5x18DvjP376u3D/A0cr7CDd943jt1xUYSHJ7gMCQpg+gChVrI/A/Hxitwb6V+aXlgcX5xf2cG5VVaGrKzoT644uBoMhNppoDe/lFUw2+5nlMGXsa5YjmjTqqomcX1YwaUWyarfdwgeM/evU8g/K6fkP2tJksXx0+w+GdV3JM9K57oafw/d+cG/FnUOC1107dvOXKy4oBTwjIITpGUKpwC0Cx56YfDkhfi7W1ZUOBFSWJNt6/bFEzW7z2Ho2FApCvEFegOT80u0KLZ5Pu+0WjhJS2gIc4cPqvud9pFwr2oGbHwagbGiv937wa/DECXdn+Y66bzzr+G+9+CPwkYp0uOX6Jt+7Q6CtH1juIJBc9UBgemVlm6opx+vRVjO14TzPbIiDdjm/9LwctNt++BcA9E/rVuSCNLUDN74TAP/ZroelS5Yy3SYkvHZRC7zxeye/t+K2jOTzFwEhTH/xlNpKIDC/mHwVAX2jEwGyHbTz2NnXLPucrVfi88uF+cm3ZCj0OxrRDgWUWQ3p13u2bzpSrz60ejt0++0BnVJ3A8DFXkjTMB7qj/MeeDnXk0ik4C/e8xVYWFiX/5IEcDMo8On9R2+u/MJmq4PfZP0XwmyyCWnX7swuJj6LAG9r1/GVGxefZfKZpmEEFDPCiJUr4sv3SyvLX0kmM+yBZsBZISL8hgD+adfWoWsR0ZurJV962tyV0IEbR3RUf1XW1aILSZMO3HypjvRWIHjlw4+MRf7hn78L6bSWB0A8Fl1dWE68XVPT37r+8Vu9OZ9tbmhbqndCmC01Xa3b2bnFBN8Ze3LrjsB7z20jIMWwnI0ZxkC1TGyly9a6ZiJ+2D8AgH2WK0P7LuHPUFWu3nXG4MFa9qUd6s7cdvMLEfC7Zb1KuSBNY0ZuvnmjHoRXjB6f+Pw39v8MHnl0LOs976//+pV3nPfG1/1uO+DWTmMQwmyn2WzSsbCzdjWUnCn7oGnS/vvZrcWlFUil04aT9t54t/GzFskmZwBYQsLX79oxdL3dzr33UnDD0NQfEtBH0XTrxpdGXz2yY/j7tehLO9WpHbjlLYDwb6XGRIBwfOBsSAXCPznnvOGyPpbp1ls3ZQIZw2vBykoSZmeXIRYLQ29v9+3BZ175rHbCrh3GIoTZDrPY5GOYW0o8FwhuafJu1qV7bDnLpMnnmixh9sRivgedTqczsLC0zOPREXDfru1DdxQb3JEjM70UTH0BAV8BABoBvWb39uHr6gJECzeiHbjlvYDwicIhaIoKR4YugNnuQeOrvpXpOx88p/93XoGYr291FEzcfvNuFWFNQGgEOBJ45pUc6URSEyEghNlEk9GuXZldXP1bBPzrdh1fpeNyXjfh+6h8pqko/m1FO2pKKBj4722b+1+2Xv/Y5dvjxyc/BAgfYtJEoKt2bR/+n0rH1Gn5tQO3fNjCzBh6KhCGg8MXw0o4XgjFD0CBP7psG7KGZU1K/+SWZwFRnkMDK5MeoHAv7tu3RETKz4/BlSrCSwhgJyBMIsH+p+/A73Ua7o0er3+7tNEjkfabFoG5xQQ/EES95JihfNJkSdMf9awdMYXPSePRyLkDAz2PulkYR8Ym/gYI+C7hiqLg5Tu3Dt3nplwn59EO/PAaQHoPk+TB4YsgFSjpi30CCd6qBOAnOsFu0mEQAfp1AH3n9EPnDS488d6iOBLtu2fkyl4k+AcAMBx+OBMifPTp2+VFtJ5rUAiznmh3YFtEFJhfSrKVX1cHDn/dITtJk88y2YWe6vFMc3k1MZtIJDeoivK1M7cOuvF9mu3jkePj/wmArweAw90hevLw8LCh15VUGoETv3n0urENe16mo1K12fPw/FHYNvMYmwFlG+Kz0EObLvrFfNfg09bDHwH+/uk7sDjhysT5joAQpu+QSoVOBOaXU08lXb9HUCmOgEGaS8tGdBNDKqzuyskYEHwTVGX/9Om5TwLSPiB6caVGPA8++GAoGh+8G9CwZv63ke2bOvYakJv1eudRejsgcICBqsnSbqcrtQhDC8chnFmFZCAKkz3bYSW0Rr1bqlufuGwHvt9NnyWPNwSEML3hJ6XLIDC7lHgnEmS9mwhgaxEwDIGWV4CNdfieJkc4ceHcYJwAblBJ3x+PR++071IeOT7xBACcgRntzF27thyrFO9Dx049SUHl1wAQ0HXlqXvOHOTfJRVB4M5jxJLdGuOfRoC1YXnii+eeN/wnjWi7k9oUwuyk2W7AWOcWE3yd4Q8a0HTLNem4CgLRSBjYlV5+ohkA/G9A2t/bHfkxFrG+PHJ8gi9eBlcXpsJ79+61L2FWhMWR4xOfAoA/B6IbR3YMs9MDSSUQuPMovQ0QPtNov8gIBOH0ymsv3h37qkxW7RAQwqwdtlIzAMwtJjhCAwfPleQCgUQiCcurCSNnMBCAWKxrEUH5jqLS/p6u8I8QMT82WkGdR45PGAdhI9s3Vb23H3niif6QHmSH4xFUlXPFqcH6E/fz4/QqJODoIWEXU1yzLArpGoFy6dPPRNEK1AjlqjdVjfoj1bYRAnNziRFQ4XAbDakuQ0mnM0lW0RJRGADHgPTXj+wYvtVN40eOT3AA44ieDPTu2dO/4KZMsTyHj01+EZGuRoC/27V9099UW0+nlPvFMXqGDsBegDY2csyqnplLRgJn/c5mnGpkP9q1bSHMdp3ZJhjX7NLqa5FQ4va5m4skAtwCiPuTK6HvzSanewOksROBy9l8kgj/EzOBd42MbFzXr+iRsYmjQLBD1bXzzjxzyyPuml6b6/DY5POR6EYkuGvXjk2XVVtPJ5W7+yjt1BC+BQANDe6s6un7upeDv7V3L1alku+kOat0rEKYlSIm+V0jMLeY+AIAvNF1gc7LmAGAA0R0HWiRb2/YgHNOCIhIHR2beC8BslMBDnHyBCH+ye5tQzeVgurI2MStQHCFDvSSPduHWeKpKo2NjUVTFOJrJZld24bC4qDdHYy3j1IkrMLngICv5zQsKaR96WlnBhrah4YNvoYNC2HWENxOr3p2MfEQApzX6TgUjJ8D/7Krum+qkL4hHo+XVZ0dOjp5kaLoXwTAp1h1fZsQ371729Aadffh45MfQ6D3A9AnRrYPe7pqcGRsYgIIhihFm3bvHp6UeXSPwF3H6c1E8Fk/rpy4b9XMiUSweW7012c+ecReL5VWIflLICCEKUujJgjMz9NGUpKnG209WJPBVV4pAeI9HA9UU/QbBrq6TlRaxe1Ege3HJ94OaEibHHEkhUT/oanBT+7Z2s9XSYx05OjUC0HR2Yn6z0e2b3pGpe048x85PsFOwTdhBoZ37do04aWuTix75zF6B4BxT7NuKaCnYff4fdC7Ms1b7y3qFVf+e90a74CGhDA7YJIbMcSZhcSLFYRO90l6HxBeR5q+f8OG6FE/5uHgyZMDgYzKLuz4zl2AiZMIvkKg/8ueHZsfGh2d7dPVFJNbADOwpVqisyxlWapM7to2FC92hcWP8bRzHXzwfNdx+Kl1Du37UCPplaOJYNeZdsWR9AqcffJXEElnHTStKrr+W/icF/6v7413aIVCmB068bUe9tzS6jVA+J5at9OE9T+CgNchwXU9PWFXflyrGcPhscndSPr7AfAPrfNNruYOJPj/dKQ3ICDHUnzryPZNn6+m/sePj3+AAD8KiN8f2Tb04mrqkDIAdx6nlwDBt2uBBRK8TCHtvzRF7WKJkiVLljAL0qNKRrkEn/c8cXPowyQIYfoAolSxFoH5xcRPCcCTSrBlcEUYBaD9BOp1G2Kh++vZ79HRU2dqqvI2BHgDANhBoe0u3K8DvGzP9k1HKunT48fGX0yINzARK6js27lt8CeVlJe8OQRun6RYeBUWa4IJwdWAsLBheeJje8bv28Nnl0UTwn+oz3r+m2vShw6rVAizwya8HsMlosj8UnKW7wPWo70GtfEEElwPpF/X29t1d4P6kG325MmTXQlNvQoIXkMAzykwNnmCAH6NBPcR0iNAOAaBzPFgpntp+/beOdsC9tDRqYsR6S2IxOSLBPCPu7dv+qtGj63V27/zGCUBIFSDcRg+ZOl73+vSugK3I8ClJdogHejK4BUv+GEN+tBRVQphdtR012ewCwsrl+uo/Kw+rdW1FbZovZ6AruuLRX6GiGzx2nTp0KlTg5hSPoZY9ZWeDAH87ci2oY/KdRJv0/vTx+lCVYVahUq7/rIdRvBvoNtv3Krr+Av2I1y8x3RcCaf34jN+vzbSrjeYWqa0EGbLTFXrdHRuIfluQPr71unxej2lWUDl2wB0XW93+ECrGL8cPTq1WVN0VsVGdKCXIkAUAS4AxD2owxmkwBYgw9q21zF6tmr+lqKpn965c6Bm56/tsS7cjeLOo/QpQPhzd7krznXfZTsw6ySBbrvxcp3wx5YxWJHK8NPqFVfWqi8Vd74VCwhhtuKsNXmf55cS/0MErWwoskRA3yXC6zbEw7cgtqbHlCPHJz7Hhj8A8J2R7Zte2uTLpu26x1eBwseBrxAN1Whwi5ftwB5n3dqBmz4MAHz1qFjKKIpyPu57nrwMVTkhQphVAifFSih+iHB+KTUFQP0thhH7YL0JAL+xGAv9YBsi/93S6fDh8SEM4SEA6CFFf9burZtvb+kBtVjn7zpGzyaAH9Wy2wEdNl+6E/m+rJHo3nuD+vzUAwBwTol296tXPP/VtexTO9cthNnOs9uAsS0uJs/VgB5uQNPVNJkihB8qQNelViPfHRzEtjvfOTw28W4kYPX4/ce3DV2yD5Hd8UmqAwJ3HqP/sO7L1qw1Irjs8jPxLmcD6QM3PlcBvKVEo5qia2fhc170eM061cYVC2G28eQ2YmhzC6tXA+IXG9G2yzY1ALgdiPYjRb7d24szLsu1ZLbR0dGIrnY9yBG/gPC9IzuG2uRsubmng4iUu44Dh7arlTrWlCgRXn35dtxfiEbm1pvuQoSnlUDpI+oVz2fVraQKERDCrBAwyb4+AvMLyS8T0mubDCcdAe4EgG+omPlWLBbrKDdvh584tQ915QAAJADxwpFtQ6ymlVRDBH52nC5RCH5Zwybsqt932Q68Zg1h3nbz/0GirxdrnwDvDlxxZSkyrUOXW7cJIczWnbum7PncYoIfxrubonNI9xDgN3VFv66/qyvrb7Up+lbnThw5PsE+Rd8EAD/dtW1oX6tY+9YZJt+au+s4vZ8IPuZbhSUqIoLPX34msmFXXqKffn+DnlJLaU+W1CueH69139qxfiHMdpzVBo1paWlpOEMBVkM1Mj3A/ltBp+v6+iIVebhpZKdr3faRIzO9EEyzMch2IHz/yI6hT9S6zU6u/86j9GNAYPeENU0E8D+X78DfL9aIduCmBACEi3x3Wr3i+YM17VibVi6E2aYT24hhzS0mXwZA7FKt3ukxAtofAOW6eDzcKgZH9cYIDh+buBwR+J4ekA6/u/vMTaymluQzApY7PA4XUgvvPoW9vfeyHfjUwg/ptpvO1gmKXh8hwDsCV1xZczL3GdamqE4IsymmoT06Mb+Q+BTV7pJ2PkgIHP3jm4TK/g3dod+0B4K1H8WRY5PvA6SPG8GoU/QUiXPpP+Y/P0ovRAQOsVaPNH7ZDtxc2JB2202fBYK3Fe8AfVC94gU1VxfXY/D1bkMIs96It3F7c0urdwNhKX+WnkdOAKcUgG8i6dfF49FfiNu2yiFl683HxyZvAoDncnST1YWp5+zduzdVeU1SohQCdx6jfwaAd9YJIf3p2yHodNNIt950gY7wqxIef0gh/Rx89gsfq1P/2qoZIcy2ms7GDeYkUVfXUnK+tFuuqvtmuGtjlWtfLHJHs/pvrXp0DShoxbpkh/EjiPSvu7YNc6BjST4hcOcx+jkAXOZTdWWrCQVh8JItyPsE2BG73qXeDYB7ixVEgu8qz37+S8pWKhmKIiCEKQvDFwRmF1f3IeBtvlQGMI+Ihv/Wnu7wrSiX7X2CNVfNkbHx84GMC+/dXuJm+t6xFq/wwQcptBAHfnGsW6QeXYNznrELD3LAav22m/kqSSlPPpqC+BR81pV1DUHX4lOa130hzHaazQaOZX4x+UEC+ruqu4CwDETfI1L298VDNyPi/2PvTcDsOqpz0VX7nFZrsqSWrMG2JMtTgJBgAgkQRpt5CAkQQkAQ4rzEwjzCkIR3bwImTArJTXJfciEhRr6MubbBGR4QQgYMmMkhJgGcMAZPso012VJrslrdfXa9b62qVbVqndpnaLXarVYdf3Kfs3ftGlbVXn+tsfBIpPI5iRS47e49Pw94RBlAbcC+6PzNGz55Eps7Lar+yh32kaaCObWpc7afzg3/+CYwttk2aeHdrac/p2gTTmAlFsA8AeKVRyMFxg/aWPg2AAAgAElEQVRP/CMAPGtImqDb+z8YMNcfXb7ok2cb88CQz5fiJ0iB23bu/W0wFkNMHqjr6kkXbVn79ROs8rR+/Cs77SsMwF/OJRFqC8973O3/cKax5kN4jmm+bfPd6oGpnzTPf355x05gcgpgngDxyqOOAtba1sEjx9GNXh4V1USeKbBwg63sR+3k4k+sXm1QfVU+DyIFbrtrz3sB4NUAsM8a8/gLN6279UHszind9E07afPx23M5iA0H795+7r5v/446NFx24WBlzBPMU5/97bns10JsqwDmQpzVOR7TgSOTFxtb9zokF/O3fhHzt1Yw9TcrVqxAcC2feUIB3PDcfvfe6wHgRRhuUlftn75o45rTOjPSTKfmpp0WVdwvnunzM3nugj3/MXXm4XtHGp7tWFu9oP30Z81VmMtMhnDKPFMA85SZqvnb0YOHJ15jAf5M9dBagJswDKRlpq9fvnx5OIJo/o7k9O3Zt771rUVLVqxFpvoMAPhBPVI/4aKzztp3+lJkZiO/aadF7+OTFlqV69WFe26BNYezCbY61tqXt5/+3I/NbDTlKU2BAphlTZwwBcYPH7sWwLBn3tfBwHW2Zf9qbMmSnSdcealgzihw7733Lp2Yat1gDfw0APxnPVI/rYDmcOS/aafFA6PPHu6pEyv9I7u+DmNH9+pKpi3A1vbTnoMSb/nMEgUKYM4SIU/nasYPTXzaGHMT5m9duXJxOQnjFF4MLufs5GcBzKMB4Nt20j61ZAMafEJv2mnHB7TlD15pn5IP++HNsOJYkmd9whrzivZTn/03s9ZIqYgoUACzLIRCgUKBhAJ33HFgVd06foMHze+YaXjq+eevP62ORJvpkrhpJ1oi5vbzqDs+ByOdkKxpb2XhBebpz0kOlZ7bHi3c1gpgLty5LSMrFJgxBXbuHB+bNhOfQdC0YL5rq9YziyNQf3LetNMem8ukBUuPH4YfvxsTC9HnP6q6/XzzjGfc1b+npcRMKFAAcyZUK88UCpwGFEBJs9Oa/AcD8DgwsBNM9cwLNq4tOUh7zP1Xdtq7DMCmuVoe5973PdgwfieAhR3VsenfKHGWJ5fyBTBPLn1L7YUCpzQFvrV37/Ilx+CTYOylALCnqsyzz9u4rlcI0Sk93hPt/E07LXoaP+9E6xnk+UXTE3DxXV86YGx9Rfupz8awoPI5yRQogHmSCVyqLxQ41Slw9913L5mEkb8CaxAIxg2Ynzt/87ovnurjOhn9v+lO+0Iw8Lcno+6kTgtw4d5bvrT20H2/YJ7+9GJfPukEdw0UwJwjQpdmCgVOZQr827/ZkVXr977fWPglAJgw1vzy+eeuK1KNmtQrrx1/6jlrRz77sPOWwKKRk8Ne6xrgP297APbcW69/2yvP6IonOZXX2Xzv+8mZ0fk+6tK/QoFCgaEpgKdh3Hb33j8yAL9FGREN/PcLN63/o6ErWsAPXHnt/h0A5vKqMnDWmSOwfvUIrF3VhlZrdljtvgNT8N07J+DIAx2oK/Pod710Vcn9O4fraXZmcQ47XJoqFCgUeHApcNtdu38DwPwxAFQA8N7zN617nTEG0x+e1p9t77Mj684Yx5Q7ayQhjAE4Y2kLVp3RgmVLWrB8aQuWjBpYsqjqC6THJ2s4dLQD9x+cht33T8EDE3Wo2oJ90u9tXf3l05roczz4AphzTPDSXKHAQqDA7Tv3vtgai6dyLAZrPz21tPXSh65de3ghjG2mY3jTR/c/p6rNp4d5vlUZaFUA7bYh8Kw8R+50ACYma5juNId11sb+zLtetvrvh2mvlD0xChTAPDH6lacLBU5bCtx6557Hmxb8f2BhHWYFqgF+7qLN6287XQny5usOfNBYuGzOxm/t87a/fPVQAD1nfVugDRXAXKATW4ZVKDAXFLjzzt3ndSrzdwDwcANwf13Vv3DhxrM+Pxdtz6c2XvtpO7pyfBwPGFg1V/0qKtm5onRspwDm3NO8tFgosKAogPlnzcjURy3AswFgCgBef8Hm9X+xoAbZZzBvvnb/8w2YT87lmA3Uj3/n1jUlBd4cEr0A5hwSuzRVKLBQKYBnat5x197ftwb+HxqjtU+/4NwNn12o49XjuvLaA/8HAF4+p+O11Y9sf/nKctjBHBK9AOYcErs0VSiw0Clw2127XwYWXgHtzqsvOOecrpymP9i1a201XT0TLDwKbZ8WzERl7PegVX3q/HPWfv9UpM9bP3jH4s7oKoyHPGMu+z9tzeo/ePmqA3PZ5uneVgHM030FlPEXCswBBW7bufeJYOC/AdjnAEC7ocmP29b06y4855y756BLs9bEm68d/3kD9q9nVKGFr4EB3Cg8f8hjwSa3bx0bnVGb5aEZU6AA5oxJVx4sFCgUGJQCt921B+MTNwxQ/j6A+rkXbD7rawOUnRdFrrx2/FoAyweoD94nC1/b/vKxx+ADb7lu/5OsNQOnG7QAd/7e1rHzBm+slJwNChTAnA0qljoKBQoFelLgtrv3/BVYePGAZNpnjXn8hZvW3Tpg+Qet2Fuvt4s60+Oojl05bCcswGW/t3Xsw/jcW6/fu7wzPTJMHOuXtm8de/KwbZbyJ0aBApgnRr/ydKFAocAAFLj97t2/Zq25eoCiroiF7y+qJn9i06ZNeL7kvP387jUHn1Wb+h9n0MH7jraPbP6Tl7jx/c5HD/1Iq+4MYcM1123fumrrDNotj5wABQpgngDxyqOFAoUCg1EAz9asW5MYpziw3c0C/M8LN69/42AtPDilrrx2/1UA5lXDt27/aPvW1f+Nn/vdaw5cWhv43KD1GGPe9c6XrXrzoOVLudmhQAHM2aFjqaVQoFCgDwVu27nnr8HAzw9BqKlWbR+yZcuGO4Z4Zs6KvvWttuo85OAPAewgtlnZr+lW217w9pesDl7Eb7lu/1ZrzTUDd96YbdtftmpwiX3gikvBXhQogFnWR6FAocCcUOCOe3Y/rq7NkIH29gMXbN7wq3PSwSEbect1Bx9rbf3VIR/D4tds3zr2Cvncm68bf6OxdoiTX8zTtm9dNbBEOoM+lkcyFCiAWZbFgqCAtbY6cODAGdYuXtHpTC22trXUjNRnVLVZZK1dDmCWGlMvAoAV1prF1phRY6AN1i4FQ6durHCEMC6WDq9bwPLGGlNVYJfX/vxYAzACAEssgDUALbK4uXt4lMRKfBgAz6hwFbnv+Jfq99dNbcAelMS3QLm38bjDo8ZQxhyqACwc8m1gI5MW4JgF6ADYI65dw/UcqQA61tjjUFfHAOrDdVUdN536mDHV0aqyk8aYw9PT9USrNTJhzMThsbGxw8aYeATGSV4Nt9299+/A2p8ZopljVWfR2eedNzY+xDNzUvTK6w68Ayy8ZcjGrKngJ9750rFb5HNXXnPg/wUDvzFoXS1rLnj7y1fdPmj5Um52KFAAc3boWGo5QQr84Ad2dMWKo6uqql5ljF2J/zrQWmXAroQa8PeqGqpVCFwAsLwGg8C03FhYBhUsBwtLA8A48OK1jWCA3xnU8C9iXQfAIFDiT8RC/92DFD1D1wXYBcDLHGWlQdFWAAhECJT4nZ4N9blKsU08VpL6hv8zYKGGikCyRd8N/XP/x+v8F0tQlfRMPNIi/S3HjHdcWQsV1egHbwEmAOCIAXsUwCAIHyIwNvjdHLa2Plg5UD6E4Gxt56C15mBdV4cOH15+8KKLzPFBp/+2u/deBNYiWCwZ9BkAeM0Fm9e/d4jyc1L0ymv3fxXAPHaYxizYf/q9rasxhWDyufLaA+gt+8oB6+rsPbxqyY5XGd5UDfhYKXaiFCiAeaIULM9nKYAAuGrVA2sApjZUFZxZ1+ZMa2CNMdVqY2G1BbsaDIxZC2sMwGoAWJYHNg8LEQA9tgRAlMDIfUGAQkBgwMCqOwA1SmNK8pPdR0DDMlXDmUoO3CxCjjuJicRHhjH6jUAkwM0YMFie/yLoGUsNdAjA8IPl8YOA6EbnwIwh0gOb7ylLsijZyjHKTQF/d7WnGwg5NilZ8jNIO94QyI0HX6u9ZC03GEcMmAPWwH5r6wMVwAFrzbit4EBl4X5rzYFOy+w3U7B33bplB+64Z982a+17Bn11jIFvnL9p/aMGLT8X5d72kcPrptvTGFsq6dC/aQOXbn/Z2I3dgDn+DwC2C0izFVq4a/vLx87t31gpMdsUKIA52xRd4PUhEK5efWxdXU+uB6jOshWsA2vOqgDOtLbeYE21ugK7wYJd5YCHQUqrJJlQ4bqXvojHC9DC74Qmvq6Aici3ETSY0eNvr/5kFSNJdihJeizDAviMwQvTBHYOmRj7xPsg+mtRGvWAVtPDBIJBSmPgc2CHgMQghb9bXmLk6wLESdJDwJ1OwT1IjAyKvVYV18dAKqVK7Deqjxk4+S+rkaX0jc/xRkPzBRKTHQmCOO6kYievRhC2KJXjXBH9GJBl35Bwh44dn7hwulMPHHhf19WjL9qy9uvz5fV6y7X7X2HB4Hmgw3xu3r51LCuRXnnNgZvBwE8NWNkXt28de8qAZUuxWaRAAcxZJOapXhXaAXfvPrKmqszZpt05C8CcVVnYUIM5G8CebTD3p4FViGaeuTIjZEmEAMzb9YgcLHERyLA0FjAvSFu0DoP05u/zM1KSC/VgMwhkQdIL6tVEOuxSd6q6EzAVqs0Aiq5jTi3q7kvAk7ZLbldKaBKY+D7+5esOYuMHn5VtZAHHbxJkO/Qc7ig8HYmeDHJ+vrgdKX364jSyjjVQISC6eSOVdZSACRR5E0GG3RbNrYNMNL/6+hEwwxgIaFGsp92Ok5wdwNZQPTA5edF0p4Nnafb9tKrqy0uXLP5fpoZ9xsDekZF6z4oVKw4Yg1XP/efKaw8gWCaOO/16YcD84ju3rro+V+7N1x64zQCc368Of/8j27eO/fKAZUuxWaRAAcxZJOapUNXevXuXG7P4bABzDkB9tjH4F//ZcyzAmQCwWNj/WH3pcn8aU5E60ZLqkVRRyAx9eQQBZsB4tS0AxklabDdjiYwByEJLSW2SCUpVY5TcnPXOAS32ydfN/SN1poEO9UGqPqPaU9rySMXqVaEsafF0yjbxGv6WkhgDHN/Dvwx8UoLTy4Pr8NgWaOcAyxk+Sf2LtFagF8BQVmoMdKyjpZOIWTVMP6yF2m8qKls7wPOSMwIjlfU2W5J4PViaGpXIWJ/cKOBvVkXy+AmwGXC5RS99sqo5lGUb8sTk5LmT0x0Ein68qF6+ePSGqqoeYPoYayfBwAEw1W6oYbcxdo8xsGdqqt4DMLFnw4YNR0/WO3nltQcw3+3GQeu3Bm79r9aqh/7VS4iWXZ8rrz2ASdQHOkvTALzjnVvH3jpo26Xc7FGg3yKdvZZKTXNGgTvusIuXLTu00ZiKQfHc2oHi2eREEx1c3PxHd5KWt6eR2hF1ax4QpScog2iFAOpkL9sxYNrec4a4rkdOlkQZSKVNTEo8DBpSYsM2JWPWtjvJsPke1oPAzNKgtt+x9KNBTYIBvxNS1SkBnBkeAxvrnNG7lbx4PHIm75bXMROgoDjGi4EkMHb08QAnNwDNi6aHips2CYaBTnjqalW3VF2Tg1Ll1anSNioBkb4bS/MSx4ergAHVqZd5PnicWHdtoQo2U7cZoDHYTt1ZMTE19dBObdf0eklaVbVv+eLRL1pS+7pdgChvofL1h02SPWKs3QNQ3QtgdxsDuyerzq6J8VW7zzvPoKPTjD5XfnT8AqjtsGn7Xrd961ij3fbKaw8MLimXGMwZzdtsPFQAczao+CDVMT4+PjZRtzdW051NxpiNAHYjoPrUADOedpCuHBcnBmaNCdKgIXthsOVJBwaU0NzvGjVwpEZEsQPLczn0BPUOnxa9Oh2jlh/3LEuj8h6DsJToUgkyAiYzbe1goQGR17O0mUn1Z07iw7ISAOQ7kdjenDAbpSgGyC47HqsuA+MmxaGTgpHZk8Trr4GdduDG1yXxSO3sbYIMdvwXr5M9tiEkJPHuTYElNsHSMknx6Ijk1elUp1fxYt9ZwnRPOi9eLMMbGj8/BIqIuqFPAtycpsA9K6Us+k5uy3VnbHKy3tyxnbOttajp6Pq0qurexaOLvtYy1RGhIm5SNzOq0rx71TCpiNFJCUEUAO4FqH5ojN1VVdM/HBvrH74yA/vleKs9tentL1mHHshdn9d+2o6uHB8fHMAN/Nz2l43N6WHVDxKLm3fNFsCcd1PS3aG777ZLFi8+vLmq6nM7UG00YDZBbTdBZZcFD0viCASEFLvgawnzG+yOTpp0DAa/kxOLAzn/nHiGnGoci3TlHfjUUBlD4gKBrVDLYinvqGL9EU7eWceAQTUgj857+Oj1x+pXZnTE3BRFSJXJtjEGMe/+itcpljFpxwVjtPgZvp94rxpo+RhIak9KiqwaJZUlqzUZOFxPvR1PhnkExxcPJjx2UoNilT7shHuKZAxgyLGbAZOFXdDNRCpdhUq6pC53R0rNDIT8DK0FduYJFaECF3UHhiRG9+ENQAS8YLdE6dGgTVl6+mrVu/fqZSAWwIrCppszklYr25mul3VsfYa1dokzg9JKnWyZ6oFWZQ6DMRNsG5Vq4NDTbq9q1hjov25k4WMOA1iUSO+1tvqhtfU9x4+vuGfTJhNy2r75ugPvMRZ+Xa3Lxp8GzB+8c+uq32kq8N+v379yZNoMHGdqquox73zpylPmNJdB6XQqlCuAOc9m6d5Dh84cOV5vMabaWBt7LoGjNWf5TbgIgmcbk3Rr9x6lLkyh8kDIqi+SLD1wslTp/kYvT2fLIux19Tu1LEuhdC3+ixIo2ew8iLL9jp4XEilKol5dilhbI4R6idF7t3J4hUNh54nqP13hGXxDemh2SXbUAyelIViTjc5f4+e1nY/vs01Pxjhm14oOQQlOL1I6ZZowc8bffD8MkYcqmH4vySnYOoV9kyRgprt3+kG0cZqF6HjjmnCqVP44xTDaPyPQ4X0h9RPYo7DswNHVgXbiGEgTY0qnOamDcZJomEvrnnXbNZK3K9dmcKpy6maXnCHdHDDI4rqUkqy0saK1NtBQxq4mc00lJHjivgdBWc6VW+vW4lgwPOZua+0977uxfvvxafjJAVnHZN2Z3vKuX1qLISjZz5uvu3+TsVXXYdtN5UvSggEpfxKKFcA8CUQdtEpUqU5Ots+tqvo8i+Boq/MwGJ/eZLfDlxJZ8GBkyQ4ZhrAzxrlESZOkATSZhTg/BjpCQ5Y6LJDkRaKN7zeHajiW5p53KlXUIqLdyZD06NsLDMaBodzZ++fcsyFqXzoHcZ9xSF4izYWUUAXO/Bc8MhFwkZlVNY0T/zoeyJsKoS7EZ315xya9jc8zSOfUwjxW2k3DRSWlMdhJ5irVyaxCTpaCkIqJJBxz4//iPBBASNUhgx5XJCVBLRVyGbSJBjW4tDciuPF8RrUqXukCJudvVOECojXG4ESSYHwWx4lSPdEeswwxwLF9MoAyzU+wPdIwLRAQkQpC0tfXE2dEeiczyOtEDvq3e5pVzm7W/QKhoYkJT9ZsegNV1KQqcM87bcn7Pldfdnya4oYH+fT1aH3r9fs3d6bNzkEqo8lqt9f9/kvO2Ddo+VJu9ihQAHP2aNmzJmvtyL59h861LbigZasLrLFbYjo2DzQOYFLjv98he/B0QfP+gyAkJD4vDSbqWN5BI38K4EuPcz22JqDy0ig7+kgJKIIgA3gChAY5IUuhWJMEXt7pu3WGzyMDx78unlGqdaV9EsEEmVXb2+lYLSjK6NjJrCOIa7X7IxMYYN3ddI/PSPUn0zOxG3L4RmDI6bP0KwJOTGLAYRzBSUqGXXjVt384rokIDJEWqaToWnflXD8ZcEgdb6ca0vYRQDLgGacide1GKT7YLgVIIjbGRAdVNQ11XYGpvPMP2jWho9SmzkbKa9D1U9qj0dYr7eFRpRylQDcylkBTEAz3fD+DlO1veHryJkvG+hLxvFq+ymwkAP7XZ6Zfg97Ig7COxW37pCtfsvrLvcoOC5gHV61a/J7nDp5daZB+ljKDUaAA5mB0GrrU/fffv6KuWxfaqnW+qe0WY8zmmvxFgoop2v6iGkhKaJFJRibRPV8RZMmz1Xc0lEMwY6mFmUW0C3qpzYUQeNVsHdSyXqgkEBXSDBbGOtmu6cYkd/g+/6ogGsYteAYfpFt29sGQDgTQiuPzhHq3azxCEmYg478huF6U8VgV4gK5S/JZZq58L9QjCiOAs9RI4qp/iKRz3wjn1+v6G2ylHO4RCRM3NO5aulmKtmaXTSi1RUp1bQSUtO60PtdEkLRcwiF3McRfOgnStZU6+3DYCAGplzSdQ1JQgRJqkVTK9Xr1KMdeOgt6BLqawZbtkSzFyTkUsZzBph03KdHzloGOY0IFSGvVtlaHB/DGjamlcafpEqOJwNbvuaHz+noAwFw+Cvt+7SmtqwHsLmvNzrpV7aw6x+5Yu3ZtclD0Gz+ye9ni9mjWISjHeLZvHSt8e2iOPDsPFMLPDh1h//79K6enR8+HVn1BZe2F1sJaBwCGYgxVMwqEoqeqcKDRzglSWsT6yPlFeKxKaa4LwALz92rWGqDF6jYCqCSJuHEZaPiDEoP7BNWsBEP8zqphz9xGkhynGEcoHH7IqOo2CQRcDkwDeKNqN0pPQpp1AB6cmgJweRjg9HOoyqbn/WZBglKgaUadqecoARvtWCIchpwHZrS5xnlj+5mjXJRKo4qRQVICuAS/qEZM1Jlx05XLgWvBTAvvZ5QcCaREKEcKzhHEnFzrPkHCZM9g75jjVbIEVJzMgBPmejANCQqiLdGHkEjQd6Dn1L7iOj+T2MJ1ij+WygU4x41TYneW4TckNcd5ZhtqYgd3GwixscXfoW788d4bOq+Z6oTcxY0c5OHnmM8+4+F0OovUaKC6/H5jzZ11Xd3Zbk/esXr16oNXXnsAc/X6AwB6M6UCmLPEtGdQTQHMGRANH8FYxzPOOHKetfX5UMFFxmJqOLQ7mhaCEb1lFkY8o8Q7PkWZiz3DcsiAWBXqu8EvqpQQ/feaYiJZovHl6Z6SqOSIUK3FqiNmvi520mdbyYA5ci9vTySxU6qeutdLaidlQCVVq7Cxss3TSZOOHTuJ0rHolgdQGo5j9jH0pQtAI/hwHlcpmTt1pPuE/jLQBo9XDnFwHr/OwaiibDQ4fw69U5Uh0zUHwAwxUYJKnYWYUctNjcicQ81FFSg71lB3HNg1LFNm5DgA8lDljYnbkzjHLbInsv0ySo4MDLzx4t8hY1BityR6VbV0zBHSJPUxONu4tnxIjOt7um5j6Im31XsHr8S2GOkdNx4BeHjdJt61bk1FkI5EC3RStEwkc+4/25D5cf3eXf35zrZjU5T/uOfnhY+u3rt5NThbYxWlef0Q5t+96nP1GyenYXO/OvF+AcxBqHRyyhTAHJCuyH/uu++Bs+pW57xWbc/H7DhOgiG25ACmrincAplFDXQkVF07xk/2Ou+WzwCEHoLuuwcvXxdm0qGUYwimjiFQGyiVklTIQBDDRzDWwamm3DW2yaSgwTvnJGuMIWcbxciJ7UQgYfTxY2PJ1oeGsKTo+aJxzj9OKnUM25i2UukywHHqNAZotx4ttBFAyY5mLOdC5fpZ+uQ65Bp2YOb66UBGqzVZepWA5k4DYQ9Rn4yBbK2uLbYtOjpEadB5dkqg832Mas9AAz8/XjXNUp8v7yoWalGSwGVoS2JTlGuW1afxmhy3VEWynZDHwCCm4yYduIZTUaIk6QEyJG6gdRrspGSrJFrgWhQSYAD8CI7J5kDaSCU9JMjJDZZ+Y51KWISw9FDhahU47s7wfZNxoYFmlTvRRuUZtvX7v1T/X4ePwdm9WEdloPPaZ7bfzmX82Gk9CT8E63gEmP/zlc5l+4/CRb3q5HsT08eX//ErT14Wo0H6cLqWKYDZY+attYv27j24qdVqn2dNvcVYu9giONYCBB16tBnsgorUA4YDOictMYAmEqH0LI12vJh7J/bPzxWftpHvOPWvx0cmz04z80QJNqhnXUC9YyBeWvH2SrY3uo1A/JADUJQsHZ3c8zWBMAOZjxl16V68FKxy1GovXQp1sVATLdn+Fm2jrpPRRse2UhlKwh60iYpcMOauY76wJQZElm7CO+NVn4nDkHSc8WRxamenTZASX04SkjPHYMwgopm9tAUyCHakrdVXRs/5jRZlQfAhIW5eg0SW2iI9LXHnxSEhTuKOAIlt+TGQWlWoj4V0jvRLVZ5aYo5Sntjc5KQ93nQqJysOXSL9sJAglUqdj2pzm0rXX6ft0ep1UUeOP9prvmp/8b7D9iG93rNWZSZe8/TWdv/O+wRPcVPk2yCpHMf1sZvrn981bgdKvj7Vtqv+x0tWJ2epnq4ANtfjLoCpKO6TBGyqK3tey5oNtQtoR2Ud2iI9ANR4+m+L1JU+iJ+TkQePR1K5uthE4ma2HuEXM6oK6eTe6JSTcdrpsSDc3HWrHwNj9aCUUyEykyBm73a8TqJ1VeI4ndSqJNao4sR+RxB1oOk9X4UUlvGC9V60NNYkbpQTLzh7qLUdlEyFTddJrByv55wuOJavkhKZH0MCZA4bKFonqJh98h0GfJL6PNjL90JKOqQupudc/0gK9uE2LPlLRu3qCSpKYcd0E6slQN/N4DVKx4CF5OUiBEP2U9lXab5DrCPVSJ6rUZMQkgugFyhJhgHssN5UTepB1XnCevVqJb1eA+gwAIV54fJdiQ7S2Epe4zKuUiTfCJK3J5mgr9sg+Q2p2BiwrZLuJ/MipTuxoZAq09TOmcaB4nzW1/9r52d3jdt+cZj2Dc9svTmNY42A7vvhAL4C+6lv1M++ba99xiAA8LSHwaUPWX/s5rPPPpvy6pbP3FGgACYAIEiOjh46x5hqEx5XZZx06O1xGKXtYgRNTdIb8kefUacmBxUPqA74HEAGtSyDowgBoaqgdozbXWcblkEGSW1JtZJQpXppzQd5R+lOgmJUGfI6IskuSZXGdyTDFnX447CiY06yImsBOhzIYUoAACAASURBVCIRAkuhrCplMKc+R1W1k+7Ec7LdykuieG6GS27gkzAQTVJJVINabJel9hhaEaUYlnhrRL0E8LTEFscsY/8cpKUOPN1OXQyHUupigAwMn+Mw1XwTw84At8deD1opUEvwFSpOkhpd8nkCPAcgyuNXq1ixfy6sQ5yA4lX+SiILHrVhpSVJA4T3bQp2YS06ABbnhWYSVCSSoliImncx0KWqXJ4J99fdc/ZELV3GM0tDI+kB4n5jYj/5jfpZt++zl/Rj09suab15yQjw4dqo/O24fahOoGHtZ79tH/ute+wv9qsT7z//kebK89ZVP2yZGrMR3XXs2Bk7ZSaiQeooZWZGgdMWMK217f37j22YNtPntmpYG6UiU9XeVmfcrpxseZ68zgZhzCLHyA3eI4DDkJGYaICSkqNEGiQ2pwoNMYocAuJsffgC18FT1qnwPEhnEnpLJw0K8cg5AvFyIAktVZtK8Oi/apwaNaiDo7OFY9ypR2qwnXLoCTsdBWnY24xCViDlrcqhNszcHHaE00Zok5FsDjgJg/fSlephOU58juMt5ZiZcUa7cnr0VmSyzHCdhCtzz0bwTGM+yXmGQ3h0AoIwP9Z2ZCKJIMV5VXhIFsG2a586LmwmyDJOmXJiykMXEkGJAbidNL+rS3vn1rK3VxqL54PiYuzgWmaA9Pb0VHqOXrUEyHJsrh1yM+qI2GFSO7JUxWtGSXtaMmdg02vUzRluOKsKT2cJWhyh2cAyQXPgQVnOE2lUpGSe8brltUFrQGwE4DPftk/8zr31z/Z7eV762Ood61eYQwSUbmPg+uBpH5yLLNh/ux0eetOt9av71Yn3n/zQ6p2P2gw/sBamrUs434EO7G23p+4cGxu71xgT0xkOUmEpMzAFTjvAPHTo0Jpjx6qN0O5sqEhiTJKFs4RoOih9xJeuQkMk8hPHBChYn9SDZO+L4ImqTBfITyDl6jboxOJebLYvshopSF5+xkjlI8GZvkcHGskcAjMXql4JNImzAqpZZV7WnGMEvdRejRayzXR7tbru+RR6Htx1EDeHzVCWGKKb8/B1IBtiOElSdwDoVctCQvfNRI/X4LEbNgCJBIp0Q6kxZBJSUlqyUVDM0s2TT2DAmY9kvtqgPrV2ilMOirdMSvXBTiiAMKQnFIDv5rk7pME5uLCaNNyX0iI7fnlGnMaCog2ZAT2ABAFjXFsIaaxiRZEnfPdAZ6zBBAfRcYodeiRnkXbAAAjIwN0mUNpocWPo1dPeWxR/xzJ+6XXxrcCflDetOGzcQ5B7lNYXOut4Uwepc1Fl666RI5528OE2qL9CVSo0CcH2TY3c9F/2EV+7o+57HuUzf9z88UPPMngMWPjwmnQbkpDVyv5gd33W3/9HfWUXBTIXLj7X/M+nPLR1M2sAWj7JBM6dreyUnW7tWrKkvmfFihX3D1JfKTM4BU4LwMQsO+Pj42dPTbU225Zd2nYnD6NlqaJTG/G8CKF+FFIQMfSOy8HKKr+KVbbWmBEy6rv7Ibm3cAoyNXAmHQe0nhmyhBk8PoX0qWdPO9bwfZa04hx6puSDr1kC5JystGMWoE3yoXD8kdJZaEN6twaVM6v5XCnnYSpjDp3kLZkdA71Ul9F9VO8qMOUcs85bNX4wETh5zIr4UQ9yUaUd0uRZkkYTIPO/I4NM+iwaMqYtstcE2yqDDKvkrbXTxPTZPhjylgp1cpon1W2zYqC/l9zYkSuoQfnQZcpQo3Kq4mAJEDl0x3t5RtrycVsuPx1JuZZAMXhTe3Wkz+magjNJh6yyxPUdwDCUS8DQ3Y5qVW3L9f1KHK68d2hXyJOfBB1eEh3dFODp9RRUrawVkR6w9F5jMvmoNUm1A0HV7ubBdyZstHjD950fwuYbvlX/Zj82+4SLqj//qfPgez6RQrCNMvh7whGtD07YxR/6Uv3ufnXi/YdsMO995sWtz7Vw/TnU7JA3fQttJc5Jzdp2bUznKMDID1evXrLbGIMboPI5QQosaMDct2/fGcaMnmOtWS9skt5miOAxXU0LCZOkm2lvY/MOMNHRh7ChwoMf2f5m6MVz4ROU5s2pUUk6MC5kBIE4hEyw7c9do5MvmKkHUPShI/SyOjVRYBaS8XQ5tFDvov3ULQu3i++2zTlgZRstbwTo3YtMImXiUhLn3Xuwz0pnHHbKiWpgydQiwLqGMO+rD18h5xmUxDvO0zckS3BekEzHkBy+y9PV1e0lVpFjl4eEIhpOX0s4gnhzIXtMJom3sSoGNLeZYEelkLc2vH0yplI4mgSnk+Q1FSr0kHxBOblQu1IdTzlbOeEBxVtSRhoO62AVJNkeY/ahIDkGUAuOOV6tKsCR6Ucg4pMcONWekwSDzc8PJkhzUWWfJCCQ8x7ttnwKigNYf7KNXwzeS1ZvtvxGj7URkegpSKfrl8Av5BXW74BU68cY0TShRABKJ0n7U3egqneP16s/enP9zn689+JN5oOXOEmQP2GdWB8XKzaL9Z/9c+fPawtL+tW7eU31kRc+yvwNrYmWpUPSESitbU37NULrhzZ4bbAIrJ0O3FfXx3adzEO1+/V7IdxfkIB54MCBVXXdPqfTsS642EuRHM8owcLtjKVtcZqYY0YCZZskAS5yXs9hjKlrlHwIeARA4taeHIAcsFLpyhgqS9pDSpXnbU8EdjWBq6vX2XxkAnZmiqTyi5JfNswkzKsHUWYQOQeKSthPtR3Jd5WkKA2ycv0TsIvMOnzPAwJ5MgpbqCNGCEmJ4QRRyiXv4zS5g3A2ijZSV5M/TzLOI1316cu87SjajUXPU9Wdm0OU4Dj5BCcCR2csmSRcxrJ61W3YxDTZK2nWnXTov5JkhrY+ZxuPWXbwSlQdus1XTD6QyZvKbaJ6VcT8+WOzPHD7OoVEilnrvUQSPDil7TCCtE+px44vQrUspTEamDQRJN6g/iUITlMirWOoT2ffIe2Fd1jqOm0knGrCCRVYgtfr3P2Odl6KFY0qUVKNsj2UUuNpW70HbZqnqQ6Y935u+t398sletN5c/5xHVv+sgCLSy2tqKi8p/sXn63cdn4KN/YDlzDOqT259AlyF89x2QEl9502VbTu1c9vHc3N6QhfTXR2uqqnda9asOdSvnXK/mwILCjAPHjy4emKitandrpfyUKdZ+vEXSFrxUqQAUKaDZ6rxNI+O6Th1LP5Hqtsg9TlJ0rgMPuwo5AAyeMDiURpOwgzetAFYfdiJU9kKqQ29Gtmm5vvlVY4OUIkniV29zCErc2IyQHEcqGciMlVYSOlGO1J5pFaXVy+n4WNbVG4tVXjsE42HpAulpuMnwobAiXBdmYSClCgclty1bgckAhLcSXMIDarAvcMK2k8pPIbszCIVn1cjy1jXIE2IDQupssWGI/RfbGR4HqSHpgCZsPmJavHumEQ9n36GQyIAJ2GHLE+O0TvnnHCKCN7HvKxOEpTJ0mMGniA5yvhDDDkR9kFfRp4qksQ24jiCvdMTRKo146oI6unEZpisgXQtK89Zl64xvJddx5aluXURVX2/WDMRJUKhOZFJA7yHOm9UkrR5bl4deGe1OX/x+c7vT06Hg9qz2LJxzPzzix5TfZTcsmLcZ6KyljbTD3y5/s3Dx+DR/YDqjMXw5V99cvutvMFi84Fto3cz4FFCMiE+nzWKlqkg4VZVPdFqdXYPcmB2v/6cTvcXBGB6ifJsa2s8cicBPylBInjiYiIQdSCG/mRBquHMOqnEKZx3zLTpIIMX9jnTIUmInXpa7CzkVLKoZeTYTdcmSVrKWYhVRyIJADFIL1F1S33ueVYtu/UaX+wuW6SQVgOIKtANa16qBoU62PsXENEEvYIUTGOTANMdc8rs1XsFc6/j5kIe++VBJMSFBuk2129xDJp3HuK8tNRfPhUl9tuFxUiVYXwPsLQ7KYNV1cnmJDBf1hq4rDitNNSEjg1zdXIO1ajF0ICI0o2Xdtwt76naEknEWSUqGD6lu5NgRcyS09XFI+Ccc0+w5QlHm2jfCx6jbK9kUJRg4YGY4NWnNZSJ3BOAI7saS3RxPGGZOZr696iyJNE7b25Lnro1a1/4Hl+LzlrxZBUBvAkgpseJBXMDeQWRVoA3YJ6OMiFCQxrKIB2+/8bO7xw93jszz+rlcPMrH996L3sNi7XrktbjBbe5Ibp/9KbOr+w9bJ/TD4AWtc33Xn1p6woC2zZKmCxpukxL/mi1AMwMlMEreYTjacFW051jxkzu0Qnh+/XhdL1/SgPmvffeu3RkZPkma1tLjZkKDjRhG+vOb/TSU6ISFN6mjrElIMqAGp2BuEpv90PV6jQxeFLdIoChA5Fjzp4ZO6aNdk0OT3Hsmxg1Sp4cLkEepB70AtindTnWK+16JJGyA4mTXsWzvqXUacbxYv/RBzT7J3xavtBP+V4waJE3amrvFMwoSMtOKk5Vx44xc9pArNzbaUNKwdCgSK0XbVoSCP3mo9uxh8fINjL3Ox6MHYCZ1aGpitt5Lhqo+SQS+Y6EJPXsRJMBXrJ3CS/cBicYF6qQ5kRNYmWjGl0mR3crIXq/+tNBnL3TH/DMUqC3PbJK2s8H90eDsMjIkzi9SFVxjk9K55iwuYsZpUjyC8uObaGCbnLjQsuQtRP8voiNGEnSRAKvblSqYfd8RWd0BscptclKHX2YniK1nnjZw8kzwh5K9PvITfbV+4/Yx/UCjmWL7fd/7Ukjb0NQRDWPB8cwrxW6G7pXG0Gv84mv18+/8357ea868V7LwP2ve2br+R6IvW05Hm9n7YgfI/r+QA1TgO5y4RSeRV69LqXbyWr6gYnxVbvPO89M9Gv/dL5/SgJmiKGcrtfEQGeWfKILuDFTenwsNSSHKDOGRDChw/yiNCokUZY+/Uvcwt/oPIQvEYOn97qNOWQxDMWHZ7Dk6eM70XOWnEQ4OQLbQunNDyrIxE7Jtj8h+SAueZuod9hwCWhdyj6V7UQwKBFSk0lY7lVSTLMutWUT+PKmgJmjUm3KOUlAPo05JWcgBvAQ7sN2Gk6EEMIV2NnKx/uxStmBMxnqgtMI2R/TZAPdfVJhMyHJd+T9QRUuHLVIHZuxfzkWz/Y5re5TcY2qbwxYAZiiHZRkieCQw2Ea0RZKGxYGCOn96tSN3qkpeNJyXULSExujkFw90D71JO2yjystg5OowtmZ7GAVgvidrTJdh67OBm9mlhTJNJLGI6d98TZyHQYjgFSu7QDafJ83Viyh4fiv/9f6F+89CM/rBR6L2rDniqe1Xy/CeQi0vHcrx3Y69Wkb7Gf/Ex7z7R/WbxsAkOyvPKX15BWLagQ3D5gjrHoFOxI3VAiOIt5VVq2uO21BXVfja9cu22dQBCifLgqccoCJx2jV9cjZnYpP/xBjwp1U5sN2RwRQVE9kgDRRywoADaAkbJfQweXdBms6wf6GalnvLevVtg7wPCAGj9QWhqD4+p20KlSS6U7ahXx45hnUgy6rECuvyKbJkpRSHZKkhKo+Tk8X8C1RkaksNQnjEUHhbsfOHqYs6WGmuABEzlGl+4BjKYHo2SGJQYbBEE184gjBrFmiJbCPEmEmEURk4vGZeDwZ9kWGvLCzklT5Uh9VwgctBfE4OJOOU3Wn8ZPathckCwY50kaowH9hUiBG6JxyfIaemDA+2k6jFBnK+40Hq2KFXTNKjtwHpeJkJirt3XJdEebFo9iIDBGcegCbL0hl+yVzEO+flM7p3SYVrVgfmPKDGL1MlxXshdEu2pXuL/oBdAF9hoUoKbqyn7qlftZte+vLemGKMTD1+me0X+rKuGQOUcK21mIEt/dwxevfvKs65/Pf7XxwEJz66fPNix9zAdyB/Cxs5kYQK0la9ZuTrlSMbuPm/u/mQr3/eN35BBQ1bRZLBpmc+VAGl9f99x/bYExnpQQ0mfxbOJlgdHniOCOC0AFVFELNF0C2QSLFwlLdyzGb1A2URGM4ilPJcro7lDxJ6sQP2TqlFy2BD6ls/UvkADfssElqrI2pF3G8pHcGYuZN/SbmkzgmJE40xOyUp2wATveFg6dDEHW45jO++Ji/5PBr1zSHkHiOwG0pdZhTIQoPRdGntC9sG0vj5CRYSucauZnh+ZFlnb04fsQ8C/V1XbfFGkrAQUinjlnHU4UJtKVaWmw0QrYirRYUp18kkig59Ag1q1BbOjrLAH8XKoRzwqdscNYa9nbFv069GrxKY3wnH8/Fp9sk4Spp3lVUIXIeWwkq/J1plWxSZUytGodfrg49wikyTFe/PiSNGWj8FMp2uS7pWCYle71Z4XfG1xGO2nKd8U5SSm3q+ukdruRc440vfLfzk7fcZd/Yjze+5LHVK85aAeNcDmmKE4ax4Bgr6dWxtNk53oHqqs9N/xP59ff5nL+2eu3zHt36IgIkddSvn1SadNKlML+wlB+Ofgv9EsfBxaZbh888c+neIm1mmEi/CXow7+PZk0uXHjyn1apGpCOKyDvZ5egi7RYZ789kOJPOQ8O9+EJKlVKlAFMHVNHrMnjOZsDT2zQRSLNqW+w32+/IocbvnrEJl2vWZRgKh1CzKjiAQdwhSikobhaiajG8Gx5nORMQS1zkAcnpzISko6feJ01PzmkUR4o5qdY91HyWo3dokiBGNkOUYkW8ZGCSMgOR71C3NgEBV0iQQmKXzI+ZLVXDXro0bpZEYzICCaAyxCc5oimj2gspA5nRZhhXsMcFAoscp9I2KlSsbBvFfklv3OCQk6RJ9EyU4wiFatGrcT2Q+kQHIUmCTEwRctGytOswxvVZaBqElJfGP6ber/E5z+a9I5yQpAk8pOSqVIo5MOQ5Dc40YbFH+2FQTYv1w/b4xM7MUquIuebOsoRc3bKzc8EXvmd/vx9fvORh1WsesRlubwJJVsey486ffaa+ZqqG8/vVe+Zy865fekLrGkebmOhB2iXdRkydktNdsdYghBLItToj9dThfSvvvegiwzlx+3VtQd+f9yrZvXv3LgcY3eAwKgniJ9CKhzDL7CD8kqYxigo4teOKYwEGTAKgeNEbzZ1HbazTOxrJfhFKYB3TnB1IOA6x6tHbPVvB5kkG0HBkGGUE8i9rsLmmts0Q1O+dkDjfq+tbJv8sbgdk4HeXVBBWuU/zFwLcozeuf7EohENkwuEsO7wbl44riYQX1Fpyxys8XOWL5seBOU2DClYzSu8wpLxdyYM4qzp2hwvrWD4vzaowGu6Ljy3V686FeTg9W+rwpIPxxbxJpozzloxHheBQ3SKrjVSxEZjYymV5IYnO57Z19krnZBMZp1fDsmeoSFHoJT06S7ISp5GIicC2uvrq6+fxyPCMIIn6OVYghZkLa/Io9+PnM1e5HK9L/7tCLzEaL5ouMG8qZtmyTsKWmpaE6TdIio6GHuw5jhbBkWOqfYo5/wq5DTRm+cIdnAKlzu7DdsXHvlr/ZT90+PGN5k1P+9H2zUIV6mMmnUMOxkqGcCAAu+PGzvYHJs0z+9W7dNRce/mTq3ckKnFW/Eo1ebxGVSLtq4r4plfJRn7G1xwfTK+jinbdunVH+vVrod+f14CJ4SLHjxtKPsCTLNSj0nGHXxj9178jQQXHKko1bgmC0Q4q1b28ELQ0GqVQPB6LpMjgSevXXTUtvVinQ9q4YPd0L6aP9yRvW7YtcHJ3D4TOdpMkIBcqXJJCM+EcgbGwipE4gssB5Ow/MnF35gQUljz8OZnEPXReWmbeCEjWu+l7dbEEfScJxZAMB2Buq0JexT5ZgT9ZI7Fn8lz6F5+C2ZU9kkYTbLYMtlLb4OcxMtiYgMJthoSzjy8r5iOoYfEaqUWFNMTjdLZnocLltaM9hFVfZBKDaEuMJ1y4sy6FHVOcIOLCONixKFYsJbVEDer6Jz0rg/MQd1eCpXxffNYbt3IciHV5gGq+Kfsh62KgDMk9tCepryiRANX6cxsXDxJBPWHByjXu6pExyKknsN/8SA9iMmWIjQw7wbATHbznhvpjtQUMZWv8bFlj/vjnHtX6FIKijJMUNs2wntEeec2/TF1+/1HbNwn7orb5lysuMa/UICd/08ZkMViYyPt26E4T/xiF2hyP3vRcBgF00SJ7/6pVqw70Gu9CvzdvAROde44bMxaYzaQ7X5JedL9DItHOS5lyx8knPMi/PSaykQZSJSufF4ZyUsciiFK/pildGWUO8ipcBMVE7YjlKB0fed7SGZucHQjVtm5XS2pJdCryalmn/u0OvXAeM5woIOz4A2jHY8oojEZ6cIoQk0aVDI9ZAi2xSRFDl0i+WnpxFeToGyQRNS+kGqczIDExPgfgd4fHSOmCOGFUM6dtZrQKjnNGb1buH6mVQxxqV/IIEubUWDwD5iObnErYffzGwNOdwNX3BbdESSo9mbJP2TJ9VSE0w0mXTuJh79jQngdUYuzCI5SmrNl7lyXdKM1JdXDmvZFzR/TwuW6dtKsSDmjbny8fpGu58cq167xKXU5DfBa/IxDydZG+sOvsS18fq10ZtHnt8NoM3r/pWGXyBqc1IScdNwCiwfs+W7/7+HTvWMy1Z5gPvPQJ1QfaeH5q3OywVOnXYhuzEXfQo/Vv/72+5M599XsydE8uGQN7XnOpeTwBovq4M9kppC787VcfEcM/w9/5GQZQvD86CvtXrly5f5D6FmKZeQmYu3fvXjYysmLMmInAgHCyJqRadiI67vBES0CVk5VRP/C4hZowZYa82PSkR6nTlWdVnvQ2YymUkyJIydMvRn8Wpgtf8YkMDKTSZ8sDqAtX8ZJnbJPaZ2nWZQvyjEScsoJlmGF4XkWORai9E0ARJDnHD/IZbuR1T5YYFxlBNe7ipaTFu3sNvtRvF0OoT6CgNsJRaxxD6lWqIsicQwqC1MtB6SjpCimXGST3XY9fZvbJALKTXENQvUswQAkHREysO3tSfEQKPQQTl8It5tvFROyJvc7bG6UqM6hcvUbRrVkfa8gSLmsLhOqQwTUFVtw3pXGdmuG6oH6/0ZGARZkyvFZCApjKzRtOyaHEvdbWmMwjqjXle6aTrAfCSU1R4NvKrkkxrA0hE7zW/esW1da+spzdj8+mDeDY8mpq3OC6FHSYHdG9Ivi/D3xp6i2HjsFTegHDGYvhU7/65Gq714ySQxY6+1C/fWzkSDxtxP7nPXbNZ7/T+dIgYPMzP24vPnejSVLcLQawyCdHhe0yVxeWwbJ4D7938zkHuIH4uPH3PHdkpL5v9erVBwfp40IrM+8AE/M33XffA3g+pTNaOgZkqup40LsfF1lTggSHagfebTWoIHIvmHar5nZ5ojPAqW2W/IgA96AaraS3LkqUrjAlWfCA6+INOQm88rh1nrMuHR/Vj6pbV4dIQuCTJvjr+qgtUjU65uV26urwZla9BUmTQ10cDVKPQk42r1WRio5KhZcG6auXSIKTlHabJFNxPdpslcduaCIkTvDryN9wtHcexk4h3fRJVLRJGIt2NNOSunCEYjryJiWkbcNnpGbAq1bjZjDELYqsPnzUFp2i6nXZ0kYmmDqpTwVABobPtjsHZO7DayQlRZImj8nnyUo/s56qQrMgwS94AwvJO+RN5rWu7Ln+/cqCY5ddW4ZN0PuOW03exGBKTJYS/e4DvVXRzYDXgz/tw48rBUgRi0ubkWv+ZfrX7jsCr+gFCqNt+NoVl5orKPyjbTvs1Yqb6pEgdYZ4WiRm/eefq2/o1HBur3rx3pZ18MIXPcp+PQoMi2kujZkI74i1iy3yTj8gus/XcnZMLscCiie+q0/w1WPHVt57OiY5mFeAiRqEXYcPr2lPVG2pbnUqTgaYiUovAgRQuVtiECWwO24qrbZoWihhgYqFkQNUuZBFPzmJu5RagweqVN2aqRgLyN6zwqmpQkcDTOHX4bMoveQZnYacepBPW8Hdb5KyL+S8peUuQJd6LiSrxDZKEpBXeXHqOFme3iX1EjtGQ6rfwJi9Zy+XDAdj8wVmoF1Svi/gJa5u138B5ASynh7kANLHY1qtc2PYbqsANZnajIrQjzex8WhVrWgrJIrxuBboF+xgPsbSjdk75gQ6pKEmUs1KakTpPOVibkOIhHSKCWNy0mGw3eXm0jPUJPmCsN0l64dPAwmbPzzuzOf0TdaKc8wLmz6S7lC9ydmxukDOxydiHHN3vKAx5PAkQ5r4mD4pvYuZZA9VObnu+Ktpgyjm30HKNyLDPRx4xCT41Je230BMg/nE1+tn79xv39QL2FoV3P3rT2u/ElrwUDD2ImPMuQBmI4A9EwBWAMAoGDgCFo5YsLcbY75/7ZfqR+09VD+pH2CuXgZv/OUnjl6vygX+03BdV+s37hMG+SqCLf9lsEw0ex44Fy2qp8fGxu5GLW6/fi6k+/MKMFEVC7BsGUuWygYZJLuoBnU7KQmQPDkMogiOLJE2qSlyKglZr3txutVHiXTrG/Y2SbKtRumQexUl5sQb18eF8ovLdkF2cMIkDcHWM+3jS32KPddPx4yYASQOROG8z+BcQ6pckUXHcUEhsbreskQbJVO6quxUQn0nVZysZnRteRukjHeLL5GL/1Tpw7LvGDuX+FAb0jw4EGeJLTD0oJkQJ3NIJt4lATMNxEkfeUm2m904tapMrRY9knObAqaNk1BjzlUCvBiH2M8hJ25QhFrWOf7E7E6ytzIpgVZ55qR8wQjTYPfs5OA68x+ioVDpqkQF4XG6LsEuI/XxmiPa2Na03yQmfEvGfiLgcTd4fXhVqgYSr5YN6TO5X1Lip2fqlp1muyVuZD03qD///frht+yED2Tp4S9WBuzrntMeis/+YLeFv/96/0Q7SxaZq151yaLtTZt65bOQdFOGOeU8xHPAiRUE8JwAs2SJGT/d7JlDTWSvhXGi91AYPHz48OojyKkfkAm+o62QAUpKnL5d+cJ7AIhgKiVK/o67KMckU/WFXChSLYFlpRTLtgJXh3IGUfZVX0aoYSN4OYCFKhcLWlWUr1Y6DmFTXuVK6ThcgHO0fXqeG0DUbyimK9IHsScuT1bwyE3i6fwzwUmIL3fAsgAAIABJREFUjxmTa6VLSmUpAe1VWH20XTnGH6+T04ZMfs4qYR1a4HllkIiZkUkQwu/SqSMy43CkWn5lOoB2krErQaE6zFRZ3Srb7Nq5K6lWq2SxUvlMoprMSOs0XinRCKmR7ZChDcx4E1Wo8UQQkSqP1HvMTPn8RT51h468k0DPKMNg5zcAYgPhSigpTklvGCuRSBzsyMbX2S7v9qBOumNpT73LisFjkH/e25PrtLYtUKYL5PUmgddXUOsm6Q9J1AxJzXmTk9Rx74Fq6fVfm76xH++7/KltWLa4X6l4f6oD8L4bpmG6D2a2DHzh15++aCtPXaaF3EYoviPKyScDvEH6ZB5HgCm0dutXrtxpKCnZ6fGZN4D5gx/Y0fXrDy9HwKSVfDRIY8kER9UsgVRYEMLeqWcO3YVIzSBuSOZG3zNlGleABFmWgqVdlR+UEihLnt4mys46NAYvIQapCH9PcZYakZUIE76rrEMkGQavW6RH/ugyAqX4QjhpFNuW9huSFjEEpiM9artiWhlY0l2+cMBQqe0UkKTB7p4LM0NiJkYAq0NXhA02eGM6pxT2GI11CwcoknJ13KNHs+QIKbGecmotXm8MhHgOqgfcoHaWgOuD6BPnKsFws9lmckydaCO8QrkNAhDhVetp6HOHColPpF8jcrPqkf8KhsvvU9c7hGDkwY1BjtW+2D3BMGMcLseCuvUg11HMQMMNOWCW5582OgSJGFP5/qebjRjQ3+DZLJmBPxYLLznnnpAdp5PxOK0xublpdzaCgUv+9+c6v370OCzqBRe/+PgWnLVqOFb7T7d04Ls/TPYeXU0YA3tf+7SRixMTlPCObeqT8ssg1qmFCoxEEM8H4MRrk1XlNu0TYEZGOvedTmdrDjeLJ3ETgQkKRkdHF+HkMWgycNJfwZBxMiVwMgjJiXehJ92JsMOOO00ZlR1Zg6pDM5UuGiKgJjsyLYH6xSbUty3c3VaVkx59cHGwIyZp/ghAKWyFF7R0QvJ0wVPL2OYr7G2pJKrA2kmhXq2L9h1M6+deDH8WaNwIyNhJlqI0g+MNTeL9GqRXySj990DHjIpI75ST+crkCe25Uj0D9/RLnFr0XKq8qc55yqM6xrFyXtNAGp/IPLep0NIrScdsN44dTlSqycZOBPyzkcAGSdFX0PInlqT2uFg7z29KIOd0EoEtzk4mMYNO49cFrs4TlDLMdDFdMdcytlLSvQkl5Hun+iDWnjdBYMwje6nT9zTkyR+u7HojJEvWVmD/5SaO0ti1WvYiMPB0W8HTAOACfPbjX+vAnft6A9tzf6IFP3LWcKx27yEL132lI3L4dC/pxW347OVPGXm55o9NvzUwyln2/Eq8g6nAIiMW8DkCTfL1aB3ZsOGMvScRGuZV1cPN4knsOsZdtlotDxgufohBR0qd3AXeASmJM/RQgqjsttxd6e8NwwtMS+7ksP26jmmnurgGSmpe3SvVv1LNS/V5ByMGT1Y7MbOR0ifbGbulT6yJTmbxgOQyefChyvycc48Hi4kU6KXyZ4FqxibVvuxcxNKotxERTUKeXIcgzpaHal72RBTeid2bD5kRKEO9xDmJ7nepfYQzSQhlCCxQbJZE/KRnukQbzDij1XxahRokc+F8IlW3ASjVCMR7ReOUfSfa8SHUNhzxRDUQiKr1ihGpGJOLZ4aRx6dXFXJfE27t8pOGD7XdAHqJwk8517BE3iVxppKbByoPUkRndorBLghtR/56bt6t2wT45ynYX6xVeY+/k1rYQs3rGr+7x92JQ7GVRlssvi5Mt7quUZr2ySdG6vPAUOadZzBIyl5/8bs1fP2O3hrJJz60gp88v4Ljk1Nwzce/AF/5+vfgyNEJGFuxDM7ZsAYuftgW+KlHXAhnraMcLeHz1e8ch6/eqZ3ecZFY+LHNLXjchdV7RgEwZMUtnoY4Si0lc3m+ntHaxQXkN/vabwQ1atjeorrurF69+i49kwv197wCzKqqulI2Cbsl9RXBU6prWYpstaqWAzAVB5eT7vz68naknBqqSTWVWwdMQ6V6jIvYLWYXHqPVuTq2lJ5aDJaDhStWfwTVra/NO+qg9KkdLDiFn5dCJeBTAoTYH6euSnPghn5zWQ+8OvUglnPSEDsrsU2K1byo3nKl2nXHdFyScwZVtqEJpw92IGLVMPVEpp7jsnIWhE0tCZoXXpQodUV7r18f0oanbXky/MCfdSpBhzcxfvzspxNy80aA9AHv4WQIpzLm5BaONpYAkcBFhDxgeIOUEqXk7wAX7XURAITmJBem4jU0HhQCwDWwNbpvKgI57JfbJXWJUT4tX0ALPpw9OaQ9/8bQ5sqtD6cNISe09AxLepKAkDdP/uB0mdxBOOFwkvGcrVO+myw9yp6hmpWceaoK1pgW/DgY+1gL8HgA2NyL+X/vXgv/+M3exsaLz63g0odX8Pp3/G+48avfaqzuIeefA097/CPgGU+8GM7fvIGW0dQXvgD76uVw2I6SZ9lyMwkbq3GAp1yK3h7/OXWMpN3kY5dZizyyqaFePDIHnsrcRSF+XDfyr7PGxu5cqACpxzWvAFN2Ltj/KLMPphRNAUirbaXOXerj5eKQEmLXIhOMmaXH2GaSx9bx8YzXrAOiroUaJGXZF+mlVlUTnMiAkjMsqkc7uCilgb2adLlmBR04tV4YCoMy5rHFeK9UEmXvWieJ+gxJHAqTeMkGSdQzMulUxBKGTD7vxh37JtR7XhpLQcKVpzSCYTj+CzHljONITqrr9Y5mNzw+AF0y/sRJBZ2ipAQtGxCbAIrbk5sUGcun4/qwDhnbF7I4eRWhejYEx0fVabfzivZw5lhInocoBboRsJTmfuBPwES0Pd/9VDKTlGj2mBVZt/R6SM4ITTccIVGGD8+huEjShPjee69ftzL8/7tO4PCvZAKWOdueUxePWDNSrzBgtliw5xuwWyyYC4yBCwFgfa+Fpe+NH7XwoS/0Bszz1hn40TP3wov/7/8xcNUrli+Fs9evhr/82YfBikXdUubxxzwZ7JKldy2q7KMkL9QN9AJOzd8yvDJR0ar3PADn2NjYzoEHdooXnDeAiTbMdrvdvTI8gVlFyy/BUWOq5Q636CXC33JxaFUtlmNQ7ZEdJEynBET94qWMKb8CBpB0WX3aaLuTtlByKkrVtww4tHuWNgj2ImZVLKfuIybvE8m7I85CCj8chARgrpPmg7MRyZFSXVLlFuYpZcRKlenHnIBrYKZCdXpCr5X0Dk2dTbhathMyE042ORmwDeWz96LEGOtl708R5pEwfv2MVwlqr9xERRuAkCXEASS/PPB1O9Rk3gleA3TAgfDqlWpr74kbbJWkwma1snBw09oXD3zBbEBSn3Joy+k5if7KQYX65iREN59yM+bOv61XmjY8wlj4MVvBj3nV6rp+i2xQFerVn52Goz3O8jjzDAOt8ZvgD/7ib/o12XX/Iy97DDx2c6qqnezU8KWlm+AJj3vEzYuq+rlxVTtTFv9GIGUeqa9jGbzHGjvmaazWZamS+Yp8nhwDo7mpXrNm6T1DD+wUfWDeAObdd9slS5fuH4m7nlRSSycswqcGNm3vRPUEhqk06ffdK+YYiCwj57M7eHqw2c5Im/RgzplIAZ4EljBHk9XxZEPBNtCMHZfAMNKSEx2wWjgCVgDT7mQKvq/qwGtfL4MSSgOYQgzb06ozUut5JhYpRr0OSeI5DZ9Us4nzO5n5yjAPD+5uDOI5BrMAauwMxFgufst1z0yeqlN2RJZsE5BQZSSIeoYenc2c+pQSxSd2Vicl+nAQb7MLak8d1+kOSAyScZNtztNDizs8Vv4bnG20t6QGI/9uUHn/bjCIafWs5iNMx2CuYI2GAl7SdijTSHhGXZdaBtZEhBRzfCxftP1PtUyr9Syo7AsAzKNE7uTBXl6AgVWoa7Y8Ee4ZH22sd7QNcO6iW+B3/rDv4SZddfzkxjH4sxf9BIwtWQQT0x24+8AxePeXfwDfO1LDx6/67T8cbcMf5BrO8R68xiAqQZW/y3C+6CMSohF8Dm/nSe/42ISZaLcfOHvFivsGJuopXnDeACZuEffv378kB5g5sNMAyoCHf3lRaLWtZNSeubgXT+j88bueU63W6GcjaAJF2UdpcM8BMgOocu/GRUqZjniH15UmUMSA+vZCHGd0hJLOQYG5J4nkYzYijoOdIglUeD8mZ+35MbekOlfatPA+M/pgMxWETuyXPoVgOg/pvMgNgZOA+ocPSNBOnFBc58S7IByShAOKez7jrCRDOGQ9MpjfnzTCNje23WGNUkXKdl/uq1Tdq9hNKbUFMExiCfMHIMuNAX+HKKGlVEdnMnlP/nbf2cmo2WYma2yuL3gHi/dP01rYhEea0xka6JxTVdWfAMBDZsqff3DnroFVqGdtvBCe/YIrsk2tNBNw8UVteOT5i+BPPvB38LFPfZmcf4b5tCoDZ4y2YfxY+tyLn/X4bW9//c//dVwrqYTJ/EYLFTkwlZIm8y8tZeJ1z4/Cu9LpHDlwOh37NZ8A0+zbt29Zq9Wi3Utd17aq0J8l2gVT22TMxp+TPqWqtmlxNgEhgyaqLPSzTfYCVm9INYcGX2yPr3HbDL6ZMBkau16gvIhZMpNORJJWMiOH8MDl4dCuvk82IrJrUkKFKe0oxM4+ZA+lZoWkwIdrU/cVk/fturi8AKAGKnbuCF68MQG8O8PQ/yaJMoZ2OLWwAqbMqRmhDt9bt65EHGOTXS9cl5l8BMhFAAyk9ZIkg6tz7PGbNR1K4Z2iks0Ar7mcE5mXrFDN6GifAl02tCfY/iTY9wu5otEgKLEKH3/z4eoMVlNg7AjUtD64rH5hRsCG8I7g/BS0Axafp1N+0BtWHN6eVKPB0fdJOiL5BOb0mG3BRwFI9Trjz3V/96WhVKiji5fCX/3aM2DJ4qUwBS1oQwdWVROw0hyDZ7zvi/DG178cnvLYh8OBg0fgE5+5GT71ua8BgvKJfM5YvuxNN330be/N1SFVqzkein4hzDebwvg4NI/5kNZa4Rpas2bJrpK44ERm8QSetdYuuu+++0YZKLEqBE5ZpZ/nAPTONum8a3kRNAEr1nP0qKmWLWPvTWsfeKBq8W/ZTpMNUy6+QYfayygf2KzwatOSMC9sHXrCzwopVCZgIIbLHm0y/R+rcvlFEOMgPGbnolxIC5bNHbDtXqbkTFCOadPqTGpOtKPVd/5+ZKq5kBSpEsYHdPiATv0lbXQuVy+vgXBaSFhTur0G+16yXATNMP43qEW9xKdVwI6xYwB8kODYMcqpz6M3LWsDXEYc95zbyDEDC1KlBC1/EgaVYwcfBXg5z1c5KDxuilX2+J3nHr9LwOXr3Jb2dk2O8GKQFXGR3A5vdLgtrXlR88DrJvAH16d6pW1V/zLou9lU7tM3/vvQKtQme+MT3vN5WLVmFXzi6jdR9hD+fOfWu+GTn7kZsK2Dhx8YussImF+57q1/rh9sMgW59905UGohQ5uymNdIXiTtmY4/PnB47dq1h4fu+Cn8wLyRMB0jsGbXrl1L2u12ImXy5LIaMweabNUMABTih9wKVfaabP5ZflaXlb/5ew6UZTvyfm596B0glpH2BQR2t7ATz1gvcQeVaiLZ+XYY9MKY2XvW1dcjqYJX54qXyZOVMv+wLYuSI7D0KZkq1S9soa4/0XbH4MAxowwYgj5BYvVg0CXhy7IMFBLkMxJteESeNoFxmL6sdEAhiVjPP8+rmkeS0MXGSts/UZXpbX4OYHg+6buXmhJVNIBB72YEKQYNCUb4nemt70uQ4UQXWF5IXsH2FNd5iPnkuNCwWdJjTcGKNQzdDl4Z+3ywWcd3M5w8QjTT3uO+XHbuu/vhSrMtu6rMiG3B14lUJ/Cp63poFWqTvfGf/2sP9eSDf/g6eNSPnd/Vq8mpafjMl74JH/7bz8P3b//hwL2+cPO6J//1e37zm/iAFDJkBb1MV249uk+O97h6k0PaeZNmO526s3798n0l+frA03VyCqKguG/fvqW9audFIBeJXhiS6UUJzYFnXdc177QkAOYY5ckYZQ4sc+1wvxE8ezgK0aMZtWvkT+kh1okTiAZQfono7/GYIs951MbtMWeF6fYGdmpcKTUQQxNnLGoVnW8zOAipJPRSAlVB+QnDxnI5NaZvPlC4aZMoJeFGoO629XXHp2LaXmqtQYXJPWFJTcx90q6Q4kiVHcNFknkIZ0I6acDZc3le5O+4YUjT1DH9u23B0ps4qpZ7vxOu7SZHuW5pvSkFHo8xCWPJzUuwpdNOx9q6Ndr6LQB49Wy8u+OHjsInb7iZ/g2iQm2yN2Jf3nj5C+CXXnhJY7dwgr/8b9+F919/A3zj27f37P7oSOsD//rXv/cGuTFHfihNWfJdlswgYQw+2YEM3eN83synuB6nonV20jPPXHofGWtOs8+8kjCZ9hgct2fPHnI70+pZLV3qMrxj4oXEqlq5SHJSInHVzAnlctHItaGlXn5erx8JMlLN27TONLjzb7kDzBnocy9HHHPYSMrYR7otAM9LrzEZPbbNqlzqRyapfNykcr7QODJxAkoi3Uimie0HO6lXKcY+dTN2R2d2VIrAoZxdxGHAYlUpG1o6B9LBxJ1gEdVR8aBspFjSlrTzCdualgT9mIOkmYabxJ4I2niaUXvS81V6lYbBMa0z6mMimVpv+r0PUrZaR2GsmnnmtC4+PjTYYGWftJmB5zHzHnSpWnPvini/MQWfwaQlXA5TTFYj5nfBGEwbN2s87kRVqP0AU47zP753J3z8n/8Vbvr378GufQfCLWPMHcuWjL77/X/22vdfuGoVbvyFKSF1vNIauZyWjfml3sTrBDGOz7pN89TUwYNnn3328DrkBQCus7aYZpsW6DW7a9euEVwQTeoGdBCSNk7tJCT7lJM4e/XZvYR4Pm+305EEV76vVbD9QHkQevFilmAsr3Ed2iu4X+J6zRQjsAbJpAs8+Zkkybw4N5SdkzIbCaFG1hJqOHw4SNCc9EBLqSShTkFFTiZ8xJhX/yJI8HWPDk79mbPdeRuapH9iY5M3RMwqqlCxD9KWh+rOPvbOAJDK8SdpXgKwACYSl9Rc+WHFx315BossEDYBjp4rnSkrownRYJ1I9Hpz2PB8AuB+jImdW9NAb1ppU4CHxfP644Pj8XBJi6kAHd2mYfTHKmNfDcY+i1yYZumDXq6f+fI34SN/e+NQKtTr3v1b8KMXbhq6F0ePHd//zW/f/o5vfON7113xS888KitgqVJf03OrgZXvD58U5siRDRs2JH0YekCn8APzFjA9SBBo4ncNmixpSqkNF4Eu10tCzEmJPJe6Xglacr5z5SSg6p1401rRkqUEMd2eBE05Bk7mkHMy0iDKUlps1yUykAw6IxWE1H6SOUopFNW4fI8ZsK7XjyeJx3TXpL0zSAa8Rkni0s4mmM1IApmmL0tcOoUgl5O2wDj3+aT9Tc4/WmIWa0g66QjnFMfUc0CgY1Tl4edMW7nmmrxdWepqsA9GMuWAR2yEqKBI1Tgor1NgyUBLj/fTtHQBomrUjtpaHq+HtxEoI93pZCLLUqcxnRVQGUya/mQD9jEAeIjziX+GUaG++LmPh7f8+kuGbNQcBWs/1ILpPz527FhjgvOcQKGFh5wk6vllRuvkbJrsyc/mHmtPb7AkDjXkDM55cTybfdeuXY3qWb3DkgtF6/Sb9PtNoCqBLzfwfi8+P5OTgnsRUoKRLtcErBpgmzYDuUT2HqoIh/m7bBfz2aYSesyLa+1icgaS+SWxLJ9mgMyNKnZA2uVUw6EtPr4zcTpJVbNuNlSieF7DPR1ElE1NMohGVWVMiKDjA1PbWhNA+7Wjs9V4M5tQkS6OTka8nvjcVayj6XDzpnUxCCA5DAQr6+bf8rq81nV8nQZV7pCQ9kgCFICswTvZHIxCHcqLwekNKf7GfqWbBgeQbuz8N92UyE1Nu23PhBY8vLbw8MrAj1iwFwIYPH1kbKYMrkmFunHDGnjliy6FX3jeExIP2T7tfNcY+BhMt95//Pj4fi7b6ZyVrNdWa1fg38z3+G8uLA/rYUFD8zyOMNC8h50PJyaWHz7vPLTQnN6feQ+YngFU99wDo3KB5KatSX0rJU8Gr9yOS+76tXqJF6AGXVmfvod91GExTcutSe2cKy8lTN1nveDVTp+qQ0m0i+GqsBYHnKlzifgtVXOsNkS1KqXMyiVWQAkAmS7mxA0ShHcs0i+vb4faUOnSggqw29mIxuSPfYqOJGw7ZG9MKZE5L1divl2qVUmfzKkmye20rJN0sO66rsn2GJi1AkfJ+PV64zr1fDap+hlcuU65YeK5zEu1MQlG0zP4PM6dPEBdgm7uuRxwUzkG0YykKTcKen1Gm+XicF5lQlv/AKt4UbrUkjiV94lJOGVcWsautLZ1TqdVbTa2PpckUWs2GmM3WQCUSlcNAhcPHDsOBw8fhZVnLIOlS5ozAPm6OmDh+1DZrwGYr1Ud+MLRo8tvm552wN9uO6EGf/N37gPzQwmSeE/yEvmdTVg59azkKTyfuLleZm29YsWKQ3jCwiBjX+hlTgnA9C+fufVWWLR4sQuibwJPvdPKMZ5eLtjEPVXShE6nQ8b1XuDXBLbDLiCuR7aX6+8gUmhT2zJomcvkgpfl89ILV0psXEYnWGAmzcDmMxTV+Jf7jkwYgRQlHZ9cPoKL8Px1YhlgLuCQpF70LahslcZEhosk61w5p/SaIinJhOPSJFPm8XkpnJi0BEgJHAxmvKHQh5p7MO/azPRw2mmSkBu9fBvoFl4TN2+p45fWpMjj6tI14pzEJPDxszznUn2vJWoJipzRSqbHyzk0ifeONioSKIO0KbJ3SaCU42J/BR4Pv+vp2JcuhxFzVsvYtdbAOgC72gCM1WBXmNqMgjFLwNYjYMwyOnsGD4G31nmSWnsUwBywAAdMBfdBDfdaU+1s28nbjhxZFTLRMlBKuiJQ5gBTg6rmiTleKIWHXExmfG+NmZiYOL527dqjp1voSC+GcMoAJg8CVbT33AOL5OJAVYVWT0iQ0ZJfk7OQe+FiogQGLa0W0gTVDCUH0rkyemc+CLhKoMRxcL05dbOW3GS/UumxOa0ZlpNqXB0Xqhkiu54rGvgNbMwh64SwKI1iAWa2MkuRBm0tIfILLtZH0/FOoUvusG6nZtbPe4DTTjQq3KP5xA62Ocr5do4opDak6mNfU+9VBmL2PBZgKyTr7rnSGxjhRORV7Ilnr7wW+tKtTXApGAX9EwcfNZbk2Do5Z6iyF+DXBcbunRtFqVF4JXebirwmgFWvNAbpLOWA0tme66XJ+aOUZDyCMc+d39rwQPxGWdA8eR31Zln/Zh6EfzXoackQK8YyGgRzoMhlc3VwB5skT7yvJUxWyWpeI51/8N7KlSsRKCcH4UmnU5lTDjD9gsZ+t++5BxO8pB8Ezl76/MA1xWGrzDS1akODXJPqSTDrrp29BK0mde4gC07bY/kZrWLmPja9GLIt/ZLk+sH1SeDkcvq0A/eCxlitSOsk0YKcAmkzTRyKmPZ8UC0zsqDW87UoyZa4oFZv5hxj3JynjJnnqiE0IyEPMeZFLtxDqiq1dCWBUtjXEiBqAm7NvHMboAESPCSHC/hBBCccSS+ZiMHtcJp9HBCgZIYpQZx+YSHBA9vTRoTaBIcgqsOPN3d+JTXHTj1SkuQ1iapETVeUIuU7rSTMoJFwIDWd2J/l+4fVSHtiTiqUi6WXdCjLSeDjOi+8MN1U3XormJzEKZ9tEh4kb2iycR49Oja5cSNgdpNBtBSDsK4FVeaUBEwBUKi+at95J1S5BaMBkDMIMUAyQ5K7Rc5lm3uZ+tkZc9KpftGagK7XqtJA21Qn15EDS2aMGnib1DK9wFPek/YOZFbsJJADyxxACQbug0WTvLRd4S0SDOWRZ7I9LNMZqae7NjjHTYUSYMJIlfMKOynlgDfnKKPplDJkJ6Ehf5W7BJEuz4k5OgtQj8WQAlxMH9iPK+XU6HG9dNm0k/AReQCAB6kAaOJdTDYqMXFCyvC1F7CQqsMQUhpmpXAqK4ESATJueKQNO0qUegPi5sZplLBN/s6AiMAjJUfuYBNANkmMW7aEjEqAgMf1IBjyb/1dz6d8ju8xz+slYWLZHN/D65JPTE9Pd9auXXsMX51+a+l0vn9KA6YEzltvhRFcOPiPd1jaq2xkZE+I28RF1M9JhxcUv0zajqnVvhIMZVm5YOVLieWlOlkDcs67Ntfn3ALuB+5yt8m5eGU9OGadDUmCVQ408Zou05RkgctGG2dQNbJkQQxYgazMlduV5k+2j/3X3qa53zmbGo+Ny+dAkDMkaS0ES03M0CUgMNh1PxNDICKwDgaGEphyICWT/TdJjExnHR7j5zIrjYr574r91J7MerypWjqf6Qf7wmFJ3n5N5gct/eP4cKPGNshu2qaA6YVMv5FxBzzk3sl+4Cjva4lPAqqUEBH0tMQ4KPjkADMHnDnPWdmG3kyjf8b69euPF6eewWZiQQCmAM7WrbdCmx2Dmha19C5jAOrnZCN3o5q0WpLtVZafZTDX4N7PE7jXtGqQ7AeaXJf0ntO2Ga7DGyGT9aLUeV1rqQlgmw77drveEAvKZ5gG1RgfjK2ZtT6xRXp0Zph1cu6p7qNjys5zVIKfbzP3vij7ZhryEMMdMsxeAUCvo+Wkd2eTgxaDB9NHl5P1yxg7Bnemfy4rj94MJVJ6JlezeCcT+ki1dw7A2VaZA0Y+7UceiuxF9CAl5uYbQUFe1wAp36l+qlYpRfZTxTI49gFKpk+WF0sJVPaTr0vpUgoLGiRzG+3169dPno7p7QaDxnypBQWYTcCpvcmwXJNHmVxYWsLUJNT2w5wXrZZKNWDmpmUY0JQvuARfact1jDCm0Mq12QRuTZuDXB0sqcq6ckDLz7JdVDJCzmPJDFpLUMJmFyRReQyR9Mp1QEBxor465/3JgKhVtjknF3mwtR4zAwurWIVKMLF/CYfdGmUHAAAbuklEQVSVUAVdy5y9KtuQx8vJzYkbQ+bcVhEGJOvR4KbHkTupgsvo81j1s1L6y9lYc+W5/5L+6KiDBxhLoNQbgNy4tWTJY5XvolS3Yh3aBsn8oB9YYjnkJTOVEjO5jnOOVHlO7a/mVLg51WyTpDk1tb7euBEQKIvqtSel8zcXJGDyUFGriNh4553QynmZNQETq0mbJDZ84aSdg9vrBV6a/DnbSK/5Y3tK7uVueq7ppWkCz0FBU7en65OMkAFTqngZDLmeXLv6tBZZJsPEB5JuPZjKMJQuDIxJzt0trUaV/WB1aw68EsbvwU2HOeTOW5USk+ycpqlY411OThK49PdcnZoI2g7darnYWXJ0Ejlb9Tzm1qGkn9wk8CZJngvLz6M9kutO1eFeKesL6nsMhrIfEiwZRLWphsuz5yr/1k44JwiUOfL0478BUKWU2ks9i41o0xS+n8eOre9s2UJAqZNpzAA2Tt9H+k3YgqAMOk4icN56K7S0urYpPEWrTCUhpNSYK9frGgMe/m16cWVbEijli60nRgY4yxe+n7Qq1ckZh6AQgjCThZADZi1xMhDov9yeVitKm2eT6pCZu7ClEaf1bVOco2TkTWAkQYl5tGbGsUx0ThGSJ9nc+JDw3MHkOabfj9Y5gOZncgCppVNpm5bAJDcDvWzP0utY91XbQbXEKMs3bRi66+RtRPSA1hsLLVFyHfK6lCxZ6yS1Tyw9asecfvOh7ksVay9P08SxKre+RFxxqJOBs5cTEIMm/t24ETAOtFO8XoecxYbipwVgKiZHnrX33IOBxd2qWS35SZtFzplIq0G5rSbvuiZJtyntVQ5Um2wn7Hwgx6vtGr1AupfDQA78mlzTey1NaROVzFp66zZJurkTW6QdDCVPLQHxCQsSZJQzSzgeyvc7qHozCQOoiJdzsrGZcuwcD8jAwH3oB5IZKTYXGpJck3XLzYcES7FpSN57uYnJ0CkMSYMo0WKZtU3SIl/Hchoc81J5t5pZ00yqXHOqZlkva4Kw/Zy6tek9GkKSPNHQi+BQ5cGxqb4suN56q0viIgES3/eNG+kAc/QSL9Lk7OBkqOW0A0wFnsFJSEtiGlgYOOVfXqhaXSpBs2m+uB4tQeacChgImwKbZRuSCTS5nfdbQ/2kUvl8Dkh72UtT1Wr30UQyC5FmiNrmKG2gDnxdZAqDGveTpa4+at0AhFLlGxl2PABaBsm7trqOz3LAuoyESwp3iECbgoKUlHTfc6CS20z0KidpqCXNJmk/tz643Vxi/17rSQOlzKiTG29u/nLSpB5XslHxoSIsXR4/flYXcOTAcgCgPFGATNiPAEnJh3s6AYkK6BnlFISSZLFN9mNwJ3D/tAZMpptW2WrQYVBrSlvVRH+t7h1mnnRbg7St1Uty58ltI4hOTMS4MLZ3yGeHAUw9Jq3izd3PMf2cN65ULzpAdB8xb6xmTbIRMVgFwPR5crU6V9cfT7egVugQ5Lwk5Ox5TepGtsHJfnL/o3IxhjvwuPpJnpKW3Pdc6FGvdZZrS9J0EBBl0GQw1CAqxz+IJKnLyA0OAyxrMzgspFfIlfQxkHbJnAaGadUAlicDIGl59pijnDSpi0s7PG4GcFM2m30dhlWdVmULYKrp9uDJzkKk8mhKbSVBqJ/0J1W3/cCvV2D0TFan7n8vla4cE3/PSd/DgGq/cBctdWqVopQm8F4uPjQHNpL5ayeiCMAu3tHF/FEKuSTWT3rpNoV9SG/OnNqVOKTwapXfZZ7iXnG4WEdT3G+vNSHt0tKrW0tyag5Cvt9+4JsDRL1R4PGzhCvnEwFRb6C0WlWOG+nFWXhyznm97JR6LLMsUTalEezlZNYEhBpUuQ78SwDpDyYoIDkThngCzxTA7EM8zF2LvAo9bUdHd1U5VS2DqpZM+4EoPsfSnga1XJos2dWm4Gguo50CBgVNCZhyRy6diprScPGzOrev7Ldkfk3etRIcdOhOBLpcTtWo+mSwZIaMIMuSEIYvOCYe1az4e+lS2xlU5cgp2PC5XjZKDR4aYKRNrikEqWmJNoGV3oAwDaVKVjt4MV0lfbUKt4u7i/SSWvJvGqeuQ4OovK/DtBAscyEhOfpopx5ZpgdQ9kvr1zgV4oYGsV6xu7l7Wj3LIInalGKTPAGwm41HC2AOQUUOU0HtIKbjY6DkKvoFMg/RVFK0l0Q6CHDKAGoJiP36m5Osc2Pgcih1or1I/p4N8OQ2ezF5LqNVilKCkfZRljil00rOa1OqHyVz1+pcCYw5sGgCNw0KspwGIQlqvSS7nMo7p/aUdM09k7uWA019rSnrjpZqm+KWsT5WvXLdUs2K1wZxfOMyfSTJflJa7n7O5ojdGgQs+7EBVsliXUXV2o9ac3y/AOYMCe5VtxSuIuM82WbST40rm+1VNveyS+lRSoH9ynKbTQykn6v6DEmVVWljXU3JI5okT1Zf9mLknGwiB2iszpUqQTkmzdB7SViDqCK1elZ6FWtAYJDAvznVa5M6Vl7PAWyvOdN0bAoDkpuRXH2Sbk6lHR2bmjYWPH59X/9mUNWSpQRMrcnpt4kUY8iBYT8AbSKpfK6JrzYlKsDr9K/YImfKZebmuQKYs0RnYftEmlZ8qgBWL0Gt184YkzTL0wgGsLEM1fumNFu6kpw6VzoFDdWoKKw3Bjnv4pzTkJZEsIwOT9HSn74vpTMSBWJcJr0DOTuaZN4aTHlYOeBk0GgCsEFiBgehcT8QZVtfkw05t/HoB5oaPHupmDWNOAWjVsPmJE05fgbLnAc5luPr8m/m3RkUCJvKDfp8IFGPOSwAOcgCn4dlCmCepEkREiiqbiuM++xlV+FuzAJIajtMmON+yZ+b7jcBaJOdlTcITSrdQVW9cmqapNGm6WNJE+/zuaFNoMiAyQCJf1mt2Gq16NzMJolSSqs5iVL2r5dUiuX6AQeW6WXn1BKsbHuY8J9+kqfsp6QtagB6jbdJeuz1Ckqw1OWaAHSWwXJYoNTdlCrWIkGeJH47V9UWwJwrSjuphsDT/9MxVMP2pJ8KqN/9hLeJrCLZfvRLx9Wv8/1Ast99B3y7utarBpB+0lRO8uwnNen7+FuCXy8g1CCiJad+dNP3BwFVfKYpU1VTjGzTdd5MaLDW5XuNM2e7bAqHkU5eTWDZSwWL/VSAOQzgDaOilepV/a6xBImai2HaH3Y5lPJzTIECmHNMcLUDR/qTCtdfD5k7huhWP0eDfk4LAzc1DGjK8/1kA72kz0FAUwJnL4ciZvDyLzPuBmmLjo+SYKiZt7SPynL4XE5tzOPWYNIEer2cYLguWWbQrE25CZ4pcGo1MNOsyZtZ07NpjCwd6/GxTwCvJ7l+pFNPg7lhEPUqS4A5Mg3yfChTwHFgVnLKFiyAOc+mTqhyGUz576A97SVZ9gNXboPLMTPJqnV7AWjOMzc3gEFBEp8dtCxLIPIYtxxwNtk9sSwzbqlyZWmWDxnPgWvTJEkpVDqyDDqpuXJNgDnTGNleUia3z5sOGT8q+6YBlWnGY5abnKbDCrg+mXQgN/4hvF/1eu5F9l4SId8rqtUTWbin8LMFME+RyVNORYOCaC+vvMADhTs8rwdtB9VUyq6bQZ2KsLLceX79poKBsFfGFqxDlmsCTS2xyZCVnK1TA4ZUBWvglUCqx6TBMmeT1EAi1atNp9wMA5LYp14qW9mnXjbTfvOVU6/K+WkKl2qy9Q9h35egNwgAYrfk2g/ASDeKWrXfVJ829wtgnsJTnZFG+cUfdF772Vd6qas04OrYtKQPOYeifmEs/RgqdoClTvQw5g7Jepct20VJ9vGjJagm9aB0GNKS4SBSmGeylDVIt6FBJLf8BjnFpt+y7ZeWUdoBezlU9fJQbhqbprUMCekX+8tzKqXLAYFSr+V+azvYGXnDWICx36oq9wdlrIVSpxgFhlTt9mMuJDR5EgyzZvqW1VLpIFKqPn6pHxjjkW45CSwnrWE5DlvpFUMoPVJzgJwD4152Tqmy5PqakvrLpdgPXDVANWVs0sub2246/o7Laztyzq7MfWwCS+3Ew1JoD29Xva56SZRSWqTvBRhPMWY2j7rbl6HNo76WrswSBXpIpk0tNNk+B5FApSRK3/uFt8zGMCWoImA2MeWcExKD5kz7kQNTDZb9HJZ028MAowTFfmNosgvnjrKTQI7fZ3Ik3SBaA6x7gGToMlyDN3TFO7XfhJf7J0SBApgnRL6F97AHU9qIZyRKuV7k/UEkVFnniRIuZ5tNJOAmda8OctcdkWn98F4/ex6raHNenvw8/m3yjB3E03UYsJwJYXMJJRgQmwAu144+1UfbmmVdOTt0D5DkuWW1e5EUZzLR5ZkTpkABzBMm4elXgQBVBkENrv3WVb/7OaL2C4/JegfrE+qbwl2wQQYODZqDzLB2jmmSIAfxDB3UGxj7NYhNcJD+6yQUvRyrcqEduWxWTYktBDDmgLCA4SATVso8KBSYCeN6UDpaGj01KdBDYmVPX2SQMv50UGm1H0H6ru2msBhk9BIA8JQa3ViTOpLLDQKY/QYwyP1BAbOfpMjjzamuuR+9VL3e6SrxLhV276IqHWQyS5l5T4G+TGXej6B0cMFQICO58tj0Os2phnN06Lu+NWjKAHkJFNIBp4ngTY5FM5mgQYFwkLp71ZXzMvZAJ+3TXY4zxbN0EMqXMguNAn0ZykIbcBnPwqaAAt0c4PYCX0kcloDJSWkQNSmWyR223URxHZiv25BAN4ATDDbT5C2avV68RRf2u1BGN/sUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNRYKFAoUChQKLEAKFMBcgJNahlQoUChQKFAoMPsUKIA5+zQtNT6IFLjiiisu6XQ641dfffU3H8RuPChNX3755Y9stVqrAODOq6666s6T3Qnf3vhctHWyx1LqLxQYhAIFMAehUilzSlAAwbKu689jZ621PzET0Ny2bdsLAAD/PXJycvKSD33oQ+OnxOABYNu2bTcCwFMA4O07dux428ns97Zt2xCQz7XWfuLqq69GepVPocCCp0ABzAU/xQt3gB4gLxEjxO8IGPh5e27kVVXdeNVVV93I0lhd1480xmyx1j5SPEuPNoHB5Zdffpkx5rLZpOyOHTvkOGZU9VwCpqfBB7GjVVWdV6TMGU1ZeegUo0ABzFNswkp3IwW2bduGUtRbh6QJSV/btm2zDc8dBICP478dO3bg367PDNvt2c0dO3ac8Ls4G4A5xGYAVb8X+0HdAgB9JXFr7YeuvvrqDw05X6V4ocC8ocAJv6TzZiSlI6cdBZSE+QYAWAkAOwGgkSmzhCkA8wsAcKO1FlWM3xxEjZuRbDXt+0q6+oHZUKFu27YNQQtpMGOV7MnYDIixzrhfp93iLgOelxQogDkvp6V0ahgKKNvlr6AU4xk/NAERA2ZVVZeiinaY9vqVlaBzopIjqo6NMX/ar01/n9XRuGno6/RjrX2D3iCIvn+4qqpZkQbrusb+ozRaAHPAiSzF5icFCmDOz3kpvRqQApdddtmqRYsWoUfsuQDwBbYFMiA2AdYcAebBHTt2oOpyxh+5GZhxJQ0P5jYLAjC7wA1pPTIygiD6Ng20HtjfUFXV27Q9czZUxbM99lJfocBMKFAAcyZUK8/MGwpcfvnlHzfG/Jzv0IeFZMW2zcT5B6UmZOhCJdvT/jYTu5sAnQDgMyWYAsysI5OvewsA/LL/3qscFiHaDAOYvh9o0yW1944dO7A9+vhNC0q0eA8/H56cnHwDexgXwJzp7Jfn5hsFCmDOtxkp/RmKAq961av+1Fr7+kEfYpDo4fSjqxpajXiyALOXenfbtm1ow/0T7Hw/NXAv6Zrts2zrRTAcHR19m6DxTmvtC7SEecUVV2zpdDp/KjYv6Dz1th07dvypdyTawnUOOlelXKHAfKNAAcz5NiOlP0NRABn64sWLMSQk+XA8JgKkvDExMfHNxYsXr6rr+g6Wsvh+XdcYKoJSmrTfDZ0E4EECTFSVYt9v2bFjRxc9JA0GVUd7EEZPZJIcMcxmamrqMpYcEVzxurQBe8BlmyXevsVae9kgzlRDTXwpXCjwIFCgAOaDQPTS5MmnQC8bpoghTMCll/1umB4LFeSHd+zYcULxmlIl20fCpEQCqC6dnJx8ZK+EC/0A09MHgRLrww9Ki5fJMJtt27YxQOP9rnFqsC0OP8OsoFJ2vlKgAOZ8nZnSr74UYOmyrmt0rNFSFdswMWwEP+RBiqAj7J4Jo+8HmCfTAYcHq+2KgwCmd7j5hiDYLb2yFDUBZsYWiVW+fXJy8k8ZgNnxR6heudku0EQ1bV3XCKxE+5IVqO+SLgXmOQUKYM7zCSrda6aAZ/AHhqERZqVhdSwAvFBJTZwIIWu3nK+AqaQ9JkcjaPaSMIUtFNXSicerB2YEQEpYYK39FfxrjKGMP6h+rarqBRkvWaTrG6y1lxTV7DCrtZSdbxQogDnfZqT0ZygKePUnMu9xY4xMuB48QdFuyRKSkC4TT09stJ+E2WQvlR3GVHvsfPP/t3d3x20bURhALamCdJJSUoWe7Q6SEvIoN5GUkHSQElyC8yZpRsPM5WA1mzVIgBQpfaKOHzP8uTiX8WcAuxcVKDc3N9+6fYiLexv7Wutzl84wp7O47f3YujS62Wz+6gNs7n7m0iXZOs7xku5wifXfKRi3+1f7MXl1+Xba33mSPZwH/Ri8mMCZBQTmmYF9/NsI7LqH2f5yrzAbx7QtBeaaI5lbrfqSbRVLgdl99vNM1yHA5u4vbscCrhnasHYRz3T2WdtO2n3Pv6cz1JMOhVjTA68hcC4BgXkuWZ/7pgL7Jv1UCMxN9xm3VBxzAC3A+vt15wrM/lLs1dXV73d3d7W1ZPtn2G4z3qtdDMzJoi6ltulBden1f98x+sxsQamXCM5jfkjeEykgMCPboqhDBU58f/HgvZdV73B59EvtQaz/fo7AHGa+zt6v7AO1P6Ped0m2G77+HJQVenNj9Hb1aC5sp88wfP3QH7bXRwkIzKh2KOZYgYTA7EPs8fHxp1NMupm7JDss8qn7iT/PPV5rWhRVl0TbIp3tM0J3BebM4qGaSVsrkI99GHeFbm1JaROAqr1H/WPk2N+F9xE4pYDAPKWmz3ozgT5Y1tybmyu0m/5z8F/qw5aM8RLo0Q92Ho6rVvjWfcL2WK1aYLN35el01luB9zzSbsW2kj/b4PU2AOIFjf2tJvw8PT19rueOLg1VeMH3eCuBswsIzLMT+4LXEHjrwJxbfNOOe80l2Qq2+/v77+Pq1PEMszsL3LvXsje/vb39pR551sJ1aZVse+9oekgfPaHkEC2vfS8CAvO9dEqdewXe8pLsvsU3VfSawGzbXcbVu2NgTmeyNXVn7SO/tm4VyO2y7TGBuTSfdmzOmmP2kybw3gQE5nvrmHpnBYbA3PsEkj2EbaHL6kuyw32/2Tmua8Jj12uWtpUc83MQmMeoeQ+BT58Epl/BRQi89iXZcexbTbnZNY5uZWB+r/uMS2eYp2iWwDyFos/4iAIC8yN2/QKPeTjD/HJ9fX3wys5ugcveM8xpNWzteWyrP5dmt7ZFP7OLdPpBA5vNZruSde4+4qGXRefa3J8RLy2OOuBZnHNfVUPna4jB6rP1C/xZOqQLExCYF9bQj3o4r3EPc1o8U/cO2zSb7Wb+h4eHX/c9HWR4yHVts+jDvEbpteD9YVzfSy7JTsML+qH0tUWkrbB9ngy06zdzIlOB+VH/p7zA4xaYF9jUj3hIr3EPcwrMPybfGjT+eW5i0Og/jY2rs8x+P+IPbZob1/eSwOzH9I1ftubJIYNpe+rL2p9X+4eAwFwr5nXxAgIzvkUKXCMwhdJ25eghU2n6z+4Gue+cSFOXYzebzbdxDu1SjUuD28eh6+3z+uP6+vXr9oHNa/9M91nnnsf5T/+Ull2f95Lvbme3m83GdJ+1DfO6eAGBGd8iBRIgQIBAgoDATOiCGggQIEAgXkBgxrdIgQQIECCQICAwE7qgBgIECBCIFxCY8S1SIAECBAgkCAjMhC6ogQABAgTiBQRmfIsUSIAAAQIJAgIzoQtqIECAAIF4AYEZ3yIFEiBAgECCgMBM6IIaCBAgQCBeQGDGt0iBBAgQIJAgIDATuqAGAgQIEIgXEJjxLVIgAQIECCQICMyELqiBAAECBOIFBGZ8ixRIgAABAgkCAjOhC2ogQIAAgXgBgRnfIgUSIECAQIKAwEzoghoIECBAIF5AYMa3SIEECBAgkCAgMBO6oAYCBAgQiBcQmPEtUiABAgQIJAgIzIQuqIEAAQIE4gUEZnyLFEiAAAECCQICM6ELaiBAgACBeAGBGd8iBRIgQIBAgoDATOiCGggQIEAgXkBgxrdIgQQIECCQICAwE7qgBgIECBCIFxCY8S1SIAECBAgkCAjMhC6ogQABAgTiBQRmfIsUSIAAAQIJAgIzoQtqIECAAIF4AYEZ3yIFEiBAgECCgMBM6IIaCBAgQCBeQGDGt0iBBAgQIJAgIDATuqAGAgQIEIgXEJjxLVIgAQIECCQICMyELqiBAAECBOIFBGZ8ixRIgAABAgkCAjOhC2ogQIAAgXgBgRnfIgUSIECAQIKAwEzoghoIECBAIF5AYMa3SIEECBAgkCAgMBO6oAYCBAgQiBcQmPEtUiABAgQIJAgIzIQuqIEAAQIE4gUEZnyLFEiAAAECCQICM6ELaiBAgACBeIH/AGEE9TA4yDM3AAAAAElFTkSuQmCC"

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 股吧
	 * @author EdisonGu
	 */
	var React = __webpack_require__(27);
	var BoxHeader = __webpack_require__(217);
	var request = __webpack_require__(180);
	
	var _require = __webpack_require__(206),
	    goStockListHtml = _require.goStockListHtml,
	    goStockDetailHtml = _require.goStockDetailHtml,
	    getMMDD = _require.getMMDD,
	    getTodayYesterdayPlus = _require.getTodayYesterdayPlus;
	
	var userInfo = localStorage.getItem('userInfo') || '{}';
	
	var _JSON$parse = JSON.parse(userInfo),
	    _JSON$parse$token = _JSON$parse.token,
	    token = _JSON$parse$token === undefined ? '' : _JSON$parse$token,
	    _JSON$parse$nickname = _JSON$parse.nickname,
	    nickname = _JSON$parse$nickname === undefined ? '' : _JSON$parse$nickname,
	    _JSON$parse$headImage = _JSON$parse.headImage,
	    headImage = _JSON$parse$headImage === undefined ? '' : _JSON$parse$headImage,
	    _JSON$parse$serverId = _JSON$parse.serverId,
	    serverId = _JSON$parse$serverId === undefined ? '' : _JSON$parse$serverId;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    var params = {};
	    if (window.jfztglobal.stockname) name = window.jfztglobal.stockname;
	    return {
	      name: name,
	      datalist: []
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.getData();
	  },
	  goPage: function goPage() {
	    var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var _props = this.props,
	        symbol = _props.symbol,
	        market = _props.market;
	
	    goStockListHtml(market, symbol, position);
	  },
	  getData: function getData() {
	    var _this = this;
	
	    var _props2 = this.props,
	        code = _props2.code,
	        market = _props2.market;
	
	    var params = {
	      token: token,
	      appCode: '9fztgw',
	      symbol: code.toLowerCase(),
	      market: market.toLowerCase(),
	      pageNo: 1,
	      pageSize: 15
	    };
	    request.get(request.apis.stockBar.list, params).then(function (res) {
	      if (res.code === 1) {
	        _this.setState({
	          datalist: res.data
	        });
	      }
	    })['catch'](function (err) {
	      console.log(err, '====');
	    });
	  },
	  clickSymbol: function clickSymbol(item) {
	    var _props3 = this.props,
	        symbol = _props3.symbol,
	        market = _props3.market;
	
	    goStockDetailHtml(market, symbol, item.newsId);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props4 = this.props,
	        symbol = _props4.symbol,
	        name = _props4.name;
	
	    if (this.state.datalist && this.state.datalist.length > 0) {
	      return React.createElement(
	        'div',
	        null,
	        React.createElement(BoxHeader, { title: name + '\u5708', showmore: true, more: function more() {
	            return _this2.goPage();
	          }, showself: true, self: function self() {
	            return _this2.goPage('position');
	          }, selfText: '发布新帖' }),
	        React.createElement(
	          'div',
	          { className: 'clearfix block--stock-bar-content-wrap', style: { paddingTop: 0, minHeight: '400px' } },
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'div',
	              { className: 'lhb-table table-thead clearfix' },
	              React.createElement(
	                'span',
	                { style: { width: '365px', textAlign: 'left' } },
	                '\u6807\u9898'
	              ),
	              React.createElement(
	                'span',
	                { style: { width: '60px', textAlign: 'right' } },
	                '\u9605\u8BFB\u6570'
	              ),
	              React.createElement(
	                'span',
	                { style: { width: '60px', textAlign: 'right' } },
	                '\u8BC4\u8BBA\u6570'
	              ),
	              React.createElement(
	                'span',
	                { style: { width: '90px', textAlign: 'right' } },
	                '\u4F5C\u8005'
	              ),
	              React.createElement(
	                'span',
	                { style: { width: '80px', textAlign: 'right' } },
	                '\u53D1\u5E03\u65F6\u95F4'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right', textAlign: 'right' } },
	                '\u6700\u540E\u66F4\u65B0'
	              )
	            ),
	            symbol && this.state.datalist.map(function (item, index) {
	              if (item) {
	                return React.createElement(
	                  'div',
	                  { style: { cursor: 'pointer' }, className: 'lhb-table table-td clearfix stock-bar-list', key: index, onClick: function onClick() {
	                      return _this2.clickSymbol(item);
	                    } },
	                  React.createElement(
	                    'span',
	                    { className: 'ellipsis-text text-body', style: { width: '365px', textAlign: 'left' } },
	                    item.title
	                  ),
	                  React.createElement(
	                    'span',
	                    { style: { width: '60px', textAlign: 'right' } },
	                    item.hitCount
	                  ),
	                  React.createElement(
	                    'span',
	                    { style: { width: '60px', textAlign: 'right' } },
	                    item.reviewCount
	                  ),
	                  React.createElement(
	                    'span',
	                    { className: 'ellipsis-text', style: { width: '90px', textAlign: 'right', paddingLeft: '5px' } },
	                    item.nickName
	                  ),
	                  React.createElement(
	                    'span',
	                    { style: { width: '80px', textAlign: 'right' } },
	                    getMMDD(item.createTime)
	                  ),
	                  React.createElement(
	                    'span',
	                    { style: { "float": 'right', textAlign: 'right' } },
	                    getTodayYesterdayPlus(item.updateTime)
	                  )
	                );
	              }
	            })
	          )
	        )
	      );
	    } else {
	      return React.createElement(
	        'div',
	        null,
	        React.createElement(BoxHeader, { title: name + '\u5708', showmore: true, more: function more() {
	            return _this2.goPage();
	          }, showself: true, self: function self() {
	            return _this2.goPage('position');
	          }, selfText: '发布新帖' }),
	        React.createElement(
	          'div',
	          { className: 'noData' },
	          React.createElement('img', { src: __webpack_require__(356), style: { width: '180px', height: '160px', margin: 'auto' } })
	        )
	      );
	    }
	  }
	});

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  headerHtml: "\n            <div class=\"global-header-tool-wrap\"></div>\n            <style>\n    .global-new-header-wrap {\n      background: #252733;\n      z-index: 9999;\n      position: fixed;\n      top: 0;\n      left: 0;\n      height: 50px;\n      width: 100%;\n    }\n  \n    .global-new-header-wrap .global-new-header {\n      width: 1000px;\n      height: 100%;\n      margin: 0 auto;\n    }\n    .img--new-header-logo {\n      position: absolute;\n      margin-top: 10px;\n      width: 145px !important;\n    }\n    .new-header-menu-wrap {\n      width: 100%;\n      padding-top: 11px;\n      font-size: 20px;\n      line-height: 28px;\n      text-align: right;\n      color: #333333; \n    }\n    .new-header-menu-wrap a {\n      position: relative;\n      color: #CFCFD2;\n      padding-right: 12px;\n      padding-left: 12px;\n    }\n    .new-header-menu-wrap a:hover {\n      color: #E94041;\n    }\n  \n    .new-header-menu-wrap a.first {\n      padding-left: 0px;\n      padding-right: 12px;\n      border-left: unset;\n      border-left: none;\n    }\n  \n    .new-header-menu-wrap a.last {\n      padding-left: 12px;\n      padding-right: 0px;\n      border-right: unset;\n      border-right: none;\n    }\n    .new-header-menu-wrap .active {\n      color: #E94041;\n    }\n    .new-header-menu-wrap .active:before {\n      position: absolute;\n      left: 10px;\n      bottom: -3px;\n      content: '';\n      width: 18px;\n      height: 3px;\n      background: #E94041;\n    }\n    .new-header-menu-wrap .active2:before {\n      left: 22px;\n    }\n    .new-header-menu-wrap .active3:before {\n      left: 33px;\n    }\n    .new-header-menu-wrap .active4:before {\n      left: 42px;\n    }\n    .new-header-menu-wrap .active5:before {\n      left: 52px;\n    }\n    .global-new-header-wrap .market-hot-icon {\n      position: absolute;\n      top: -5px;\n      right: 1px;\n      width: 26px;\n      height: 17px;\n    }\n    .global-new-header-wrap .header-login-box {\n      float: right;\n      width: 130px;\n      height: 30px;\n      position: relative;\n    }\n    .global-new-header-wrap .header-login-btn {\n      cursor: pointer;\n      position: absolute;\n      top: -1px;\n      right: 0;\n      width: 100px;\n      height: 30px;\n      font-size: 16px;\n      line-height: 30px;\n      background: #E94041;\n      border-radius: 2px;\n      text-align: center;\n      color: #ffffff;\n    }\n    .global-new-header-wrap .none {\n      display: none;\n    }\n    .global-new-header-wrap .header-user-avatar {\n      cursor: pointer;\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n    }\n    .global-new-header-wrap .header-logined-box {\n      position: absolute;\n      top: -3px;\n      right: 24px;\n    }\n    .global-new-header-wrap .header-logined-box::before {\n      content: '';\n      position: absolute;\n      right: -24px;\n      top: 16px;\n      width: 0;\n      height: 0;\n      border: 4px solid;\n      border-color: #ffffff transparent transparent;\n    }\n    .global-new-header-wrap .header-avatar-popup {\n      z-index: 10;\n      padding-top: 8px;\n      position: absolute;\n      right: -24px;\n      width: 140px;\n      color: #333333;\n      font-size: 14px;\n      line-height: 20px;\n      border-radius: 4px;\n      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);\n      text-align: left;\n    }\n    .header-user-name {\n      background: #ffffff;\n      border-radius: 4px 4px 0 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      padding: 12px;\n      border-bottom: 1px solid #F2F5F8;\n    }\n    .header-user-name:hover, .header-login-out:hover {\n      background: #EBEFF3;\n    }\n    .header-login-out {\n      background: #ffffff;\n      border-radius: 0 0 4px 4px;\n      cursor: pointer;\n      padding: 12px;\n    }\n    .login-out-icon {\n      display: inline-block;\n      vertical-align: middle;\n      width: 12px;\n      height: 13px;\n    }\n  \n  \n  </style>\n  <div class=\"global-new-header-wrap\">\n    <div class=\"clearfix global-new-header\">\n      \n        <a onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Home'])})()\" href=\"https://www.9fzt.com/index.html\" class=\"float-left\">\n          <img class=\"img--new-header-logo\" src=\"https://www.9fzt.com/assets/img/logo1.png\" alt=\"\u4E5D\u65B9\u667A\u6295\">\n        </a>\n      \n      <a class=\"9fztgw_dhlztrk\" onClick=\"(function(){_hmt.push(['_trackEvent', 'click_PC_Banner', 'click_Zhuanti_Banner', location.href])})()\">\n      </a>\n      <div class=\"float-right new-header-menu-wrap\">\n        \n          <a target=\"_blank\" navpointval=\"nav,attractive\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Attractive'])})()\" class=\"\" href=\"https://www.9fzt.com/9fztgw_1_top/index.html\">\u770B\u70B9</a>\n          <a target=\"_blank\" navpointval=\"nav,market\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_MarketCenter'])})()\" class=\"\" href=\"https://www.9fzt.com/marketCenter/index.html\">\u884C\u60C5</a>\n          <a target=\"_blank\" navpointval=\"nav,laboratory\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Lh'])})()\" class=\"\" href=\"https://laboratory.9fzt.com/index.html\">\u91CF\u5316</a>\n          <a target=\"_blank\" navpointval=\"nav,download\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Download'])})()\" class=\"download \" href=\"https://www.9fzt.com/download.html\">\u4E0B\u8F7D</a>\n          <a target=\"_blank\" navpointval=\"nav,product\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Produck'])})()\" class=\"\" href=\"https://www.9fzt.com/courseCenter/jwcp.html\">\u4EA7\u54C1</a>\n          <a target=\"_blank\" navpointval=\"nav,fund\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Fund'])})()\" class=\"fund \" href=\"https://fund.9fzt.com/index\">\u57FA\u91D1</a>\n          <a target=\"_blank\" navpointval=\"nav,about_us\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_AboutUs'])})()\" class=\"\" href=\"https://www.9fzt.com/dynamic.html\">\u5173\u4E8E\u6211\u4EEC</a>\n          <a target=\"_blank\" navpointval=\"nav,jftech\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Navbar_Jfkj'])})()\" class=\"last \" href=\"https://jftech.9fzt.com\">\u4E5D\u65B9\u79D1\u6280</a>\n        \n        <div class=\"header-login-box clearfix\">\n          <div id=\"headerlogin\" class=\"header-login-btn\">\u767B\u5F55/\u6CE8\u518C</div>\n          <div class=\"header-logined-box none\">\n            <img class=\"header-user-avatar\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/default-user-avatar.png\">\n            <div class=\"header-avatar-popup none\">\n              <p class=\"header-user-name\">\n                <a href=\"https://www.9fzt.com/personal/index.html\" target=\"_blank\" style=\"padding: 0;width: 100%;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color: #333333;\">\n                  <img class=\"\" style=\"width: 12px;height: 14px;display: inline-block;vertical-align: middle;\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/user/login-avatar-icon.png\" alt=\"\">\n                  <span style=\"vertical-align: middle;\">\u7528\u62379527</span>\n                </a>\n              </p>\n              <p id=\"headerloginout\" class=\"header-login-out\">\n                <img class=\"login-out-icon\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/loginout.png\">\n                <span style=\"vertical-align: middle;\">\u9000\u51FA\u767B\u5F55</span>\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- <div class=\"menu\">\n        <div class=\"outter\">\n            <ul>\n                <li>\n                    <a navpointval=\"attractive,\u677F\u5757\u8BE6\u60C5\" href=\"https://test-stock.9fzt.com/plate/XBHS.GN_GN252038.html\" target=\"_blank\">\u677F\u5757\u8BE6\u60C5</a>\n                </li>\n            \n                <li>\n                    <a navpointval=\"attractive,\u6307\u6570\u8BE6\u60C5\" href=\"https://test-stock.9fzt.com/zsindex/sh_000001.html\" target=\"_blank\">\u6307\u6570\u8BE6\u60C5</a>\n                </li>\n            \n                <li>\n                    <a navpointval=\"attractive,\u884C\u60C5\" href=\"https://test-www.9fzt.com/marketCenter/aStockMarket.html?tab=0\" target=\"_blank\">\u884C\u60C5</a>\n                </li>\n            </ul>\n        </div>\n      </div> -->\n    </div>\n  </div>\n  <div class=\"global-new-header-wrap-mt-box\" style=\"margin-top:50px;\"></div>\n  \n  \n    <script src=\"//upload.9fzt.com/production/jfztgw/js/globalLogin.js\"></script>\n    <script defer src=\"//upload.9fzt.com/production/jfztgw/js/extraLogic.js\"></script>\n    <script src=\"https://upload.9fzt.com/production/jfnpm/sa-track/1.0.3/jftrack.min.js\"></script>\n  \n  \n            <style>\n    .global-quote-tool-wrap {\n      width: 100%;\n      margin: auto;\n      background: #353648;\n    }\n    .global-quote-tool-wrap .global-quote-tool {\n      width: 1000px;\n      background: #353648;\n      margin: 0 auto;\n    }\n    .global-quote-tool {\n      font-size: 14px;\n      height: 32px;\n      line-height: 32px;\n      position: relative;\n    }\n    .global-quote-tool .quote-item {\n      font-size: 14px;\n      margin-right: 13px;\n      color: #CFCFD2;\n    }\n    .global-quote-tool .quote-item.mr-0 {\n      margin-right: 0;\n    }\n    .global-quote-tool .fund-item {\n      font-size: 14px;\n      color: #CFCFD2;\n    }\n    .global-quote-tool .fund-item:hover {\n      cursor: pointer;\n      color: #E94041;\n    }\n    .global-quote-tool .quote-item:hover {\n      cursor: pointer;\n      color: #E94041;\n    }\n    \n    .quote-center-icon {\n      display: inline-block;\n      background: url('/assets/img/header/quote-center.png') no-repeat;\n      background-size: contain;\n      width: 13px;\n      height: 12px;\n    }\n    .quote-download-icon {\n      display: inline-block;\n      background: url('/assets/img/header/headerdownload.png') no-repeat;\n      background-size: contain;\n      width: 16px;\n      height: 15px;\n      margin-left: 2px;\n    }\n    .quote-haderdownload {\n      background: #b60041;\n      color: #fff;\n      height: 20px;\n      line-height: 20px;\n      padding: 0 10px 0 16px;\n      position: relative;\n      top: 6px;\n    }\n    .global-stockindex .changePrice {\n      padding: 0;\n      margin: 0;\n    }\n    .global-quote-tool-wrap .dingpan .icon {\n      margin-top: 2px;\n      width: 28px;\n      height: 14px;\n      display: inline-block;\n      vertical-align: -2px;\n    }\n    .global-quote-tool-wrap .dingpan .hot {\n      display: inline-block;\n      width: 31px;\n      height: 13px;\n      vertical-align: -1px;\n      animation: scaleDraw 1.5s ease infinite;\n    }\n    .global-quote-tool-wrap .downlaod span:hover {\n      text-decoration: underline;\n    }\n    @keyframes scaleDraw {  \n      0%{\n          transform: scale(1);  \n      }\n      50%{\n          transform: scale(1.2);\n      }\n      100%{\n          transform: scale(1);\n      }\n    }\n    .global-quote-tool-wrap .special-color {\n      color: #EF7340;\n    }\n    .global-quote-tool-wrap .head-lhb-icon {\n      position: absolute;\n      top: -4px;\n      right: -22px;\n      width: 27px;\n      height: 16px;\n      /* animation: bounce 1.5s linear infinite; */\n    }\n    @keyframes bounce {\n      0% {\n        transform: translateY(0px); \n      }\n      50% {\n        transform: translateY(-6px); \n      }\n      100% {\n        transform: translateY(0px); \n      }\n    }\n    .global-quote-tool-wrap .por {\n      position: relative;\n    }\n  </style>\n  <div class=\"global-quote-tool-wrap\">\n    <div class=\"global-quote-tool\">\n      <span style=\"font-weight: bold;margin-right: 10px;\">\n        <a navpointval=\"quote,market_center\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter'])})()\"  href=\"https://www.9fzt.com/marketCenter/index.html\"><span class=\"inlineval inlineval-hover\">\u884C\u60C5\u4E2D\u5FC3</span></a>\n      </span>\n      <a navpointval=\"quote,stock_list\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_SHZA'])})()\" style=\"margin-left: -4px;\"  href=\"https://www.9fzt.com/marketCenter/aStockMarket.html?tab=0\" class=\"quote-item\">\u6CAA\u6DF1\u4EACA\u80A1</a>\n      <a navpointval=\"quote,sh_index\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_SZZS'])})()\"  href=\"https://stock.9fzt.com/zsindex/sh_000001.html\" class=\"quote-item\">\u4E0A\u8BC1\u6307\u6570</a>\n      <a navpointval=\"quote,plate_market\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_BK'])})()\"  href=\"https://stock.9fzt.com/plate/index.html\" class=\"quote-item\">\u677F\u5757\u884C\u60C5</a>\n      <a navpointval=\"quote,stock_change\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_Changes'])})()\"  href=\"https://stock.9fzt.com/marketChanges/stock.html\" class=\"quote-item\">\u80A1\u5E02\u5F02\u52A8</a>\n      <a navpointval=\"quote,stock_community\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_GQ'])})()\"  href=\"https://www.9fzt.com/stockBar/index.html\" class=\"quote-item\">\u80A1\u5708</a>\n      <a navpointval=\"quote,special_subject\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_SPECIAL'])})()\"  href=\"https://www.9fzt.com/special/index.html\" class=\"quote-item\">\n        \u4E13\u9898\n      </a>\n      <a navpointval=\"quote,intelligence\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_ZDQBZ'])})()\"  href=\"https://stock.9fzt.com/intelligence/index.html\" class=\"quote-item\">\u6DA8\u8DCC\u60C5\u62A5\u7AD9</a>\n      <a navpointval=\"quote,staring_market\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_DP'])})()\"  href=\"https://www.9fzt.com/stareMarket/index.html\" class=\"quote-item\">\u76EF\u76D8</a>\n      <a navpointval=\"quote,hk_stock\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_DP'])})()\"  href=\"https://gmg.9fzt.com/quote/hklist.html\" class=\"quote-item por\">\u6E2F\u80A1</a>\n      <a navpointval=\"quote,institute\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_YJS'])})()\"  href=\"https://www.9fzt.com/graduateSchool/index.html\" class=\"quote-item\">\u7814\u7A76\u6240</a>\n      <a navpointval=\"quote,live\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_LIVE'])})()\"  href=\"https://www.9fzt.com/liveDetail/gszb.html\" class=\"quote-item\">\u76F4\u64AD</a>\n      <a navpointval=\"quote,open_account\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_KH'])})()\"  href=\"https://www.9fzt.com/others/openAccount.html\" class=\"quote-item special-color\">\u80A1\u7968\u5F00\u6237</a>\n      <a navpointval=\"quote,stock_selection\" target=\"_blank\"  onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_MarketCenter_XG'])})()\"  href=\"https://stock.9fzt.com/stockSelection/index.html\" class=\"quote-item special-color\">\u667A\u80FD\u9009\u80A1</a>\n  \n      <div class=\"other-block-info\" style=\"display: none;\">\n        <div style=\"position: absolute; top: 0; left: 1020px; white-space: nowrap;\">\n          <div style=\"margin: 7px 0 10px 0\">\n              <a href=\"https://edu.newwinner.com.cn\" target=\"_blank\" onClick=\"\">\n                  <div style=\"border: 1px solid #E94041; width: 133px; height: 24px; line-height: 22px; border-radius: 14px; text-align: center;\">\n                      <img style=\"width: 12px; height: 14px; display: inline-block; vertical-align: middle;\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAAAAXNSR0IArs4c6QAAArNJREFUSEvtlj9oE2EYxp/n0mhLUYfLpVhd6+Cii4NbLmeoQkGFdjGgCFpBFESKiODi4CBFBEG0uigWxA6CWSz1mi7q0MUuCsZRW5I0g6IGk+ZeuaRX87d3F2tw8Nvuvu95fve+3/e+9xE+hoyOBrOp1BgEx8sy4pE2MDDOiYmiVxt6XZiJxQZQLE0KZF+1huA8goF4eGYm5cXLEzAbjZ6yBLcg0tvUlPyuEBe02dkHbtB1gV8NQ82X5D4gR92MKvN81hPg6a2mmWu1viVw2TAOWJY8FJF+b7BVJLmoKDwRMs2XzXQNQBkZ2ZTJ5a7TkotiH4s2BgERhTfDqnqFU1OF2j2vesoZxu5SyZoUYG8bnAYJgbeBgBJXTfOdM7kWQVo3zkKscQA9GwGr8siDylhf0rxTqSQAaV2/B8HoBoNq7YiJvmTyDDPR6Dmx5PZfha2aU+F5piPR14Ds7wQQ4BtmInpBgGAngASKTEd06QRs7ZT+k0AC36jwmHR3z0s+fxeCw+tlheQCBAkQJ0VkR03hu0Vow4RdB/uSM69sof2Lynz4+BSQI81bF5Palt4hJhI/MoYxLCVryjOwHuYIW0GJ3zB7bVbXr1qCa56A9bBsLNYvK6XLWkgds/tjPbQBFjHiwnLzD7gCW8CSIrIL5PNwSB2phhLY5qSxHFkLWLm1NewhWQACUWfPViOrwJyOASY0TR12oFhaCtp75gZrCiTwIjyXPFQWV9JYA2sGdd6tF1nLOiT5RUHXoBWwCihZT6ojqz+VrIrUC6x5Sn22HYLvhUgRGBIRxU3+v7W5Zcj3PDN69LPfm5lvilNO5CLTuv4Ygni7Jr50xCTtWrOKKwsAQr7E/hcvK8GuPeVLVHZwcLv1s3iDkIgAO/17tVYQ+CTgnLI5eEmbnl5q66L7Jx/UceAv7xtpTgfEugoAAAAASUVORK5CYII=\" alt=\"\" />\n                      <span style=\"font-size: 12px; color: #E94041; vertical-align: middle;\">\u4E5D\u65B9\u6295\u6559\u57FA\u5730</span>\n                      <img style=\"width: 13px; height: 14px; display: inline-block; vertical-align: middle;\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcBAMAAACNPbLgAAAAHlBMVEUAAADpQEHsQUXpQUHuRETpQULqQULpQULtRETpQEFlVEwxAAAACXRSTlMA9kOYHuG1jjgxMkO4AAAAMklEQVQY02PABlxQeIEKyLxKIWQe80QUSUt6SWbORIAZqDxUlSim0E+qUgh3CLpgC3IAlZYbCa724C8AAAAASUVORK5CYII=\" alt=\"\" />\n                  </div>\n              </a>\n          </div>\n          <div>\n              <a href=\"/protectCenter.html?tab=3\" target=\"_blank\" onClick=\"(function(){_hmt.push(['_trackEvent', 'Home_click', 'click_User_Protection'])})()\">\n                  <div style=\"border: 1px solid #E94041; width: 133px; height: 24px; line-height: 22px; border-radius: 14px; text-align: center;\">\n                      <img style=\"width: 12px; height: 14px; display: inline-block; vertical-align: middle;\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAMAAAA2a+hwAAAAhFBMVEUAAADpQULqQEHqQULyS0v/amrqQEHqQkLsRUXqQEHqQELqQEHqQELqQULpQULrQULrQULvRUXpQEHqQEHqQEHqQUHqQELsQkLsRkb/TU3pQEHpQULqQELqQUHrQkLqRUXuRETwRkbvSEj/WlrpQULqQELpQUHqQUHpQUHtRETqVVXpQEEw56iuAAAAK3RSTlMA9+mhEwTEXBvv2M6rpo5yZB/HwJKHfkIoCt7RtrVNMC0hFwjts5iVUjgM/7eNqQAAAPdJREFUKM+90tmSQ0AUgOGftgshkZB9m/28//uNaa2IZS7z3ZziL0qrQ1+2j3xmbKRWuFMpX4sWX4fFKZUlhpWUDo0gWXmxLQN27K2SHE9mecg/Xho3wXY2LuGmozVuGbiLelqMzm/58HjXf4JI31l8rdt2hp/mIuKoZ1C/qGklOCvRjqR6bsFV9Qy/4R5LI8WXtlKIfYEgEsPn3h4NWFZw20srgIM0PvlTdV9/AJZiKBcu9tOvwLHEWOTnsHdevQ6pTEqb/QmnWmj2yJ+KPoYaN0XLPQ3bqbfaO2+wdw/oVdVvasezrNv4jJE8MY8FTLl+vNlFRecXibhhFzGfwW0AAAAASUVORK5CYII=\" alt=\"\" />\n                      <span style=\"font-size: 12px; color: #E94041; vertical-align: middle;\">\u7528\u6237\u4FDD\u62A4\u4E2D\u5FC3</span>\n                      <img style=\"width: 13px; height: 14px; display: inline-block; vertical-align: middle;\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcBAMAAACNPbLgAAAAHlBMVEUAAADpQEHsQUXpQUHuRETpQULqQULpQULtRETpQEFlVEwxAAAACXRSTlMA9kOYHuG1jjgxMkO4AAAAMklEQVQY02PABlxQeIEKyLxKIWQe80QUSUt6SWbORIAZqDxUlSim0E+qUgh3CLpgC3IAlZYbCa724C8AAAAASUVORK5CYII=\" alt=\"\" />\n                  </div>\n              </a>\n          </div>\n          <div style=\"margin-top: 9px;color: #CCCCCC; font-size: 12px; line-height: 17px;\">\u6295\u8BC9\u7535\u8BDD 021-20289058 \u8F6C3</div>\n      </div>\n      </div>\n    </div>\n  </div>\n  \n  <script>\n    if(location.href.indexOf('www.9fzt.com') > -1 || location.href.indexOf('test-www.9fzt.com') > -1) {\n      var otherBlockInfo = document.querySelector('.other-block-info')\n      if(otherBlockInfo) {\n        otherBlockInfo.style && (otherBlockInfo.style.display = 'block')\n      }\n    }\n  </script>\n  \n            <style>\n    .global-stockindex-wrap {\n      width: 100%;\n      margin: auto;\n      /* position: fixed; */\n      /* top: 127px; */\n      /* z-index: 9999; */\n      background: #353648;\n    }\n    .global-stockindex-wrap .global-stockindex {\n      border-top: 1px solid #303040;\n      width: 1000px;\n      background: #353648;\n      margin: 0 auto;\n    }\n    .global-stockindex {\n      font-size: 14px;\n      height: 33px;\n      line-height: 32px;\n      overflow: hidden;\n    }\n    .global-stockindex .quote-item {\n      font-size: 14px;\n      margin-right: 15px;\n    }\n    .quote-center-icon {\n      display: inline-block;\n      background: url('https://upload.9fzt.com/test/jfztgw/assets/img/header/quote-center.png') no-repeat;\n      background-size: contain;\n      width: 13px;\n      height: 12px;\n    }\n    .global_earth-icon {\n      display: inline-block;\n      background: url('https://upload.9fzt.com/test/jfztgw/assets/img/header/global_earth.png') no-repeat;\n      background-size: contain;\n      width: 13px;\n      height: 12px;\n    }\n    /* global_earth */\n    .quote-download-icon {\n      display: inline-block;\n      background: url('https://upload.9fzt.com/test/jfztgw/assets/img/header/headerdownload.png') no-repeat;\n      background-size: contain;\n      width: 16px;\n      height: 15px;\n      margin-left: 2px;\n    }\n    .quote-haderdownload {\n      background: #b60041;\n      color: #fff;\n      height: 20px;\n      line-height: 20px;\n      padding: 0 10px 0 16px;\n      position: relative;\n      top: 6px;\n    }\n    .inlineval {\n      width: 86px;\n      display: inline-block;\n      /* height:33px; */\n      line-height:32px;\n    }\n    .stock-swiper-content {\n      width: 840px;\n      overflow: hidden;\n      float:left;\n    }\n    /* .inlineval:after {\n      content: ' ';\n      display: inline-block;\n      width: 100%;\n    } */\n    .stock-index-label {\n      color: #CFCFD2;\n    }\n    .stock-index-label:hover{\n      cursor: pointer;\n      color: #E94041;\n    }\n    .stock-index-label-nor {\n      color: #333;\n    }\n    .swiper-slide {\n      width: 280px;\n    }\n    .stock-swiper-content a:hover .index-label {\n      color: #E94041 !important;\n    }\n    .stock-swiper-content .noclick {\n      cursor: default;\n    }\n    .stock-swiper-content .noclick:hover .index-label {\n      color: #CFCFD2 !important;\n    }\n  </style>\n  <div class=\"global-stockindex-wrap\">\n    <div class=\"global-stockindex clearfix\" id=\"global_header_stockindex\">\n      <span style=\"font-weight: 500;margin-right: 10px;float: left;line-height:32px;\">\n        <span class=\"inlineval\">\u5168\u7403\u6307\u6570</span>\n      </span>\n        <div class=\"stock-swiper-content\" style=\"width: 910px; height: 32px; position: relative;\">\n        </div>\n    </div>\n  </div>\n  \n  \n    <script src=\"//upload.9fzt.com/production/jfztgw/js/globalstockindex.js\"></script>\n  \n  \n            <style>\n    .data-center-wrap {\n      width: 100%;\n      margin: auto;\n      background: #353648;\n    }\n    .data-center-wrap .data-center {\n      border-top: 1px solid #303040;\n      width: 1000px;\n      background: #353648;\n      margin: 0 auto;\n    }\n    .data-center {\n      font-size: 14px;\n      height: 33px;\n      line-height: 32px;\n      overflow: hidden;\n    }\n    .data-center .quote-item {\n      font-size: 14px;\n      margin-right: 23px;\n      color: #CFCFD2;\n    }\n    .data-center .mr-0 {\n      margin-right: 0;\n    } \n    .data-center .quote-item-special {\n      color: #EF7340;\n    }\n    .data-center .quote-item:hover {\n      cursor: pointer;\n      color: #E94041;\n    }\n    .quote-center-icon {\n      display: inline-block;\n      background: url('/assets/img/header/quote-center.png') no-repeat;\n      background-size: contain;\n      width: 13px;\n      height: 12px;\n    }\n    /* global_earth */\n    .quote-download-icon {\n      display: inline-block;\n      background: url('/assets/img/header/headerdownload.png') no-repeat;\n      background-size: contain;\n      width: 16px;\n      height: 15px;\n      margin-left: 2px;\n    }\n    .quote-haderdownload {\n      background: #b60041;\n      color: #fff;\n      height: 20px;\n      line-height: 20px;\n      padding: 0 10px 0 16px;\n      position: relative;\n      top: 6px;\n    }\n    .inlineval {\n      font-weight: bold;\n      width: 76px;\n      display: inline-block;\n      /* height:33px; */\n      line-height: 32px;\n      color:#FFFFFF;\n    }\n    .inlineval-hover:hover {\n      color: #E94041;\n    }\n  </style>\n  <div class=\"data-center-wrap\">\n    <div class=\"data-center clearfix\">\n      <span style=\"font-weight: 500;margin-right: 10px;float: left;height:33px;line-height:33px;\">\n        <a navpointval=\"data,data_center\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/dataCenter/index.html\">\n          <span class=\"inlineval inlineval-hover\">\u6570\u636E\u4E2D\u5FC3</span>\n        </a>\n      </span>\n        <a navpointval=\"data,money _flow\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_foundFlow'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/cashFlow/index.html\" class=\"quote-item\">\u8D44\u91D1\u6D41\u5411</a>\n        <a navpointval=\"data,lhb\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_lhb'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/lhb/index.html\" class=\"quote-item\">\u9F99\u864E\u699C</a>\n        <a navpointval=\"data,margin_trading\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_rzrq'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/rzrq/index.html\" class=\"quote-item\">\u878D\u8D44\u878D\u5238</a>\n        <a navpointval=\"data,stock_connect\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_hsgt'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/hsgt/bxzj.html\" class=\"quote-item\">\u6CAA\u6DF1\u6E2F\u901A</a>\n        <a navpointval=\"data,price_comparison\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_priceParity'])})()\" target=\"_blank\" href=\"https://www.9fzt.com/priceParity/index.html\" class=\"quote-item\">\u6BD4\u4EF7\u6570\u636E</a>\n        <a navpointval=\"data,research_report\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_industryReport'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/report/company.html\" class=\"quote-item\">\u7814\u62A5\u6570\u636E</a>\n        <a navpointval=\"data,notice\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_Notice_Entry_Nuggets_homepage'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/notice/index.html\" class=\"quote-item hidden-ggjj\">\u516C\u544A\u6398\u91D1</a>\n        <a navpointval=\"data,IPO\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_xgsg'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/dataCenter/stockApply.html\" class=\"quote-item quote-item-special\">\u65B0\u80A1\u7533\u8D2D</a>\n        <a navpointval=\"data,block_trading\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_dzjy'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/dzjy/index.html\" class=\"quote-item quote-item-special\">\u5927\u5B97\u4EA4\u6613</a>\n        <a navpointval=\"data,performance\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_yjsd'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/yjsd/index.html\" class=\"quote-item quote-item-special\">\u4E1A\u7EE9\u901F\u9012</a>\n        <a navpointval=\"data,technology_index\" onClick=\"(function(){_hmt.push(['_trackEvent', 'head_click', 'click_DataCenter_kjlt'])})()\" target=\"_blank\" href=\"https://stock.9fzt.com/jfIndex/RH_GN1226.html\" class=\"quote-item quote-item-special mr-0\">\u79D1\u6280\u9F99\u5934\u6307\u6570</a>\n    </div>\n  </div>\n  \n          ",
	  footerHtml: "\n          <div class=\"global-new-footer-wrap\">\n    <div class=\"top\">\n      <div class=\"top-partner\">\n        <p class=\"top-partner-text\">\u5408\u4F5C\u4F19\u4F34\uFF1A</p>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"https://www.yicai.com/\"><img class=\"top-partner-img\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/partner-1.png\" alt=\"\u4E5D\u65B9\u667A\u6295-\u5408\u4F5C\u4F19\u4F34\"></a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.hbgbdst.com/\"><img class=\"top-partner-img\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/partner-2.png\" alt=\"\u4E5D\u65B9\u667A\u6295-\u5408\u4F5C\u4F19\u4F34\"></a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"https://www.360.cn/\"><img class=\"top-partner-img\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/partner-3.png\" alt=\"\u4E5D\u65B9\u667A\u6295-\u5408\u4F5C\u4F19\u4F34\"></a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"https://weibo.com/\"><img class=\"top-partner-img\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/partner-4.png\" alt=\"\u4E5D\u65B9\u667A\u6295-\u5408\u4F5C\u4F19\u4F34\"></a>\n      </div>\n      <div class=\"bottom-friendship\">\n        <p class=\"bottom-friendship-text\">\u53CB\u60C5\u94FE\u63A5\uFF1A</p>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.xinhuanet.com/\" class=\"bottom-friendship-links\">\u65B0\u534E\u7F51</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.sse.com.cn/\" class=\"bottom-friendship-links\">\u4E0A\u6D77\u8BC1\u5238\u4EA4\u6613\u6240</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.szse.cn/\" class=\"bottom-friendship-links\">\u6DF1\u5733\u8BC1\u5238\u4EA4\u6613\u6240</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.cnstock.com/\" class=\"bottom-friendship-links\">\u4E0A\u6D77\u8BC1\u5238\u62A5</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.cs.com.cn/\" class=\"bottom-friendship-links\">\u4E2D\u56FD\u8BC1\u5238\u62A5</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.stcn.com/\" class=\"bottom-friendship-links\">\u8BC1\u5238\u65F6\u62A5</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"https://www.yicai.com/\" class=\"bottom-friendship-links\">\u7B2C\u4E00\u8D22\u7ECF</a>\n        <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.hbgbdst.com/\" class=\"bottom-friendship-links\">\u6E56\u5317\u536B\u89C6</a>\n      </div>\n    </div>\n    <div class=\"bottom\">\n      <div class=\"bottom-info clearfix\">\n        <div class=\"bottom-info-left\">\n          <p class=\"mb-11\">\u4E0A\u6D77\u4E5D\u65B9\u4E91\u667A\u80FD\u79D1\u6280\u6709\u9650\u516C\u53F8 \u7248\u6743\u6240\u6709</p>\n          <p class=\"mb-11\">\u7ECF\u8425\u8BC1\u5238\u671F\u8D27\u4E1A\u52A1\u8BB8\u53EF\u8BC1\uFF1A91310116MA1JAC8A6D</p>\n          <p class=\"mb-11\">\n            \u529E\u516C\u5730\u5740\uFF1A\u4E0A\u6D77\u5E02\u9752\u6D66\u533A\u5F90\u6C11\u4E1C\u8DEF88\u53F7B1\u30011F\uFF08\u5357\u88D9\uFF09\u30011F\uFF08\u5317\u5854\uFF09\u30012F\uFF08\u5357\u5854\u76F4\u64AD\u95F4\uFF09\u30013F\uFF08\u5357\u88D9\uFF09\u30013F\u5317\u30013F\uFF08\u897F\u5317\u88D9\uFF09\u30015F\u5357\u30015F\u5317\u30016F\u5317\u30016F\u5357\u30017F\u5357\u30017F\u5317\u30018F\u5317\u30018F\u5357\u300111F\u5317\u300115F\u5317\n          </p>\n          <p class=\"regist-address\">\u6CE8\u518C\u5730\u5740\uFF1A\u4E0A\u6D77\u5E02\u666E\u9640\u533A\u4E91\u5CAD\u4E1C\u8DEF89\u53F712\u5C421202\u5BA4</p>\n        </div>\n        <div class=\"bottom-info-middle\">\n          <a rel=\"nofollow\" target=\"_blank\" class=\"mr-35 wzba\" href=\"http://beian.miit.gov.cn\">\u6CAAICP\u590718014860\u53F7-19</a>\n          <a rel=\"nofollow\" target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502015365\">\u6CAA\u516C\u7F51\u5B89\u5907 31011502015365\u53F7</a>\n          <p class=\"mt-11 mb-11\">\u8BC1\u5238\u6295\u8D44\u54A8\u8BE2\u673A\u6784\u4E1A\u52A1\u673A\u6784\u8BB8\u53EF\u8BC1\uFF1AZX0023</p>\n          <span class=\"mr-35\">\u8054\u7CFB\u7535\u8BDD\uFF1A400-719-8899</span>\n          <span>\u6295\u8BC9\u7535\u8BDD\uFF1A021-20289058 \u8F6C3</span>\n          <p class=\"mt-11\">\u603B\u7ECF\u7406\u4FE1\u7BB1\uFF1Axht_sh@newwinner.com.cn</p>\n        </div>\n        <div class=\"bottom-info-right\">\n          <div class=\"circle\">\n            <img class=\"icon-weibo\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/weibi.png\">\n            <img class=\"qrcode\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/code-1.png\" alt=\"\u4E5D\u65B9\u667A\u6295\u5FAE\u535A\">\n          </div>\n          <div class=\"circle\">\n            <img class=\"icon-weixi\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/weixi.png\">\n            <img class=\"qrcode\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/code-2.png\" alt=\"\u4E5D\u65B9\u667A\u6295\u516C\u4F17\u53F7\">\n          </div>\n          <div class=\"circle wap\">\n            <img class=\"icon-phone\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/phone.png\">\n            <img class=\"qrcode\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/code-3.png\" alt=\"\u4E5D\u65B9\u667A\u6295\u65D7\u8230\u7248\">\n          </div>\n          <div class=\"circle pc\">\n            <img class=\"icon-pc\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/pc.png\">\n            <a href=\"https://upload.9fzt.com/production/jfzt/setup_ow.exe\" onClick=\"(function(){_hmt.push(['_trackEvent', 'click_PC_Banner', 'click_Bottom_DownloadPC', location.href])})()\">\n              <img class=\"qrcode\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/code-4.png\" alt=\"\u4E5D\u65B9\u667A\u6295PC\u7248\">\n            </a>\n          </div>\n        </div>\n      </div>\n      <div class=\"bottom-warn\">\n        <a rel=\"nofollow\" target=\"_blank\" class=\"mr-90\" href=\"http://www.cyberpolice.cn/wfjb/\">\n          <img class=\"bottom-warn-icon\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/icon-1.png\">\n          <span class=\"bottom-warn-text\">\u4E0A\u6D77\u7F51\u8B66110</span>\n        </a>\n        <a rel=\"nofollow\" target=\"_blank\" class=\"mr-90\" href=\"https://www.12377.cn/\">\n          <img class=\"bottom-warn-icon\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/icon-2.png\">\n          <span class=\"bottom-warn-text\">\u4E0D\u826F\u4FE1\u606F\u4E3E\u62A5</span>\n        </a>\n        <a rel=\"nofollow\" target=\"_blank\" class=\"mr-90\" href=\"http://www.shjbzx.cn/\">\n          <img class=\"bottom-warn-icon\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/icon-3.png\">\n          <span class=\"bottom-warn-text\">\u8FDD\u6CD5\u8FDD\u89C4\u4E3E\u62A5\u4E2D\u5FC3</span>\n        </a>\n        <img class=\"bottom-warn-icon\" src=\"https://upload.9fzt.com/production/jfzt-website-pc/footer/icon-4.png\">\n        <span class=\"bottom-warn-text\">\u5E02\u573A\u6709\u98CE\u9669 \u6295\u8D44\u9700\u8C28\u614E</span>\n      </div>\n    </div>\n  </div>\n  \n  <script>\n    if (location.href.indexOf('fund.9fzt.com/index') > -1) {\n      document.querySelector('.global-new-header-wrap .new-header-menu-wrap .fund').classList.add('active');\n      document.querySelector('.global-new-header-wrap .new-header-menu-wrap .fund').classList.add('active2');\n    }\n    if (location.hostname.indexOf('newwinner.com.cn') > -1) {\n      document.querySelector('.global-new-footer-wrap .wzba').innerHTML = '\u6CAAICP\u590718014860\u53F7-1';\n    } else if (location.hostname.indexOf('9fzt.cn') > -1) {\n      document.querySelector('.global-new-footer-wrap .wzba').innerHTML = '\u6CAAICP\u590718014860\u53F7-22';\n    } else if (location.hostname.indexOf('study2025.com') > -1) {\n      document.querySelector('.global-new-footer-wrap .wzba').innerHTML = '\u6CAAICP\u590718014860\u53F7-15';\n    } else if (location.hostname.indexOf('9fzt.net') > -1) {\n      document.querySelector('.global-new-footer-wrap .wzba').innerHTML = '\u6CAAICP\u590718014860\u53F7-20';\n      document.querySelector('.global-new-header-wrap .new-header-menu-wrap .download').style.display = 'none';\n      document.querySelector('.global-new-footer-wrap .circle.wap').style.display = 'none';\n      document.querySelector('.global-new-footer-wrap .circle.pc').style.display = 'none';\n    } else if (location.hostname.indexOf('9fzt.com.cn') > -1) {\n      document.querySelector('.global-new-footer-wrap .wzba').innerHTML = '\u6CAAICP\u590718014860\u53F7-21';\n    }\n  </script>\n  \n        ",
	  headJSCSS: "\n          <script src=\"https://upload.techgp.cn/production/lodash.custom.min.js\"></script>\n          <link rel=\"stylesheet\" type=\"text/css\" href=\"https://www.9fzt.com/css/common.css\">\n        "
	};

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 个股信息
	 * @author 一秒五喷
	 */
	var React = __webpack_require__(27);
	
	var _require = __webpack_require__(206),
	    getYYYYMMDDHHMMSS = _require.getYYYYMMDDHHMMSS,
	    formatUnit = _require.formatUnit,
	    getColor = _require.getColor,
	    getGszt = _require.getGszt,
	    goSymbolHtml = _require.goSymbolHtml,
	    toFixed = _require.toFixed;
	
	var isList = location.href.indexOf('list') > 0;
	
	var _require2 = __webpack_require__(207),
	    getIsAIndexStock = _require2.getIsAIndexStock,
	    getExchange = _require2.getExchange;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  render: function render() {
	    var _this = this;
	
	    var dyna = this.props.dyna;
	    var statistics = this.props.statistics;
	    var isUp = dyna.Updown ? dyna.Updown > 0 : null;
	    var _props = this.props,
	        symbol = _props.symbol,
	        market = _props.market;
	
	    var blues = [2, 3, 7, 9, 10, 12, 13, 15];
	    var isAInDex = getIsAIndexStock(this.props.symbol, this.props.market);
	
	    return React.createElement(
	      'div',
	      { className: 'stock-info clearfix' },
	      React.createElement(
	        'div',
	        { className: 'stockName' },
	        isList ? React.createElement(
	          'span',
	          { onClick: function onClick() {
	              return _this.props.goHome();
	            }, className: 'stock-name', style: { color: '#333333', marginRight: '4px', fontSize: '22px', cursor: 'pointer' } },
	          decodeURIComponent(this.props.name) || '----'
	        ) : React.createElement(
	          'span',
	          { className: 'stock-name', style: { color: '#333333', marginRight: '4px', fontSize: '22px' } },
	          decodeURIComponent(this.props.name) || '----'
	        ),
	        React.createElement(
	          'span',
	          { style: { lineHeight: '26px' }, className: 'stock-code' },
	          symbol.toUpperCase() || '--',
	          '.',
	          getExchange(symbol, market)
	        ),
	        React.createElement(
	          'span',
	          { style: { color: '#999999' } },
	          '\u5355\u4F4D\uFF1A'
	        ),
	        React.createElement(
	          'span',
	          { style: { color: '#999999' } },
	          this.props.dataSourceType === 'HK' ? '港元' : '美元'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'float-left stock--middle-side stock--index-middle-side', style: { border: 'none' } },
	        React.createElement(
	          'div',
	          { className: 'stock-line clearfix', style: { borderRight: '1px solid #e6e6e6' } },
	          React.createElement(
	            'div',
	            { className: 'float-left' },
	            React.createElement(
	              'div',
	              { className: 'stock-price ' + (isUp !== null ? isUp ? 'rise' : 'green' : '') },
	              dyna.LastPrice ? dyna.LastPrice.toFixed(this.props.dataSourceType === 'HK' ? 3 : 2) : '--',
	              React.createElement('i', { style: { margin: '0 0 5px 4px' }, className: '' + (isUp !== null ? isUp ? 'upArrowIcon' : 'downArrowIcon' : '') })
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'float-right', style: { textAlign: 'right', margin: '8px 26px 0 0' } },
	            React.createElement(
	              'div',
	              { className: 'span--stock-price ' + (isUp !== null ? isUp ? 'rise' : 'green' : '') },
	              statistics.PreClosePrice ? (dyna.LastPrice - statistics.PreClosePrice).toFixed(this.props.dataSourceType === 'HK' ? 3 : 2) : '--'
	            ),
	            React.createElement(
	              'div',
	              { style: { lineHeight: '30px', height: '30px', marginTop: '5px' }, className: 'span--stock-price ' + (isUp !== null ? isUp ? 'rise' : 'green' : '') },
	              dyna.Updown || dyna.Updown === 0 ? (dyna.Updown * 100).toFixed(2) + '%' : '--'
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'stock-line clearfix', style: { position: 'relative', bottom: '25px' } },
	          React.createElement('i', { className: blues.includes(this.props.StatusType) ? 'radius' : 'radius stop' }),
	          React.createElement(
	            'span',
	            { className: blues.includes(this.props.StatusType) ? 'stock-tranions' : 'stock-tranions stop' },
	            getGszt(this.props.StatusType)
	          ),
	          React.createElement(
	            'span',
	            { className: 'stock-code' },
	            this.props.dataSourceType === 'US' ? '(' + getYYYYMMDDHHMMSS(dyna.Time * 1000 + 12 * 3600000) + ')' : '(' + getYYYYMMDDHHMMSS(dyna.Time * 1000) + ')'
	          )
	        )
	      ),
	      isAInDex ? React.createElement(
	        'div',
	        null,
	        React.createElement(
	          'div',
	          { className: 'float-left stock--right-side-index' },
	          React.createElement(
	            'div',
	            { className: 'stock-line clearfix' },
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u4ECA\u5F00'
	              ),
	              React.createElement(
	                'span',
	                { className: 'stock-val ' + (statistics.OpenPrice > statistics.PreClosePrice ? 'rise' : 'green'), style: { "float": 'right', color: getColor(statistics.OpenPrice - statistics.PreClosePrice) } },
	                statistics.OpenPrice ? statistics.OpenPrice.toFixed(3) : '--'
	              )
	            ),
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u6700\u9AD8'
	              ),
	              React.createElement(
	                'span',
	                { className: 'stock-val ' + (dyna.HighestPrice > statistics.PreClosePrice ? 'rise' : 'green'), style: { "float": 'right', color: getColor(statistics.OpenPrice - statistics.PreClosePrice) } },
	                dyna.HighestPrice ? dyna.HighestPrice.toFixed(3) : '--'
	              )
	            ),
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u6210\u4EA4\u91CF'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right' }, className: 'stock-val' },
	                formatUnit(dyna.Volume / 100) || '--'
	              )
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'stock-line clearfix' },
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u6628\u6536'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right' }, className: 'stock-val' },
	                toFixed(statistics.PreClosePrice, 3) || '--'
	              )
	            ),
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u6700\u4F4E'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right' }, className: 'stock-val ' + (dyna.LowestPrice > statistics.PreClosePrice ? 'rise' : 'green') },
	                toFixed(dyna.LowestPrice, 3) || '--'
	              )
	            ),
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block-hk', style: { width: '130px', marginRight: '30px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u6210\u4EA4\u989D'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right' }, className: 'stock-val' },
	                formatUnit(dyna.Amount) || '--'
	              )
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'stock-line clearfix' },
	            React.createElement(
	              'div',
	              { className: 'float-left stock-inline-block', style: { width: '130px', marginRight: '47px' } },
	              React.createElement(
	                'span',
	                { className: 'stock-label' },
	                '\u632F\u5E45'
	              ),
	              React.createElement(
	                'span',
	                { style: { "float": 'right' }, className: 'stock-val' },
	                dyna.SA ? (dyna.SA * 100).toFixed(2) + '%' : '--%'
	              )
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'float-left stock--right-co-num', style: { display: isAInDex ? 'block' : 'none' } },
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'span',
	              null,
	              '\u4E0A\u6DA8\u5BB6\u6570'
	            ),
	            React.createElement(
	              'span',
	              null,
	              dyna.Z
	            )
	          ),
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'span',
	              null,
	              '\u5E73\u76D8\u5BB6\u6570'
	            ),
	            React.createElement(
	              'span',
	              null,
	              dyna.D
	            )
	          ),
	          React.createElement(
	            'div',
	            null,
	            React.createElement(
	              'span',
	              null,
	              '\u4E0B\u8DCC\u5BB6\u6570'
	            ),
	            React.createElement(
	              'span',
	              null,
	              dyna.P
	            )
	          )
	        )
	      ) : React.createElement(
	        'div',
	        { className: 'float-left stock--right-side-index' },
	        React.createElement(
	          'div',
	          { className: 'stock-line clearfix' },
	          React.createElement(
	            'div',
	            { className: 'float-left stock-inline-block-hk', style: { width: '223px' } },
	            React.createElement(
	              'span',
	              { className: 'stock-label' },
	              '\u4ECA\u5F00'
	            ),
	            React.createElement(
	              'span',
	              { className: 'stock-val ' + (statistics.OpenPrice > statistics.PreClosePrice ? 'rise' : 'green'), style: { marginLeft: '41px', color: getColor(statistics.OpenPrice - statistics.PreClosePrice) } },
	              statistics.OpenPrice ? statistics.OpenPrice.toFixed(3) : '--'
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'float-left stock-inline-block-hk', style: { width: '221px' } },
	            React.createElement(
	              'span',
	              { className: 'stock-label' },
	              '\u6210\u4EA4\u91CF'
	            ),
	            React.createElement(
	              'span',
	              { style: { marginLeft: '41px' }, className: 'stock-val' },
	              formatUnit(dyna.Volume / 100) || '--'
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'float-left stock-inline-block', style: { width: '130px' } },
	            React.createElement(
	              'span',
	              { className: 'stock-label' },
	              '\u632F\u5E45'
	            ),
	            React.createElement(
	              'span',
	              { style: { marginLeft: '40px' }, className: 'stock-val' },
	              dyna.SA ? (dyna.SA * 100).toFixed(2) + '%' : '--%'
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'stock-line clearfix' },
	          React.createElement(
	            'div',
	            { className: 'float-left stock-inline-block-hk', style: { width: '223px' } },
	            React.createElement(
	              'span',
	              { className: 'stock-label' },
	              '\u6628\u6536'
	            ),
	            React.createElement(
	              'span',
	              { style: { marginLeft: '41px' }, className: 'stock-val' },
	              toFixed(statistics.PreClosePrice, 3) || '--'
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'float-left stock-inline-block-hk', style: { width: '221px' } },
	            React.createElement(
	              'span',
	              { className: 'stock-label' },
	              '\u6210\u4EA4\u989D'
	            ),
	            React.createElement(
	              'span',
	              { style: { marginLeft: '41px' }, className: 'stock-val' },
	              formatUnit(dyna.Amount) || '--'
	            )
	          )
	        )
	      )
	    );
	  }
	});

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 公司概况组件
	 * @author 一秒五喷
	 */
	var React = __webpack_require__(27);
	var BoxHeader = __webpack_require__(217);
	
	var apis = __webpack_require__(186);
	var request = __webpack_require__(180);
	
	var _require = __webpack_require__(206),
	    toFixed = _require.toFixed;
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.dayChart = echarts.init(document.getElementById('cash-day-pie-chart'));
	    this.dayChart2 = echarts.init(document.getElementById('cash-day-pie-chart2'));
	    this.fiveChart = echarts.init(document.getElementById('cash-bar-chart'));
	    this.getData();
	  },
	  getData: function getData() {
	    var _this = this;
	
	    var params = {
	      symbol: this.props.market + this.props.code
	    };
	    request.get(apis.quote.getLv2AdayInfo, params).then(function (res) {
	      if (res.result && res.result.status.code === 0) {
	        _this.renderDayChart(_this.createDayChartSeries(res.result.data));
	      }
	    });
	    request.get(apis.quote.getLv2AdayMin, params).then(function (res) {
	      if (res.code === 0) {
	        _this.renderDayChart2(_this.createDayChartSeries2(res.data));
	      }
	    });
	    request.get(apis.quote.getLv2Day5Info, params).then(function (res) {
	      if (res.result && res.result.status.code === 0) {
	        _this.renderFiveChart(_this.createFiveSeries(res.result.data));
	      }
	    });
	  },
	  createDayChartSeries: function createDayChartSeries(data) {
	    if (!data) data = {};
	    var _data = data,
	        r0_in = _data.r0_in,
	        r1_in = _data.r1_in,
	        r0_out = _data.r0_out,
	        r1_out = _data.r1_out;
	
	    var r_in = (r0_in + r1_in) / 100000000;
	    var r_out = (r0_out + r1_out) / 100000000;
	    var r_inPerc = toFixed(r_in * 100 / (r_in + r_out), 2) + '%';
	    var r_outPerc = toFixed(r_out * 100 / (r_in + r_out), 2) + '%';
	    this.setState({
	      dayChart: {
	        r_in: toFixed(r_in, 2),
	        r_out: toFixed(r_out, 2),
	        miceValue: toFixed(r_in - r_out, 2)
	      }
	    });
	    return [{
	      type: 'pie',
	      radius: ['40%', '65%'],
	      center: ['50%', '50%'],
	      labelLine: {
	        show: true,
	        length: 10,
	        length2: 10
	      },
	      itemStyle: {
	        borderWidth: 2,
	        borderColor: '#ffffff'
	      },
	      label: {
	        color: '#666666',
	        fontSize: 14
	      },
	      data: [{
	        name: r_outPerc,
	        value: r_out,
	        itemStyle: {
	          color: '#1BAA3C'
	        }
	      }, {
	        name: r_inPerc,
	        value: r_in,
	        itemStyle: {
	          color: '#E63535'
	        }
	      }]
	    }];
	  },
	  createDayChartSeries2: function createDayChartSeries2(data) {
	    var xAxis = ['净特大单', '净大单', '净中单', '净小单'];
	    var dataList = [];
	    dataList.push(toFixed(data.r0_in / 100000000, 2));
	    dataList.push(toFixed(data.r1_in / 100000000, 2));
	    dataList.push(toFixed(data.r2_in / 100000000, 2));
	    dataList.push(toFixed(data.r3_in / 100000000, 2));
	    return {
	      series: [{
	        type: 'bar',
	        data: dataList,
	        barWidth: 45,
	        itemStyle: {
	          color: function color(c) {
	            console.log(c);
	            if (c.data < 0) {
	              return '#1BAA3C';
	            } else {
	              return '#E63535';
	            }
	          }
	        },
	        label: {
	          show: true,
	          formatter: '{c}',
	          fontSize: 14,
	          position: 'top'
	        }
	      }],
	      xAxis: xAxis
	    };
	  },
	  createFiveSeries: function createFiveSeries(data) {
	    var xAxis = [];
	    var dataList = [];
	    var keys = Object.keys(data);
	    var sumR_in = 0;
	    for (var i = keys.length - 1; i > -1; i--) {
	      var key = keys[i];
	      xAxis.push(key.slice(5));
	      var _data$key = data[key],
	          r0_in = _data$key.r0_in,
	          r0_out = _data$key.r0_out,
	          r1_in = _data$key.r1_in,
	          r1_out = _data$key.r1_out;
	
	      var sumValue = parseFloat(r0_in) + parseFloat(r1_in) - parseFloat(r0_out) - parseFloat(r1_out);
	      var _value = toFixed(sumValue / 100000000, 2);
	      sumR_in = sumR_in + sumValue;
	      dataList.push(_value);
	    }
	    this.setState({
	      fiveChart: {
	        r_in: toFixed(sumR_in / 100000000, 2)
	      }
	    });
	    return {
	      series: [{
	        type: 'bar',
	        data: dataList,
	        barWidth: 35,
	        itemStyle: {
	          color: function color(c) {
	            console.log(c);
	            if (c.data < 0) {
	              return '#1BAA3C';
	            } else {
	              return '#E63535';
	            }
	          }
	        },
	        label: {
	          show: true,
	          formatter: '{c}',
	          fontSize: 12,
	          position: 'top'
	        }
	      }],
	      xAxis: xAxis
	    };
	  },
	
	  renderDayChart: function renderDayChart(series) {
	    var option = {
	      title: {
	        text: '当日资金',
	        left: '40%',
	        top: '45%',
	        textStyle: {
	          fontSize: 12,
	          color: '#666'
	        }
	      },
	      tooltip: {
	        trigger: 'item',
	        formatter: '{d}%'
	      },
	      series: series
	    };
	    this.dayChart.setOption(option, true);
	  },
	  renderDayChart2: function renderDayChart2(ret) {
	    var option = {
	      tooltip: {
	        trigger: 'item',
	        formatter: '{c}'
	      },
	      grid: {
	        left: 5,
	        right: 45,
	        top: 20,
	        bottom: 10,
	        containLabel: true
	      },
	      xAxis: {
	        type: 'category',
	        data: ret.xAxis,
	        boundaryGap: false,
	        nameTextStyle: {
	          fontSize: 12,
	          color: '#666666'
	        },
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: false
	        },
	        axisLabel: {
	          color: '#666666',
	          fontSize: 14
	        }
	      },
	      yAxis: {
	        show: false
	      },
	      series: ret.series
	    };
	    this.dayChart2.setOption(option, true);
	  },
	  renderFiveChart: function renderFiveChart(ret) {
	    var option = {
	      tooltip: {
	        trigger: 'item',
	        formatter: '{c}'
	      },
	      grid: {
	        left: 0,
	        right: 30,
	        top: 20,
	        bottom: 10,
	        containLabel: true
	      },
	      xAxis: {
	        type: 'category',
	        data: ret.xAxis,
	        boundaryGap: false,
	        nameTextStyle: {
	          fontSize: 12
	        },
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: false
	        },
	        axisLabel: {
	          color: '#666666'
	        }
	      },
	      yAxis: {
	        show: false
	      },
	      series: ret.series
	    };
	    this.fiveChart.setOption(option, true);
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'box-content' },
	      React.createElement(BoxHeader, { title: '\u8D44\u91D1' }),
	      React.createElement(
	        'div',
	        { className: 'block--cash-content-wrap' },
	        React.createElement(
	          'div',
	          { className: 'cash-chart-title' },
	          '\u4ECA\u65E5\u8D44\u91D1(\u4EBF\u5143)'
	        ),
	        React.createElement(
	          'div',
	          { className: 'cash-chart-sec-title' },
	          '\u4E3B\u529B\u51C0\u6D41\u5165 ',
	          React.createElement(
	            'span',
	            { className: this.state.dayChart && this.state.dayChart.miceValue >= 0 ? 'up' : 'down' },
	            this.state.dayChart && this.state.dayChart.miceValue
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'cash-chart-pointers' },
	          React.createElement(
	            'div',
	            null,
	            React.createElement('span', { className: 'rise-block' }),
	            '\u4E3B\u529B\u6D41\u5165\xA0',
	            React.createElement(
	              'span',
	              { className: 'up' },
	              ' ',
	              this.state.dayChart && this.state.dayChart.r_in
	            )
	          ),
	          React.createElement(
	            'div',
	            null,
	            React.createElement('span', { className: 'green-block' }),
	            '\u4E3B\u529B\u6D41\u51FA\xA0',
	            React.createElement(
	              'span',
	              { className: 'down' },
	              ' ',
	              this.state.dayChart && this.state.dayChart.r_out
	            )
	          )
	        ),
	        React.createElement('div', { id: 'cash-day-pie-chart' }),
	        React.createElement('div', { id: 'cash-day-pie-chart2' }),
	        React.createElement(
	          'div',
	          { className: 'cash-chart-title' },
	          '\u8FD1\u4E94\u65E5\u4E3B\u529B\u8D44\u91D1(\u4EBF\u5143)'
	        ),
	        React.createElement(
	          'div',
	          { className: 'cash-chart-sec-title' },
	          '\u4E3B\u529B\u51C0\u6D41\u5165 ',
	          React.createElement(
	            'span',
	            { className: this.state.fiveChart && this.state.fiveChart.r_in >= 0 ? 'up' : 'down' },
	            this.state.fiveChart && this.state.fiveChart.r_in
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'cash-chart-pointers flex-start' },
	          React.createElement(
	            'div',
	            null,
	            React.createElement('span', { className: 'rise-block' }),
	            '\u8D44\u91D1\u6D41\u5165'
	          ),
	          React.createElement(
	            'div',
	            null,
	            React.createElement('span', { className: 'green-block', style: { marginLeft: '10px' } }),
	            '\u8D44\u91D1\u6D41\u51FA'
	          )
	        ),
	        React.createElement('div', { id: 'cash-bar-chart' })
	      )
	    );
	  }
	});

/***/ })

});
//# sourceMappingURL=zsIndex.js.map